//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.3.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const PEOPLE_API_BASE_URL = new InjectionToken<string>('PEOPLE_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class PeopleFunctionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PEOPLE_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverGracePeriodHistory(caregiverGracePeriodId: number, body?: GetHistoryRequestBase | undefined): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/{caregiverGracePeriodId}/caregiverGracePeriodHistory";
        if (caregiverGracePeriodId === undefined || caregiverGracePeriodId === null)
            throw new Error("The parameter 'caregiverGracePeriodId' must be defined.");
        url_ = url_.replace("{caregiverGracePeriodId}", encodeURIComponent("" + caregiverGracePeriodId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverGracePeriodHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverGracePeriodHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetCaregiverGracePeriodHistory(response: HttpResponseBase): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverParticipantRelationshipDateRangesHistory(caregiverParticipantRelationshipId: number, body?: GetHistoryRequestBase | undefined): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/{caregiverParticipantRelationshipId}/caregiverParticipantRelationshipDateRangesHistory";
        if (caregiverParticipantRelationshipId === undefined || caregiverParticipantRelationshipId === null)
            throw new Error("The parameter 'caregiverParticipantRelationshipId' must be defined.");
        url_ = url_.replace("{caregiverParticipantRelationshipId}", encodeURIComponent("" + caregiverParticipantRelationshipId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverParticipantRelationshipDateRangesHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverParticipantRelationshipDateRangesHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetCaregiverParticipantRelationshipDateRangesHistory(response: HttpResponseBase): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverWwlHistory(caregiverWwlId: number, body?: GetHistoryRequestBase | undefined): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/{caregiverWwlId}/caregiverWwlHistory";
        if (caregiverWwlId === undefined || caregiverWwlId === null)
            throw new Error("The parameter 'caregiverWwlId' must be defined.");
        url_ = url_.replace("{caregiverWwlId}", encodeURIComponent("" + caregiverWwlId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverWwlHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverWwlHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetCaregiverWwlHistory(response: HttpResponseBase): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverRolesHistoryById(id: number, body?: GetHistoryRequestBase | undefined): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/{id}/caregiverroleshistory";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverRolesHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverRolesHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetCaregiverRolesHistoryById(response: HttpResponseBase): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverQualificationHistoryById(id: number, body?: GetHistoryRequestBase | undefined): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/{id}/cgqualificationhistory";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverQualificationHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverQualificationHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetCaregiverQualificationHistoryById(response: HttpResponseBase): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateEorSsn(personId: string, body?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/{personId}/ssn/EorValidate";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateEorSsn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateEorSsn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processValidateEorSsn(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertAgencyAdmin(body?: PersonAgenciesDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/AgencyAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertAgencyAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertAgencyAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpsertAgencyAdmin(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAgencyAdmin(personId: string): Observable<PersonAgenciesDto> {
        let url_ = this.baseUrl + "/api/AgencyAdmin/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgencyAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgencyAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonAgenciesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonAgenciesDto>;
        }));
    }

    protected processGetAgencyAdmin(response: HttpResponseBase): Observable<PersonAgenciesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonAgenciesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAgencyAdminAgencies(personId: string): Observable<AgencyPersonMapping[]> {
        let url_ = this.baseUrl + "/api/AgencyAdmin/{personId}/agencies";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgencyAdminAgencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgencyAdminAgencies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgencyPersonMapping[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgencyPersonMapping[]>;
        }));
    }

    protected processGetAgencyAdminAgencies(response: HttpResponseBase): Observable<AgencyPersonMapping[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgencyPersonMapping.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAgencyAdminUserProfile(personId: string): Observable<AgencyAdminProfile> {
        let url_ = this.baseUrl + "/api/AgencyAdmin/{personId}/details";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgencyAdminUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgencyAdminUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgencyAdminProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgencyAdminProfile>;
        }));
    }

    protected processGetAgencyAdminUserProfile(response: HttpResponseBase): Observable<AgencyAdminProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgencyAdminProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAgencyAdminStatusHistory(personId: number): Observable<PersonStatusHistory[]> {
        let url_ = this.baseUrl + "/api/AgencyAdmin/{personId}/history";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgencyAdminStatusHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgencyAdminStatusHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonStatusHistory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonStatusHistory[]>;
        }));
    }

    protected processGetAgencyAdminStatusHistory(response: HttpResponseBase): Observable<PersonStatusHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonStatusHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAgencyAdminHistory(personId: number, body?: GetHistoryRequestBase | undefined): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/AgencyAdmin/details/{personId}/history";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgencyAdminHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgencyAdminHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetAgencyAdminHistory(response: HttpResponseBase): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getArea(): Observable<Areas[]> {
        let url_ = this.baseUrl + "/api/Area";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Areas[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Areas[]>;
        }));
    }

    protected processGetArea(response: HttpResponseBase): Observable<Areas[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Areas.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitAttestation(body?: SubmitAttestationCommand | undefined): Observable<Int32Response> {
        let url_ = this.baseUrl + "/api/attestation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitAttestation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitAttestation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32Response>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32Response>;
        }));
    }

    protected processSubmitAttestation(response: HttpResponseBase): Observable<Int32Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Int32Response.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32Response.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAttestationById(attestationId: number): Observable<AttestationResponseV2> {
        let url_ = this.baseUrl + "/api/attestation/{attestationId}";
        if (attestationId === undefined || attestationId === null)
            throw new Error("The parameter 'attestationId' must be defined.");
        url_ = url_.replace("{attestationId}", encodeURIComponent("" + attestationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttestationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttestationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttestationResponseV2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttestationResponseV2>;
        }));
    }

    protected processGetAttestationById(response: HttpResponseBase): Observable<AttestationResponseV2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttestationResponseV2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAttestation(attestationId: number, body?: UpdateAttestationCommand | undefined): Observable<Int32Response> {
        let url_ = this.baseUrl + "/api/attestation/{attestationId}";
        if (attestationId === undefined || attestationId === null)
            throw new Error("The parameter 'attestationId' must be defined.");
        url_ = url_.replace("{attestationId}", encodeURIComponent("" + attestationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAttestation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAttestation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32Response>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32Response>;
        }));
    }

    protected processUpdateAttestation(response: HttpResponseBase): Observable<Int32Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Int32Response.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32Response.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAttestationHistoryById(attestationResponseId: number, body?: GetHistoryRequestBase | undefined): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/attestation/{attestationResponseId}/getattestationhistory";
        if (attestationResponseId === undefined || attestationResponseId === null)
            throw new Error("The parameter 'attestationResponseId' must be defined.");
        url_ = url_.replace("{attestationResponseId}", encodeURIComponent("" + attestationResponseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttestationHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttestationHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetAttestationHistoryById(response: HttpResponseBase): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverAttestation(caregiverId: number, body?: GetAttestationCommand | undefined): Observable<AttestationResponseV2[]> {
        let url_ = this.baseUrl + "/api/attestation/caregiver/{caregiverId}";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverAttestation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverAttestation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttestationResponseV2[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttestationResponseV2[]>;
        }));
    }

    protected processGetCaregiverAttestation(response: HttpResponseBase): Observable<AttestationResponseV2[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttestationResponseV2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAttestationForm(body?: AttestationFormRequest | undefined): Observable<AttestationFormResponse> {
        let url_ = this.baseUrl + "/api/attestation/form";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttestationForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttestationForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttestationFormResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttestationFormResponse>;
        }));
    }

    protected processGetAttestationForm(response: HttpResponseBase): Observable<AttestationFormResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttestationFormResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caregiverId (optional) 
     * @param participantId (optional) 
     * @return Success
     */
    getAttestationResponse(caregiverId?: number | undefined, participantId?: number | undefined): Observable<AttestationResponse[]> {
        let url_ = this.baseUrl + "/api/attestation/response?";
        if (caregiverId === null)
            throw new Error("The parameter 'caregiverId' cannot be null.");
        else if (caregiverId !== undefined)
            url_ += "caregiverId=" + encodeURIComponent("" + caregiverId) + "&";
        if (participantId === null)
            throw new Error("The parameter 'participantId' cannot be null.");
        else if (participantId !== undefined)
            url_ += "participantId=" + encodeURIComponent("" + participantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttestationResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttestationResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttestationResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttestationResponse[]>;
        }));
    }

    protected processGetAttestationResponse(response: HttpResponseBase): Observable<AttestationResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttestationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAttestationTypes(): Observable<AttestationTypeDto[]> {
        let url_ = this.baseUrl + "/api/attestation/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttestationTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttestationTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttestationTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttestationTypeDto[]>;
        }));
    }

    protected processGetAttestationTypes(response: HttpResponseBase): Observable<AttestationTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttestationTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllAttestationStatus(): Observable<AttestationStatusDto[]> {
        let url_ = this.baseUrl + "/api/attestationstatus/all/details";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAttestationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAttestationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttestationStatusDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttestationStatusDto[]>;
        }));
    }

    protected processGetAllAttestationStatus(response: HttpResponseBase): Observable<AttestationStatusDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttestationStatusDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAttestationInternalstatusDetails(): Observable<AttestationStatusDto[]> {
        let url_ = this.baseUrl + "/api/attestationstatus/internal/details";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttestationInternalstatusDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttestationInternalstatusDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttestationStatusDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttestationStatusDto[]>;
        }));
    }

    protected processGetAttestationInternalstatusDetails(response: HttpResponseBase): Observable<AttestationStatusDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttestationStatusDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCareerHourRatePeriod(body?: CareerHourRatePeriodRequest | undefined): Observable<CareerHourRatePeriodGridResponseBase> {
        let url_ = this.baseUrl + "/api/CareerHour/period";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCareerHourRatePeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCareerHourRatePeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourRatePeriodGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourRatePeriodGridResponseBase>;
        }));
    }

    protected processCreateCareerHourRatePeriod(response: HttpResponseBase): Observable<CareerHourRatePeriodGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CareerHourRatePeriodGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCareerHourRatePeriod(body?: CareerHourRatePeriodRequest | undefined): Observable<CareerHourRatePeriodGridResponseBase> {
        let url_ = this.baseUrl + "/api/CareerHour/period";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCareerHourRatePeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCareerHourRatePeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourRatePeriodGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourRatePeriodGridResponseBase>;
        }));
    }

    protected processUpdateCareerHourRatePeriod(response: HttpResponseBase): Observable<CareerHourRatePeriodGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CareerHourRatePeriodGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCareerHourRateByPeriodId(careerHourRatePeriodId: number): Observable<CareerHourRate[]> {
        let url_ = this.baseUrl + "/api/CareerHour/period/{careerHourRatePeriodId}/rate";
        if (careerHourRatePeriodId === undefined || careerHourRatePeriodId === null)
            throw new Error("The parameter 'careerHourRatePeriodId' must be defined.");
        url_ = url_.replace("{careerHourRatePeriodId}", encodeURIComponent("" + careerHourRatePeriodId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCareerHourRateByPeriodId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCareerHourRateByPeriodId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourRate[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourRate[]>;
        }));
    }

    protected processGetAllCareerHourRateByPeriodId(response: HttpResponseBase): Observable<CareerHourRate[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareerHourRate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkOverlapCareerHourRatePeriod(body?: CareerHourRatePeriodData | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/CareerHour/period/checkoverlap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckOverlapCareerHourRatePeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckOverlapCareerHourRatePeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckOverlapCareerHourRatePeriod(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllCareerHourRatePeriod(body?: FilterRequest | undefined): Observable<CareerHourRatePeriodGridResponseBase> {
        let url_ = this.baseUrl + "/api/CareerHour/period/getall";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCareerHourRatePeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCareerHourRatePeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourRatePeriodGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourRatePeriodGridResponseBase>;
        }));
    }

    protected processGetAllCareerHourRatePeriod(response: HttpResponseBase): Observable<CareerHourRatePeriodGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CareerHourRatePeriodGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCareerHourRateByPeriodId(body?: CareerHourRateRequest | undefined): Observable<CareerHourRate[]> {
        let url_ = this.baseUrl + "/api/CareerHour/period/rate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCareerHourRateByPeriodId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCareerHourRateByPeriodId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourRate[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourRate[]>;
        }));
    }

    protected processCreateCareerHourRateByPeriodId(response: HttpResponseBase): Observable<CareerHourRate[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareerHourRate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCareerHourRateByPeriodId(body?: CareerHourRateRequest | undefined): Observable<CareerHourRate[]> {
        let url_ = this.baseUrl + "/api/CareerHour/period/rate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCareerHourRateByPeriodId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCareerHourRateByPeriodId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourRate[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourRate[]>;
        }));
    }

    protected processUpdateCareerHourRateByPeriodId(response: HttpResponseBase): Observable<CareerHourRate[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareerHourRate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCareerHourRateModifierByCareerHourRateId(careerHourRateId: number): Observable<CareerHourRateModifier[]> {
        let url_ = this.baseUrl + "/api/CareerHour/period/rate/{careerHourRateId}/modifier";
        if (careerHourRateId === undefined || careerHourRateId === null)
            throw new Error("The parameter 'careerHourRateId' must be defined.");
        url_ = url_.replace("{careerHourRateId}", encodeURIComponent("" + careerHourRateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCareerHourRateModifierByCareerHourRateId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCareerHourRateModifierByCareerHourRateId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourRateModifier[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourRateModifier[]>;
        }));
    }

    protected processGetAllCareerHourRateModifierByCareerHourRateId(response: HttpResponseBase): Observable<CareerHourRateModifier[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareerHourRateModifier.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCareerHourRateModifierByCareerHourRateId(body?: CareerHourRateModifierRequest | undefined): Observable<CareerHourRateModifier[]> {
        let url_ = this.baseUrl + "/api/CareerHour/period/rate/modifier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCareerHourRateModifierByCareerHourRateId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCareerHourRateModifierByCareerHourRateId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourRateModifier[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourRateModifier[]>;
        }));
    }

    protected processCreateCareerHourRateModifierByCareerHourRateId(response: HttpResponseBase): Observable<CareerHourRateModifier[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareerHourRateModifier.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCareerHourRateModifierByCareerHourRateId(body?: CareerHourRateModifierRequest | undefined): Observable<CareerHourRateModifier[]> {
        let url_ = this.baseUrl + "/api/CareerHour/period/rate/modifier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCareerHourRateModifierByCareerHourRateId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCareerHourRateModifierByCareerHourRateId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourRateModifier[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourRateModifier[]>;
        }));
    }

    protected processUpdateCareerHourRateModifierByCareerHourRateId(response: HttpResponseBase): Observable<CareerHourRateModifier[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareerHourRateModifier.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCareerHourRateModifierQualificationByCareerHourRateModifierId(careerHourRateModifierId: number): Observable<CareerHourRateModifierQualification[]> {
        let url_ = this.baseUrl + "/api/CareerHour/period/rate/modifier/{careerHourRateModifierId}/qualification";
        if (careerHourRateModifierId === undefined || careerHourRateModifierId === null)
            throw new Error("The parameter 'careerHourRateModifierId' must be defined.");
        url_ = url_.replace("{careerHourRateModifierId}", encodeURIComponent("" + careerHourRateModifierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCareerHourRateModifierQualificationByCareerHourRateModifierId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCareerHourRateModifierQualificationByCareerHourRateModifierId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourRateModifierQualification[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourRateModifierQualification[]>;
        }));
    }

    protected processGetAllCareerHourRateModifierQualificationByCareerHourRateModifierId(response: HttpResponseBase): Observable<CareerHourRateModifierQualification[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareerHourRateModifierQualification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCareerHourRateModifierQualificationByCareerHourRateModifierId(body?: CareerHourRateModifierQualificationRequest | undefined): Observable<CareerHourRateModifierQualification[]> {
        let url_ = this.baseUrl + "/api/CareerHour/period/rate/modifier/qualification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCareerHourRateModifierQualificationByCareerHourRateModifierId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCareerHourRateModifierQualificationByCareerHourRateModifierId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourRateModifierQualification[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourRateModifierQualification[]>;
        }));
    }

    protected processCreateCareerHourRateModifierQualificationByCareerHourRateModifierId(response: HttpResponseBase): Observable<CareerHourRateModifierQualification[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareerHourRateModifierQualification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCareerHourRateModifierQualificationByCareerHourRateModifierId(body?: CareerHourRateModifierQualificationRequest | undefined): Observable<CareerHourRateModifierQualification[]> {
        let url_ = this.baseUrl + "/api/CareerHour/period/rate/modifier/qualification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCareerHourRateModifierQualificationByCareerHourRateModifierId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCareerHourRateModifierQualificationByCareerHourRateModifierId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourRateModifierQualification[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourRateModifierQualification[]>;
        }));
    }

    protected processUpdateCareerHourRateModifierQualificationByCareerHourRateModifierId(response: HttpResponseBase): Observable<CareerHourRateModifierQualification[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareerHourRateModifierQualification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllQualificaion(): Observable<Qualification[]> {
        let url_ = this.baseUrl + "/api/CareerHour/qualification";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllQualificaion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllQualificaion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Qualification[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Qualification[]>;
        }));
    }

    protected processGetAllQualificaion(response: HttpResponseBase): Observable<Qualification[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Qualification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCareerHourInfo(body?: CareerHourQualificationInfoRequest | undefined): Observable<CareerHourQualificationInfoResponse[]> {
        let url_ = this.baseUrl + "/api/CareerHour/qualificationinfo/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCareerHourInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCareerHourInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourQualificationInfoResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourQualificationInfoResponse[]>;
        }));
    }

    protected processGetCareerHourInfo(response: HttpResponseBase): Observable<CareerHourQualificationInfoResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareerHourQualificationInfoResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCareerHourRateInfo(): Observable<CareerHourRateInfo[]> {
        let url_ = this.baseUrl + "/api/CareerHour/rateinfo/fetch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCareerHourRateInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCareerHourRateInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourRateInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourRateInfo[]>;
        }));
    }

    protected processGetCareerHourRateInfo(response: HttpResponseBase): Observable<CareerHourRateInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareerHourRateInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveCareerHourLogAdjustment(body?: SaveCareerHourLogRequest[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/CareerHourLog/adjustment/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCareerHourLogAdjustment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCareerHourLogAdjustment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processSaveCareerHourLogAdjustment(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCareerHourLogBySearchCriteria(body?: CareerHourLogSearchRequest | undefined): Observable<CareerHourLogResponseGridResponseBase> {
        let url_ = this.baseUrl + "/api/CareerHourLog/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCareerHourLogBySearchCriteria(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCareerHourLogBySearchCriteria(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourLogResponseGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourLogResponseGridResponseBase>;
        }));
    }

    protected processGetCareerHourLogBySearchCriteria(response: HttpResponseBase): Observable<CareerHourLogResponseGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CareerHourLogResponseGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCareerHourLogTypes(): Observable<CareerHourLogType[]> {
        let url_ = this.baseUrl + "/api/CareerHourLog/type/fetch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCareerHourLogTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCareerHourLogTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourLogType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourLogType[]>;
        }));
    }

    protected processGetCareerHourLogTypes(response: HttpResponseBase): Observable<CareerHourLogType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareerHourLogType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveCaregiver(body?: CareGiverDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/caregiver";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCaregiver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCaregiver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveCaregiver(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCaregiverParticipantRelationshipFromProspect(body?: number | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/caregiver-participant/prospect/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCaregiverParticipantRelationshipFromProspect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCaregiverParticipantRelationshipFromProspect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateCaregiverParticipantRelationshipFromProspect(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportCaregiverParticipantProspect(body?: ExportCaregiverParticipantProspectCommand | undefined): Observable<ResponseModelResultSet> {
        let url_ = this.baseUrl + "/api/caregiver-participant/prospect/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCaregiverParticipantProspect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCaregiverParticipantProspect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModelResultSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModelResultSet>;
        }));
    }

    protected processExportCaregiverParticipantProspect(response: HttpResponseBase): Observable<ResponseModelResultSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModelResultSet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchCaregiverParticipantProspect(body?: SearchCaregiverParticipantProspectCommand | undefined): Observable<CaregiverParticipantRequestRelationConfirmationDtoResultSet> {
        let url_ = this.baseUrl + "/api/caregiver-participant/prospect/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchCaregiverParticipantProspect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCaregiverParticipantProspect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverParticipantRequestRelationConfirmationDtoResultSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverParticipantRequestRelationConfirmationDtoResultSet>;
        }));
    }

    protected processSearchCaregiverParticipantProspect(response: HttpResponseBase): Observable<CaregiverParticipantRequestRelationConfirmationDtoResultSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverParticipantRequestRelationConfirmationDtoResultSet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCaregiverParticipantProspect(body?: CaregiverParticipantRequestRelationConfirmationDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/caregiver-participant/prospect/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaregiverParticipantProspect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaregiverParticipantProspect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateCaregiverParticipantProspect(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyCaregiverParticipantRelationshipFromProspect(body?: number | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/caregiver-participant/prospect/verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyCaregiverParticipantRelationshipFromProspect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyCaregiverParticipantRelationshipFromProspect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processVerifyCaregiverParticipantRelationshipFromProspect(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteProspectiveRelationship(body?: ProspectiveRelationshipDeleteRequest | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/caregiver-participant/prospective-relationship/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProspectiveRelationship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProspectiveRelationship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processDeleteProspectiveRelationship(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    updateCaregiverBackgroundCheckStatusApprove(caregiverId: string): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/caregiver/{caregiverId}/attestation/backgroundcheck/approve";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaregiverBackgroundCheckStatusApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaregiverBackgroundCheckStatusApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateCaregiverBackgroundCheckStatusApprove(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    updateCaregiverBackgroundCheckStatusReject(caregiverId: string): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/caregiver/{caregiverId}/attestation/backgroundcheck/reject";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaregiverBackgroundCheckStatusReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaregiverBackgroundCheckStatusReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateCaregiverBackgroundCheckStatusReject(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    updateCaregiverDemographicStatusApprove(caregiverId: string): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/caregiver/{caregiverId}/attestation/demographic/approve";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaregiverDemographicStatusApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaregiverDemographicStatusApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateCaregiverDemographicStatusApprove(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverDemographicDetails(caregiverId: string): Observable<CaregiverDemographicDetails> {
        let url_ = this.baseUrl + "/api/caregiver/{caregiverId}/attestation/demographic/details";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverDemographicDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverDemographicDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverDemographicDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverDemographicDetails>;
        }));
    }

    protected processGetCaregiverDemographicDetails(response: HttpResponseBase): Observable<CaregiverDemographicDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverDemographicDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    updateCaregiverDemographicStatusReject(caregiverId: string): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/caregiver/{caregiverId}/attestation/demographic/reject";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaregiverDemographicStatusReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaregiverDemographicStatusReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateCaregiverDemographicStatusReject(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverAttestationStatusDetails(caregiverId: number): Observable<CaregiverAttestationStatusDetailsDto> {
        let url_ = this.baseUrl + "/api/caregiver/{caregiverId}/attestation/details";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverAttestationStatusDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverAttestationStatusDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverAttestationStatusDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverAttestationStatusDetailsDto>;
        }));
    }

    protected processGetCaregiverAttestationStatusDetails(response: HttpResponseBase): Observable<CaregiverAttestationStatusDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverAttestationStatusDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverAttestationQualifications(caregiverId: string): Observable<CaregiverQualificationTypeGridResponseBase> {
        let url_ = this.baseUrl + "/api/caregiver/{caregiverId}/attestation/qualification";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverAttestationQualifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverAttestationQualifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverQualificationTypeGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverQualificationTypeGridResponseBase>;
        }));
    }

    protected processGetCaregiverAttestationQualifications(response: HttpResponseBase): Observable<CaregiverQualificationTypeGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverQualificationTypeGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverAttestationStatus(caregiverId: string): Observable<CaregiverAttestationStatusResponse> {
        let url_ = this.baseUrl + "/api/caregiver/{caregiverId}/attestation/status";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverAttestationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverAttestationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverAttestationStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverAttestationStatusResponse>;
        }));
    }

    protected processGetCaregiverAttestationStatus(response: HttpResponseBase): Observable<CaregiverAttestationStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverAttestationStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    updateCaregiverTrainingStatusApprove(caregiverId: string): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/caregiver/{caregiverId}/attestation/training/approve";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaregiverTrainingStatusApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaregiverTrainingStatusApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateCaregiverTrainingStatusApprove(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    updateCaregiverTrainingStatusReject(caregiverId: string): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/caregiver/{caregiverId}/attestation/training/reject";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaregiverTrainingStatusReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaregiverTrainingStatusReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateCaregiverTrainingStatusReject(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCaregiverAttestationStatusDetails(caregiverId: string, body?: CaregiverAttestationStatus | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/caregiver/{caregiverId}/attestation/update";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaregiverAttestationStatusDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaregiverAttestationStatusDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateCaregiverAttestationStatusDetails(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverCCH(caregiverId: string): Observable<CaregiverCch> {
        let url_ = this.baseUrl + "/api/caregiver/{caregiverId}/cch";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverCCH(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverCCH(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverCch>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverCch>;
        }));
    }

    protected processGetCaregiverCCH(response: HttpResponseBase): Observable<CaregiverCch> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverCch.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverEmployerList(caregiverId: number): Observable<CaregiverEmployerList[]> {
        let url_ = this.baseUrl + "/api/caregiver/{caregiverId}/employerlist";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverEmployerList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverEmployerList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverEmployerList[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverEmployerList[]>;
        }));
    }

    protected processGetCaregiverEmployerList(response: HttpResponseBase): Observable<CaregiverEmployerList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverEmployerList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverEmployerOfRecordList(caregiverId: number): Observable<CaregiverEmployerOfRecordList[]> {
        let url_ = this.baseUrl + "/api/caregiver/{caregiverId}/employerofrecordlist";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverEmployerOfRecordList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverEmployerOfRecordList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverEmployerOfRecordList[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverEmployerOfRecordList[]>;
        }));
    }

    protected processGetCaregiverEmployerOfRecordList(response: HttpResponseBase): Observable<CaregiverEmployerOfRecordList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverEmployerOfRecordList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverHistory(caregiverId: number, type: string): Observable<CaregiverHistory[]> {
        let url_ = this.baseUrl + "/api/caregiver/{caregiverId}/history/{type}";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverHistory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverHistory[]>;
        }));
    }

    protected processGetCaregiverHistory(response: HttpResponseBase): Observable<CaregiverHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiver(personId: string): Observable<CaregiverDetails> {
        let url_ = this.baseUrl + "/api/caregiver/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverDetails>;
        }));
    }

    protected processGetCaregiver(response: HttpResponseBase): Observable<CaregiverDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverQualificationsByPersonId(personId: string): Observable<CaregiverQualificationTypeGridResponseBase> {
        let url_ = this.baseUrl + "/api/caregiver/{personId}/fetch";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverQualificationsByPersonId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverQualificationsByPersonId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverQualificationTypeGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverQualificationTypeGridResponseBase>;
        }));
    }

    protected processGetCaregiverQualificationsByPersonId(response: HttpResponseBase): Observable<CaregiverQualificationTypeGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverQualificationTypeGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverDetailsHistoryById(personId: number, body?: GetHistoryRequestBase | undefined): Observable<HistoryRecordGridResponseBase> {
        let url_ = this.baseUrl + "/api/caregiver/{personId}/History";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverDetailsHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverDetailsHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HistoryRecordGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HistoryRecordGridResponseBase>;
        }));
    }

    protected processGetCaregiverDetailsHistoryById(response: HttpResponseBase): Observable<HistoryRecordGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HistoryRecordGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getWithinGracePeriod(body?: WithinGracePeriodRequest | undefined): Observable<WithinGracePeriodResponse> {
        let url_ = this.baseUrl + "/api/caregiver/allgraceperiods";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWithinGracePeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWithinGracePeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WithinGracePeriodResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WithinGracePeriodResponse>;
        }));
    }

    protected processGetWithinGracePeriod(response: HttpResponseBase): Observable<WithinGracePeriodResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WithinGracePeriodResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiversAttestationStatus(body?: GetCaregiversAttestationStatusCommand | undefined): Observable<CaregiverAttestationStatusResultSet> {
        let url_ = this.baseUrl + "/api/caregiver/attestation/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiversAttestationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiversAttestationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverAttestationStatusResultSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverAttestationStatusResultSet>;
        }));
    }

    protected processGetCaregiversAttestationStatus(response: HttpResponseBase): Observable<CaregiverAttestationStatusResultSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverAttestationStatusResultSet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiversByPayors(body?: CaregiverFilterRequest | undefined): Observable<CaregiverLkpDTOGridResponseBase> {
        let url_ = this.baseUrl + "/api/caregiver/bypayor/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiversByPayors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiversByPayors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverLkpDTOGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverLkpDTOGridResponseBase>;
        }));
    }

    protected processGetCaregiversByPayors(response: HttpResponseBase): Observable<CaregiverLkpDTOGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverLkpDTOGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param showInactive (optional) 
     * @param showDefault (optional) 
     * @return Success
     */
    getAllQualificationRoleTypes(showInactive?: boolean | undefined, showDefault?: boolean | undefined): Observable<QualificationRole[]> {
        let url_ = this.baseUrl + "/api/caregiver/caregiverroletype/getall?";
        if (showInactive === null)
            throw new Error("The parameter 'showInactive' cannot be null.");
        else if (showInactive !== undefined)
            url_ += "showInactive=" + encodeURIComponent("" + showInactive) + "&";
        if (showDefault === null)
            throw new Error("The parameter 'showDefault' cannot be null.");
        else if (showDefault !== undefined)
            url_ += "showDefault=" + encodeURIComponent("" + showDefault) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllQualificationRoleTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllQualificationRoleTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualificationRole[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualificationRole[]>;
        }));
    }

    protected processGetAllQualificationRoleTypes(response: HttpResponseBase): Observable<QualificationRole[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QualificationRole.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCareerHourLog(body?: CareerHourLogRequest[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/caregiver/cch/upsertlog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCareerHourLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCareerHourLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateCareerHourLog(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverCchDetails(caregiverId: string, body?: FilterRequest | undefined): Observable<CchDetailsGridResponseBase> {
        let url_ = this.baseUrl + "/api/caregiver/cchDetails/{caregiverId}";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverCchDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverCchDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CchDetailsGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CchDetailsGridResponseBase>;
        }));
    }

    protected processGetCaregiverCchDetails(response: HttpResponseBase): Observable<CchDetailsGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CchDetailsGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCaregiverConversionRecords(): Observable<CaregiverConversionResponse> {
        let url_ = this.baseUrl + "/api/caregiver/conversion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCaregiverConversionRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCaregiverConversionRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverConversionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverConversionResponse>;
        }));
    }

    protected processGetAllCaregiverConversionRecords(response: HttpResponseBase): Observable<CaregiverConversionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverConversionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCaregiverConversionRecords(body?: CaregiverConversionUpdateRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/caregiver/conversion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaregiverConversionRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaregiverConversionRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateCaregiverConversionRecords(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    completeCaregiverConversionRecords(body?: CaregiverConversionCompleteRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/caregiver/conversion/complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteCaregiverConversionRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteCaregiverConversionRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCompleteCaregiverConversionRecords(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllParticipantRelationshipsByCaregiver(body?: CaregiverRelatedParticipantsRequest | undefined): Observable<ParticipantRelationshipData[]> {
        let url_ = this.baseUrl + "/api/caregiver/fetch/participants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllParticipantRelationshipsByCaregiver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllParticipantRelationshipsByCaregiver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantRelationshipData[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantRelationshipData[]>;
        }));
    }

    protected processGetAllParticipantRelationshipsByCaregiver(response: HttpResponseBase): Observable<ParticipantRelationshipData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParticipantRelationshipData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverGhaGracePeriod(body?: WithinGracePeriodRequest | undefined): Observable<WithinGracePeriodResponse> {
        let url_ = this.baseUrl + "/api/caregiver/gha/graceperiod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverGhaGracePeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverGhaGracePeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WithinGracePeriodResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WithinGracePeriodResponse>;
        }));
    }

    protected processGetCaregiverGhaGracePeriod(response: HttpResponseBase): Observable<WithinGracePeriodResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WithinGracePeriodResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverGracePeriod(body?: CaregiverGracePeriodRequest | undefined): Observable<GracePeriodOverrideResponse> {
        let url_ = this.baseUrl + "/api/caregiver/graceperiod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverGracePeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverGracePeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GracePeriodOverrideResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GracePeriodOverrideResponse>;
        }));
    }

    protected processGetCaregiverGracePeriod(response: HttpResponseBase): Observable<GracePeriodOverrideResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GracePeriodOverrideResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCaregiverGracePeriod(body?: CaregiverGracePeriod[] | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/caregiver/graceperiod/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCaregiverGracePeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCaregiverGracePeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processCreateCaregiverGracePeriod(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverGracePeriodByMapping(mapping: number): Observable<CaregiverGracePeriod[]> {
        let url_ = this.baseUrl + "/api/caregiver/graceperiod/get/{mapping}";
        if (mapping === undefined || mapping === null)
            throw new Error("The parameter 'mapping' must be defined.");
        url_ = url_.replace("{mapping}", encodeURIComponent("" + mapping));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverGracePeriodByMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverGracePeriodByMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverGracePeriod[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverGracePeriod[]>;
        }));
    }

    protected processGetCaregiverGracePeriodByMapping(response: HttpResponseBase): Observable<CaregiverGracePeriod[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverGracePeriod.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCaregiverGracePeriod(body?: CaregiverGracePeriod[] | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/caregiver/graceperiod/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaregiverGracePeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaregiverGracePeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processUpdateCaregiverGracePeriod(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     * @deprecated
     */
    getOkToWorkStatus(body?: OkToWorkStatusRequest | undefined): Observable<OkToWorkStatusResponse> {
        let url_ = this.baseUrl + "/api/caregiver/oktoworkstatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOkToWorkStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOkToWorkStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OkToWorkStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OkToWorkStatusResponse>;
        }));
    }

    protected processGetOkToWorkStatus(response: HttpResponseBase): Observable<OkToWorkStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OkToWorkStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caregiverId (optional) 
     * @param participantId (optional) 
     * @param body (optional) 
     * @return Success
     */
    deleteCaregiverParticipantAttestationResponses(caregiverId?: number | undefined, participantId?: number | undefined, body?: AttestationResponse[] | undefined): Observable<AttestationResponse[]> {
        let url_ = this.baseUrl + "/api/caregiver/participant/attestationresponse/delete?";
        if (caregiverId === null)
            throw new Error("The parameter 'caregiverId' cannot be null.");
        else if (caregiverId !== undefined)
            url_ += "caregiverId=" + encodeURIComponent("" + caregiverId) + "&";
        if (participantId === null)
            throw new Error("The parameter 'participantId' cannot be null.");
        else if (participantId !== undefined)
            url_ += "participantId=" + encodeURIComponent("" + participantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCaregiverParticipantAttestationResponses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCaregiverParticipantAttestationResponses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttestationResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttestationResponse[]>;
        }));
    }

    protected processDeleteCaregiverParticipantAttestationResponses(response: HttpResponseBase): Observable<AttestationResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttestationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caregiverId (optional) 
     * @param participantId (optional) 
     * @param body (optional) 
     * @return Success
     */
    upsertCaregiverParticipantAttestationResponses(caregiverId?: number | undefined, participantId?: number | undefined, body?: AttestationResponse[] | undefined): Observable<AttestationResponse[]> {
        let url_ = this.baseUrl + "/api/caregiver/participant/attestationresponse/upsert?";
        if (caregiverId === null)
            throw new Error("The parameter 'caregiverId' cannot be null.");
        else if (caregiverId !== undefined)
            url_ += "caregiverId=" + encodeURIComponent("" + caregiverId) + "&";
        if (participantId === null)
            throw new Error("The parameter 'participantId' cannot be null.");
        else if (participantId !== undefined)
            url_ += "participantId=" + encodeURIComponent("" + participantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertCaregiverParticipantAttestationResponses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCaregiverParticipantAttestationResponses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttestationResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttestationResponse[]>;
        }));
    }

    protected processUpsertCaregiverParticipantAttestationResponses(response: HttpResponseBase): Observable<AttestationResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttestationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverParticipantLiveInDates(body?: CaregiverParticipantLiveInDatesRequest | undefined): Observable<CaregiverParticipantLiveInDatesResponse[]> {
        let url_ = this.baseUrl + "/api/caregiver/participant/liveindates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverParticipantLiveInDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverParticipantLiveInDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverParticipantLiveInDatesResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverParticipantLiveInDatesResponse[]>;
        }));
    }

    protected processGetCaregiverParticipantLiveInDates(response: HttpResponseBase): Observable<CaregiverParticipantLiveInDatesResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverParticipantLiveInDatesResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveCaregiverParticipantRequestRelationConfirmation(body?: CaregiverParticipantRequestRelationConfirmationDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/caregiver/participant/requestrelationship/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCaregiverParticipantRequestRelationConfirmation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCaregiverParticipantRequestRelationConfirmation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processSaveCaregiverParticipantRequestRelationConfirmation(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverParticipantRelConfirmationAttestationDetails(personId: number): Observable<CaregiverParticipantReqRelConfirmationStatusDetailsDto> {
        let url_ = this.baseUrl + "/api/caregiver/participantlist/relation/confirmation/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverParticipantRelConfirmationAttestationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverParticipantRelConfirmationAttestationDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverParticipantReqRelConfirmationStatusDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverParticipantReqRelConfirmationStatusDetailsDto>;
        }));
    }

    protected processGetCaregiverParticipantRelConfirmationAttestationDetails(response: HttpResponseBase): Observable<CaregiverParticipantReqRelConfirmationStatusDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverParticipantReqRelConfirmationStatusDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverRelatedParticipants(body?: CaregiverRelatedParticipantsRequest | undefined): Observable<CustEmpRelResponseDto[]> {
        let url_ = this.baseUrl + "/api/caregiver/participants/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverRelatedParticipants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverRelatedParticipants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustEmpRelResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustEmpRelResponseDto[]>;
        }));
    }

    protected processGetCaregiverRelatedParticipants(response: HttpResponseBase): Observable<CustEmpRelResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustEmpRelResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverProfile(personId: string): Observable<CaregiverProfile> {
        let url_ = this.baseUrl + "/api/caregiver/profile/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverProfile>;
        }));
    }

    protected processGetCaregiverProfile(response: HttpResponseBase): Observable<CaregiverProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverProfileWithNoExtras(personId: string, svcDate: Date): Observable<CaregiverProfile> {
        let url_ = this.baseUrl + "/api/caregiver/profile/{personId}/{svcDate}/noextras";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (svcDate === undefined || svcDate === null)
            throw new Error("The parameter 'svcDate' must be defined.");
        url_ = url_.replace("{svcDate}", encodeURIComponent(svcDate ? "" + svcDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverProfileWithNoExtras(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverProfileWithNoExtras(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverProfile>;
        }));
    }

    protected processGetCaregiverProfileWithNoExtras(response: HttpResponseBase): Observable<CaregiverProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverQualificationTypeExpirationDate(body?: CaregiverQualificationTypeExpirationDateRequest | undefined): Observable<Date> {
        let url_ = this.baseUrl + "/api/caregiver/qualification/expirationdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverQualificationTypeExpirationDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverQualificationTypeExpirationDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Date>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Date>;
        }));
    }

    protected processGetCaregiverQualificationTypeExpirationDate(response: HttpResponseBase): Observable<Date> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertQualificationRoleTypes(body?: QualificationRoleTypesRequest | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/caregiver/qualification/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertQualificationRoleTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertQualificationRoleTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpsertQualificationRoleTypes(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverQualificationTypeStart(body?: EventHarvestorRequest | undefined): Observable<CaregiverQualificationStartResponse[]> {
        let url_ = this.baseUrl + "/api/caregiver/qualification/start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverQualificationTypeStart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverQualificationTypeStart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverQualificationStartResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverQualificationStartResponse[]>;
        }));
    }

    protected processGetCaregiverQualificationTypeStart(response: HttpResponseBase): Observable<CaregiverQualificationStartResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverQualificationStartResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllCaregiverQualificationTypeByCaregiverId(body?: CaregiverQualificationGridRequest | undefined): Observable<CaregiverQualificationTypeGridResponseBase> {
        let url_ = this.baseUrl + "/api/caregiver/qualificationtype/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCaregiverQualificationTypeByCaregiverId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCaregiverQualificationTypeByCaregiverId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverQualificationTypeGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverQualificationTypeGridResponseBase>;
        }));
    }

    protected processGetAllCaregiverQualificationTypeByCaregiverId(response: HttpResponseBase): Observable<CaregiverQualificationTypeGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverQualificationTypeGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverQualificationTypeMappingAndQualTypeByExpDate(body?: CaregiverQualificationNotifyRequest | undefined): Observable<CaregiverQualificationNotifyResponse[]> {
        let url_ = this.baseUrl + "/api/caregiver/qualificationtypemappingandqualtype/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverQualificationTypeMappingAndQualTypeByExpDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverQualificationTypeMappingAndQualTypeByExpDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverQualificationNotifyResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverQualificationNotifyResponse[]>;
        }));
    }

    protected processGetCaregiverQualificationTypeMappingAndQualTypeByExpDate(response: HttpResponseBase): Observable<CaregiverQualificationNotifyResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverQualificationNotifyResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverParticipantRelStatusDateRange(caregiverId: string, participantId: string): Observable<CaregiverParticipantRelStatusDateRange[]> {
        let url_ = this.baseUrl + "/api/caregiver/relationshipstatusrange/{caregiverId}/{participantId}";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverParticipantRelStatusDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverParticipantRelStatusDateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverParticipantRelStatusDateRange[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverParticipantRelStatusDateRange[]>;
        }));
    }

    protected processGetCaregiverParticipantRelStatusDateRange(response: HttpResponseBase): Observable<CaregiverParticipantRelStatusDateRange[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverParticipantRelStatusDateRange.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRoleQualification(body?: CaregiverRoleTypeQualificationList | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/caregiver/role/qualifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRoleQualification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRoleQualification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateRoleQualification(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCaregiverRoleTypeQualification(qualificationRoleTypeId: number): Observable<CaregiverRoleTypeQualificationList> {
        let url_ = this.baseUrl + "/api/caregiver/role/qualifications/{qualificationRoleTypeId}";
        if (qualificationRoleTypeId === undefined || qualificationRoleTypeId === null)
            throw new Error("The parameter 'qualificationRoleTypeId' must be defined.");
        url_ = url_.replace("{qualificationRoleTypeId}", encodeURIComponent("" + qualificationRoleTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCaregiverRoleTypeQualification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCaregiverRoleTypeQualification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverRoleTypeQualificationList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverRoleTypeQualificationList>;
        }));
    }

    protected processGetAllCaregiverRoleTypeQualification(response: HttpResponseBase): Observable<CaregiverRoleTypeQualificationList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverRoleTypeQualificationList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRoleQualificationPrereqsubrules(body?: CaregiverRoleTypePrereqSubRule[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/caregiver/role/qualificationsprereqsubrule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRoleQualificationPrereqsubrules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRoleQualificationPrereqsubrules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateRoleQualificationPrereqsubrules(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverRoles(personId: number): Observable<QualificationRole[]> {
        let url_ = this.baseUrl + "/api/caregiver/roles/fetch/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualificationRole[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualificationRole[]>;
        }));
    }

    protected processGetCaregiverRoles(response: HttpResponseBase): Observable<QualificationRole[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QualificationRole.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertCaregiverQualificationRoleType(body?: QualificationRoleDto | undefined): Observable<QualificationRoleDto[]> {
        let url_ = this.baseUrl + "/api/caregiver/upsert/qualification/role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertCaregiverQualificationRoleType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCaregiverQualificationRoleType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualificationRoleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualificationRoleDto[]>;
        }));
    }

    protected processUpsertCaregiverQualificationRoleType(response: HttpResponseBase): Observable<QualificationRoleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if(resultData200?.success == true) {
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(QualificationRoleDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
            }
            else if (resultData200?.message?.trim()) {
                return throwException(resultData200.message, status, _responseText, _headers);
            }
            else {
                return throwException("An unexpected error occurred.", status, _responseText, _headers);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertCaregiverMultipleQualificationRolesType(body?: QualificationRoleDto[] | undefined): Observable<QualificationRoleDto[]> {
        let url_ = this.baseUrl + "/api/caregiver/upsert/qualification/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertCaregiverMultipleQualificationRolesType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCaregiverMultipleQualificationRolesType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualificationRoleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualificationRoleDto[]>;
        }));
    }

    protected processUpsertCaregiverMultipleQualificationRolesType(response: HttpResponseBase): Observable<QualificationRoleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if(resultData200?.success == true) {
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(QualificationRoleDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
            }
            else if (resultData200?.message?.trim()) {
                return throwException(resultData200.message, status, _responseText, _headers);
            }
            else {
                return throwException("An unexpected error occurred.", status, _responseText, _headers);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertCaregiverWWL(body?: CaregiverWWLListRequest | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/caregiver/wwl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertCaregiverWWL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCaregiverWWL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpsertCaregiverWWL(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCaregiverWWLByCaregiverEmployerMappingId(caregiverEmployerMappingId: number): Observable<CaregiverWWLListResponse> {
        let url_ = this.baseUrl + "/api/caregiver/wwl/{caregiverEmployerMappingId}";
        if (caregiverEmployerMappingId === undefined || caregiverEmployerMappingId === null)
            throw new Error("The parameter 'caregiverEmployerMappingId' must be defined.");
        url_ = url_.replace("{caregiverEmployerMappingId}", encodeURIComponent("" + caregiverEmployerMappingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCaregiverWWLByCaregiverEmployerMappingId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCaregiverWWLByCaregiverEmployerMappingId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverWWLListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverWWLListResponse>;
        }));
    }

    protected processGetAllCaregiverWWLByCaregiverEmployerMappingId(response: HttpResponseBase): Observable<CaregiverWWLListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverWWLListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverWWLByEmployer(body?: CaregiverWWLByEmployerRequest | undefined): Observable<CaregiverWeeklyWWL[]> {
        let url_ = this.baseUrl + "/api/caregiver/wwl/employer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverWWLByEmployer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverWWLByEmployer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverWeeklyWWL[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverWeeklyWWL[]>;
        }));
    }

    protected processGetCaregiverWWLByEmployer(response: HttpResponseBase): Observable<CaregiverWeeklyWWL[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverWeeklyWWL.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCareGiverWorkWeekLimit(body?: CareGiverWwlRequest | undefined): Observable<CareGiverWwlResponse[]> {
        let url_ = this.baseUrl + "/api/caregiver/wwl/hours/limit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCareGiverWorkWeekLimit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCareGiverWorkWeekLimit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareGiverWwlResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareGiverWwlResponse[]>;
        }));
    }

    protected processGetCareGiverWorkWeekLimit(response: HttpResponseBase): Observable<CareGiverWwlResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareGiverWwlResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteCaregiverCourse(id: string): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/caregivercourse/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCaregiverCourse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCaregiverCourse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteCaregiverCourse(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverCourses(personId: string): Observable<GetCaregiverCourseResponse[]> {
        let url_ = this.baseUrl + "/api/caregivercourse/{personId}/fetch";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverCourses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverCourses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCaregiverCourseResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCaregiverCourseResponse[]>;
        }));
    }

    protected processGetCaregiverCourses(response: HttpResponseBase): Observable<GetCaregiverCourseResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCaregiverCourseResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveCaregiverCourses(body?: SaveCaregiverCourseRequest[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/caregivercourse/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCaregiverCourses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCaregiverCourses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processSaveCaregiverCourses(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRelationByCaregiverIdandEmployerId(caregiverId: number, employerId: number): Observable<CaregiverEmployerRelResponse> {
        let url_ = this.baseUrl + "/api/caregiveremployer/caregiver/{caregiverId}/employer/{employerId}";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        if (employerId === undefined || employerId === null)
            throw new Error("The parameter 'employerId' must be defined.");
        url_ = url_.replace("{employerId}", encodeURIComponent("" + employerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelationByCaregiverIdandEmployerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelationByCaregiverIdandEmployerId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverEmployerRelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverEmployerRelResponse>;
        }));
    }

    protected processGetRelationByCaregiverIdandEmployerId(response: HttpResponseBase): Observable<CaregiverEmployerRelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverEmployerRelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertCaregiverEmployerRelation(caregiverId: number, employerId: number, body?: UpsertCaregiverEmployerRelCommand | undefined): Observable<Int32Response> {
        let url_ = this.baseUrl + "/api/caregiveremployer/caregiver/{caregiverId}/employer/{employerId}";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        if (employerId === undefined || employerId === null)
            throw new Error("The parameter 'employerId' must be defined.");
        url_ = url_.replace("{employerId}", encodeURIComponent("" + employerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertCaregiverEmployerRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCaregiverEmployerRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32Response>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32Response>;
        }));
    }

    protected processUpsertCaregiverEmployerRelation(response: HttpResponseBase): Observable<Int32Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Int32Response.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32Response.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverEmployerRelHistoryById(caregiverEmployerMappingId: number, body?: GetHistoryRequestBase | undefined): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/caregiveremployer/caregiver/caregiveremployerrel/{caregiverEmployerMappingId}/history";
        if (caregiverEmployerMappingId === undefined || caregiverEmployerMappingId === null)
            throw new Error("The parameter 'caregiverEmployerMappingId' must be defined.");
        url_ = url_.replace("{caregiverEmployerMappingId}", encodeURIComponent("" + caregiverEmployerMappingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverEmployerRelHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverEmployerRelHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetCaregiverEmployerRelHistoryById(response: HttpResponseBase): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiversByCaregiverEmployerMappingId(body?: CaregiverEmployerMappingRequest | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/caregiveremployer/caregivers/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiversByCaregiverEmployerMappingId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiversByCaregiverEmployerMappingId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetCaregiversByCaregiverEmployerMappingId(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverEmployerRelationshipStartDate(body?: EventHarvestorRequest | undefined): Observable<CaregiverEmployerRelationshipStartDateResponse[]> {
        let url_ = this.baseUrl + "/api/caregiveremployer/relationship/start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverEmployerRelationshipStartDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverEmployerRelationshipStartDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverEmployerRelationshipStartDateResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverEmployerRelationshipStartDateResponse[]>;
        }));
    }

    protected processGetCaregiverEmployerRelationshipStartDate(response: HttpResponseBase): Observable<CaregiverEmployerRelationshipStartDateResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverEmployerRelationshipStartDateResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverEmployerLkp(body?: CaregiverEmployerFilterRequest | undefined): Observable<CaregiverEmployerLkpDTOGridResponseBase> {
        let url_ = this.baseUrl + "/api/caregiveremployerlkp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverEmployerLkp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverEmployerLkp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverEmployerLkpDTOGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverEmployerLkpDTOGridResponseBase>;
        }));
    }

    protected processGetCaregiverEmployerLkp(response: HttpResponseBase): Observable<CaregiverEmployerLkpDTOGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverEmployerLkpDTOGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertCaregiverParticipantExemptions(caregiverId: number, participantId: number, body?: ExemptionDto[] | undefined): Observable<ExemptionDtoResponseModelWithData> {
        let url_ = this.baseUrl + "/api/caregiverparticipant/exemptions/{caregiverId}/{participantId}";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertCaregiverParticipantExemptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCaregiverParticipantExemptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExemptionDtoResponseModelWithData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExemptionDtoResponseModelWithData>;
        }));
    }

    protected processUpsertCaregiverParticipantExemptions(response: HttpResponseBase): Observable<ExemptionDtoResponseModelWithData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExemptionDtoResponseModelWithData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertCaregiverParticipantLiveInDates(id: number, body?: DateRangeDto[] | undefined): Observable<DateRangeDtoResponseModelWithData> {
        let url_ = this.baseUrl + "/api/caregiverparticipant/liveindates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertCaregiverParticipantLiveInDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCaregiverParticipantLiveInDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateRangeDtoResponseModelWithData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateRangeDtoResponseModelWithData>;
        }));
    }

    protected processUpsertCaregiverParticipantLiveInDates(response: HttpResponseBase): Observable<DateRangeDtoResponseModelWithData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateRangeDtoResponseModelWithData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverParticipantRelationshipStartDate(body?: EventHarvestorRequest | undefined): Observable<CaregiverParticipantRelationshipStartDateResponse[]> {
        let url_ = this.baseUrl + "/api/caregiverparticipant/relationship/start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverParticipantRelationshipStartDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverParticipantRelationshipStartDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverParticipantRelationshipStartDateResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverParticipantRelationshipStartDateResponse[]>;
        }));
    }

    protected processGetCaregiverParticipantRelationshipStartDate(response: HttpResponseBase): Observable<CaregiverParticipantRelationshipStartDateResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverParticipantRelationshipStartDateResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertCaregiverParticipantRelationships(id: number, body?: CaregiverParticipantRelationshipModel[] | undefined): Observable<CaregiverParticipantRelationshipModelResponseModelWithData> {
        let url_ = this.baseUrl + "/api/caregiverparticipant/relationships/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertCaregiverParticipantRelationships(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCaregiverParticipantRelationships(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverParticipantRelationshipModelResponseModelWithData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverParticipantRelationshipModelResponseModelWithData>;
        }));
    }

    protected processUpsertCaregiverParticipantRelationships(response: HttpResponseBase): Observable<CaregiverParticipantRelationshipModelResponseModelWithData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverParticipantRelationshipModelResponseModelWithData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertCaregiverParticipantStatusDates(id: number, body?: DateRangeDto[] | undefined): Observable<DateRangeDtoResponseModelWithData> {
        let url_ = this.baseUrl + "/api/caregiverparticipant/statusdates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertCaregiverParticipantStatusDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCaregiverParticipantStatusDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateRangeDtoResponseModelWithData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateRangeDtoResponseModelWithData>;
        }));
    }

    protected processUpsertCaregiverParticipantStatusDates(response: HttpResponseBase): Observable<DateRangeDtoResponseModelWithData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateRangeDtoResponseModelWithData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverParticipantRelationships(id: number): Observable<CaregiverParticipantRelationshipsResponse> {
        let url_ = this.baseUrl + "/api/caregiverparticipantmapping/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverParticipantRelationships(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverParticipantRelationships(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverParticipantRelationshipsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverParticipantRelationshipsResponse>;
        }));
    }

    protected processGetCaregiverParticipantRelationships(response: HttpResponseBase): Observable<CaregiverParticipantRelationshipsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverParticipantRelationshipsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertCaregiverParticipantProspect(body?: UpsertCaregiverParticipantProspectCommand | undefined): Observable<Int32Response> {
        let url_ = this.baseUrl + "/api/caregiverparticipantprospect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertCaregiverParticipantProspect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCaregiverParticipantProspect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32Response>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32Response>;
        }));
    }

    protected processUpsertCaregiverParticipantProspect(response: HttpResponseBase): Observable<Int32Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Int32Response.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32Response.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverParticipantProspectById(caregiverParticipantProspectId: number): Observable<CaregiverParticipantProspectResponse> {
        let url_ = this.baseUrl + "/api/caregiverparticipantprospect/{caregiverParticipantProspectId}";
        if (caregiverParticipantProspectId === undefined || caregiverParticipantProspectId === null)
            throw new Error("The parameter 'caregiverParticipantProspectId' must be defined.");
        url_ = url_.replace("{caregiverParticipantProspectId}", encodeURIComponent("" + caregiverParticipantProspectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverParticipantProspectById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverParticipantProspectById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverParticipantProspectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverParticipantProspectResponse>;
        }));
    }

    protected processGetCaregiverParticipantProspectById(response: HttpResponseBase): Observable<CaregiverParticipantProspectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverParticipantProspectResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    verifyCaregiverParticipantProspectById(caregiverParticipantProspectId: number): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/caregiverparticipantprospect/{caregiverParticipantProspectId}/verify";
        if (caregiverParticipantProspectId === undefined || caregiverParticipantProspectId === null)
            throw new Error("The parameter 'caregiverParticipantProspectId' must be defined.");
        url_ = url_.replace("{caregiverParticipantProspectId}", encodeURIComponent("" + caregiverParticipantProspectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyCaregiverParticipantProspectById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyCaregiverParticipantProspectById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processVerifyCaregiverParticipantProspectById(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverParticipantProspect(body?: GetCaregiverParticipantProspectCommand | undefined): Observable<CaregiverParticipantProspectResponse[]> {
        let url_ = this.baseUrl + "/api/caregiverparticipantprospect/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverParticipantProspect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverParticipantProspect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverParticipantProspectResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverParticipantProspectResponse[]>;
        }));
    }

    protected processGetCaregiverParticipantProspect(response: HttpResponseBase): Observable<CaregiverParticipantProspectResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverParticipantProspectResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveCaregiverProspect(personId: string, body?: CaregiverProspectRequest | undefined): Observable<IActionResult> {
        let url_ = this.baseUrl + "/api/CaregiverProspect/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCaregiverProspect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCaregiverProspect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IActionResult>;
        }));
    }

    protected processSaveCaregiverProspect(response: HttpResponseBase): Observable<IActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverProspectI9DateAndStatusHistoryById(personId: number, body?: GetHistoryRequestBase | undefined): Observable<CaregiverProspectI9DateAndStatusHistory[]> {
        let url_ = this.baseUrl + "/api/CaregiverProspect/i9DateAndStatusHistory/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverProspectI9DateAndStatusHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverProspectI9DateAndStatusHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverProspectI9DateAndStatusHistory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverProspectI9DateAndStatusHistory[]>;
        }));
    }

    protected processGetCaregiverProspectI9DateAndStatusHistoryById(response: HttpResponseBase): Observable<CaregiverProspectI9DateAndStatusHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverProspectI9DateAndStatusHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverProspectProfile(personId: string): Observable<CaregiverProspectResponse> {
        let url_ = this.baseUrl + "/api/CaregiverProspect/profile/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverProspectProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverProspectProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverProspectResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverProspectResponse>;
        }));
    }

    protected processGetCaregiverProspectProfile(response: HttpResponseBase): Observable<CaregiverProspectResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverProspectResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverProspectStatusHistory(personId: string): Observable<CaregiverProspectStatus[]> {
        let url_ = this.baseUrl + "/api/CaregiverProspect/status/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverProspectStatusHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverProspectStatusHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverProspectStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverProspectStatus[]>;
        }));
    }

    protected processGetCaregiverProspectStatusHistory(response: HttpResponseBase): Observable<CaregiverProspectStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverProspectStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverQualificationCourses(body?: QualificationTypeCoursesDto | undefined): Observable<QualificationTypeCoursesMappingResponseGridResponseBase> {
        let url_ = this.baseUrl + "/api/caregiverqualificationcourse/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverQualificationCourses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverQualificationCourses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualificationTypeCoursesMappingResponseGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualificationTypeCoursesMappingResponseGridResponseBase>;
        }));
    }

    protected processGetCaregiverQualificationCourses(response: HttpResponseBase): Observable<QualificationTypeCoursesMappingResponseGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualificationTypeCoursesMappingResponseGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertCaregiverQualificationTypeMapping(body?: CaregiverQualificationTypeMappingRequest | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/caregiverqualificationtypemapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertCaregiverQualificationTypeMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCaregiverQualificationTypeMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpsertCaregiverQualificationTypeMapping(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveCaregiverParticipantRel(attestationType: string, body?: CaregiverParticipantRelQuestionnaireDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/caregiverrelationship/{attestationType}/save";
        if (attestationType === undefined || attestationType === null)
            throw new Error("The parameter 'attestationType' must be defined.");
        url_ = url_.replace("{attestationType}", encodeURIComponent("" + attestationType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCaregiverParticipantRel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCaregiverParticipantRel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processSaveCaregiverParticipantRel(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverParticipantRelationshipAttestationStatus(caregiverId: string): Observable<CaregiverParticipantRelAttestationResponse[]> {
        let url_ = this.baseUrl + "/api/caregiverrelationship/{caregiverId}/attestation/status";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverParticipantRelationshipAttestationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverParticipantRelationshipAttestationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverParticipantRelAttestationResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverParticipantRelAttestationResponse[]>;
        }));
    }

    protected processGetCaregiverParticipantRelationshipAttestationStatus(response: HttpResponseBase): Observable<CaregiverParticipantRelAttestationResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverParticipantRelAttestationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverParticipantRelAttestationstatusDetails(body?: CaregiverParticipantRelAttestationstatusDetailsRequest | undefined): Observable<AttestationStatusDto[]> {
        let url_ = this.baseUrl + "/api/caregiverrelationship/attestationstatus/details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverParticipantRelAttestationstatusDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverParticipantRelAttestationstatusDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttestationStatusDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttestationStatusDto[]>;
        }));
    }

    protected processGetCaregiverParticipantRelAttestationstatusDetails(response: HttpResponseBase): Observable<AttestationStatusDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttestationStatusDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverParticipantRelAttestationDetails(body?: CaregiverParticipantRelAttestationRequest | undefined): Observable<CaregiverParticipantRelAttestationResponse[]> {
        let url_ = this.baseUrl + "/api/caregiverrelationship/details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverParticipantRelAttestationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverParticipantRelAttestationDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverParticipantRelAttestationResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverParticipantRelAttestationResponse[]>;
        }));
    }

    protected processGetCaregiverParticipantRelAttestationDetails(response: HttpResponseBase): Observable<CaregiverParticipantRelAttestationResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverParticipantRelAttestationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAttestationQuestionnaire(body?: QuestionnnaireRequest | undefined): Observable<QuestionnnaireResponseApiResponse> {
        let url_ = this.baseUrl + "/api/caregiverrelationship/questionnaire/details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttestationQuestionnaire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttestationQuestionnaire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionnnaireResponseApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionnnaireResponseApiResponse>;
        }));
    }

    protected processGetAttestationQuestionnaire(response: HttpResponseBase): Observable<QuestionnnaireResponseApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionnnaireResponseApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveCaseManagerDetails(body?: CaseManagerDTO | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/casemanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCaseManagerDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCaseManagerDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveCaseManagerDetails(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaseManagerDetailsById(personId: string): Observable<CaseManagerDTO> {
        let url_ = this.baseUrl + "/api/casemanager/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseManagerDetailsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseManagerDetailsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaseManagerDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaseManagerDTO>;
        }));
    }

    protected processGetCaseManagerDetailsById(response: HttpResponseBase): Observable<CaseManagerDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaseManagerDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaseManagerParticipantRel(participantId: number): Observable<CaseManagerParticipantRelDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/casemanager/participant/{participantId}";
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseManagerParticipantRel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseManagerParticipantRel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaseManagerParticipantRelDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaseManagerParticipantRelDtoGridResponseBase>;
        }));
    }

    protected processGetCaseManagerParticipantRel(response: HttpResponseBase): Observable<CaseManagerParticipantRelDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaseManagerParticipantRelDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaseManagerProfileDetails(personId: string): Observable<CaseManagerProfileDetails> {
        let url_ = this.baseUrl + "/api/casemanager/profile/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseManagerProfileDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseManagerProfileDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaseManagerProfileDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaseManagerProfileDetails>;
        }));
    }

    protected processGetCaseManagerProfileDetails(response: HttpResponseBase): Observable<CaseManagerProfileDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaseManagerProfileDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaseManagerLkp(body?: FilterRequest | undefined): Observable<CaseManagerLkpGridResponseBase> {
        let url_ = this.baseUrl + "/api/casemanagerlkp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseManagerLkp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseManagerLkp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaseManagerLkpGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaseManagerLkpGridResponseBase>;
        }));
    }

    protected processGetCaseManagerLkp(response: HttpResponseBase): Observable<CaseManagerLkpGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaseManagerLkpGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCourses(): Observable<GetAllCourseResponse[]> {
        let url_ = this.baseUrl + "/api/courses/fetch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCourses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCourses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllCourseResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllCourseResponse[]>;
        }));
    }

    protected processGetCourses(response: HttpResponseBase): Observable<GetAllCourseResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllCourseResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertCourses(body?: CourseDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/courses/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertCourses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCourses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpsertCourses(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverCredentialStatusTypes(): Observable<CredentialStatusTypeMapping[]> {
        let url_ = this.baseUrl + "/api/credentialstatustypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverCredentialStatusTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverCredentialStatusTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CredentialStatusTypeMapping[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CredentialStatusTypeMapping[]>;
        }));
    }

    protected processGetCaregiverCredentialStatusTypes(response: HttpResponseBase): Observable<CredentialStatusTypeMapping[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CredentialStatusTypeMapping.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateCustEmpRel(body?: CustEmpRelationDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/custemprel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateCustEmpRel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateCustEmpRel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateUpdateCustEmpRel(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteCustEmpRel(body?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/custemprel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustEmpRel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustEmpRel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteCustEmpRel(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverParticipantExemptionsHistoryById(id: number, body?: GetHistoryRequestBase | undefined): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/custemprel/{id}/cgptexemptionshistory";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverParticipantExemptionsHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverParticipantExemptionsHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetCaregiverParticipantExemptionsHistoryById(response: HttpResponseBase): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverParticipantMapStatusDateRangesHistoryById(id: number, body?: GetHistoryRequestBase | undefined): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/custemprel/{id}/cgptmapstatusdaterangehistory";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverParticipantMapStatusDateRangesHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverParticipantMapStatusDateRangesHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetCaregiverParticipantMapStatusDateRangesHistoryById(response: HttpResponseBase): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getParticipantCaregiverRelHistory(caregiverParticipantMappingId: number, body?: GetHistoryRequestBase | undefined): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/custemprel/caregiver/participantcaregiverrel/{caregiverParticipantMappingId}/history";
        if (caregiverParticipantMappingId === undefined || caregiverParticipantMappingId === null)
            throw new Error("The parameter 'caregiverParticipantMappingId' must be defined.");
        url_ = url_.replace("{caregiverParticipantMappingId}", encodeURIComponent("" + caregiverParticipantMappingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantCaregiverRelHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantCaregiverRelHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetParticipantCaregiverRelHistory(response: HttpResponseBase): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getQualificationRoleTypeHistory(caregiverParticipantMappingId: number): Observable<QualificationRoleTypeHistory[]> {
        let url_ = this.baseUrl + "/api/custemprel/caregiverroletypehistory/{caregiverParticipantMappingId}";
        if (caregiverParticipantMappingId === undefined || caregiverParticipantMappingId === null)
            throw new Error("The parameter 'caregiverParticipantMappingId' must be defined.");
        url_ = url_.replace("{caregiverParticipantMappingId}", encodeURIComponent("" + caregiverParticipantMappingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualificationRoleTypeHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualificationRoleTypeHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualificationRoleTypeHistory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualificationRoleTypeHistory[]>;
        }));
    }

    protected processGetQualificationRoleTypeHistory(response: HttpResponseBase): Observable<QualificationRoleTypeHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QualificationRoleTypeHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    checkCustEmpAlreadyExist(custId: number, empId: number): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/custemprel/checkifexist/cust/{custId}/emp/{empId}";
        if (custId === undefined || custId === null)
            throw new Error("The parameter 'custId' must be defined.");
        url_ = url_.replace("{custId}", encodeURIComponent("" + custId));
        if (empId === undefined || empId === null)
            throw new Error("The parameter 'empId' must be defined.");
        url_ = url_.replace("{empId}", encodeURIComponent("" + empId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCustEmpAlreadyExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCustEmpAlreadyExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCheckCustEmpAlreadyExist(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCustEmpRelationsById(id: number): Observable<CustEmpRelByIdResponseDto> {
        let url_ = this.baseUrl + "/api/custemprel/detail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustEmpRelationsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustEmpRelationsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustEmpRelByIdResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustEmpRelByIdResponseDto>;
        }));
    }

    protected processGetCustEmpRelationsById(response: HttpResponseBase): Observable<CustEmpRelByIdResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustEmpRelByIdResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllCustEmpRelations(body?: CustEmpRelFilterRequest | undefined): Observable<CustEmpRelResponseDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/custemprel/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCustEmpRelations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCustEmpRelations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustEmpRelResponseDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustEmpRelResponseDtoGridResponseBase>;
        }));
    }

    protected processGetAllCustEmpRelations(response: HttpResponseBase): Observable<CustEmpRelResponseDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustEmpRelResponseDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCustEmpRelInfo(body?: CustEmpRelFilterRequest | undefined): Observable<CustEmpRelResponseDto[]> {
        let url_ = this.baseUrl + "/api/custemprel/list/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustEmpRelInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustEmpRelInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustEmpRelResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustEmpRelResponseDto[]>;
        }));
    }

    protected processGetCustEmpRelInfo(response: HttpResponseBase): Observable<CustEmpRelResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustEmpRelResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    verifyQualificationRoleType(caregiverId: number, participantId: number, qualificationRoleTypeId: number, startDate: Date, endDate: Date): Observable<QualificationRoleVerificationArrayApiResponse> {
        let url_ = this.baseUrl + "/api/custemprel/verifyqualificationroletype/caregiver/{caregiverId}/participant/{participantId}/qualificationroletype/{qualificationRoleTypeId}/{startDate}/{endDate}";
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        if (qualificationRoleTypeId === undefined || qualificationRoleTypeId === null)
            throw new Error("The parameter 'qualificationRoleTypeId' must be defined.");
        url_ = url_.replace("{qualificationRoleTypeId}", encodeURIComponent("" + qualificationRoleTypeId));
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined.");
        url_ = url_.replace("{startDate}", encodeURIComponent(startDate ? "" + startDate.toISOString() : "null"));
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined.");
        url_ = url_.replace("{endDate}", encodeURIComponent(endDate ? "" + endDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyQualificationRoleType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyQualificationRoleType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualificationRoleVerificationArrayApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualificationRoleVerificationArrayApiResponse>;
        }));
    }

    protected processVerifyQualificationRoleType(response: HttpResponseBase): Observable<QualificationRoleVerificationArrayApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualificationRoleVerificationArrayApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAttestationDataByCodeLangCode(code: string, languageCode: string): Observable<ComponentDetails[]> {
        let url_ = this.baseUrl + "/api/data/{code}/{languageCode}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        if (languageCode === undefined || languageCode === null)
            throw new Error("The parameter 'languageCode' must be defined.");
        url_ = url_.replace("{languageCode}", encodeURIComponent("" + languageCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttestationDataByCodeLangCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttestationDataByCodeLangCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentDetails[]>;
        }));
    }

    protected processGetAttestationDataByCodeLangCode(response: HttpResponseBase): Observable<ComponentDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComponentDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAttestationDataByCode(code: string): Observable<ComponentDetails[]> {
        let url_ = this.baseUrl + "/api/data/code/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttestationDataByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttestationDataByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentDetails[]>;
        }));
    }

    protected processGetAttestationDataByCode(response: HttpResponseBase): Observable<ComponentDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComponentDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllDeductionType(): Observable<DeductionTypeDto[]> {
        let url_ = this.baseUrl + "/api/DeductionType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDeductionType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDeductionType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeductionTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeductionTypeDto[]>;
        }));
    }

    protected processGetAllDeductionType(response: HttpResponseBase): Observable<DeductionTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeductionTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertDesignatedReresentative(body?: PersonType | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/DesignatedRepresentative";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertDesignatedReresentative(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertDesignatedReresentative(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpsertDesignatedReresentative(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDesignatedRepresentative(personId: string): Observable<PersonType> {
        let url_ = this.baseUrl + "/api/DesignatedRepresentative/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDesignatedRepresentative(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDesignatedRepresentative(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonType>;
        }));
    }

    protected processGetDesignatedRepresentative(response: HttpResponseBase): Observable<PersonType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDesignatedRepresentativeStatusHistory(personId: number): Observable<PersonStatusHistory[]> {
        let url_ = this.baseUrl + "/api/DesignatedRepresentative/{personId}/history";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDesignatedRepresentativeStatusHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDesignatedRepresentativeStatusHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonStatusHistory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonStatusHistory[]>;
        }));
    }

    protected processGetDesignatedRepresentativeStatusHistory(response: HttpResponseBase): Observable<PersonStatusHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonStatusHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDesignatedRepresentativeParticipant(personId: string): Observable<ParticipantDesignatedRepresentative[]> {
        let url_ = this.baseUrl + "/api/DesignatedRepresentative/{personId}/participants";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDesignatedRepresentativeParticipant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDesignatedRepresentativeParticipant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantDesignatedRepresentative[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantDesignatedRepresentative[]>;
        }));
    }

    protected processGetDesignatedRepresentativeParticipant(response: HttpResponseBase): Observable<ParticipantDesignatedRepresentative[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParticipantDesignatedRepresentative.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDesignatedRepresentativeProfile(personId: string): Observable<DesignatedRepresentativeProfile> {
        let url_ = this.baseUrl + "/api/DesignatedRepresentative/{personId}/profile";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDesignatedRepresentativeProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDesignatedRepresentativeProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DesignatedRepresentativeProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DesignatedRepresentativeProfile>;
        }));
    }

    protected processGetDesignatedRepresentativeProfile(response: HttpResponseBase): Observable<DesignatedRepresentativeProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DesignatedRepresentativeProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDischargeReason(): Observable<DischargeReasons[]> {
        let url_ = this.baseUrl + "/api/DischargeReason";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDischargeReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDischargeReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DischargeReasons[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DischargeReasons[]>;
        }));
    }

    protected processGetDischargeReason(response: HttpResponseBase): Observable<DischargeReasons[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DischargeReasons.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllExternalKeys(body?: GetAllExternalKeysFilterRequest | undefined): Observable<ExternalKeysResponseDto[]> {
        let url_ = this.baseUrl + "/api/ekeys/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllExternalKeys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExternalKeys(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalKeysResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalKeysResponseDto[]>;
        }));
    }

    protected processGetAllExternalKeys(response: HttpResponseBase): Observable<ExternalKeysResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalKeysResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getEmployer(body?: EmployerRequest | undefined): Observable<EmployersGridResponseBase> {
        let url_ = this.baseUrl + "/api/Employer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployersGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployersGridResponseBase>;
        }));
    }

    protected processGetEmployer(response: HttpResponseBase): Observable<EmployersGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployersGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmployerById(employerId: number): Observable<EmployerDetails> {
        let url_ = this.baseUrl + "/api/Employer/{employerId}";
        if (employerId === undefined || employerId === null)
            throw new Error("The parameter 'employerId' must be defined.");
        url_ = url_.replace("{employerId}", encodeURIComponent("" + employerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployerDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployerDetails>;
        }));
    }

    protected processGetEmployerById(response: HttpResponseBase): Observable<EmployerDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployerDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmployerAccountsById(employerId: number): Observable<EmployerAccounts[]> {
        let url_ = this.baseUrl + "/api/Employer/{employerId}/accounts";
        if (employerId === undefined || employerId === null)
            throw new Error("The parameter 'employerId' must be defined.");
        url_ = url_.replace("{employerId}", encodeURIComponent("" + employerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerAccountsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerAccountsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployerAccounts[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployerAccounts[]>;
        }));
    }

    protected processGetEmployerAccountsById(response: HttpResponseBase): Observable<EmployerAccounts[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployerAccounts.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getEmployerHistoryById(employerId: number, body?: GetHistoryRequestBase | undefined): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/Employer/{employerId}/history";
        if (employerId === undefined || employerId === null)
            throw new Error("The parameter 'employerId' must be defined.");
        url_ = url_.replace("{employerId}", encodeURIComponent("" + employerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetEmployerHistoryById(response: HttpResponseBase): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getEmployerStatusHistory(employerId: number, body?: string | undefined): Observable<EmployerStatusHistory[]> {
        let url_ = this.baseUrl + "/api/Employer/{employerId}/statushistory";
        if (employerId === undefined || employerId === null)
            throw new Error("The parameter 'employerId' must be defined.");
        url_ = url_.replace("{employerId}", encodeURIComponent("" + employerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerStatusHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerStatusHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployerStatusHistory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployerStatusHistory[]>;
        }));
    }

    protected processGetEmployerStatusHistory(response: HttpResponseBase): Observable<EmployerStatusHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployerStatusHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteEmployer(ids: string): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/Employer/{ids}";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined.");
        url_ = url_.replace("{ids}", encodeURIComponent("" + ids));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEmployer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEmployer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteEmployer(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmployerIdByEcn(employerEcn: string): Observable<number> {
        let url_ = this.baseUrl + "/api/Employer/ecn/{employerEcn}/id";
        if (employerEcn === undefined || employerEcn === null)
            throw new Error("The parameter 'employerEcn' must be defined.");
        url_ = url_.replace("{employerEcn}", encodeURIComponent("" + employerEcn));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerIdByEcn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerIdByEcn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetEmployerIdByEcn(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllEmployerEin(): Observable<Employers[]> {
        let url_ = this.baseUrl + "/api/Employer/ein";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmployerEin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmployerEin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Employers[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Employers[]>;
        }));
    }

    protected processGetAllEmployerEin(response: HttpResponseBase): Observable<Employers[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Employers.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employer (optional) 
     * @param employerId (optional) 
     * @param sortColumn (optional) 
     * @param sortDirection (optional) 
     * @param filterColumn (optional) 
     * @param filterValue (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param filterType (optional) 
     * @return Success
     */
    getEmployerOfRecordIdsByEmployerId(employer?: string | undefined, employerId?: number | undefined, sortColumn?: string | undefined, sortDirection?: string | undefined, filterColumn?: string | undefined, filterValue?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, filterType?: string | undefined): Observable<StringGridResponseBase> {
        let url_ = this.baseUrl + "/api/Employer/eor?";
        if (employer === null)
            throw new Error("The parameter 'employer' cannot be null.");
        else if (employer !== undefined)
            url_ += "employer=" + encodeURIComponent("" + employer) + "&";
        if (employerId === null)
            throw new Error("The parameter 'employerId' cannot be null.");
        else if (employerId !== undefined)
            url_ += "employerId=" + encodeURIComponent("" + employerId) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filterColumn === null)
            throw new Error("The parameter 'filterColumn' cannot be null.");
        else if (filterColumn !== undefined)
            url_ += "FilterColumn=" + encodeURIComponent("" + filterColumn) + "&";
        if (filterValue === null)
            throw new Error("The parameter 'filterValue' cannot be null.");
        else if (filterValue !== undefined)
            url_ += "FilterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (filterType === null)
            throw new Error("The parameter 'filterType' cannot be null.");
        else if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerOfRecordIdsByEmployerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerOfRecordIdsByEmployerId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringGridResponseBase>;
        }));
    }

    protected processGetEmployerOfRecordIdsByEmployerId(response: HttpResponseBase): Observable<StringGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getEmployerSearch(body?: EmployerSearchRequest | undefined): Observable<EmployerResponseGridResponseBase> {
        let url_ = this.baseUrl + "/api/Employer/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployerResponseGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployerResponseGridResponseBase>;
        }));
    }

    protected processGetEmployerSearch(response: HttpResponseBase): Observable<EmployerResponseGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployerResponseGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    employerUpsert(body?: EmployerDetails | undefined): Observable<EmployerIdApiResponse> {
        let url_ = this.baseUrl + "/api/Employer/upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployerUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployerUpsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployerIdApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployerIdApiResponse>;
        }));
    }

    protected processEmployerUpsert(response: HttpResponseBase): Observable<EmployerIdApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployerIdApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkEmployerUsage(body?: EmployerUsageRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/Employer/usage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckEmployerUsage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckEmployerUsage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCheckEmployerUsage(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportEmployerDeduction(body?: EmployerSearchRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/employerdeductions/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportEmployerDeduction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportEmployerDeduction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processExportEmployerDeduction(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmployerOfRecordHistory(employerOfRecordId: number, deletedRecords: boolean): Observable<EmployerOfRecordEmployerMappingDetails[]> {
        let url_ = this.baseUrl + "/api/EmployerOfRecord/{employerOfRecordId}/history/{deletedRecords}";
        if (employerOfRecordId === undefined || employerOfRecordId === null)
            throw new Error("The parameter 'employerOfRecordId' must be defined.");
        url_ = url_.replace("{employerOfRecordId}", encodeURIComponent("" + employerOfRecordId));
        if (deletedRecords === undefined || deletedRecords === null)
            throw new Error("The parameter 'deletedRecords' must be defined.");
        url_ = url_.replace("{deletedRecords}", encodeURIComponent("" + deletedRecords));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerOfRecordHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerOfRecordHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployerOfRecordEmployerMappingDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployerOfRecordEmployerMappingDetails[]>;
        }));
    }

    protected processGetEmployerOfRecordHistory(response: HttpResponseBase): Observable<EmployerOfRecordEmployerMappingDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployerOfRecordEmployerMappingDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmployerOfRecordCaregiver(personId: string): Observable<Relationships[]> {
        let url_ = this.baseUrl + "/api/EmployerOfRecord/{personId}/caregivers";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerOfRecordCaregiver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerOfRecordCaregiver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Relationships[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Relationships[]>;
        }));
    }

    protected processGetEmployerOfRecordCaregiver(response: HttpResponseBase): Observable<Relationships[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Relationships.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmployerOfRecordParticipant(personId: string): Observable<Relationships[]> {
        let url_ = this.baseUrl + "/api/EmployerOfRecord/{personId}/participants";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerOfRecordParticipant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerOfRecordParticipant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Relationships[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Relationships[]>;
        }));
    }

    protected processGetEmployerOfRecordParticipant(response: HttpResponseBase): Observable<Relationships[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Relationships.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllEmployerPayRates(body?: EmployerPayRateSetupGridRequest | undefined): Observable<EmployerPayRateSetupDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/EmployerPayRates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmployerPayRates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmployerPayRates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployerPayRateSetupDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployerPayRateSetupDtoGridResponseBase>;
        }));
    }

    protected processGetAllEmployerPayRates(response: HttpResponseBase): Observable<EmployerPayRateSetupDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployerPayRateSetupDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkOverlapEmployerPayRate(body?: EmployerPayRatePeriodData | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/EmployerPayRates/checkoverlap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckOverlapEmployerPayRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckOverlapEmployerPayRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckOverlapEmployerPayRate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertEmployerPayRate(body?: EmployerPayRateListRequest | undefined): Observable<EmployerPayRateSetupDto[]> {
        let url_ = this.baseUrl + "/api/EmployerPayRates/upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertEmployerPayRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertEmployerPayRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployerPayRateSetupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployerPayRateSetupDto[]>;
        }));
    }

    protected processUpsertEmployerPayRate(response: HttpResponseBase): Observable<EmployerPayRateSetupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployerPayRateSetupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPersonIdByExternalKey(body?: PersonIdByExternalKeyRequest[] | undefined): Observable<PersonProvIdResponse> {
        let url_ = this.baseUrl + "/api/getPersonIdByExternalKey/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonIdByExternalKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonIdByExternalKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonProvIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonProvIdResponse>;
        }));
    }

    protected processGetPersonIdByExternalKey(response: HttpResponseBase): Observable<PersonProvIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonProvIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEntityHistory(entityType: string, entityId: number, type: string): Observable<History[]> {
        let url_ = this.baseUrl + "/api/history/{entityType}/{entityId}/{type}";
        if (entityType === undefined || entityType === null)
            throw new Error("The parameter 'entityType' must be defined.");
        url_ = url_.replace("{entityType}", encodeURIComponent("" + entityType));
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<History[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<History[]>;
        }));
    }

    protected processGetEntityHistory(response: HttpResponseBase): Observable<History[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(History.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getImpersonateUserDetail(body?: string | undefined): Observable<ImpersonateUserDetail> {
        let url_ = this.baseUrl + "/api/Impersonate/user/detail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImpersonateUserDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImpersonateUserDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateUserDetail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateUserDetail>;
        }));
    }

    protected processGetImpersonateUserDetail(response: HttpResponseBase): Observable<ImpersonateUserDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateUserDetail.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllDropDownListsByCategories(body?: MasterConfigRequestDto | undefined): Observable<MasterConfigDto[]> {
        let url_ = this.baseUrl + "/api/MasterConfig/getAllDropDownLists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDropDownListsByCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDropDownListsByCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterConfigDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterConfigDto[]>;
        }));
    }

    protected processGetAllDropDownListsByCategories(response: HttpResponseBase): Observable<MasterConfigDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterConfigDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMasterConfigDropDownListByCategory(category: string): Observable<MasterConfigDto[]> {
        let url_ = this.baseUrl + "/api/MasterConfig/getDropDownListsByCategory/{category}";
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMasterConfigDropDownListByCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMasterConfigDropDownListByCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MasterConfigDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MasterConfigDto[]>;
        }));
    }

    protected processGetMasterConfigDropDownListByCategory(response: HttpResponseBase): Observable<MasterConfigDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MasterConfigDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveMco(body?: McoData | undefined): Observable<Int64NullableApiResponse> {
        let url_ = this.baseUrl + "/api/MCO";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveMco(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveMco(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int64NullableApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int64NullableApiResponse>;
        }));
    }

    protected processSaveMco(response: HttpResponseBase): Observable<Int64NullableApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int64NullableApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMcoDetailsHistoryById(id: number, body?: GetHistoryRequestBase | undefined): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/MCO/{id}/mcodetailshistory";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMcoDetailsHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMcoDetailsHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetMcoDetailsHistoryById(response: HttpResponseBase): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMcoDetails(body?: McoRequest | undefined): Observable<McoDetailResponse> {
        let url_ = this.baseUrl + "/api/MCO/details/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMcoDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMcoDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<McoDetailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<McoDetailResponse>;
        }));
    }

    protected processGetMcoDetails(response: HttpResponseBase): Observable<McoDetailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = McoDetailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMco(body?: McoRequest | undefined): Observable<McoResponse> {
        let url_ = this.baseUrl + "/api/MCO/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMco(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMco(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<McoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<McoResponse>;
        }));
    }

    protected processGetMco(response: HttpResponseBase): Observable<McoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = McoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMcoHistory(body?: McoRequest | undefined): Observable<McoDataGridResponseBase> {
        let url_ = this.baseUrl + "/api/MCO/history/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMcoHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMcoHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<McoDataGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<McoDataGridResponseBase>;
        }));
    }

    protected processGetMcoHistory(response: HttpResponseBase): Observable<McoDataGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = McoDataGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMcoPayors(body?: McoRequest | undefined): Observable<McoPayorMappingGridResponseBase> {
        let url_ = this.baseUrl + "/api/MCO/payors/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMcoPayors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMcoPayors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<McoPayorMappingGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<McoPayorMappingGridResponseBase>;
        }));
    }

    protected processGetMcoPayors(response: HttpResponseBase): Observable<McoPayorMappingGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = McoPayorMappingGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    downloadSampleNotificationTemplate(): Observable<FileResultDto> {
        let url_ = this.baseUrl + "/api/MessageInjector/downloadsample";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadSampleNotificationTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadSampleNotificationTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResultDto>;
        }));
    }

    protected processDownloadSampleNotificationTemplate(response: HttpResponseBase): Observable<FileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    uploadMessageInjectorToBlob(): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/MessageInjector/upload";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadMessageInjectorToBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadMessageInjectorToBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUploadMessageInjectorToBlob(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getNeededCaregiverQualifications(body?: GetNeededCaregiverQualificationsCommand | undefined): Observable<CaregiverQualificationType[]> {
        let url_ = this.baseUrl + "/api/needed-qualification/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNeededCaregiverQualifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNeededCaregiverQualifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverQualificationType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverQualificationType[]>;
        }));
    }

    protected processGetNeededCaregiverQualifications(response: HttpResponseBase): Observable<CaregiverQualificationType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaregiverQualificationType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getOvertimeElgibility(body?: OvertimeEligibilityRequest | undefined): Observable<OvertimeEligibilityResponse> {
        let url_ = this.baseUrl + "/api/overtimeeligibility/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOvertimeElgibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOvertimeElgibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OvertimeEligibilityResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OvertimeEligibilityResponse>;
        }));
    }

    protected processGetOvertimeElgibility(response: HttpResponseBase): Observable<OvertimeEligibilityResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OvertimeEligibilityResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveParticipant(body?: Participants | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/Participant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveParticipant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveParticipant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processSaveParticipant(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getParticipantDesignatedRep(participantId: number): Observable<ParticipantDesignatedRepresentative[]> {
        let url_ = this.baseUrl + "/api/Participant/{participantId}/drep";
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantDesignatedRep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantDesignatedRep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantDesignatedRepresentative[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantDesignatedRepresentative[]>;
        }));
    }

    protected processGetParticipantDesignatedRep(response: HttpResponseBase): Observable<ParticipantDesignatedRepresentative[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParticipantDesignatedRepresentative.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getParticpantHistory(participantId: number, type: string): Observable<ParticipantHistory[]> {
        let url_ = this.baseUrl + "/api/Participant/{participantId}/history/{type}";
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticpantHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticpantHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantHistory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantHistory[]>;
        }));
    }

    protected processGetParticpantHistory(response: HttpResponseBase): Observable<ParticipantHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParticipantHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getParticipantRateIcon(participantId: number): Observable<ParticipantIcon> {
        let url_ = this.baseUrl + "/api/Participant/{participantId}/ratestatus";
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantRateIcon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantRateIcon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantIcon>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantIcon>;
        }));
    }

    protected processGetParticipantRateIcon(response: HttpResponseBase): Observable<ParticipantIcon> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParticipantIcon.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param svcDate (optional) 
     * @return Success
     */
    getParticpant(personId: string, svcDate?: Date | undefined): Observable<Participants> {
        let url_ = this.baseUrl + "/api/Participant/{personId}?";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (svcDate === null)
            throw new Error("The parameter 'svcDate' cannot be null.");
        else if (svcDate !== undefined)
            url_ += "svcDate=" + encodeURIComponent(svcDate ? "" + svcDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticpant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticpant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Participants>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Participants>;
        }));
    }

    protected processGetParticpant(response: HttpResponseBase): Observable<Participants> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Participants.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getParticipantDetailsHistory(personId: number, body?: GetHistoryRequestBase | undefined): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/Participant/{personId}/history";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantDetailsHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantDetailsHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetParticipantDetailsHistory(response: HttpResponseBase): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteParticipantCaseMgrRel(body?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/participant/casemanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteParticipantCaseMgrRel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteParticipantCaseMgrRel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteParticipantCaseMgrRel(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveParticipantCaseMgrRel(body?: ParticipantCaseMgrRelRequest | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/participant/casemanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveParticipantCaseMgrRel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveParticipantCaseMgrRel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveParticipantCaseMgrRel(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getParticipantCaseMgrRelById(id: number): Observable<ParticipantCaseMgrRelResponse> {
        let url_ = this.baseUrl + "/api/participant/casemanager/detail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantCaseMgrRelById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantCaseMgrRelById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantCaseMgrRelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantCaseMgrRelResponse>;
        }));
    }

    protected processGetParticipantCaseMgrRelById(response: HttpResponseBase): Observable<ParticipantCaseMgrRelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParticipantCaseMgrRelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllParticiantCaseMgrRel(body?: ParticipantCaseMgrFilterRequest | undefined): Observable<ParticipantCaseMgrRelResponseGridResponseBase> {
        let url_ = this.baseUrl + "/api/participant/casemanager/list/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllParticiantCaseMgrRel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllParticiantCaseMgrRel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantCaseMgrRelResponseGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantCaseMgrRelResponseGridResponseBase>;
        }));
    }

    protected processGetAllParticiantCaseMgrRel(response: HttpResponseBase): Observable<ParticipantCaseMgrRelResponseGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParticipantCaseMgrRelResponseGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllParticipants(): Observable<CustEmpParticipant> {
        let url_ = this.baseUrl + "/api/Participant/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllParticipants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllParticipants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustEmpParticipant>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustEmpParticipant>;
        }));
    }

    protected processGetAllParticipants(response: HttpResponseBase): Observable<CustEmpParticipant> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustEmpParticipant.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getParticipantPaySummary(body?: CoPayListRequest | undefined): Observable<PatientPaySummaryDetails[]> {
        let url_ = this.baseUrl + "/api/Participant/paysummary/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantPaySummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantPaySummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientPaySummaryDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientPaySummaryDetails[]>;
        }));
    }

    protected processGetParticipantPaySummary(response: HttpResponseBase): Observable<PatientPaySummaryDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientPaySummaryDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getServCodesByParticipantId(participantId: number): Observable<ServiceCodes[]> {
        let url_ = this.baseUrl + "/api/Participant/servcode/{participantId}";
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServCodesByParticipantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServCodesByParticipantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCodes[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCodes[]>;
        }));
    }

    protected processGetServCodesByParticipantId(response: HttpResponseBase): Observable<ServiceCodes[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceCodes.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getParticipantServFacilitator(participantId: number): Observable<ParticipantServiceFacilitator[]> {
        let url_ = this.baseUrl + "/api/Participant/servfacilitator/{participantId}";
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantServFacilitator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantServFacilitator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantServiceFacilitator[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantServiceFacilitator[]>;
        }));
    }

    protected processGetParticipantServFacilitator(response: HttpResponseBase): Observable<ParticipantServiceFacilitator[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParticipantServiceFacilitator.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllParticipantTaskByPayorId(participantId: number, payorId: number): Observable<ParticipantTaskListResponse> {
        let url_ = this.baseUrl + "/api/Participant/tasks/{participantId}/{payorId}";
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        if (payorId === undefined || payorId === null)
            throw new Error("The parameter 'payorId' must be defined.");
        url_ = url_.replace("{payorId}", encodeURIComponent("" + payorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllParticipantTaskByPayorId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllParticipantTaskByPayorId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantTaskListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantTaskListResponse>;
        }));
    }

    protected processGetAllParticipantTaskByPayorId(response: HttpResponseBase): Observable<ParticipantTaskListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParticipantTaskListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    bulkUpsertParticipantTask(body?: BulkParticipantTaskListRequest[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Participant/tasks/bulksave";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkUpsertParticipantTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkUpsertParticipantTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processBulkUpsertParticipantTask(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getParticipantPayor(participantId: number): Observable<ParticipantPayor[]> {
        let url_ = this.baseUrl + "/api/Participant/tasks/payor/{participantId}";
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantPayor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantPayor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantPayor[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantPayor[]>;
        }));
    }

    protected processGetParticipantPayor(response: HttpResponseBase): Observable<ParticipantPayor[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParticipantPayor.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertParticipantTask(body?: ParticipantTaskListRequest | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Participant/tasks/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertParticipantTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertParticipantTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpsertParticipantTask(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getParticipantTaskIcon(participantId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Participant/tasksicon/{participantId}";
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantTaskIcon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantTaskIcon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetParticipantTaskIcon(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRelationByParticipantIdandCaregiverId(participantId: number, caregiverId: number): Observable<ParticipantCaregiverRelationResponse> {
        let url_ = this.baseUrl + "/api/participantcaregiver/participant/{participantId}/caregiver/{caregiverId}";
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelationByParticipantIdandCaregiverId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelationByParticipantIdandCaregiverId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantCaregiverRelationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantCaregiverRelationResponse>;
        }));
    }

    protected processGetRelationByParticipantIdandCaregiverId(response: HttpResponseBase): Observable<ParticipantCaregiverRelationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParticipantCaregiverRelationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertParticipantCaregiverRelation(participantId: number, caregiverId: number, body?: UpsertParticipantCaregiverRelationCommand | undefined): Observable<Int32Response> {
        let url_ = this.baseUrl + "/api/participantcaregiver/participant/{participantId}/caregiver/{caregiverId}";
        if (participantId === undefined || participantId === null)
            throw new Error("The parameter 'participantId' must be defined.");
        url_ = url_.replace("{participantId}", encodeURIComponent("" + participantId));
        if (caregiverId === undefined || caregiverId === null)
            throw new Error("The parameter 'caregiverId' must be defined.");
        url_ = url_.replace("{caregiverId}", encodeURIComponent("" + caregiverId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertParticipantCaregiverRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertParticipantCaregiverRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32Response>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32Response>;
        }));
    }

    protected processUpsertParticipantCaregiverRelation(response: HttpResponseBase): Observable<Int32Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Int32Response.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32Response.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveProgramCoordinator(body?: ProgramCoordinatorDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/pc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveProgramCoordinator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveProgramCoordinator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveProgramCoordinator(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProgramCoordinator(personId: string): Observable<ProgramCoordinatorDto> {
        let url_ = this.baseUrl + "/api/pc/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgramCoordinator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramCoordinator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProgramCoordinatorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProgramCoordinatorDto>;
        }));
    }

    protected processGetProgramCoordinator(response: HttpResponseBase): Observable<ProgramCoordinatorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProgramCoordinatorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProgramCoordinatorEmployerHistory(programCoordinatorId: number, type: string): Observable<PCEmployerModel[]> {
        let url_ = this.baseUrl + "/api/pc/{programCoordinatorId}/history/{type}";
        if (programCoordinatorId === undefined || programCoordinatorId === null)
            throw new Error("The parameter 'programCoordinatorId' must be defined.");
        url_ = url_.replace("{programCoordinatorId}", encodeURIComponent("" + programCoordinatorId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgramCoordinatorEmployerHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramCoordinatorEmployerHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PCEmployerModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PCEmployerModel[]>;
        }));
    }

    protected processGetProgramCoordinatorEmployerHistory(response: HttpResponseBase): Observable<PCEmployerModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PCEmployerModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllProgramCoordinator(): Observable<PcLookUp[]> {
        let url_ = this.baseUrl + "/api/pc/all/lookup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProgramCoordinator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProgramCoordinator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PcLookUp[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PcLookUp[]>;
        }));
    }

    protected processGetAllProgramCoordinator(response: HttpResponseBase): Observable<PcLookUp[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PcLookUp.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProgramCoordinatorProfile(personId: string): Observable<ProgramCoordinatorProfile> {
        let url_ = this.baseUrl + "/api/pc/profile/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgramCoordinatorProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramCoordinatorProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProgramCoordinatorProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProgramCoordinatorProfile>;
        }));
    }

    protected processGetProgramCoordinatorProfile(response: HttpResponseBase): Observable<ProgramCoordinatorProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProgramCoordinatorProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    checkActivePerson(personId: string, personType: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/people/{personId}/{personType}/isactive";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (personType === undefined || personType === null)
            throw new Error("The parameter 'personType' must be defined.");
        url_ = url_.replace("{personType}", encodeURIComponent("" + personType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckActivePerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckActivePerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckActivePerson(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    syncPersonAccounts(personId: string): Observable<ResponseModel> {
      let url_ = this.baseUrl + "/api/people/{personId}/accountsync";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncPersonAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncPersonAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processSyncPersonAccounts(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAddressHistoryByPersonId(personId: string): Observable<AddressHistoryResponse[]> {
        let url_ = this.baseUrl + "/api/people/{personId}/addresshistory";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddressHistoryByPersonId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddressHistoryByPersonId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressHistoryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressHistoryResponse[]>;
        }));
    }

    protected processGetAddressHistoryByPersonId(response: HttpResponseBase): Observable<AddressHistoryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddressHistoryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param queryDate (optional) 
     * @return Success
     */
    getCareTeam(personId: string, queryDate?: string | undefined): Observable<CareTeamResponse> {
        let url_ = this.baseUrl + "/api/people/{personId}/celltrak-careteam?";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (queryDate === null)
            throw new Error("The parameter 'queryDate' cannot be null.");
        else if (queryDate !== undefined)
            url_ += "queryDate=" + encodeURIComponent("" + queryDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCareTeam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCareTeam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareTeamResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareTeamResponse>;
        }));
    }

    protected processGetCareTeam(response: HttpResponseBase): Observable<CareTeamResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CareTeamResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPersonAddressAndPhone(personId: string): Observable<PersonAddressPhone[]> {
        let url_ = this.baseUrl + "/api/people/{personId}/phoneaddress";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonAddressAndPhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonAddressAndPhone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonAddressPhone[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonAddressPhone[]>;
        }));
    }

    protected processGetPersonAddressAndPhone(response: HttpResponseBase): Observable<PersonAddressPhone[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonAddressPhone.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPhoneHistoryByPersonId(personId: string): Observable<PhoneHistoryResponse[]> {
        let url_ = this.baseUrl + "/api/people/{personId}/phonehistory";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPhoneHistoryByPersonId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPhoneHistoryByPersonId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhoneHistoryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhoneHistoryResponse[]>;
        }));
    }

    protected processGetPhoneHistoryByPersonId(response: HttpResponseBase): Observable<PhoneHistoryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PhoneHistoryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getUnmaskedSSNByPersonId(personId: string): Observable<UnmaskedSSN> {
        let url_ = this.baseUrl + "/api/people/{personId}/ssn";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnmaskedSSNByPersonId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnmaskedSSNByPersonId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnmaskedSSN>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnmaskedSSN>;
        }));
    }

    protected processGetUnmaskedSSNByPersonId(response: HttpResponseBase): Observable<UnmaskedSSN> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnmaskedSSN.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateSsn(personId: string, body?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/people/{personId}/ssn/validate";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateSsn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateSsn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processValidateSsn(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveAddressPhonePrimary(body?: PrimaryAddressPhone | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/people/address/phone/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAddressPhonePrimary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAddressPhonePrimary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processSaveAddressPhonePrimary(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAddressType(): Observable<StringInt32KeyValuePair[]> {
        let url_ = this.baseUrl + "/api/people/addresstype";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddressType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddressType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringInt32KeyValuePair[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringInt32KeyValuePair[]>;
        }));
    }

    protected processGetAddressType(response: HttpResponseBase): Observable<StringInt32KeyValuePair[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StringInt32KeyValuePair.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    syncCareTeamToCellTrak(body?: string[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/people/celltrak-careteam-sync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncCareTeamToCellTrak(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncCareTeamToCellTrak(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processSyncCareTeamToCellTrak(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveCommunicationEmails(body?: CommunicationEmailRequest[] | undefined): Observable<CommunicationEmailsResponseIEnumerableApiResponse> {
        let url_ = this.baseUrl + "/api/people/communication/emails/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCommunicationEmails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCommunicationEmails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommunicationEmailsResponseIEnumerableApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommunicationEmailsResponseIEnumerableApiResponse>;
        }));
    }

    protected processSaveCommunicationEmails(response: HttpResponseBase): Observable<CommunicationEmailsResponseIEnumerableApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommunicationEmailsResponseIEnumerableApiResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCommunicationEmails(personId: string): Observable<CommunicationEmailsResponse[]> {
        let url_ = this.baseUrl + "/api/people/communication/emails/fetch/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommunicationEmails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunicationEmails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommunicationEmailsResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommunicationEmailsResponse[]>;
        }));
    }

    protected processGetCommunicationEmails(response: HttpResponseBase): Observable<CommunicationEmailsResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommunicationEmailsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCommunicationEmailsHistory(personId: string): Observable<CommunicationEmailsHistoryResponse[]> {
        let url_ = this.baseUrl + "/api/people/communication/emails/history/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommunicationEmailsHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunicationEmailsHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommunicationEmailsHistoryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommunicationEmailsHistoryResponse[]>;
        }));
    }

    protected processGetCommunicationEmailsHistory(response: HttpResponseBase): Observable<CommunicationEmailsHistoryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommunicationEmailsHistoryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCommunicationEmails(body?: CommunicationEmailRequest[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/people/communication/emails/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCommunicationEmails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCommunicationEmails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateCommunicationEmails(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCustRepRelStatusHistory(custRepRelId: number): Observable<StatusHistory[]> {
        let url_ = this.baseUrl + "/api/People/CustRepRel/{custRepRelId}/history";
        if (custRepRelId === undefined || custRepRelId === null)
            throw new Error("The parameter 'custRepRelId' must be defined.");
        url_ = url_.replace("{custRepRelId}", encodeURIComponent("" + custRepRelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustRepRelStatusHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustRepRelStatusHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusHistory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusHistory[]>;
        }));
    }

    protected processGetCustRepRelStatusHistory(response: HttpResponseBase): Observable<StatusHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatusHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    checkCustRepAlreadyExist(custId: number, repId: number): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/People/CustRepRel/checkifexist/cust/{custId}/rep/{repId}";
        if (custId === undefined || custId === null)
            throw new Error("The parameter 'custId' must be defined.");
        url_ = url_.replace("{custId}", encodeURIComponent("" + custId));
        if (repId === undefined || repId === null)
            throw new Error("The parameter 'repId' must be defined.");
        url_ = url_.replace("{repId}", encodeURIComponent("" + repId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCustRepAlreadyExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCustRepAlreadyExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCheckCustRepAlreadyExist(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllCustRepRelations(body?: CustRepRelFilterRequest | undefined): Observable<CustRepRelResponseGridResponseBase> {
        let url_ = this.baseUrl + "/api/People/CustRepRel/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCustRepRelations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCustRepRelations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustRepRelResponseGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustRepRelResponseGridResponseBase>;
        }));
    }

    protected processGetAllCustRepRelations(response: HttpResponseBase): Observable<CustRepRelResponseGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustRepRelResponseGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCustRepRelationsById(id: number): Observable<CustRepRelByIdResponse> {
        let url_ = this.baseUrl + "/api/People/CustRepRel/fetch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustRepRelationsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustRepRelationsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustRepRelByIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustRepRelByIdResponse>;
        }));
    }

    protected processGetCustRepRelationsById(response: HttpResponseBase): Observable<CustRepRelByIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustRepRelByIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllRepresentative(body?: FilterRequest | undefined): Observable<RepresentativeResponseGridResponseBase> {
        let url_ = this.baseUrl + "/api/People/CustRepRel/representative/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRepresentative(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRepresentative(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RepresentativeResponseGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RepresentativeResponseGridResponseBase>;
        }));
    }

    protected processGetAllRepresentative(response: HttpResponseBase): Observable<RepresentativeResponseGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RepresentativeResponseGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateCustRepRel(body?: CustRepRelationRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/People/CustRepRel/upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateCustRepRel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateCustRepRel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateUpdateCustRepRel(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdateCustRepRelBulk(body?: CustRepRelationBulkRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/People/CustRepRel/upsert-bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateCustRepRelBulk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateCustRepRelBulk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateUpdateCustRepRelBulk(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllPerson(body?: PersonEmailFilterDto | undefined): Observable<PeopleGridResponse> {
        let url_ = this.baseUrl + "/api/people/email/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeopleGridResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeopleGridResponse>;
        }));
    }

    protected processGetAllPerson(response: HttpResponseBase): Observable<PeopleGridResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PeopleGridResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmployerPartRelTypes(): Observable<EmployerPartRelationshipType[]> {
        let url_ = this.baseUrl + "/api/people/employer-part-rel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerPartRelTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerPartRelTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployerPartRelationshipType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployerPartRelationshipType[]>;
        }));
    }

    protected processGetEmployerPartRelTypes(response: HttpResponseBase): Observable<EmployerPartRelationshipType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployerPartRelationshipType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmployerOfRecordTerminationStatusHistory(employerOfRecordId: number): Observable<TerminationStatusHistory[]> {
        let url_ = this.baseUrl + "/api/People/EmployerOfRecord/{employerOfRecordId}/termination-status/history";
        if (employerOfRecordId === undefined || employerOfRecordId === null)
            throw new Error("The parameter 'employerOfRecordId' must be defined.");
        url_ = url_.replace("{employerOfRecordId}", encodeURIComponent("" + employerOfRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerOfRecordTerminationStatusHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerOfRecordTerminationStatusHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TerminationStatusHistory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TerminationStatusHistory[]>;
        }));
    }

    protected processGetEmployerOfRecordTerminationStatusHistory(response: HttpResponseBase): Observable<TerminationStatusHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TerminationStatusHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmployerOfRecordDetailsHistory(eorId: number): Observable<EmployerOfRecordDetailHistoryResponse[]> {
        let url_ = this.baseUrl + "/api/People/EmployerOfRecord/{eorId}/details/history";
        if (eorId === undefined || eorId === null)
            throw new Error("The parameter 'eorId' must be defined.");
        url_ = url_.replace("{eorId}", encodeURIComponent("" + eorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerOfRecordDetailsHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerOfRecordDetailsHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployerOfRecordDetailHistoryResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployerOfRecordDetailHistoryResponse[]>;
        }));
    }

    protected processGetEmployerOfRecordDetailsHistory(response: HttpResponseBase): Observable<EmployerOfRecordDetailHistoryResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployerOfRecordDetailHistoryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmployerOfRecordDetailsById(personId: string): Observable<EmployerOfRecordResponse> {
        let url_ = this.baseUrl + "/api/people/EmployerOfRecord/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerOfRecordDetailsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerOfRecordDetailsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployerOfRecordResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployerOfRecordResponse>;
        }));
    }

    protected processGetEmployerOfRecordDetailsById(response: HttpResponseBase): Observable<EmployerOfRecordResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployerOfRecordResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmployerOfRecordEmployerCaregivers(personId: string, serviceDate: Date): Observable<InternalAuthorizationRelationships> {
        let url_ = this.baseUrl + "/api/People/EmployerOfRecord/{personId}/{serviceDate}/caregivers";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (serviceDate === undefined || serviceDate === null)
            throw new Error("The parameter 'serviceDate' must be defined.");
        url_ = url_.replace("{serviceDate}", encodeURIComponent(serviceDate ? "" + serviceDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerOfRecordEmployerCaregivers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerOfRecordEmployerCaregivers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalAuthorizationRelationships>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalAuthorizationRelationships>;
        }));
    }

    protected processGetEmployerOfRecordEmployerCaregivers(response: HttpResponseBase): Observable<InternalAuthorizationRelationships> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalAuthorizationRelationships.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmployerOfRecordStatusHistory(personId: number): Observable<StatusHistory[]> {
        let url_ = this.baseUrl + "/api/People/EmployerOfRecord/{personId}/status/history";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerOfRecordStatusHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerOfRecordStatusHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusHistory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusHistory[]>;
        }));
    }

    protected processGetEmployerOfRecordStatusHistory(response: HttpResponseBase): Observable<StatusHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatusHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmployerOfRecordById(personId: string): Observable<EmployerOfRecordDetailResponse> {
        let url_ = this.baseUrl + "/api/people/EmployerOfRecord/fetch/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerOfRecordById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerOfRecordById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployerOfRecordDetailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployerOfRecordDetailResponse>;
        }));
    }

    protected processGetEmployerOfRecordById(response: HttpResponseBase): Observable<EmployerOfRecordDetailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployerOfRecordDetailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmployerOfRecordTerminationLastDates(employerOfRecordId: number, eventDate: Date): Observable<LastDates> {
        let url_ = this.baseUrl + "/api/People/EmployerOfRecord/TerminationLastDates/{employerOfRecordId}/{eventDate}";
        if (employerOfRecordId === undefined || employerOfRecordId === null)
            throw new Error("The parameter 'employerOfRecordId' must be defined.");
        url_ = url_.replace("{employerOfRecordId}", encodeURIComponent("" + employerOfRecordId));
        if (eventDate === undefined || eventDate === null)
            throw new Error("The parameter 'eventDate' must be defined.");
        url_ = url_.replace("{eventDate}", encodeURIComponent(eventDate ? "" + eventDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerOfRecordTerminationLastDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerOfRecordTerminationLastDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LastDates>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LastDates>;
        }));
    }

    protected processGetEmployerOfRecordTerminationLastDates(response: HttpResponseBase): Observable<LastDates> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LastDates.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertEmployerOfRecord(body?: EmployerOfRecordRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/People/EmployerOfRecord/upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertEmployerOfRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertEmployerOfRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpsertEmployerOfRecord(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserEmail(body?: ExternalEmailUpdateRequest | undefined): Observable<ExternalEmailUpdateResponse> {
        let url_ = this.baseUrl + "/api/people/externalemail/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalEmailUpdateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalEmailUpdateResponse>;
        }));
    }

    protected processUpdateUserEmail(response: HttpResponseBase): Observable<ExternalEmailUpdateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalEmailUpdateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateExternalEmail(body?: ExternalEmailValidationRequest | undefined): Observable<ExternalEmailValidationResponse> {
        let url_ = this.baseUrl + "/api/people/externalemail/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateExternalEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateExternalEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalEmailValidationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalEmailValidationResponse>;
        }));
    }

    protected processValidateExternalEmail(response: HttpResponseBase): Observable<ExternalEmailValidationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalEmailValidationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteExternalKeyValues(body?: ExternalKeyDeleteRequest[] | undefined): Observable<ExternalKeyDeleteResponse[]> {
        let url_ = this.baseUrl + "/api/people/externalkeydelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteExternalKeyValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExternalKeyValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalKeyDeleteResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalKeyDeleteResponse[]>;
        }));
    }

    protected processDeleteExternalKeyValues(response: HttpResponseBase): Observable<ExternalKeyDeleteResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalKeyDeleteResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertExternalKeyValues(body?: ExternalKeyInsertRequest[] | undefined): Observable<ExternalKeyInsertResponse[]> {
        let url_ = this.baseUrl + "/api/people/externalkeyinsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertExternalKeyValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertExternalKeyValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalKeyInsertResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalKeyInsertResponse[]>;
        }));
    }

    protected processInsertExternalKeyValues(response: HttpResponseBase): Observable<ExternalKeyInsertResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalKeyInsertResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getExternalKeyTypes(body?: ExternalKeyTypeRequest | undefined): Observable<ExternalKeyTypeResponse[]> {
        let url_ = this.baseUrl + "/api/people/externalkeytype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalKeyTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalKeyTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalKeyTypeResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalKeyTypeResponse[]>;
        }));
    }

    protected processGetExternalKeyTypes(response: HttpResponseBase): Observable<ExternalKeyTypeResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalKeyTypeResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateExternalKeyValue(body?: ExternalKeyValidateRequest | undefined): Observable<ExternalKeyValidateResponse> {
        let url_ = this.baseUrl + "/api/people/externalkeyvalidate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateExternalKeyValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateExternalKeyValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalKeyValidateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalKeyValidateResponse>;
        }));
    }

    protected processValidateExternalKeyValue(response: HttpResponseBase): Observable<ExternalKeyValidateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalKeyValidateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getExternalKeyValues(body?: ExternalKeyValueRequest | undefined): Observable<ExternalKeyDTO[]> {
        let url_ = this.baseUrl + "/api/people/externalkeyvalue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalKeyValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalKeyValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalKeyDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalKeyDTO[]>;
        }));
    }

    protected processGetExternalKeyValues(response: HttpResponseBase): Observable<ExternalKeyDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalKeyDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllExternalKeyValueType(): Observable<ExternalKeyDTO[]> {
        let url_ = this.baseUrl + "/api/people/externalValueType/fetch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllExternalKeyValueType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExternalKeyValueType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalKeyDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalKeyDTO[]>;
        }));
    }

    protected processGetAllExternalKeyValueType(response: HttpResponseBase): Observable<ExternalKeyDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalKeyDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getGenderType(): Observable<StringStringKeyValuePair[]> {
        let url_ = this.baseUrl + "/api/people/gendertype";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGenderType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGenderType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringStringKeyValuePair[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringStringKeyValuePair[]>;
        }));
    }

    protected processGetGenderType(response: HttpResponseBase): Observable<StringStringKeyValuePair[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StringStringKeyValuePair.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param svcDate (optional) 
     * @return Success
     */
    getParticipantById(personId: string, svcDate?: Date | undefined): Observable<ParticipantResponse> {
        let url_ = this.baseUrl + "/api/People/participant/fetch/{personId}?";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (svcDate === null)
            throw new Error("The parameter 'svcDate' cannot be null.");
        else if (svcDate !== undefined)
            url_ += "svcDate=" + encodeURIComponent(svcDate ? "" + svcDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantResponse>;
        }));
    }

    protected processGetParticipantById(response: HttpResponseBase): Observable<ParticipantResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParticipantResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportShiftSummary(body?: ShiftSummarySearchRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/People/participant/shiftsummary/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportShiftSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportShiftSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processExportShiftSummary(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllShiftAndPayrollForParticipants(body?: ShiftSummarySearchRequest | undefined): Observable<ShiftSummary> {
        let url_ = this.baseUrl + "/api/People/participant/shiftsummary/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllShiftAndPayrollForParticipants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllShiftAndPayrollForParticipants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftSummary>;
        }));
    }

    protected processGetAllShiftAndPayrollForParticipants(response: HttpResponseBase): Observable<ShiftSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePersonDetails(body?: PeopleBlastRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/people/peopleblast";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePersonDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePersonDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdatePersonDetails(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertUpdatePersonDetails(body?: PersonDetailsResponse | undefined): Observable<PersonDetailsResponse> {
        let url_ = this.baseUrl + "/api/people/person/upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertUpdatePersonDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertUpdatePersonDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonDetailsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonDetailsResponse>;
        }));
    }

    protected processInsertUpdatePersonDetails(response: HttpResponseBase): Observable<PersonDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonDetailsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = resultData409 !== undefined ? resultData409 : <any>null;
    
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyIvrPin(body?: IVRPinAuthenticationDto | undefined): Observable<IVRPinDto> {
        let url_ = this.baseUrl + "/api/people/person/verifyIvrPin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyIvrPin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyIvrPin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IVRPinDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IVRPinDto>;
        }));
    }

    protected processVerifyIvrPin(response: HttpResponseBase): Observable<IVRPinDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IVRPinDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPersonDetails(body?: string | undefined): Observable<PersonDetailsResponse> {
        let url_ = this.baseUrl + "/api/people/persondetails/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonDetailsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonDetailsResponse>;
        }));
    }

    protected processGetPersonDetails(response: HttpResponseBase): Observable<PersonDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonDetailsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    disassociatePerson(personid: string): Observable<string> {
        let url_ = this.baseUrl + "/api/people/personid/{personid}/disassociate";
        if (personid === undefined || personid === null)
            throw new Error("The parameter 'personid' must be defined.");
        url_ = url_.replace("{personid}", encodeURIComponent("" + personid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisassociatePerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisassociatePerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDisassociatePerson(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmailHistory(personid: string): Observable<EmailHistory[]> {
        let url_ = this.baseUrl + "/api/people/personid/{personid}/emailhistory";
        if (personid === undefined || personid === null)
            throw new Error("The parameter 'personid' must be defined.");
        url_ = url_.replace("{personid}", encodeURIComponent("" + personid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailHistory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailHistory[]>;
        }));
    }

    protected processGetEmailHistory(response: HttpResponseBase): Observable<EmailHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPersonIdByUserObjectId(objectid: string): Observable<PersonIdResponse[]> {
        let url_ = this.baseUrl + "/api/people/personid/fetch/{objectid}";
        if (objectid === undefined || objectid === null)
            throw new Error("The parameter 'objectid' must be defined.");
        url_ = url_.replace("{objectid}", encodeURIComponent("" + objectid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonIdByUserObjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonIdByUserObjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonIdResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonIdResponse[]>;
        }));
    }

    protected processGetPersonIdByUserObjectId(response: HttpResponseBase): Observable<PersonIdResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonIdResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPersonStatus(): Observable<StringInt32KeyValuePair[]> {
        let url_ = this.baseUrl + "/api/people/personstatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringInt32KeyValuePair[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringInt32KeyValuePair[]>;
        }));
    }

    protected processGetPersonStatus(response: HttpResponseBase): Observable<StringInt32KeyValuePair[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StringInt32KeyValuePair.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    personTypeDelete(personId: string, personType: string): Observable<PersonTypeDeleteResponse> {
        let url_ = this.baseUrl + "/api/people/persontype/delete/{personId}/{personType}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (personType === undefined || personType === null)
            throw new Error("The parameter 'personType' must be defined.");
        url_ = url_.replace("{personType}", encodeURIComponent("" + personType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPersonTypeDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPersonTypeDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonTypeDeleteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonTypeDeleteResponse>;
        }));
    }

    protected processPersonTypeDelete(response: HttpResponseBase): Observable<PersonTypeDeleteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonTypeDeleteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllPersonTypes(): Observable<StringInt32KeyValuePair[]> {
        let url_ = this.baseUrl + "/api/people/persontypes/fetch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPersonTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPersonTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringInt32KeyValuePair[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringInt32KeyValuePair[]>;
        }));
    }

    protected processGetAllPersonTypes(response: HttpResponseBase): Observable<StringInt32KeyValuePair[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StringInt32KeyValuePair.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPersonTypesById(personId: string): Observable<PersonTypeResponse[]> {
        let url_ = this.baseUrl + "/api/people/personTypes/fetch/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonTypesById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonTypesById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonTypeResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonTypeResponse[]>;
        }));
    }

    protected processGetPersonTypesById(response: HttpResponseBase): Observable<PersonTypeResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonTypeResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPhoneType(): Observable<StringStringKeyValuePair[]> {
        let url_ = this.baseUrl + "/api/people/phonetype";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPhoneType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPhoneType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringStringKeyValuePair[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringStringKeyValuePair[]>;
        }));
    }

    protected processGetPhoneType(response: HttpResponseBase): Observable<StringStringKeyValuePair[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StringStringKeyValuePair.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPreferredLanguage(): Observable<LanguageDto[]> {
        let url_ = this.baseUrl + "/api/people/preferredlanguage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreferredLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreferredLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LanguageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LanguageDto[]>;
        }));
    }

    protected processGetPreferredLanguage(response: HttpResponseBase): Observable<LanguageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LanguageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllPersonBySearchCriteria(body?: PersonRequestDto | undefined): Observable<PersonResponseDtoGridResponseBase> {
        let url_ = this.baseUrl + "/api/people/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPersonBySearchCriteria(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPersonBySearchCriteria(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonResponseDtoGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonResponseDtoGridResponseBase>;
        }));
    }

    protected processGetAllPersonBySearchCriteria(response: HttpResponseBase): Observable<PersonResponseDtoGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonResponseDtoGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendOneTimeNotification(body?: NotificationStorageRequest | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/people/sendmessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendOneTimeNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendOneTimeNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendOneTimeNotification(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPeopleStatus(): Observable<StatusResponse[]> {
        let url_ = this.baseUrl + "/api/People/status/fetch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPeopleStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPeopleStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusResponse[]>;
        }));
    }

    protected processGetPeopleStatus(response: HttpResponseBase): Observable<StatusResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatusResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getTerminationTypes(): Observable<StatusResponse[]> {
        let url_ = this.baseUrl + "/api/people/termination-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTerminationTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTerminationTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusResponse[]>;
        }));
    }

    protected processGetTerminationTypes(response: HttpResponseBase): Observable<StatusResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatusResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateIvrPin(body?: UpdateIvrPinRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/people/updateivrpin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIvrPin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIvrPin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateIvrPin(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Created
     */
    createPerson(): Observable<PersonResponse> {
        let url_ = this.baseUrl + "/api/person";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonResponse>;
        }));
    }

    protected processCreatePerson(response: HttpResponseBase): Observable<PersonResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PersonResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertPerson(body?: UpsertPersonCommand | undefined): Observable<PersonDetailsResponse> {
        let url_ = this.baseUrl + "/api/person";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonDetailsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonDetailsResponse>;
        }));
    }

    protected processUpsertPerson(response: HttpResponseBase): Observable<PersonDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PersonDetailsResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonDetailsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPersonById(personId: number): Observable<PersonResponseV2> {
        let url_ = this.baseUrl + "/api/person/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonResponseV2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonResponseV2>;
        }));
    }

    protected processGetPersonById(response: HttpResponseBase): Observable<PersonResponseV2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonResponseV2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertCaregiver(personId: number, body?: UpsertCaregiverCommand | undefined): Observable<Int32Response> {
        let url_ = this.baseUrl + "/api/person/{personId}/caregiver";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertCaregiver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCaregiver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32Response>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32Response>;
        }));
    }

    protected processUpsertCaregiver(response: HttpResponseBase): Observable<Int32Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Int32Response.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32Response.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertPersonExternalKey(personId: number, body?: UpsertPersonExternalKeysCommand | undefined): Observable<Int32Response> {
        let url_ = this.baseUrl + "/api/person/{personId}/externalKey";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertPersonExternalKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertPersonExternalKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32Response>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32Response>;
        }));
    }

    protected processUpsertPersonExternalKey(response: HttpResponseBase): Observable<Int32Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32Response.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getStatusHistory(personId: number, body?: string | undefined): Observable<PersonStatusHistory[]> {
        let url_ = this.baseUrl + "/api/person/{personId}/history";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatusHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatusHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonStatusHistory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonStatusHistory[]>;
        }));
    }

    protected processGetStatusHistory(response: HttpResponseBase): Observable<PersonStatusHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonStatusHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertParticipant(personId: number, body?: UpsertParticipantCommand | undefined): Observable<Int32Response> {
        let url_ = this.baseUrl + "/api/person/{personId}/participant";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertParticipant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertParticipant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32Response>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32Response>;
        }));
    }

    protected processUpsertParticipant(response: HttpResponseBase): Observable<Int32Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Int32Response.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32Response.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertProspect(personId: number, body?: UpsertProspectCommand | undefined): Observable<Int32Response> {
        let url_ = this.baseUrl + "/api/person/{personId}/prospect";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertProspect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertProspect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32Response>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32Response>;
        }));
    }

    protected processUpsertProspect(response: HttpResponseBase): Observable<Int32Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Int32Response.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Int32Response.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPersonByEmailId(body?: GetPersonByEmailIdCommand | undefined): Observable<PersonResponseV2> {
        let url_ = this.baseUrl + "/api/person/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonByEmailId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonByEmailId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonResponseV2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonResponseV2>;
        }));
    }

    protected processGetPersonByEmailId(response: HttpResponseBase): Observable<PersonResponseV2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonResponseV2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPersonByExternalKey(body?: GetPersonByExternalKeyCommand | undefined): Observable<PersonResponseV2> {
        let url_ = this.baseUrl + "/api/person/getByExternalKeyAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonByExternalKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonByExternalKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonResponseV2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonResponseV2>;
        }));
    }

    protected processGetPersonByExternalKey(response: HttpResponseBase): Observable<PersonResponseV2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonResponseV2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertUpdatePersonAddressAndPhone(body?: PersonPhoneAddress | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/person/phoneandaddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertUpdatePersonAddressAndPhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertUpdatePersonAddressAndPhone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processInsertUpdatePersonAddressAndPhone(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPersonStatusV2HistoryById(personId: number, body?: GetHistoryRequestBase | undefined): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/PersonStatus/{personId}/statushistory";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonStatusV2HistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonStatusV2HistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetPersonStatusV2HistoryById(response: HttpResponseBase): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPersonStatusActions(entityId: number): Observable<SystemAction[]> {
        let url_ = this.baseUrl + "/api/PersonStatus/actions/fetch/{entityId}";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonStatusActions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonStatusActions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemAction[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemAction[]>;
        }));
    }

    protected processGetPersonStatusActions(response: HttpResponseBase): Observable<SystemAction[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SystemAction.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createStatusConfigurations(body?: EntityStatus[] | undefined): Observable<EntityStatus[]> {
        let url_ = this.baseUrl + "/api/PersonStatus/configurations/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStatusConfigurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStatusConfigurations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityStatus[]>;
        }));
    }

    protected processCreateStatusConfigurations(response: HttpResponseBase): Observable<EntityStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getStatusConfigurations(): Observable<EntityStatus[]> {
        let url_ = this.baseUrl + "/api/PersonStatus/configurations/fetch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatusConfigurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatusConfigurations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityStatus[]>;
        }));
    }

    protected processGetStatusConfigurations(response: HttpResponseBase): Observable<EntityStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getStatusConfigurationsByEntityType(entityId: number): Observable<EntityStatus[]> {
        let url_ = this.baseUrl + "/api/PersonStatus/configurations/fetch/{entityId}";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatusConfigurationsByEntityType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatusConfigurationsByEntityType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityStatus[]>;
        }));
    }

    protected processGetStatusConfigurationsByEntityType(response: HttpResponseBase): Observable<EntityStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDefaultStatusConfigurationByEntityType(entityType: string): Observable<string> {
        let url_ = this.baseUrl + "/api/PersonStatus/configurations/fetch/default/{entityType}";
        if (entityType === undefined || entityType === null)
            throw new Error("The parameter 'entityType' must be defined.");
        url_ = url_.replace("{entityType}", encodeURIComponent("" + entityType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultStatusConfigurationByEntityType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultStatusConfigurationByEntityType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDefaultStatusConfigurationByEntityType(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getStatusConfigurationsByPerson(body?: GetStatusConfigurationsByPersonCommand | undefined): Observable<EntityStatus[]> {
        let url_ = this.baseUrl + "/api/PersonStatus/configurations/person/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatusConfigurationsByPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatusConfigurationsByPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityStatus[]>;
        }));
    }

    protected processGetStatusConfigurationsByPerson(response: HttpResponseBase): Observable<EntityStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStatusConfigurations(body?: EntityStatus[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PersonStatus/configurations/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatusConfigurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusConfigurations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateStatusConfigurations(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPersonEntities(): Observable<EntityType[]> {
        let url_ = this.baseUrl + "/api/PersonStatus/entities/fetch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityType[]>;
        }));
    }

    protected processGetPersonEntities(response: HttpResponseBase): Observable<EntityType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEntityStatus(body?: EntityStatusResponse[] | undefined): Observable<EntityStatusResponse[]> {
        let url_ = this.baseUrl + "/api/PersonStatus/status/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEntityStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEntityStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityStatusResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityStatusResponse[]>;
        }));
    }

    protected processCreateEntityStatus(response: HttpResponseBase): Observable<EntityStatusResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityStatusResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getEntityStatus(body?: EntityStatusRequest[] | undefined): Observable<EntityStatusResponse[]> {
        let url_ = this.baseUrl + "/api/PersonStatus/status/fetch/entityId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityStatusResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityStatusResponse[]>;
        }));
    }

    protected processGetEntityStatus(response: HttpResponseBase): Observable<EntityStatusResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityStatusResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEntityStatus(body?: EntityStatusResponse[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PersonStatus/status/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEntityStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEntityStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateEntityStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertEntityStatus(body?: EntityStatusResponse[] | undefined): Observable<EntityStatusResponse[]> {
        let url_ = this.baseUrl + "/api/PersonStatus/status/upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertEntityStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertEntityStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityStatusResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityStatusResponse[]>;
        }));
    }

    protected processUpsertEntityStatus(response: HttpResponseBase): Observable<EntityStatusResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityStatusResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validatePersonStatusIntegrationRequest(body?: EntityStatusResponse[] | undefined): Observable<EntityStatusResponse[]> {
        let url_ = this.baseUrl + "/api/PersonStatus/status/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePersonStatusIntegrationRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePersonStatusIntegrationRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityStatusResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityStatusResponse[]>;
        }));
    }

    protected processValidatePersonStatusIntegrationRequest(response: HttpResponseBase): Observable<EntityStatusResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityStatusResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPersonHistoryById(personId: number, body?: GetHistoryRequestBase | undefined): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/personv2/{personId}/History";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetPersonHistoryById(response: HttpResponseBase): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    ping(): Observable<void> {
        let url_ = this.baseUrl + "/api/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPortalUser(body?: PortalUserRequest | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PortalUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePortalUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePortalUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreatePortalUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deletePortalUser(body?: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PortalUser/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePortalUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePortalUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeletePortalUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    get(body?: PortalUserFilterRequest | undefined): Observable<PortalUserDTOGridResponseBase> {
        let url_ = this.baseUrl + "/api/PortalUser/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PortalUserDTOGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PortalUserDTOGridResponseBase>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PortalUserDTOGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PortalUserDTOGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPortalUserData(body?: PortalUserMappedRequest | undefined): Observable<PortalUserDTO[]> {
        let url_ = this.baseUrl + "/api/PortalUser/getMappedUserDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPortalUserData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPortalUserData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PortalUserDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PortalUserDTO[]>;
        }));
    }

    protected processGetPortalUserData(response: HttpResponseBase): Observable<PortalUserDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PortalUserDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPortalUserPersonAction(personId: string, person: string): Observable<PortalActions[]> {
        let url_ = this.baseUrl + "/api/PortalUser/getPersonActionDetails/{personId}/{person}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (person === undefined || person === null)
            throw new Error("The parameter 'person' must be defined.");
        url_ = url_.replace("{person}", encodeURIComponent("" + person));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPortalUserPersonAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPortalUserPersonAction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PortalActions[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PortalActions[]>;
        }));
    }

    protected processGetPortalUserPersonAction(response: HttpResponseBase): Observable<PortalActions[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PortalActions.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPortalUserRoleMappingData(body?: PortalUserRequest | undefined): Observable<PortalUserDetails[]> {
        let url_ = this.baseUrl + "/api/PortalUser/getRoleMapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPortalUserRoleMappingData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPortalUserRoleMappingData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PortalUserDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PortalUserDetails[]>;
        }));
    }

    protected processGetPortalUserRoleMappingData(response: HttpResponseBase): Observable<PortalUserDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PortalUserDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPortalUserMappingData(body?: PortalUserRequest | undefined): Observable<PortalUserMapping[]> {
        let url_ = this.baseUrl + "/api/PortalUser/getUserMapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPortalUserMappingData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPortalUserMappingData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PortalUserMapping[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PortalUserMapping[]>;
        }));
    }

    protected processGetPortalUserMappingData(response: HttpResponseBase): Observable<PortalUserMapping[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PortalUserMapping.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    onBoardPortalUser(body?: PortalUsersRequest[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PortalUser/onboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnBoardPortalUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnBoardPortalUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processOnBoardPortalUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPortalUserRoles(body?: PortalUserRequest | undefined): Observable<PersonRoleResponse[]> {
        let url_ = this.baseUrl + "/api/PortalUser/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPortalUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPortalUserRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonRoleResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonRoleResponse[]>;
        }));
    }

    protected processGetPortalUserRoles(response: HttpResponseBase): Observable<PersonRoleResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonRoleResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setLastV4LoginOn(body?: PortalUserSetLastV4LoginOnRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/PortalUser/setLastV4LoginOn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetLastV4LoginOn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetLastV4LoginOn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processSetLastV4LoginOn(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkValidateSsn(body?: PortalUserSsnValidationRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/PortalUser/ssnValidate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckValidateSsn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckValidateSsn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCheckValidateSsn(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    overrideSsnValidation(body?: PortalUserSsnValidationOverrideRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/PortalUser/ssnValidationOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOverrideSsnValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOverrideSsnValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processOverrideSsnValidation(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetSsnValidation(body?: PortalUserSsnValidationResetRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/PortalUser/ssnValidationReset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetSsnValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetSsnValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processResetSsnValidation(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param qualificationRoleId (optional) 
     * @param qualificationTypeId (optional) 
     * @return Success
     */
    getAllPrereqQualificationTypesByRole(qualificationRoleId?: number | undefined, qualificationTypeId?: number | undefined): Observable<QualificationTypeDto[]> {
        let url_ = this.baseUrl + "/api/PrereqQualificationTypesByRoleId?";
        if (qualificationRoleId === null)
            throw new Error("The parameter 'qualificationRoleId' cannot be null.");
        else if (qualificationRoleId !== undefined)
            url_ += "qualificationRoleId=" + encodeURIComponent("" + qualificationRoleId) + "&";
        if (qualificationTypeId === null)
            throw new Error("The parameter 'qualificationTypeId' cannot be null.");
        else if (qualificationTypeId !== undefined)
            url_ += "qualificationTypeId=" + encodeURIComponent("" + qualificationTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPrereqQualificationTypesByRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPrereqQualificationTypesByRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualificationTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualificationTypeDto[]>;
        }));
    }

    protected processGetAllPrereqQualificationTypesByRole(response: HttpResponseBase): Observable<QualificationTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QualificationTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProspectById(id: number): Observable<PersonResponseV2> {
        let url_ = this.baseUrl + "/api/prospect/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProspectById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProspectById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonResponseV2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonResponseV2>;
        }));
    }

    protected processGetProspectById(response: HttpResponseBase): Observable<PersonResponseV2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonResponseV2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isOkToDrive(body?: IsOkToWorkCommand | undefined): Observable<OkToWorkDate[]> {
        let url_ = this.baseUrl + "/api/qualification/isoktodrive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsOkToDrive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsOkToDrive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OkToWorkDate[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OkToWorkDate[]>;
        }));
    }

    protected processIsOkToDrive(response: HttpResponseBase): Observable<OkToWorkDate[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OkToWorkDate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isOkToWork(body?: IsOkToWorkCommand | undefined): Observable<OkToWorkDate[]> {
        let url_ = this.baseUrl + "/api/qualification/isoktowork";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsOkToWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsOkToWork(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OkToWorkDate[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OkToWorkDate[]>;
        }));
    }

    protected processIsOkToWork(response: HttpResponseBase): Observable<OkToWorkDate[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OkToWorkDate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllQualificationCategories(): Observable<QualificationCategoryDto[]> {
        let url_ = this.baseUrl + "/api/QualificationCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllQualificationCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllQualificationCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualificationCategoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualificationCategoryDto[]>;
        }));
    }

    protected processGetAllQualificationCategories(response: HttpResponseBase): Observable<QualificationCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QualificationCategoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    qualificationClassUpsert(body?: QualificationClassRequest | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/qualificationclass";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQualificationClassUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQualificationClassUpsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processQualificationClassUpsert(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getQualificationClassDetailsByQualificationTypeId(qualificationTypeId: number): Observable<QualificationClassDto[]> {
        let url_ = this.baseUrl + "/api/qualificationclass/{qualificationTypeId}";
        if (qualificationTypeId === undefined || qualificationTypeId === null)
            throw new Error("The parameter 'qualificationTypeId' must be defined.");
        url_ = url_.replace("{qualificationTypeId}", encodeURIComponent("" + qualificationTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualificationClassDetailsByQualificationTypeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualificationClassDetailsByQualificationTypeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualificationClassDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualificationClassDto[]>;
        }));
    }

    protected processGetQualificationClassDetailsByQualificationTypeId(response: HttpResponseBase): Observable<QualificationClassDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QualificationClassDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkIfDuplicateQualificationClass(body?: QualificationClassDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/qualificationclass/duplicacycheck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfDuplicateQualificationClass(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfDuplicateQualificationClass(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCheckIfDuplicateQualificationClass(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    qualificationTypeUpsert(body?: QualificationTypeRequest | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/qualificationType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQualificationTypeUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQualificationTypeUpsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processQualificationTypeUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getQualificationTypeById(qualificationTypeId: number): Observable<QualificationTypeDto> {
        let url_ = this.baseUrl + "/api/qualificationType/{qualificationTypeId}";
        if (qualificationTypeId === undefined || qualificationTypeId === null)
            throw new Error("The parameter 'qualificationTypeId' must be defined.");
        url_ = url_.replace("{qualificationTypeId}", encodeURIComponent("" + qualificationTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualificationTypeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualificationTypeById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualificationTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualificationTypeDto>;
        }));
    }

    protected processGetQualificationTypeById(response: HttpResponseBase): Observable<QualificationTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualificationTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteCaregiverQualificationTypeMapping(body?: QualificationTypeCoursesMappingRequest[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/qualificationTypeCourse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCaregiverQualificationTypeMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCaregiverQualificationTypeMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteCaregiverQualificationTypeMapping(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param showInactive (optional) 
     * @param showDefault (optional) 
     * @return Success
     */
    getAllQualificationTypes(showInactive?: boolean | undefined, showDefault?: boolean | undefined): Observable<QualificationTypeDto[]> {
        let url_ = this.baseUrl + "/api/QualificationTypes?";
        if (showInactive === null)
            throw new Error("The parameter 'showInactive' cannot be null.");
        else if (showInactive !== undefined)
            url_ += "showInactive=" + encodeURIComponent("" + showInactive) + "&";
        if (showDefault === null)
            throw new Error("The parameter 'showDefault' cannot be null.");
        else if (showDefault !== undefined)
            url_ += "showDefault=" + encodeURIComponent("" + showDefault) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllQualificationTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllQualificationTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualificationTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualificationTypeDto[]>;
        }));
    }

    protected processGetAllQualificationTypes(response: HttpResponseBase): Observable<QualificationTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QualificationTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param qualificationRoleId (optional) 
     * @return Success
     */
    getAllQualificationTypesByRole(qualificationRoleId?: number | undefined): Observable<QualificationTypeDto[]> {
        let url_ = this.baseUrl + "/api/QualificationTypesByRoleId?";
        if (qualificationRoleId === null)
            throw new Error("The parameter 'qualificationRoleId' cannot be null.");
        else if (qualificationRoleId !== undefined)
            url_ += "qualificationRoleId=" + encodeURIComponent("" + qualificationRoleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllQualificationTypesByRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllQualificationTypesByRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualificationTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualificationTypeDto[]>;
        }));
    }

    protected processGetAllQualificationTypesByRole(response: HttpResponseBase): Observable<QualificationTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QualificationTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param acn (optional) 
     * @return Success
     */
    getParticipantsRelatedPeople(participantPersonId: string, acn?: string | undefined): Observable<PeopleRelation[]> {
        let url_ = this.baseUrl + "/api/RelatedPeople/{participantPersonId}?";
        if (participantPersonId === undefined || participantPersonId === null)
            throw new Error("The parameter 'participantPersonId' must be defined.");
        url_ = url_.replace("{participantPersonId}", encodeURIComponent("" + participantPersonId));
        if (acn === null)
            throw new Error("The parameter 'acn' cannot be null.");
        else if (acn !== undefined)
            url_ += "acn=" + encodeURIComponent("" + acn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantsRelatedPeople(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantsRelatedPeople(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeopleRelation[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeopleRelation[]>;
        }));
    }

    protected processGetParticipantsRelatedPeople(response: HttpResponseBase): Observable<PeopleRelation[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PeopleRelation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getParticipantsRelatedPeopleByRoute(participantPersonId: string, acn: string): Observable<PeopleRelation[]> {
        let url_ = this.baseUrl + "/api/RelatedPeople/{participantPersonId}/{acn}";
        if (participantPersonId === undefined || participantPersonId === null)
            throw new Error("The parameter 'participantPersonId' must be defined.");
        url_ = url_.replace("{participantPersonId}", encodeURIComponent("" + participantPersonId));
        if (acn === undefined || acn === null)
            throw new Error("The parameter 'acn' must be defined.");
        url_ = url_.replace("{acn}", encodeURIComponent("" + acn));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantsRelatedPeopleByRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantsRelatedPeopleByRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeopleRelation[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeopleRelation[]>;
        }));
    }

    protected processGetParticipantsRelatedPeopleByRoute(response: HttpResponseBase): Observable<PeopleRelation[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PeopleRelation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personType (optional) 
     * @return Success
     */
    geAgencyAdminRelatedPeople(agencyAdminPersonId: string, personType?: PersonTypes | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/RelatedPeople/aa/{agencyAdminPersonId}?";
        if (agencyAdminPersonId === undefined || agencyAdminPersonId === null)
            throw new Error("The parameter 'agencyAdminPersonId' must be defined.");
        url_ = url_.replace("{agencyAdminPersonId}", encodeURIComponent("" + agencyAdminPersonId));
        if (personType === null)
            throw new Error("The parameter 'personType' cannot be null.");
        else if (personType !== undefined)
            url_ += "personType=" + encodeURIComponent("" + personType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeAgencyAdminRelatedPeople(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeAgencyAdminRelatedPeople(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGeAgencyAdminRelatedPeople(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaseManagerRelatedPeople(body?: RelatedPersonRequest | undefined): Observable<PeopleRelation[]> {
        let url_ = this.baseUrl + "/api/RelatedPeople/casemanagerrelatedpeople";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseManagerRelatedPeople(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseManagerRelatedPeople(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeopleRelation[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeopleRelation[]>;
        }));
    }

    protected processGetCaseManagerRelatedPeople(response: HttpResponseBase): Observable<PeopleRelation[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PeopleRelation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaregiverRelatedPeopleByList(body?: string[] | undefined): Observable<PeopleRelationMultiLevel[]> {
        let url_ = this.baseUrl + "/api/RelatedPeople/cg";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverRelatedPeopleByList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverRelatedPeopleByList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeopleRelationMultiLevel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeopleRelationMultiLevel[]>;
        }));
    }

    protected processGetCaregiverRelatedPeopleByList(response: HttpResponseBase): Observable<PeopleRelationMultiLevel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PeopleRelationMultiLevel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personType (optional) 
     * @return Success
     */
    getCaregiverRelations(caregiverPersonId: string, personType?: PersonTypes | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/RelatedPeople/cg/{caregiverPersonId}?";
        if (caregiverPersonId === undefined || caregiverPersonId === null)
            throw new Error("The parameter 'caregiverPersonId' must be defined.");
        url_ = url_.replace("{caregiverPersonId}", encodeURIComponent("" + caregiverPersonId));
        if (personType === null)
            throw new Error("The parameter 'personType' cannot be null.");
        else if (personType !== undefined)
            url_ += "personType=" + encodeURIComponent("" + personType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverRelations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverRelations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetCaregiverRelations(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personType (optional) 
     * @return Success
     */
    getCaregiverProspectRelatedPeopleForAcl(caregiverProspectPersonId: string, personType?: PersonTypes | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/RelatedPeople/cgp/{caregiverProspectPersonId}?";
        if (caregiverProspectPersonId === undefined || caregiverProspectPersonId === null)
            throw new Error("The parameter 'caregiverProspectPersonId' must be defined.");
        url_ = url_.replace("{caregiverProspectPersonId}", encodeURIComponent("" + caregiverProspectPersonId));
        if (personType === null)
            throw new Error("The parameter 'personType' cannot be null.");
        else if (personType !== undefined)
            url_ += "personType=" + encodeURIComponent("" + personType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverProspectRelatedPeopleForAcl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverProspectRelatedPeopleForAcl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetCaregiverProspectRelatedPeopleForAcl(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverRelatedPeople(caregiverPersonId: string): Observable<PeopleRelation[]> {
        let url_ = this.baseUrl + "/api/RelatedPeople/cgv/{caregiverPersonId}";
        if (caregiverPersonId === undefined || caregiverPersonId === null)
            throw new Error("The parameter 'caregiverPersonId' must be defined.");
        url_ = url_.replace("{caregiverPersonId}", encodeURIComponent("" + caregiverPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverRelatedPeople(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverRelatedPeople(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeopleRelation[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeopleRelation[]>;
        }));
    }

    protected processGetCaregiverRelatedPeople(response: HttpResponseBase): Observable<PeopleRelation[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PeopleRelation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personType (optional) 
     * @return Success
     */
    getCaseManagerRelatedPeopleForAcl(caseManagerPersonId: string, personType?: PersonTypes | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/RelatedPeople/cm/{caseManagerPersonId}?";
        if (caseManagerPersonId === undefined || caseManagerPersonId === null)
            throw new Error("The parameter 'caseManagerPersonId' must be defined.");
        url_ = url_.replace("{caseManagerPersonId}", encodeURIComponent("" + caseManagerPersonId));
        if (personType === null)
            throw new Error("The parameter 'personType' cannot be null.");
        else if (personType !== undefined)
            url_ += "personType=" + encodeURIComponent("" + personType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseManagerRelatedPeopleForAcl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseManagerRelatedPeopleForAcl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetCaseManagerRelatedPeopleForAcl(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCoordinatorRelatedPeople(body?: RelatedPersonRequest | undefined): Observable<PeopleRelation[]> {
        let url_ = this.baseUrl + "/api/RelatedPeople/coordinatorrelatedpeople";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoordinatorRelatedPeople(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoordinatorRelatedPeople(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeopleRelation[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeopleRelation[]>;
        }));
    }

    protected processGetCoordinatorRelatedPeople(response: HttpResponseBase): Observable<PeopleRelation[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PeopleRelation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCoordinatorRelPeople(body?: ReAssignCoordinator | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/RelatedPeople/coordinatorrelatedpeople/reassign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCoordinatorRelPeople(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCoordinatorRelPeople(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateCoordinatorRelPeople(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personType (optional) 
     * @return Success
     */
    getDesignatedRepresentativeRelatedPeople(designatedRepresentativePersonId: string, personType?: PersonTypes | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/RelatedPeople/dr/{designatedRepresentativePersonId}?";
        if (designatedRepresentativePersonId === undefined || designatedRepresentativePersonId === null)
            throw new Error("The parameter 'designatedRepresentativePersonId' must be defined.");
        url_ = url_.replace("{designatedRepresentativePersonId}", encodeURIComponent("" + designatedRepresentativePersonId));
        if (personType === null)
            throw new Error("The parameter 'personType' cannot be null.");
        else if (personType !== undefined)
            url_ += "personType=" + encodeURIComponent("" + personType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDesignatedRepresentativeRelatedPeople(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDesignatedRepresentativeRelatedPeople(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetDesignatedRepresentativeRelatedPeople(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personType (optional) 
     * @return Success
     */
    getEmployerOfRecordRelatedPeople(employerOfRecordPersonId: string, personType?: PersonTypes | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/RelatedPeople/eor/{employerOfRecordPersonId}?";
        if (employerOfRecordPersonId === undefined || employerOfRecordPersonId === null)
            throw new Error("The parameter 'employerOfRecordPersonId' must be defined.");
        url_ = url_.replace("{employerOfRecordPersonId}", encodeURIComponent("" + employerOfRecordPersonId));
        if (personType === null)
            throw new Error("The parameter 'personType' cannot be null.");
        else if (personType !== undefined)
            url_ += "personType=" + encodeURIComponent("" + personType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerOfRecordRelatedPeople(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerOfRecordRelatedPeople(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetEmployerOfRecordRelatedPeople(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personType (optional) 
     * @return Success
     */
    geMCORelatedPeople(mcoPersonId: string, personType?: PersonTypes | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/RelatedPeople/mco/{mcoPersonId}?";
        if (mcoPersonId === undefined || mcoPersonId === null)
            throw new Error("The parameter 'mcoPersonId' must be defined.");
        url_ = url_.replace("{mcoPersonId}", encodeURIComponent("" + mcoPersonId));
        if (personType === null)
            throw new Error("The parameter 'personType' cannot be null.");
        else if (personType !== undefined)
            url_ += "personType=" + encodeURIComponent("" + personType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeMCORelatedPeople(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeMCORelatedPeople(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGeMCORelatedPeople(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personType (optional) 
     * @return Success
     */
    getCoordinatorRelatedPeopleForAcl(coordinatorPersonId: string, personType?: PersonTypes | undefined): Observable<PeopleRelation[]> {
        let url_ = this.baseUrl + "/api/RelatedPeople/pc/{coordinatorPersonId}?";
        if (coordinatorPersonId === undefined || coordinatorPersonId === null)
            throw new Error("The parameter 'coordinatorPersonId' must be defined.");
        url_ = url_.replace("{coordinatorPersonId}", encodeURIComponent("" + coordinatorPersonId));
        if (personType === null)
            throw new Error("The parameter 'personType' cannot be null.");
        else if (personType !== undefined)
            url_ += "personType=" + encodeURIComponent("" + personType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoordinatorRelatedPeopleForAcl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoordinatorRelatedPeopleForAcl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeopleRelation[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeopleRelation[]>;
        }));
    }

    protected processGetCoordinatorRelatedPeopleForAcl(response: HttpResponseBase): Observable<PeopleRelation[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PeopleRelation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getParticipantsRelatedPeopleByList(body?: string[] | undefined): Observable<PeopleRelationMultiLevel[]> {
        let url_ = this.baseUrl + "/api/RelatedPeople/ptp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantsRelatedPeopleByList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantsRelatedPeopleByList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeopleRelationMultiLevel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeopleRelationMultiLevel[]>;
        }));
    }

    protected processGetParticipantsRelatedPeopleByList(response: HttpResponseBase): Observable<PeopleRelationMultiLevel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PeopleRelationMultiLevel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personType (optional) 
     * @return Success
     */
    getParticipantsRelations(participantPersonId: string, personType?: PersonTypes | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/RelatedPeople/ptp/{participantPersonId}?";
        if (participantPersonId === undefined || participantPersonId === null)
            throw new Error("The parameter 'participantPersonId' must be defined.");
        url_ = url_.replace("{participantPersonId}", encodeURIComponent("" + participantPersonId));
        if (personType === null)
            throw new Error("The parameter 'personType' cannot be null.");
        else if (personType !== undefined)
            url_ += "personType=" + encodeURIComponent("" + personType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantsRelations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantsRelations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetParticipantsRelations(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getParticipantPaidCaregivers(body?: ParticipantPaidCaregiversRequest | undefined): Observable<PtpPaidCaregiversDto[]> {
        let url_ = this.baseUrl + "/api/RelatedPeople/ptp/paid/caregivers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantPaidCaregivers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantPaidCaregivers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PtpPaidCaregiversDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PtpPaidCaregiversDto[]>;
        }));
    }

    protected processGetParticipantPaidCaregivers(response: HttpResponseBase): Observable<PtpPaidCaregiversDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PtpPaidCaregiversDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personType (optional) 
     * @return Success
     */
    geServiceFacilitatorRelatedPeople(serviceFacilitatorPersonId: string, personType?: PersonTypes | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/RelatedPeople/sf/{serviceFacilitatorPersonId}?";
        if (serviceFacilitatorPersonId === undefined || serviceFacilitatorPersonId === null)
            throw new Error("The parameter 'serviceFacilitatorPersonId' must be defined.");
        url_ = url_.replace("{serviceFacilitatorPersonId}", encodeURIComponent("" + serviceFacilitatorPersonId));
        if (personType === null)
            throw new Error("The parameter 'personType' cannot be null.");
        else if (personType !== undefined)
            url_ += "personType=" + encodeURIComponent("" + personType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeServiceFacilitatorRelatedPeople(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeServiceFacilitatorRelatedPeople(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGeServiceFacilitatorRelatedPeople(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllRptFreq(): Observable<RptFreqDto[]> {
        let url_ = this.baseUrl + "/api/RptFreq";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRptFreq(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRptFreq(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RptFreqDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RptFreqDto[]>;
        }));
    }

    protected processGetAllRptFreq(response: HttpResponseBase): Observable<RptFreqDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RptFreqDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPeopleDataForRules(body?: GetPeopleDataForRulesRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/RulesData/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPeopleDataForRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPeopleDataForRules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetPeopleDataForRules(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertServiceFacilitator(body?: PersonAgenciesDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/ServiceFacilitator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertServiceFacilitator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertServiceFacilitator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpsertServiceFacilitator(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCaseLoadParticipant(caseLoadId: number, body?: FilterRequest | undefined): Observable<CaseLoadParticipantGridResponseBase> {
        let url_ = this.baseUrl + "/api/ServiceFacilitator/{caseLoadId}/participant/fetch";
        if (caseLoadId === undefined || caseLoadId === null)
            throw new Error("The parameter 'caseLoadId' must be defined.");
        url_ = url_.replace("{caseLoadId}", encodeURIComponent("" + caseLoadId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaseLoadParticipant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaseLoadParticipant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaseLoadParticipantGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaseLoadParticipantGridResponseBase>;
        }));
    }

    protected processGetCaseLoadParticipant(response: HttpResponseBase): Observable<CaseLoadParticipantGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaseLoadParticipantGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getServiceFacilitatorDetailsHistoryById(id: number, body?: GetHistoryRequestBase | undefined): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        let url_ = this.baseUrl + "/api/ServiceFacilitator/{id}/servicefacilitatordetailshistory";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceFacilitatorDetailsHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceFacilitatorDetailsHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]>;
        }));
    }

    protected processGetServiceFacilitatorDetailsHistoryById(response: HttpResponseBase): Observable<ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getServiceFacilitator(personId: string): Observable<PersonAgenciesDto> {
        let url_ = this.baseUrl + "/api/ServiceFacilitator/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceFacilitator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceFacilitator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonAgenciesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonAgenciesDto>;
        }));
    }

    protected processGetServiceFacilitator(response: HttpResponseBase): Observable<PersonAgenciesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonAgenciesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getServiceFacilitatorAgencies(personId: string): Observable<AgencyPersonMapping[]> {
        let url_ = this.baseUrl + "/api/ServiceFacilitator/{personId}/agencies";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceFacilitatorAgencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceFacilitatorAgencies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgencyPersonMapping[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgencyPersonMapping[]>;
        }));
    }

    protected processGetServiceFacilitatorAgencies(response: HttpResponseBase): Observable<AgencyPersonMapping[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgencyPersonMapping.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getServiceFacilitatorCaseLoad(personId: string): Observable<ServiceFacilitatorCaseLoad[]> {
        let url_ = this.baseUrl + "/api/ServiceFacilitator/{personId}/caseLoad/fetch";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceFacilitatorCaseLoad(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceFacilitatorCaseLoad(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceFacilitatorCaseLoad[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceFacilitatorCaseLoad[]>;
        }));
    }

    protected processGetServiceFacilitatorCaseLoad(response: HttpResponseBase): Observable<ServiceFacilitatorCaseLoad[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceFacilitatorCaseLoad.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getServiceFacilitatorStatusHistory(personId: string): Observable<StatusHistory> {
        let url_ = this.baseUrl + "/api/ServiceFacilitator/{personId}/history";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceFacilitatorStatusHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceFacilitatorStatusHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusHistory>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusHistory>;
        }));
    }

    protected processGetServiceFacilitatorStatusHistory(response: HttpResponseBase): Observable<StatusHistory> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatusHistory.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getServiceFacilitatorProfile(personId: string): Observable<ServiceFacilitatorProfile> {
        let url_ = this.baseUrl + "/api/ServiceFacilitator/{personId}/profile";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceFacilitatorProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceFacilitatorProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceFacilitatorProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceFacilitatorProfile>;
        }));
    }

    protected processGetServiceFacilitatorProfile(response: HttpResponseBase): Observable<ServiceFacilitatorProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceFacilitatorProfile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getServiceFacilitatorById(id: number): Observable<ServiceFacilitatorDetails> {
        let url_ = this.baseUrl + "/api/ServiceFacilitator/details/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceFacilitatorById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceFacilitatorById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceFacilitatorDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceFacilitatorDetails>;
        }));
    }

    protected processGetServiceFacilitatorById(response: HttpResponseBase): Observable<ServiceFacilitatorDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceFacilitatorDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getStatus(category: string): Observable<StatusResponse[]> {
        let url_ = this.baseUrl + "/api/Status/{category}";
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusResponse[]>;
        }));
    }

    protected processGetStatus(response: HttpResponseBase): Observable<StatusResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatusResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getTasks(body?: TasksRequest | undefined): Observable<TasksResponse[]> {
        let url_ = this.baseUrl + "/api/Tasks/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TasksResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TasksResponse[]>;
        }));
    }

    protected processGetTasks(response: HttpResponseBase): Observable<TasksResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TasksResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getParticipantExpiryTasks(body?: ParticipantExpiryTasksRequest | undefined): Observable<ParticipantExpiryTasksResponse[]> {
        let url_ = this.baseUrl + "/api/Tasks/participanttasks/expiry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantExpiryTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantExpiryTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantExpiryTasksResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantExpiryTasksResponse[]>;
        }));
    }

    protected processGetParticipantExpiryTasks(response: HttpResponseBase): Observable<ParticipantExpiryTasksResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParticipantExpiryTasksResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getTaskCodes(body?: FilterRequest | undefined): Observable<TaskCodeGridResponseBase> {
        let url_ = this.baseUrl + "/api/Tasks/taskcodes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskCodeGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskCodeGridResponseBase>;
        }));
    }

    protected processGetTaskCodes(response: HttpResponseBase): Observable<TaskCodeGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskCodeGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllTaskConfigurationByPayorId(body?: TaskConfigurationFetchRequest | undefined): Observable<TaskConfigurationResponse> {
        let url_ = this.baseUrl + "/api/Tasks/taskconfiguration/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTaskConfigurationByPayorId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTaskConfigurationByPayorId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskConfigurationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskConfigurationResponse>;
        }));
    }

    protected processGetAllTaskConfigurationByPayorId(response: HttpResponseBase): Observable<TaskConfigurationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskConfigurationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertTaskConfiguration(body?: TaskConfigurationSaveRequest | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Tasks/taskconfiguration/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertTaskConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertTaskConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpsertTaskConfiguration(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getTerritory(): Observable<TerritoryDto[]> {
        let url_ = this.baseUrl + "/api/Territory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTerritory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTerritory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TerritoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TerritoryDto[]>;
        }));
    }

    protected processGetTerritory(response: HttpResponseBase): Observable<TerritoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TerritoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getTwenty147Status(body?: Twenty147StatusRequest | undefined): Observable<Twenty147StatusResponse> {
        let url_ = this.baseUrl + "/api/twenty147status/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTwenty147Status(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTwenty147Status(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Twenty147StatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Twenty147StatusResponse>;
        }));
    }

    protected processGetTwenty147Status(response: HttpResponseBase): Observable<Twenty147StatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Twenty147StatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    batchType(): Observable<StringStringKeyValuePair[]> {
        let url_ = this.baseUrl + "/api/Uct/batch-type";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringStringKeyValuePair[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringStringKeyValuePair[]>;
        }));
    }

    protected processBatchType(response: HttpResponseBase): Observable<StringStringKeyValuePair[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StringStringKeyValuePair.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertBatch(body?: UctConfiguration | undefined): Observable<UctResponse[]> {
        let url_ = this.baseUrl + "/api/Uct/insert-batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UctResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UctResponse[]>;
        }));
    }

    protected processInsertBatch(response: HttpResponseBase): Observable<UctResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UctResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCaregiverById(id: number): Observable<CaregiverResponseV2> {
        let url_ = this.baseUrl + "/api/v2/caregiver/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCaregiverById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCaregiverById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverResponseV2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverResponseV2>;
        }));
    }

    protected processGetCaregiverById(response: HttpResponseBase): Observable<CaregiverResponseV2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverResponseV2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getParticipantByPersonId(personId: number): Observable<ParticipantResponseV2> {
        let url_ = this.baseUrl + "/api/v2/participant/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantByPersonId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantByPersonId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantResponseV2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantResponseV2>;
        }));
    }

    protected processGetParticipantByPersonId(response: HttpResponseBase): Observable<ParticipantResponseV2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParticipantResponseV2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export enum Action {
    None = "None",
    Success = "Success",
    Created = "Created",
    Accepted = "Accepted",
    Updated = "Updated",
    Deleted = "Deleted",
}

export class ActionDetails implements IActionDetails {
    reasonId?: number;
    action?: string | undefined;
    actionId?: number;

    constructor(data?: IActionDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reasonId = _data["reasonId"];
            this.action = _data["action"];
            this.actionId = _data["actionId"];
        }
    }

    static fromJS(data: any): ActionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ActionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reasonId"] = this.reasonId;
        data["action"] = this.action;
        data["actionId"] = this.actionId;
        return data;
    }
}

export interface IActionDetails {
    reasonId?: number;
    action?: string | undefined;
    actionId?: number;
}

export class AddressDTO implements IAddressDTO {
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    country?: string | undefined;
    county?: string | undefined;
    type?: AddressType;
    personInternalId?: number;
    personAddressId?: number | undefined;
    isDefault?: boolean;
    verificationStatus?: AddressVerificationStatus;
    latitude?: number | undefined;
    longitude?: number | undefined;
    validationOverride?: boolean;

    constructor(data?: IAddressDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.country = _data["country"];
            this.county = _data["county"];
            this.type = _data["type"];
            this.personInternalId = _data["personInternalId"];
            this.personAddressId = _data["personAddressId"];
            this.isDefault = _data["isDefault"];
            this.verificationStatus = _data["verificationStatus"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.validationOverride = _data["validationOverride"];
        }
    }

    static fromJS(data: any): AddressDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["country"] = this.country;
        data["county"] = this.county;
        data["type"] = this.type;
        data["personInternalId"] = this.personInternalId;
        data["personAddressId"] = this.personAddressId;
        data["isDefault"] = this.isDefault;
        data["verificationStatus"] = this.verificationStatus;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["validationOverride"] = this.validationOverride;
        return data;
    }
}

export interface IAddressDTO {
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    country?: string | undefined;
    county?: string | undefined;
    type?: AddressType;
    personInternalId?: number;
    personAddressId?: number | undefined;
    isDefault?: boolean;
    verificationStatus?: AddressVerificationStatus;
    latitude?: number | undefined;
    longitude?: number | undefined;
    validationOverride?: boolean;
}

export class AddressHistoryResponse implements IAddressHistoryResponse {
    personId?: string | undefined;
    personAddressId?: string | undefined;
    addressType?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    county?: string | undefined;
    country?: string | undefined;
    zipCode?: string | undefined;
    isDefault?: boolean;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IAddressHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.personAddressId = _data["personAddressId"];
            this.addressType = _data["addressType"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.addressLine3 = _data["addressLine3"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.county = _data["county"];
            this.country = _data["country"];
            this.zipCode = _data["zipCode"];
            this.isDefault = _data["isDefault"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): AddressHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddressHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["personAddressId"] = this.personAddressId;
        data["addressType"] = this.addressType;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["addressLine3"] = this.addressLine3;
        data["city"] = this.city;
        data["state"] = this.state;
        data["county"] = this.county;
        data["country"] = this.country;
        data["zipCode"] = this.zipCode;
        data["isDefault"] = this.isDefault;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IAddressHistoryResponse {
    personId?: string | undefined;
    personAddressId?: string | undefined;
    addressType?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    county?: string | undefined;
    country?: string | undefined;
    zipCode?: string | undefined;
    isDefault?: boolean;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum AddressType {
    Mailing = "Mailing",
    Physical = "Physical",
    IVR = "IVR",
}

export enum AddressVerificationStatus {
    NotRun = "NotRun",
    Valid = "Valid",
    Invalid = "Invalid",
    Error = "Error",
}

export class AdvancedDirective implements IAdvancedDirective {
    advancedDirectiveId?: number | undefined;
    personId?: string | undefined;
    isActive?: boolean;
    isDeleted?: boolean | undefined;
    advancedDirectiveDate?: Date;
    createdBy?: string | undefined;
    readonly status?: string | undefined;

    constructor(data?: IAdvancedDirective) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advancedDirectiveId = _data["advancedDirectiveId"];
            this.personId = _data["personId"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.advancedDirectiveDate = _data["advancedDirectiveDate"] ? new Date(_data["advancedDirectiveDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            (<any>this).status = _data["status"];
        }
    }

    static fromJS(data: any): AdvancedDirective {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedDirective();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advancedDirectiveId"] = this.advancedDirectiveId;
        data["personId"] = this.personId;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["advancedDirectiveDate"] = this.advancedDirectiveDate ? this.advancedDirectiveDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["status"] = this.status;
        return data;
    }
}

export interface IAdvancedDirective {
    advancedDirectiveId?: number | undefined;
    personId?: string | undefined;
    isActive?: boolean;
    isDeleted?: boolean | undefined;
    advancedDirectiveDate?: Date;
    createdBy?: string | undefined;
    status?: string | undefined;
}

export class AgencyAdminProfile implements IAgencyAdminProfile {
    phoneDetails?: PhoneDetail[] | undefined;
    physicalAddresses?: AddressDTO[] | undefined;
    mailingAddresses?: AddressDTO[] | undefined;
    ivrAddresses?: AddressDTO[] | undefined;
    externalKeys?: ExternalKeyDTO[] | undefined;
    id?: number;
    personId?: string | undefined;
    status?: string | undefined;
    readonly personName?: string | undefined;
    ssn?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    physicalAddress?: string | undefined;
    mailingAddress?: string | undefined;
    ivrAddress?: string | undefined;
    companyCode?: string | undefined;
    unmaskedSsn?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    ivrPin?: string | undefined;
    paymentMethod?: string | undefined;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    coordinatorPersonFirstName?: string | undefined;
    coordinatorPersonLastName?: string | undefined;
    coordinatorPersonName?: string | undefined;
    lastV4LoginOn?: Date | undefined;
    isSsnValidated?: boolean | undefined;
    ssnValidationOverrideOn?: Date | undefined;
    ssnValidationOverrideBy?: string | undefined;
    agencieStatus?: string | undefined;
    agencyStatus?: PersonStatus;

    constructor(data?: IAgencyAdminProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["phoneDetails"])) {
                this.phoneDetails = [] as any;
                for (let item of _data["phoneDetails"])
                    this.phoneDetails!.push(PhoneDetail.fromJS(item));
            }
            if (Array.isArray(_data["physicalAddresses"])) {
                this.physicalAddresses = [] as any;
                for (let item of _data["physicalAddresses"])
                    this.physicalAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["mailingAddresses"])) {
                this.mailingAddresses = [] as any;
                for (let item of _data["mailingAddresses"])
                    this.mailingAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["ivrAddresses"])) {
                this.ivrAddresses = [] as any;
                for (let item of _data["ivrAddresses"])
                    this.ivrAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["externalKeys"])) {
                this.externalKeys = [] as any;
                for (let item of _data["externalKeys"])
                    this.externalKeys!.push(ExternalKeyDTO.fromJS(item));
            }
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.status = _data["status"];
            (<any>this).personName = _data["personName"];
            this.ssn = _data["ssn"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.gender = _data["gender"];
            this.ethnicity = _data["ethnicity"];
            this.race = _data["race"];
            this.maritalStatus = _data["maritalStatus"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.physicalAddress = _data["physicalAddress"];
            this.mailingAddress = _data["mailingAddress"];
            this.ivrAddress = _data["ivrAddress"];
            this.companyCode = _data["companyCode"];
            this.unmaskedSsn = _data["unmaskedSsn"];
            this.onboarded = _data["onboarded"];
            this.isFirstLoginComplete = _data["isFirstLoginComplete"];
            this.ivrPin = _data["ivrPin"];
            this.paymentMethod = _data["paymentMethod"];
            this.coordinatorPersonId = _data["coordinatorPersonId"];
            this.internalUserObjectId = _data["internalUserObjectId"];
            this.coordinatorPersonFirstName = _data["coordinatorPersonFirstName"];
            this.coordinatorPersonLastName = _data["coordinatorPersonLastName"];
            this.coordinatorPersonName = _data["coordinatorPersonName"];
            this.lastV4LoginOn = _data["lastV4LoginOn"] ? new Date(_data["lastV4LoginOn"].toString()) : <any>undefined;
            this.isSsnValidated = _data["isSsnValidated"];
            this.ssnValidationOverrideOn = _data["ssnValidationOverrideOn"] ? new Date(_data["ssnValidationOverrideOn"].toString()) : <any>undefined;
            this.ssnValidationOverrideBy = _data["ssnValidationOverrideBy"];
            this.agencieStatus = _data["agencieStatus"];
            this.agencyStatus = _data["agencyStatus"];
        }
    }

    static fromJS(data: any): AgencyAdminProfile {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyAdminProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phoneDetails)) {
            data["phoneDetails"] = [];
            for (let item of this.phoneDetails)
                data["phoneDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.physicalAddresses)) {
            data["physicalAddresses"] = [];
            for (let item of this.physicalAddresses)
                data["physicalAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.mailingAddresses)) {
            data["mailingAddresses"] = [];
            for (let item of this.mailingAddresses)
                data["mailingAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.ivrAddresses)) {
            data["ivrAddresses"] = [];
            for (let item of this.ivrAddresses)
                data["ivrAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.externalKeys)) {
            data["externalKeys"] = [];
            for (let item of this.externalKeys)
                data["externalKeys"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["status"] = this.status;
        data["personName"] = this.personName;
        data["ssn"] = this.ssn;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["gender"] = this.gender;
        data["ethnicity"] = this.ethnicity;
        data["race"] = this.race;
        data["maritalStatus"] = this.maritalStatus;
        data["preferredLanguage"] = this.preferredLanguage;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["physicalAddress"] = this.physicalAddress;
        data["mailingAddress"] = this.mailingAddress;
        data["ivrAddress"] = this.ivrAddress;
        data["companyCode"] = this.companyCode;
        data["unmaskedSsn"] = this.unmaskedSsn;
        data["onboarded"] = this.onboarded;
        data["isFirstLoginComplete"] = this.isFirstLoginComplete;
        data["ivrPin"] = this.ivrPin;
        data["paymentMethod"] = this.paymentMethod;
        data["coordinatorPersonId"] = this.coordinatorPersonId;
        data["internalUserObjectId"] = this.internalUserObjectId;
        data["coordinatorPersonFirstName"] = this.coordinatorPersonFirstName;
        data["coordinatorPersonLastName"] = this.coordinatorPersonLastName;
        data["coordinatorPersonName"] = this.coordinatorPersonName;
        data["lastV4LoginOn"] = this.lastV4LoginOn ? this.lastV4LoginOn.toISOString() : <any>undefined;
        data["isSsnValidated"] = this.isSsnValidated;
        data["ssnValidationOverrideOn"] = this.ssnValidationOverrideOn ? this.ssnValidationOverrideOn.toISOString() : <any>undefined;
        data["ssnValidationOverrideBy"] = this.ssnValidationOverrideBy;
        data["agencieStatus"] = this.agencieStatus;
        data["agencyStatus"] = this.agencyStatus;
        return data;
    }
}

export interface IAgencyAdminProfile {
    phoneDetails?: PhoneDetail[] | undefined;
    physicalAddresses?: AddressDTO[] | undefined;
    mailingAddresses?: AddressDTO[] | undefined;
    ivrAddresses?: AddressDTO[] | undefined;
    externalKeys?: ExternalKeyDTO[] | undefined;
    id?: number;
    personId?: string | undefined;
    status?: string | undefined;
    personName?: string | undefined;
    ssn?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    physicalAddress?: string | undefined;
    mailingAddress?: string | undefined;
    ivrAddress?: string | undefined;
    companyCode?: string | undefined;
    unmaskedSsn?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    ivrPin?: string | undefined;
    paymentMethod?: string | undefined;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    coordinatorPersonFirstName?: string | undefined;
    coordinatorPersonLastName?: string | undefined;
    coordinatorPersonName?: string | undefined;
    lastV4LoginOn?: Date | undefined;
    isSsnValidated?: boolean | undefined;
    ssnValidationOverrideOn?: Date | undefined;
    ssnValidationOverrideBy?: string | undefined;
    agencieStatus?: string | undefined;
    agencyStatus?: PersonStatus;
}

export class AgencyPersonMapping implements IAgencyPersonMapping {
    id?: number;
    agencyId?: number;
    agencyName?: string | undefined;
    personId?: string | undefined;
    confidentialitySigned?: boolean;
    npi?: string | undefined;

    constructor(data?: IAgencyPersonMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agencyId = _data["agencyId"];
            this.agencyName = _data["agencyName"];
            this.personId = _data["personId"];
            this.confidentialitySigned = _data["confidentialitySigned"];
            this.npi = _data["npi"];
        }
    }

    static fromJS(data: any): AgencyPersonMapping {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyPersonMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agencyId"] = this.agencyId;
        data["agencyName"] = this.agencyName;
        data["personId"] = this.personId;
        data["confidentialitySigned"] = this.confidentialitySigned;
        data["npi"] = this.npi;
        return data;
    }
}

export interface IAgencyPersonMapping {
    id?: number;
    agencyId?: number;
    agencyName?: string | undefined;
    personId?: string | undefined;
    confidentialitySigned?: boolean;
    npi?: string | undefined;
}

export class Areas implements IAreas {
    id?: number;
    areaName?: string | undefined;
    stateId?: number;

    constructor(data?: IAreas) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.areaName = _data["areaName"];
            this.stateId = _data["stateId"];
        }
    }

    static fromJS(data: any): Areas {
        data = typeof data === 'object' ? data : {};
        let result = new Areas();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["areaName"] = this.areaName;
        data["stateId"] = this.stateId;
        return data;
    }
}

export interface IAreas {
    id?: number;
    areaName?: string | undefined;
    stateId?: number;
}

export class AssociatedPerson implements IAssociatedPerson {
    person?: string | undefined;
    personId?: string | undefined;

    constructor(data?: IAssociatedPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.person = _data["person"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): AssociatedPerson {
        data = typeof data === 'object' ? data : {};
        let result = new AssociatedPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["person"] = this.person;
        data["personId"] = this.personId;
        return data;
    }
}

export interface IAssociatedPerson {
    person?: string | undefined;
    personId?: string | undefined;
}

export class AttestationFormRequest implements IAttestationFormRequest {
    languageCode?: string | undefined;
    attestationVersion?: number;
    attestationCode?: string | undefined;

    constructor(data?: IAttestationFormRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageCode = _data["languageCode"];
            this.attestationVersion = _data["attestationVersion"];
            this.attestationCode = _data["attestationCode"];
        }
    }

    static fromJS(data: any): AttestationFormRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AttestationFormRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode;
        data["attestationVersion"] = this.attestationVersion;
        data["attestationCode"] = this.attestationCode;
        return data;
    }
}

export interface IAttestationFormRequest {
    languageCode?: string | undefined;
    attestationVersion?: number;
    attestationCode?: string | undefined;
}

export class AttestationFormResponse implements IAttestationFormResponse {
    attestationFormComponents?: QuestionnaireComponentDetails[] | undefined;

    constructor(data?: IAttestationFormResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["attestationFormComponents"])) {
                this.attestationFormComponents = [] as any;
                for (let item of _data["attestationFormComponents"])
                    this.attestationFormComponents!.push(QuestionnaireComponentDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AttestationFormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AttestationFormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.attestationFormComponents)) {
            data["attestationFormComponents"] = [];
            for (let item of this.attestationFormComponents)
                data["attestationFormComponents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAttestationFormResponse {
    attestationFormComponents?: QuestionnaireComponentDetails[] | undefined;
}

export class AttestationResponse implements IAttestationResponse {
    attestationResponseId?: number | undefined;
    attestationType?: AttestationType;
    attestationVersion?: number;
    attestationStatus?: AttestationStatus;
    participantPersonId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    personId?: string | undefined;
    confirmationDate?: Date | undefined;
    languageId?: number;
    companyId?: number;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    endDate?: Date | undefined;
    viewAttestation?: boolean;

    constructor(data?: IAttestationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attestationResponseId = _data["attestationResponseId"];
            this.attestationType = _data["attestationType"];
            this.attestationVersion = _data["attestationVersion"];
            this.attestationStatus = _data["attestationStatus"];
            this.participantPersonId = _data["participantPersonId"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.personId = _data["personId"];
            this.confirmationDate = _data["confirmationDate"] ? new Date(_data["confirmationDate"].toString()) : <any>undefined;
            this.languageId = _data["languageId"];
            this.companyId = _data["companyId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.viewAttestation = _data["viewAttestation"];
        }
    }

    static fromJS(data: any): AttestationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AttestationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attestationResponseId"] = this.attestationResponseId;
        data["attestationType"] = this.attestationType;
        data["attestationVersion"] = this.attestationVersion;
        data["attestationStatus"] = this.attestationStatus;
        data["participantPersonId"] = this.participantPersonId;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["personId"] = this.personId;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : <any>undefined;
        data["languageId"] = this.languageId;
        data["companyId"] = this.companyId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["viewAttestation"] = this.viewAttestation;
        return data;
    }
}

export interface IAttestationResponse {
    attestationResponseId?: number | undefined;
    attestationType?: AttestationType;
    attestationVersion?: number;
    attestationStatus?: AttestationStatus;
    participantPersonId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    personId?: string | undefined;
    confirmationDate?: Date | undefined;
    languageId?: number;
    companyId?: number;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    endDate?: Date | undefined;
    viewAttestation?: boolean;
}

export class AttestationResponseV2 implements IAttestationResponseV2 {
    attestationId?: number;
    typeCode?: string | undefined;
    version?: number;
    statusCode?: string | undefined;
    participantPersonId?: number | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    caregiverId?: number;
    confirmationDate?: Date | undefined;
    endDate?: Date;
    languageId?: number;
    companyId?: number;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: IAttestationResponseV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attestationId = _data["attestationId"];
            this.typeCode = _data["typeCode"];
            this.version = _data["version"];
            this.statusCode = _data["statusCode"];
            this.participantPersonId = _data["participantPersonId"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.caregiverId = _data["caregiverId"];
            this.confirmationDate = _data["confirmationDate"] ? new Date(_data["confirmationDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.languageId = _data["languageId"];
            this.companyId = _data["companyId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): AttestationResponseV2 {
        data = typeof data === 'object' ? data : {};
        let result = new AttestationResponseV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attestationId"] = this.attestationId;
        data["typeCode"] = this.typeCode;
        data["version"] = this.version;
        data["statusCode"] = this.statusCode;
        data["participantPersonId"] = this.participantPersonId;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["caregiverId"] = this.caregiverId;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["languageId"] = this.languageId;
        data["companyId"] = this.companyId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IAttestationResponseV2 {
    attestationId?: number;
    typeCode?: string | undefined;
    version?: number;
    statusCode?: string | undefined;
    participantPersonId?: number | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    caregiverId?: number;
    confirmationDate?: Date | undefined;
    endDate?: Date;
    languageId?: number;
    companyId?: number;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
}

export enum AttestationStatus {
    Pending = "Pending",
    Verified = "Verified",
    CaregiverRejected = "CaregiverRejected",
    Approved = "Approved",
    InternalRejected = "InternalRejected",
    ParticipantRejected = "ParticipantRejected",
}

export class AttestationStatusDto implements IAttestationStatusDto {
    attestationStatusId?: number;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IAttestationStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attestationStatusId = _data["attestationStatusId"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AttestationStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttestationStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attestationStatusId"] = this.attestationStatusId;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IAttestationStatusDto {
    attestationStatusId?: number;
    code?: string | undefined;
    description?: string | undefined;
}

export enum AttestationType {
    DemographicsConfirmation = "DemographicsConfirmation",
    TrainingConfirmation = "TrainingConfirmation",
    BackgroundCheckConfirmation = "BackgroundCheckConfirmation",
    CaregiverFICAConfirmation = "CaregiverFICAConfirmation",
    CaregiverDifficultyOfCareConfirmation = "CaregiverDifficultyOfCareConfirmation",
    CaregiverRelationshipConfirmation = "CaregiverRelationshipConfirmation",
    CaregiverParticipantRequestRelationConfirmation = "CaregiverParticipantRequestRelationConfirmation",
    CaregiverParticipantShiftConfirmation = "CaregiverParticipantShiftConfirmation",
    CaregiverLiveInExemptionConfirmation = "CaregiverLiveInExemptionConfirmation",
}

export class AttestationTypeDto implements IAttestationTypeDto {
    attestationTypeId?: number;
    attestationType?: AttestationType;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IAttestationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attestationTypeId = _data["attestationTypeId"];
            this.attestationType = _data["attestationType"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AttestationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttestationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attestationTypeId"] = this.attestationTypeId;
        data["attestationType"] = this.attestationType;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IAttestationTypeDto {
    attestationTypeId?: number;
    attestationType?: AttestationType;
    code?: string | undefined;
    description?: string | undefined;
}

export class BulkParticipantTaskListRequest implements IBulkParticipantTaskListRequest {
    participantId?: string | undefined;
    agencyCode?: string | undefined;
    participantTasks?: BulkParticipantTaskRequest[] | undefined;

    constructor(data?: IBulkParticipantTaskListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.agencyCode = _data["agencyCode"];
            if (Array.isArray(_data["participantTasks"])) {
                this.participantTasks = [] as any;
                for (let item of _data["participantTasks"])
                    this.participantTasks!.push(BulkParticipantTaskRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BulkParticipantTaskListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BulkParticipantTaskListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["agencyCode"] = this.agencyCode;
        if (Array.isArray(this.participantTasks)) {
            data["participantTasks"] = [];
            for (let item of this.participantTasks)
                data["participantTasks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBulkParticipantTaskListRequest {
    participantId?: string | undefined;
    agencyCode?: string | undefined;
    participantTasks?: BulkParticipantTaskRequest[] | undefined;
}

export class BulkParticipantTaskRequest implements IBulkParticipantTaskRequest {
    taskCode?: string | undefined;
    runDate?: Date;
    payorCode?: string | undefined;
    description?: string | undefined;

    constructor(data?: IBulkParticipantTaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskCode = _data["taskCode"];
            this.runDate = _data["runDate"] ? new Date(_data["runDate"].toString()) : <any>undefined;
            this.payorCode = _data["payorCode"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): BulkParticipantTaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BulkParticipantTaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskCode"] = this.taskCode;
        data["runDate"] = this.runDate ? this.runDate.toISOString() : <any>undefined;
        data["payorCode"] = this.payorCode;
        data["description"] = this.description;
        return data;
    }
}

export interface IBulkParticipantTaskRequest {
    taskCode?: string | undefined;
    runDate?: Date;
    payorCode?: string | undefined;
    description?: string | undefined;
}

export class CareGiverDto implements ICareGiverDto {
    personStatus?: string | undefined;
    id?: number;
    personId?: string | undefined;
    status?: PeopleStatus;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    statusChangeReason?: string | undefined;
    ssn?: string | undefined;
    maritalStatus?: string | undefined;
    personStatusHistories?: PersonStatusHistory[] | undefined;
    caregiverId?: number | undefined;
    solomonCaregiverId?: string | undefined;
    cdcnStateId?: number | undefined;
    areaId?: number | undefined;
    territoryId?: number | undefined;
    ivrPin?: string | undefined;
    lastCheckDate?: Date | undefined;
    geoLocale?: string | undefined;
    npi?: string | undefined;
    stateUniqueId?: string | undefined;
    renderingProviderFirstName?: string | undefined;
    renderingProviderLastName?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    programCoordinator?: boolean | undefined;
    caregiverEmployerMappings?: CaregiverEmployerMapping[] | undefined;
    canPaperTimesheet?: boolean | undefined;
    lepIndicator?: boolean | undefined;
    demographicsConfirmation?: AttestationStatus;
    readonly demographicsConfirmationText?: string | undefined;
    trainingConfirmation?: AttestationStatus;
    hireDate?: Date | undefined;
    readonly trainingConfirmationText?: string | undefined;
    backgroundCheckConfirmation?: AttestationStatus;
    readonly backgroundCheckConfirmationText?: string | undefined;

    constructor(data?: ICareGiverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personStatus = _data["personStatus"];
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.status = _data["status"];
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.statusChangeReason = _data["statusChangeReason"];
            this.ssn = _data["ssn"];
            this.maritalStatus = _data["maritalStatus"];
            if (Array.isArray(_data["personStatusHistories"])) {
                this.personStatusHistories = [] as any;
                for (let item of _data["personStatusHistories"])
                    this.personStatusHistories!.push(PersonStatusHistory.fromJS(item));
            }
            this.caregiverId = _data["caregiverId"];
            this.solomonCaregiverId = _data["solomonCaregiverId"];
            this.cdcnStateId = _data["cdcnStateId"];
            this.areaId = _data["areaId"];
            this.territoryId = _data["territoryId"];
            this.ivrPin = _data["ivrPin"];
            this.lastCheckDate = _data["lastCheckDate"] ? new Date(_data["lastCheckDate"].toString()) : <any>undefined;
            this.geoLocale = _data["geoLocale"];
            this.npi = _data["npi"];
            this.stateUniqueId = _data["stateUniqueId"];
            this.renderingProviderFirstName = _data["renderingProviderFirstName"];
            this.renderingProviderLastName = _data["renderingProviderLastName"];
            this.caregiverFirstName = _data["caregiverFirstName"];
            this.caregiverLastName = _data["caregiverLastName"];
            this.programCoordinator = _data["programCoordinator"];
            if (Array.isArray(_data["caregiverEmployerMappings"])) {
                this.caregiverEmployerMappings = [] as any;
                for (let item of _data["caregiverEmployerMappings"])
                    this.caregiverEmployerMappings!.push(CaregiverEmployerMapping.fromJS(item));
            }
            this.canPaperTimesheet = _data["canPaperTimesheet"];
            this.lepIndicator = _data["lepIndicator"];
            this.demographicsConfirmation = _data["demographicsConfirmation"];
            (<any>this).demographicsConfirmationText = _data["demographicsConfirmationText"];
            this.trainingConfirmation = _data["trainingConfirmation"];
            this.hireDate = _data["hireDate"] ? new Date(_data["hireDate"].toString()) : <any>undefined;
            (<any>this).trainingConfirmationText = _data["trainingConfirmationText"];
            this.backgroundCheckConfirmation = _data["backgroundCheckConfirmation"];
            (<any>this).backgroundCheckConfirmationText = _data["backgroundCheckConfirmationText"];
        }
    }

    static fromJS(data: any): CareGiverDto {
        data = typeof data === 'object' ? data : {};
        let result = new CareGiverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personStatus"] = this.personStatus;
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["status"] = this.status;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["statusChangeReason"] = this.statusChangeReason;
        data["ssn"] = this.ssn;
        data["maritalStatus"] = this.maritalStatus;
        if (Array.isArray(this.personStatusHistories)) {
            data["personStatusHistories"] = [];
            for (let item of this.personStatusHistories)
                data["personStatusHistories"].push(item.toJSON());
        }
        data["caregiverId"] = this.caregiverId;
        data["solomonCaregiverId"] = this.solomonCaregiverId;
        data["cdcnStateId"] = this.cdcnStateId;
        data["areaId"] = this.areaId;
        data["territoryId"] = this.territoryId;
        data["ivrPin"] = this.ivrPin;
        data["lastCheckDate"] = this.lastCheckDate ? this.lastCheckDate.toISOString() : <any>undefined;
        data["geoLocale"] = this.geoLocale;
        data["npi"] = this.npi;
        data["stateUniqueId"] = this.stateUniqueId;
        data["renderingProviderFirstName"] = this.renderingProviderFirstName;
        data["renderingProviderLastName"] = this.renderingProviderLastName;
        data["caregiverFirstName"] = this.caregiverFirstName;
        data["caregiverLastName"] = this.caregiverLastName;
        data["programCoordinator"] = this.programCoordinator;
        if (Array.isArray(this.caregiverEmployerMappings)) {
            data["caregiverEmployerMappings"] = [];
            for (let item of this.caregiverEmployerMappings)
                data["caregiverEmployerMappings"].push(item.toJSON());
        }
        data["canPaperTimesheet"] = this.canPaperTimesheet;
        data["lepIndicator"] = this.lepIndicator;
        data["demographicsConfirmation"] = this.demographicsConfirmation;
        data["demographicsConfirmationText"] = this.demographicsConfirmationText;
        data["trainingConfirmation"] = this.trainingConfirmation;
        data["hireDate"] = this.hireDate ? this.hireDate.toISOString() : <any>undefined;
        data["trainingConfirmationText"] = this.trainingConfirmationText;
        data["backgroundCheckConfirmation"] = this.backgroundCheckConfirmation;
        data["backgroundCheckConfirmationText"] = this.backgroundCheckConfirmationText;
        return data;
    }
}

export interface ICareGiverDto {
    personStatus?: string | undefined;
    id?: number;
    personId?: string | undefined;
    status?: PeopleStatus;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    statusChangeReason?: string | undefined;
    ssn?: string | undefined;
    maritalStatus?: string | undefined;
    personStatusHistories?: PersonStatusHistory[] | undefined;
    caregiverId?: number | undefined;
    solomonCaregiverId?: string | undefined;
    cdcnStateId?: number | undefined;
    areaId?: number | undefined;
    territoryId?: number | undefined;
    ivrPin?: string | undefined;
    lastCheckDate?: Date | undefined;
    geoLocale?: string | undefined;
    npi?: string | undefined;
    stateUniqueId?: string | undefined;
    renderingProviderFirstName?: string | undefined;
    renderingProviderLastName?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    programCoordinator?: boolean | undefined;
    caregiverEmployerMappings?: CaregiverEmployerMapping[] | undefined;
    canPaperTimesheet?: boolean | undefined;
    lepIndicator?: boolean | undefined;
    demographicsConfirmation?: AttestationStatus;
    demographicsConfirmationText?: string | undefined;
    trainingConfirmation?: AttestationStatus;
    hireDate?: Date | undefined;
    trainingConfirmationText?: string | undefined;
    backgroundCheckConfirmation?: AttestationStatus;
    backgroundCheckConfirmationText?: string | undefined;
}

export class CareGiverWwlRequest implements ICareGiverWwlRequest {
    dateList?: Date[] | undefined;
    careGiverId?: string | undefined;
    participantId?: string | undefined;
    caregiverIds?: string[] | undefined;

    constructor(data?: ICareGiverWwlRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dateList"])) {
                this.dateList = [] as any;
                for (let item of _data["dateList"])
                    this.dateList!.push(new Date(item));
            }
            this.careGiverId = _data["careGiverId"];
            this.participantId = _data["participantId"];
            if (Array.isArray(_data["caregiverIds"])) {
                this.caregiverIds = [] as any;
                for (let item of _data["caregiverIds"])
                    this.caregiverIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CareGiverWwlRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CareGiverWwlRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dateList)) {
            data["dateList"] = [];
            for (let item of this.dateList)
                data["dateList"].push(item.toISOString());
        }
        data["careGiverId"] = this.careGiverId;
        data["participantId"] = this.participantId;
        if (Array.isArray(this.caregiverIds)) {
            data["caregiverIds"] = [];
            for (let item of this.caregiverIds)
                data["caregiverIds"].push(item);
        }
        return data;
    }
}

export interface ICareGiverWwlRequest {
    dateList?: Date[] | undefined;
    careGiverId?: string | undefined;
    participantId?: string | undefined;
    caregiverIds?: string[] | undefined;
}

export class CareGiverWwlResponse implements ICareGiverWwlResponse {
    wwlHours?: number | undefined;
    employerId?: number;
    calendarDate?: Date;
    caregiverId?: string | undefined;

    constructor(data?: ICareGiverWwlResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wwlHours = _data["wwlHours"];
            this.employerId = _data["employerId"];
            this.calendarDate = _data["calendarDate"] ? new Date(_data["calendarDate"].toString()) : <any>undefined;
            this.caregiverId = _data["caregiverId"];
        }
    }

    static fromJS(data: any): CareGiverWwlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CareGiverWwlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wwlHours"] = this.wwlHours;
        data["employerId"] = this.employerId;
        data["calendarDate"] = this.calendarDate ? this.calendarDate.toISOString() : <any>undefined;
        data["caregiverId"] = this.caregiverId;
        return data;
    }
}

export interface ICareGiverWwlResponse {
    wwlHours?: number | undefined;
    employerId?: number;
    calendarDate?: Date;
    caregiverId?: string | undefined;
}

export class CareTeamResponse implements ICareTeamResponse {
    participantPersonId?: string | undefined;
    companyCode?: string | undefined;
    caregivers?: CaregiverResponse[] | undefined;

    constructor(data?: ICareTeamResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantPersonId = _data["participantPersonId"];
            this.companyCode = _data["companyCode"];
            if (Array.isArray(_data["caregivers"])) {
                this.caregivers = [] as any;
                for (let item of _data["caregivers"])
                    this.caregivers!.push(CaregiverResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CareTeamResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CareTeamResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantPersonId"] = this.participantPersonId;
        data["companyCode"] = this.companyCode;
        if (Array.isArray(this.caregivers)) {
            data["caregivers"] = [];
            for (let item of this.caregivers)
                data["caregivers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICareTeamResponse {
    participantPersonId?: string | undefined;
    companyCode?: string | undefined;
    caregivers?: CaregiverResponse[] | undefined;
}

export class CareerHourLogRequest implements ICareerHourLogRequest {
    caregiverId?: string | undefined;
    pcn?: string | undefined;
    tcn?: string | undefined;
    externalReferenceId?: string | undefined;
    logDate?: Date;
    hour?: number;
    servCode?: string | undefined;

    constructor(data?: ICareerHourLogRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.pcn = _data["pcn"];
            this.tcn = _data["tcn"];
            this.externalReferenceId = _data["externalReferenceId"];
            this.logDate = _data["logDate"] ? new Date(_data["logDate"].toString()) : <any>undefined;
            this.hour = _data["hour"];
            this.servCode = _data["servCode"];
        }
    }

    static fromJS(data: any): CareerHourLogRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourLogRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["pcn"] = this.pcn;
        data["tcn"] = this.tcn;
        data["externalReferenceId"] = this.externalReferenceId;
        data["logDate"] = this.logDate ? this.logDate.toISOString() : <any>undefined;
        data["hour"] = this.hour;
        data["servCode"] = this.servCode;
        return data;
    }
}

export interface ICareerHourLogRequest {
    caregiverId?: string | undefined;
    pcn?: string | undefined;
    tcn?: string | undefined;
    externalReferenceId?: string | undefined;
    logDate?: Date;
    hour?: number;
    servCode?: string | undefined;
}

export class CareerHourLogResponse implements ICareerHourLogResponse {
    caregiverId?: string | undefined;
    pcn?: string | undefined;
    tcn?: string | undefined;
    externalReferenceId?: string | undefined;
    careerHourLogType?: string | undefined;
    hour?: number;
    isCchEligible?: boolean;
    logDate?: Date;
    createdBy?: string | undefined;
    createdOn?: Date;
    cch?: number;

    constructor(data?: ICareerHourLogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.pcn = _data["pcn"];
            this.tcn = _data["tcn"];
            this.externalReferenceId = _data["externalReferenceId"];
            this.careerHourLogType = _data["careerHourLogType"];
            this.hour = _data["hour"];
            this.isCchEligible = _data["isCchEligible"];
            this.logDate = _data["logDate"] ? new Date(_data["logDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.cch = _data["cch"];
        }
    }

    static fromJS(data: any): CareerHourLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["pcn"] = this.pcn;
        data["tcn"] = this.tcn;
        data["externalReferenceId"] = this.externalReferenceId;
        data["careerHourLogType"] = this.careerHourLogType;
        data["hour"] = this.hour;
        data["isCchEligible"] = this.isCchEligible;
        data["logDate"] = this.logDate ? this.logDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["cch"] = this.cch;
        return data;
    }
}

export interface ICareerHourLogResponse {
    caregiverId?: string | undefined;
    pcn?: string | undefined;
    tcn?: string | undefined;
    externalReferenceId?: string | undefined;
    careerHourLogType?: string | undefined;
    hour?: number;
    isCchEligible?: boolean;
    logDate?: Date;
    createdBy?: string | undefined;
    createdOn?: Date;
    cch?: number;
}

export class CareerHourLogResponseGridResponseBase implements ICareerHourLogResponseGridResponseBase {
    items?: CareerHourLogResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CareerHourLogResponse;

    constructor(data?: ICareerHourLogResponseGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CareerHourLogResponse.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? CareerHourLogResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CareerHourLogResponseGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourLogResponseGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICareerHourLogResponseGridResponseBase {
    items?: CareerHourLogResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CareerHourLogResponse;
}

export class CareerHourLogSearchRequest implements ICareerHourLogSearchRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    caregiverIds?: string[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    logTypeId?: number | undefined;
    isCchEligible?: boolean | undefined;

    constructor(data?: ICareerHourLogSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            if (Array.isArray(_data["caregiverIds"])) {
                this.caregiverIds = [] as any;
                for (let item of _data["caregiverIds"])
                    this.caregiverIds!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.logTypeId = _data["logTypeId"];
            this.isCchEligible = _data["isCchEligible"];
        }
    }

    static fromJS(data: any): CareerHourLogSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourLogSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        if (Array.isArray(this.caregiverIds)) {
            data["caregiverIds"] = [];
            for (let item of this.caregiverIds)
                data["caregiverIds"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["logTypeId"] = this.logTypeId;
        data["isCchEligible"] = this.isCchEligible;
        return data;
    }
}

export interface ICareerHourLogSearchRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    caregiverIds?: string[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    logTypeId?: number | undefined;
    isCchEligible?: boolean | undefined;
}

export class CareerHourLogType implements ICareerHourLogType {
    careerHourLogTypeId?: number;
    code?: string | undefined;

    constructor(data?: ICareerHourLogType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.careerHourLogTypeId = _data["careerHourLogTypeId"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CareerHourLogType {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourLogType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careerHourLogTypeId"] = this.careerHourLogTypeId;
        data["code"] = this.code;
        return data;
    }
}

export interface ICareerHourLogType {
    careerHourLogTypeId?: number;
    code?: string | undefined;
}

export class CareerHourQualificationInfoRequest implements ICareerHourQualificationInfoRequest {
    caregiverIds?: string[] | undefined;
    qualificationTypeIds?: number[] | undefined;

    constructor(data?: ICareerHourQualificationInfoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["caregiverIds"])) {
                this.caregiverIds = [] as any;
                for (let item of _data["caregiverIds"])
                    this.caregiverIds!.push(item);
            }
            if (Array.isArray(_data["qualificationTypeIds"])) {
                this.qualificationTypeIds = [] as any;
                for (let item of _data["qualificationTypeIds"])
                    this.qualificationTypeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CareerHourQualificationInfoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourQualificationInfoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.caregiverIds)) {
            data["caregiverIds"] = [];
            for (let item of this.caregiverIds)
                data["caregiverIds"].push(item);
        }
        if (Array.isArray(this.qualificationTypeIds)) {
            data["qualificationTypeIds"] = [];
            for (let item of this.qualificationTypeIds)
                data["qualificationTypeIds"].push(item);
        }
        return data;
    }
}

export interface ICareerHourQualificationInfoRequest {
    caregiverIds?: string[] | undefined;
    qualificationTypeIds?: number[] | undefined;
}

export class CareerHourQualificationInfoResponse implements ICareerHourQualificationInfoResponse {
    caregiverId?: string | undefined;
    careerHours?: number;
    qualificationTypeInfo?: QualificationTypeInfo[] | undefined;

    constructor(data?: ICareerHourQualificationInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.careerHours = _data["careerHours"];
            if (Array.isArray(_data["qualificationTypeInfo"])) {
                this.qualificationTypeInfo = [] as any;
                for (let item of _data["qualificationTypeInfo"])
                    this.qualificationTypeInfo!.push(QualificationTypeInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CareerHourQualificationInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourQualificationInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["careerHours"] = this.careerHours;
        if (Array.isArray(this.qualificationTypeInfo)) {
            data["qualificationTypeInfo"] = [];
            for (let item of this.qualificationTypeInfo)
                data["qualificationTypeInfo"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICareerHourQualificationInfoResponse {
    caregiverId?: string | undefined;
    careerHours?: number;
    qualificationTypeInfo?: QualificationTypeInfo[] | undefined;
}

export class CareerHourRate implements ICareerHourRate {
    careerHourRateId?: number;
    careerHourRatePeriodId?: number;
    clientEntityId?: string | undefined;
    companyId?: number;
    minHours?: number;
    maxHours?: number;
    rateBase?: number;
    isActive?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: ICareerHourRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.careerHourRateId = _data["careerHourRateId"];
            this.careerHourRatePeriodId = _data["careerHourRatePeriodId"];
            this.clientEntityId = _data["clientEntityId"];
            this.companyId = _data["companyId"];
            this.minHours = _data["minHours"];
            this.maxHours = _data["maxHours"];
            this.rateBase = _data["rateBase"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CareerHourRate {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careerHourRateId"] = this.careerHourRateId;
        data["careerHourRatePeriodId"] = this.careerHourRatePeriodId;
        data["clientEntityId"] = this.clientEntityId;
        data["companyId"] = this.companyId;
        data["minHours"] = this.minHours;
        data["maxHours"] = this.maxHours;
        data["rateBase"] = this.rateBase;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICareerHourRate {
    careerHourRateId?: number;
    careerHourRatePeriodId?: number;
    clientEntityId?: string | undefined;
    companyId?: number;
    minHours?: number;
    maxHours?: number;
    rateBase?: number;
    isActive?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class CareerHourRateData implements ICareerHourRateData {
    careerHourRateId?: number;
    careerHourRatePeriodId?: number;
    clientEntityId?: string | undefined;
    minHours?: number;
    maxHours?: number;
    rateBase?: number;
    isActive?: string | undefined;

    constructor(data?: ICareerHourRateData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.careerHourRateId = _data["careerHourRateId"];
            this.careerHourRatePeriodId = _data["careerHourRatePeriodId"];
            this.clientEntityId = _data["clientEntityId"];
            this.minHours = _data["minHours"];
            this.maxHours = _data["maxHours"];
            this.rateBase = _data["rateBase"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CareerHourRateData {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRateData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careerHourRateId"] = this.careerHourRateId;
        data["careerHourRatePeriodId"] = this.careerHourRatePeriodId;
        data["clientEntityId"] = this.clientEntityId;
        data["minHours"] = this.minHours;
        data["maxHours"] = this.maxHours;
        data["rateBase"] = this.rateBase;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICareerHourRateData {
    careerHourRateId?: number;
    careerHourRatePeriodId?: number;
    clientEntityId?: string | undefined;
    minHours?: number;
    maxHours?: number;
    rateBase?: number;
    isActive?: string | undefined;
}

export class CareerHourRateInfo implements ICareerHourRateInfo {
    startDate?: Date;
    differential?: string | undefined;
    endDate?: Date;
    periodCreatedOn?: Date;
    periodUpdatedOn?: Date;
    careerHourRatePeriodId?: number;
    minHours?: number;
    maxHours?: number;
    rateBase?: number;
    rateCreatedOn?: Date | undefined;
    rateUpdatedOn?: Date | undefined;
    careerHourRateId?: number;
    modifierCreatedOn?: Date | undefined;
    modifierUpdatedOn?: Date | undefined;
    rateModifier?: number;
    qualificationCreatedOn?: Date | undefined;
    qualificationUpdatedOn?: Date | undefined;
    qualificationTypeId?: number | undefined;
    careerHourRateModifierId?: number;
    careerHourRateModifierQualificationId?: number | undefined;
    rateModifiers?: RateModifierQualification[] | undefined;
    isStackable?: boolean;

    constructor(data?: ICareerHourRateInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.differential = _data["differential"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.periodCreatedOn = _data["periodCreatedOn"] ? new Date(_data["periodCreatedOn"].toString()) : <any>undefined;
            this.periodUpdatedOn = _data["periodUpdatedOn"] ? new Date(_data["periodUpdatedOn"].toString()) : <any>undefined;
            this.careerHourRatePeriodId = _data["careerHourRatePeriodId"];
            this.minHours = _data["minHours"];
            this.maxHours = _data["maxHours"];
            this.rateBase = _data["rateBase"];
            this.rateCreatedOn = _data["rateCreatedOn"] ? new Date(_data["rateCreatedOn"].toString()) : <any>undefined;
            this.rateUpdatedOn = _data["rateUpdatedOn"] ? new Date(_data["rateUpdatedOn"].toString()) : <any>undefined;
            this.careerHourRateId = _data["careerHourRateId"];
            this.modifierCreatedOn = _data["modifierCreatedOn"] ? new Date(_data["modifierCreatedOn"].toString()) : <any>undefined;
            this.modifierUpdatedOn = _data["modifierUpdatedOn"] ? new Date(_data["modifierUpdatedOn"].toString()) : <any>undefined;
            this.rateModifier = _data["rateModifier"];
            this.qualificationCreatedOn = _data["qualificationCreatedOn"] ? new Date(_data["qualificationCreatedOn"].toString()) : <any>undefined;
            this.qualificationUpdatedOn = _data["qualificationUpdatedOn"] ? new Date(_data["qualificationUpdatedOn"].toString()) : <any>undefined;
            this.qualificationTypeId = _data["qualificationTypeId"];
            this.careerHourRateModifierId = _data["careerHourRateModifierId"];
            this.careerHourRateModifierQualificationId = _data["careerHourRateModifierQualificationId"];
            if (Array.isArray(_data["rateModifiers"])) {
                this.rateModifiers = [] as any;
                for (let item of _data["rateModifiers"])
                    this.rateModifiers!.push(RateModifierQualification.fromJS(item));
            }
            this.isStackable = _data["isStackable"];
        }
    }

    static fromJS(data: any): CareerHourRateInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRateInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["differential"] = this.differential;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["periodCreatedOn"] = this.periodCreatedOn ? this.periodCreatedOn.toISOString() : <any>undefined;
        data["periodUpdatedOn"] = this.periodUpdatedOn ? this.periodUpdatedOn.toISOString() : <any>undefined;
        data["careerHourRatePeriodId"] = this.careerHourRatePeriodId;
        data["minHours"] = this.minHours;
        data["maxHours"] = this.maxHours;
        data["rateBase"] = this.rateBase;
        data["rateCreatedOn"] = this.rateCreatedOn ? this.rateCreatedOn.toISOString() : <any>undefined;
        data["rateUpdatedOn"] = this.rateUpdatedOn ? this.rateUpdatedOn.toISOString() : <any>undefined;
        data["careerHourRateId"] = this.careerHourRateId;
        data["modifierCreatedOn"] = this.modifierCreatedOn ? this.modifierCreatedOn.toISOString() : <any>undefined;
        data["modifierUpdatedOn"] = this.modifierUpdatedOn ? this.modifierUpdatedOn.toISOString() : <any>undefined;
        data["rateModifier"] = this.rateModifier;
        data["qualificationCreatedOn"] = this.qualificationCreatedOn ? this.qualificationCreatedOn.toISOString() : <any>undefined;
        data["qualificationUpdatedOn"] = this.qualificationUpdatedOn ? this.qualificationUpdatedOn.toISOString() : <any>undefined;
        data["qualificationTypeId"] = this.qualificationTypeId;
        data["careerHourRateModifierId"] = this.careerHourRateModifierId;
        data["careerHourRateModifierQualificationId"] = this.careerHourRateModifierQualificationId;
        if (Array.isArray(this.rateModifiers)) {
            data["rateModifiers"] = [];
            for (let item of this.rateModifiers)
                data["rateModifiers"].push(item.toJSON());
        }
        data["isStackable"] = this.isStackable;
        return data;
    }
}

export interface ICareerHourRateInfo {
    startDate?: Date;
    differential?: string | undefined;
    endDate?: Date;
    periodCreatedOn?: Date;
    periodUpdatedOn?: Date;
    careerHourRatePeriodId?: number;
    minHours?: number;
    maxHours?: number;
    rateBase?: number;
    rateCreatedOn?: Date | undefined;
    rateUpdatedOn?: Date | undefined;
    careerHourRateId?: number;
    modifierCreatedOn?: Date | undefined;
    modifierUpdatedOn?: Date | undefined;
    rateModifier?: number;
    qualificationCreatedOn?: Date | undefined;
    qualificationUpdatedOn?: Date | undefined;
    qualificationTypeId?: number | undefined;
    careerHourRateModifierId?: number;
    careerHourRateModifierQualificationId?: number | undefined;
    rateModifiers?: RateModifierQualification[] | undefined;
    isStackable?: boolean;
}

export class CareerHourRateModifier implements ICareerHourRateModifier {
    careerHourRateModifierId?: number;
    careerHourRateId?: number;
    companyId?: number;
    clientEntityId?: string | undefined;
    rateModifier?: number;
    isActive?: string | undefined;
    differential?: string | undefined;
    isStackable?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: ICareerHourRateModifier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.careerHourRateModifierId = _data["careerHourRateModifierId"];
            this.careerHourRateId = _data["careerHourRateId"];
            this.companyId = _data["companyId"];
            this.clientEntityId = _data["clientEntityId"];
            this.rateModifier = _data["rateModifier"];
            this.isActive = _data["isActive"];
            this.differential = _data["differential"];
            this.isStackable = _data["isStackable"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CareerHourRateModifier {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRateModifier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careerHourRateModifierId"] = this.careerHourRateModifierId;
        data["careerHourRateId"] = this.careerHourRateId;
        data["companyId"] = this.companyId;
        data["clientEntityId"] = this.clientEntityId;
        data["rateModifier"] = this.rateModifier;
        data["isActive"] = this.isActive;
        data["differential"] = this.differential;
        data["isStackable"] = this.isStackable;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICareerHourRateModifier {
    careerHourRateModifierId?: number;
    careerHourRateId?: number;
    companyId?: number;
    clientEntityId?: string | undefined;
    rateModifier?: number;
    isActive?: string | undefined;
    differential?: string | undefined;
    isStackable?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class CareerHourRateModifierData implements ICareerHourRateModifierData {
    careerHourRateModifierId?: number;
    careerHourRateId?: number;
    clientEntityId?: string | undefined;
    rateModifier?: number;
    isActive?: string | undefined;
    differential?: string | undefined;
    isStackable?: boolean;

    constructor(data?: ICareerHourRateModifierData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.careerHourRateModifierId = _data["careerHourRateModifierId"];
            this.careerHourRateId = _data["careerHourRateId"];
            this.clientEntityId = _data["clientEntityId"];
            this.rateModifier = _data["rateModifier"];
            this.isActive = _data["isActive"];
            this.differential = _data["differential"];
            this.isStackable = _data["isStackable"];
        }
    }

    static fromJS(data: any): CareerHourRateModifierData {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRateModifierData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careerHourRateModifierId"] = this.careerHourRateModifierId;
        data["careerHourRateId"] = this.careerHourRateId;
        data["clientEntityId"] = this.clientEntityId;
        data["rateModifier"] = this.rateModifier;
        data["isActive"] = this.isActive;
        data["differential"] = this.differential;
        data["isStackable"] = this.isStackable;
        return data;
    }
}

export interface ICareerHourRateModifierData {
    careerHourRateModifierId?: number;
    careerHourRateId?: number;
    clientEntityId?: string | undefined;
    rateModifier?: number;
    isActive?: string | undefined;
    differential?: string | undefined;
    isStackable?: boolean;
}

export class CareerHourRateModifierQualification implements ICareerHourRateModifierQualification {
    careerHourRateModifierQualificationId?: number;
    careerHourRateModifierId?: number;
    clientEntityId?: string | undefined;
    qualificationId?: number;
    qualificationCode?: string | undefined;
    qualificationDisplayText?: string | undefined;
    companyId?: number;
    isActive?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: ICareerHourRateModifierQualification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.careerHourRateModifierQualificationId = _data["careerHourRateModifierQualificationId"];
            this.careerHourRateModifierId = _data["careerHourRateModifierId"];
            this.clientEntityId = _data["clientEntityId"];
            this.qualificationId = _data["qualificationId"];
            this.qualificationCode = _data["qualificationCode"];
            this.qualificationDisplayText = _data["qualificationDisplayText"];
            this.companyId = _data["companyId"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CareerHourRateModifierQualification {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRateModifierQualification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careerHourRateModifierQualificationId"] = this.careerHourRateModifierQualificationId;
        data["careerHourRateModifierId"] = this.careerHourRateModifierId;
        data["clientEntityId"] = this.clientEntityId;
        data["qualificationId"] = this.qualificationId;
        data["qualificationCode"] = this.qualificationCode;
        data["qualificationDisplayText"] = this.qualificationDisplayText;
        data["companyId"] = this.companyId;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICareerHourRateModifierQualification {
    careerHourRateModifierQualificationId?: number;
    careerHourRateModifierId?: number;
    clientEntityId?: string | undefined;
    qualificationId?: number;
    qualificationCode?: string | undefined;
    qualificationDisplayText?: string | undefined;
    companyId?: number;
    isActive?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class CareerHourRateModifierQualificationData implements ICareerHourRateModifierQualificationData {
    careerHourRateModifierQualificationId?: number;
    careerHourRateModifierId?: number;
    clientEntityId?: string | undefined;
    qualificationId?: number;
    isActive?: string | undefined;
    rateModifier?: number;

    constructor(data?: ICareerHourRateModifierQualificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.careerHourRateModifierQualificationId = _data["careerHourRateModifierQualificationId"];
            this.careerHourRateModifierId = _data["careerHourRateModifierId"];
            this.clientEntityId = _data["clientEntityId"];
            this.qualificationId = _data["qualificationId"];
            this.isActive = _data["isActive"];
            this.rateModifier = _data["rateModifier"];
        }
    }

    static fromJS(data: any): CareerHourRateModifierQualificationData {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRateModifierQualificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careerHourRateModifierQualificationId"] = this.careerHourRateModifierQualificationId;
        data["careerHourRateModifierId"] = this.careerHourRateModifierId;
        data["clientEntityId"] = this.clientEntityId;
        data["qualificationId"] = this.qualificationId;
        data["isActive"] = this.isActive;
        data["rateModifier"] = this.rateModifier;
        return data;
    }
}

export interface ICareerHourRateModifierQualificationData {
    careerHourRateModifierQualificationId?: number;
    careerHourRateModifierId?: number;
    clientEntityId?: string | undefined;
    qualificationId?: number;
    isActive?: string | undefined;
    rateModifier?: number;
}

export class CareerHourRateModifierQualificationRequest implements ICareerHourRateModifierQualificationRequest {
    careerHourRateModifierQualificationList?: CareerHourRateModifierQualificationData[] | undefined;
    careerHourRateModifierIds?: number[] | undefined;

    constructor(data?: ICareerHourRateModifierQualificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["careerHourRateModifierQualificationList"])) {
                this.careerHourRateModifierQualificationList = [] as any;
                for (let item of _data["careerHourRateModifierQualificationList"])
                    this.careerHourRateModifierQualificationList!.push(CareerHourRateModifierQualificationData.fromJS(item));
            }
            if (Array.isArray(_data["careerHourRateModifierIds"])) {
                this.careerHourRateModifierIds = [] as any;
                for (let item of _data["careerHourRateModifierIds"])
                    this.careerHourRateModifierIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CareerHourRateModifierQualificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRateModifierQualificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.careerHourRateModifierQualificationList)) {
            data["careerHourRateModifierQualificationList"] = [];
            for (let item of this.careerHourRateModifierQualificationList)
                data["careerHourRateModifierQualificationList"].push(item.toJSON());
        }
        if (Array.isArray(this.careerHourRateModifierIds)) {
            data["careerHourRateModifierIds"] = [];
            for (let item of this.careerHourRateModifierIds)
                data["careerHourRateModifierIds"].push(item);
        }
        return data;
    }
}

export interface ICareerHourRateModifierQualificationRequest {
    careerHourRateModifierQualificationList?: CareerHourRateModifierQualificationData[] | undefined;
    careerHourRateModifierIds?: number[] | undefined;
}

export class CareerHourRateModifierRequest implements ICareerHourRateModifierRequest {
    careerHourRateModifierList?: CareerHourRateModifierData[] | undefined;

    constructor(data?: ICareerHourRateModifierRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["careerHourRateModifierList"])) {
                this.careerHourRateModifierList = [] as any;
                for (let item of _data["careerHourRateModifierList"])
                    this.careerHourRateModifierList!.push(CareerHourRateModifierData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CareerHourRateModifierRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRateModifierRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.careerHourRateModifierList)) {
            data["careerHourRateModifierList"] = [];
            for (let item of this.careerHourRateModifierList)
                data["careerHourRateModifierList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICareerHourRateModifierRequest {
    careerHourRateModifierList?: CareerHourRateModifierData[] | undefined;
}

export class CareerHourRatePeriod implements ICareerHourRatePeriod {
    careerHourRatePeriodId?: number;
    clientEntityId?: string | undefined;
    companyId?: number;
    startDate?: Date;
    endDate?: Date;
    isActive?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: ICareerHourRatePeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.careerHourRatePeriodId = _data["careerHourRatePeriodId"];
            this.clientEntityId = _data["clientEntityId"];
            this.companyId = _data["companyId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CareerHourRatePeriod {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRatePeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careerHourRatePeriodId"] = this.careerHourRatePeriodId;
        data["clientEntityId"] = this.clientEntityId;
        data["companyId"] = this.companyId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICareerHourRatePeriod {
    careerHourRatePeriodId?: number;
    clientEntityId?: string | undefined;
    companyId?: number;
    startDate?: Date;
    endDate?: Date;
    isActive?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class CareerHourRatePeriodData implements ICareerHourRatePeriodData {
    careerHourRatePeriodId?: number;
    clientEntityId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    isActive?: string | undefined;

    constructor(data?: ICareerHourRatePeriodData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.careerHourRatePeriodId = _data["careerHourRatePeriodId"];
            this.clientEntityId = _data["clientEntityId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CareerHourRatePeriodData {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRatePeriodData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careerHourRatePeriodId"] = this.careerHourRatePeriodId;
        data["clientEntityId"] = this.clientEntityId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICareerHourRatePeriodData {
    careerHourRatePeriodId?: number;
    clientEntityId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    isActive?: string | undefined;
}

export class CareerHourRatePeriodGridResponseBase implements ICareerHourRatePeriodGridResponseBase {
    items?: CareerHourRatePeriod[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CareerHourRatePeriod;

    constructor(data?: ICareerHourRatePeriodGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CareerHourRatePeriod.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? CareerHourRatePeriod.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CareerHourRatePeriodGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRatePeriodGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICareerHourRatePeriodGridResponseBase {
    items?: CareerHourRatePeriod[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CareerHourRatePeriod;
}

export class CareerHourRatePeriodRequest implements ICareerHourRatePeriodRequest {
    careerHourRatePeriodList?: CareerHourRatePeriodData[] | undefined;

    constructor(data?: ICareerHourRatePeriodRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["careerHourRatePeriodList"])) {
                this.careerHourRatePeriodList = [] as any;
                for (let item of _data["careerHourRatePeriodList"])
                    this.careerHourRatePeriodList!.push(CareerHourRatePeriodData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CareerHourRatePeriodRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRatePeriodRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.careerHourRatePeriodList)) {
            data["careerHourRatePeriodList"] = [];
            for (let item of this.careerHourRatePeriodList)
                data["careerHourRatePeriodList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICareerHourRatePeriodRequest {
    careerHourRatePeriodList?: CareerHourRatePeriodData[] | undefined;
}

export class CareerHourRateRequest implements ICareerHourRateRequest {
    careerHourRateList?: CareerHourRateData[] | undefined;

    constructor(data?: ICareerHourRateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["careerHourRateList"])) {
                this.careerHourRateList = [] as any;
                for (let item of _data["careerHourRateList"])
                    this.careerHourRateList!.push(CareerHourRateData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CareerHourRateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.careerHourRateList)) {
            data["careerHourRateList"] = [];
            for (let item of this.careerHourRateList)
                data["careerHourRateList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICareerHourRateRequest {
    careerHourRateList?: CareerHourRateData[] | undefined;
}

export class CaregiverAttestationStatus implements ICaregiverAttestationStatus {
    personId?: string | undefined;
    name?: string | undefined;
    demographicsConfirmation?: AttestationStatus;
    readonly demographicsConfirmationText?: string | undefined;
    demographicsConfirmationModel?: Int32ComboboxModel;
    trainingConfirmation?: AttestationStatus;
    readonly trainingConfirmationText?: string | undefined;
    trainingConfirmationModel?: Int32ComboboxModel;
    backgroundCheckConfirmation?: AttestationStatus;
    readonly backgroundCheckConfirmationText?: string | undefined;
    backgroundCheckConfirmationModel?: Int32ComboboxModel;
    readonly caregiverParticipantAttestationText?: string | undefined;
    isUnapprovedCaregiverAttestation?: boolean;
    isUnapprovedCaregiverParticipantAttestation?: boolean;

    constructor(data?: ICaregiverAttestationStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.name = _data["name"];
            this.demographicsConfirmation = _data["demographicsConfirmation"];
            (<any>this).demographicsConfirmationText = _data["demographicsConfirmationText"];
            this.demographicsConfirmationModel = _data["demographicsConfirmationModel"] ? Int32ComboboxModel.fromJS(_data["demographicsConfirmationModel"]) : <any>undefined;
            this.trainingConfirmation = _data["trainingConfirmation"];
            (<any>this).trainingConfirmationText = _data["trainingConfirmationText"];
            this.trainingConfirmationModel = _data["trainingConfirmationModel"] ? Int32ComboboxModel.fromJS(_data["trainingConfirmationModel"]) : <any>undefined;
            this.backgroundCheckConfirmation = _data["backgroundCheckConfirmation"];
            (<any>this).backgroundCheckConfirmationText = _data["backgroundCheckConfirmationText"];
            this.backgroundCheckConfirmationModel = _data["backgroundCheckConfirmationModel"] ? Int32ComboboxModel.fromJS(_data["backgroundCheckConfirmationModel"]) : <any>undefined;
            (<any>this).caregiverParticipantAttestationText = _data["caregiverParticipantAttestationText"];
            this.isUnapprovedCaregiverAttestation = _data["isUnapprovedCaregiverAttestation"];
            this.isUnapprovedCaregiverParticipantAttestation = _data["isUnapprovedCaregiverParticipantAttestation"];
        }
    }

    static fromJS(data: any): CaregiverAttestationStatus {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverAttestationStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["name"] = this.name;
        data["demographicsConfirmation"] = this.demographicsConfirmation;
        data["demographicsConfirmationText"] = this.demographicsConfirmationText;
        data["demographicsConfirmationModel"] = this.demographicsConfirmationModel ? this.demographicsConfirmationModel.toJSON() : <any>undefined;
        data["trainingConfirmation"] = this.trainingConfirmation;
        data["trainingConfirmationText"] = this.trainingConfirmationText;
        data["trainingConfirmationModel"] = this.trainingConfirmationModel ? this.trainingConfirmationModel.toJSON() : <any>undefined;
        data["backgroundCheckConfirmation"] = this.backgroundCheckConfirmation;
        data["backgroundCheckConfirmationText"] = this.backgroundCheckConfirmationText;
        data["backgroundCheckConfirmationModel"] = this.backgroundCheckConfirmationModel ? this.backgroundCheckConfirmationModel.toJSON() : <any>undefined;
        data["caregiverParticipantAttestationText"] = this.caregiverParticipantAttestationText;
        data["isUnapprovedCaregiverAttestation"] = this.isUnapprovedCaregiverAttestation;
        data["isUnapprovedCaregiverParticipantAttestation"] = this.isUnapprovedCaregiverParticipantAttestation;
        return data;
    }
}

export interface ICaregiverAttestationStatus {
    personId?: string | undefined;
    name?: string | undefined;
    demographicsConfirmation?: AttestationStatus;
    demographicsConfirmationText?: string | undefined;
    demographicsConfirmationModel?: Int32ComboboxModel;
    trainingConfirmation?: AttestationStatus;
    trainingConfirmationText?: string | undefined;
    trainingConfirmationModel?: Int32ComboboxModel;
    backgroundCheckConfirmation?: AttestationStatus;
    backgroundCheckConfirmationText?: string | undefined;
    backgroundCheckConfirmationModel?: Int32ComboboxModel;
    caregiverParticipantAttestationText?: string | undefined;
    isUnapprovedCaregiverAttestation?: boolean;
    isUnapprovedCaregiverParticipantAttestation?: boolean;
}

export class CaregiverAttestationStatusDetailsDto implements ICaregiverAttestationStatusDetailsDto {
    employeeOkToWork?: boolean;
    caregiverAttestationDetails?: CaregiverAttestationStatusResponse;
    caregiverParticipantRelAttestationDetails?: CaregiverParticipantRelAttestationResponse[] | undefined;
    caregiverEmployerMappingDetails?: CaregiverEmployerMappingDetails[] | undefined;

    constructor(data?: ICaregiverAttestationStatusDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeOkToWork = _data["employeeOkToWork"];
            this.caregiverAttestationDetails = _data["caregiverAttestationDetails"] ? CaregiverAttestationStatusResponse.fromJS(_data["caregiverAttestationDetails"]) : <any>undefined;
            if (Array.isArray(_data["caregiverParticipantRelAttestationDetails"])) {
                this.caregiverParticipantRelAttestationDetails = [] as any;
                for (let item of _data["caregiverParticipantRelAttestationDetails"])
                    this.caregiverParticipantRelAttestationDetails!.push(CaregiverParticipantRelAttestationResponse.fromJS(item));
            }
            if (Array.isArray(_data["caregiverEmployerMappingDetails"])) {
                this.caregiverEmployerMappingDetails = [] as any;
                for (let item of _data["caregiverEmployerMappingDetails"])
                    this.caregiverEmployerMappingDetails!.push(CaregiverEmployerMappingDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaregiverAttestationStatusDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverAttestationStatusDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeOkToWork"] = this.employeeOkToWork;
        data["caregiverAttestationDetails"] = this.caregiverAttestationDetails ? this.caregiverAttestationDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.caregiverParticipantRelAttestationDetails)) {
            data["caregiverParticipantRelAttestationDetails"] = [];
            for (let item of this.caregiverParticipantRelAttestationDetails)
                data["caregiverParticipantRelAttestationDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.caregiverEmployerMappingDetails)) {
            data["caregiverEmployerMappingDetails"] = [];
            for (let item of this.caregiverEmployerMappingDetails)
                data["caregiverEmployerMappingDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICaregiverAttestationStatusDetailsDto {
    employeeOkToWork?: boolean;
    caregiverAttestationDetails?: CaregiverAttestationStatusResponse;
    caregiverParticipantRelAttestationDetails?: CaregiverParticipantRelAttestationResponse[] | undefined;
    caregiverEmployerMappingDetails?: CaregiverEmployerMappingDetails[] | undefined;
}

export class CaregiverAttestationStatusResponse implements ICaregiverAttestationStatusResponse {
    demographicStatus?: number;
    trainingStatus?: number;
    backgroundCheckStatus?: number;

    constructor(data?: ICaregiverAttestationStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.demographicStatus = _data["demographicStatus"];
            this.trainingStatus = _data["trainingStatus"];
            this.backgroundCheckStatus = _data["backgroundCheckStatus"];
        }
    }

    static fromJS(data: any): CaregiverAttestationStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverAttestationStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["demographicStatus"] = this.demographicStatus;
        data["trainingStatus"] = this.trainingStatus;
        data["backgroundCheckStatus"] = this.backgroundCheckStatus;
        return data;
    }
}

export interface ICaregiverAttestationStatusResponse {
    demographicStatus?: number;
    trainingStatus?: number;
    backgroundCheckStatus?: number;
}

export class CaregiverAttestationStatusResultSet implements ICaregiverAttestationStatusResultSet {
    totalRecords?: number;
    data?: CaregiverAttestationStatus[] | undefined;

    constructor(data?: ICaregiverAttestationStatusResultSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CaregiverAttestationStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaregiverAttestationStatusResultSet {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverAttestationStatusResultSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICaregiverAttestationStatusResultSet {
    totalRecords?: number;
    data?: CaregiverAttestationStatus[] | undefined;
}

export class CaregiverCch implements ICaregiverCch {
    cumulativeHours?: number;

    constructor(data?: ICaregiverCch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cumulativeHours = _data["cumulativeHours"];
        }
    }

    static fromJS(data: any): CaregiverCch {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverCch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cumulativeHours"] = this.cumulativeHours;
        return data;
    }
}

export interface ICaregiverCch {
    cumulativeHours?: number;
}

export class CaregiverConversionAddressDto implements ICaregiverConversionAddressDto {
    caregiverConversionAddressId?: number;
    startDate?: Date | undefined;
    type?: number | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipcode?: string | undefined;
    isInvalid?: boolean;
    caregiverConversionId?: number;

    constructor(data?: ICaregiverConversionAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverConversionAddressId = _data["caregiverConversionAddressId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipcode = _data["zipcode"];
            this.isInvalid = _data["isInvalid"];
            this.caregiverConversionId = _data["caregiverConversionId"];
        }
    }

    static fromJS(data: any): CaregiverConversionAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverConversionAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverConversionAddressId"] = this.caregiverConversionAddressId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipcode"] = this.zipcode;
        data["isInvalid"] = this.isInvalid;
        data["caregiverConversionId"] = this.caregiverConversionId;
        return data;
    }
}

export interface ICaregiverConversionAddressDto {
    caregiverConversionAddressId?: number;
    startDate?: Date | undefined;
    type?: number | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipcode?: string | undefined;
    isInvalid?: boolean;
    caregiverConversionId?: number;
}

export class CaregiverConversionCompleteRequest implements ICaregiverConversionCompleteRequest {
    caregivers?: CaregiverConversionPersonDto[] | undefined;

    constructor(data?: ICaregiverConversionCompleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["caregivers"])) {
                this.caregivers = [] as any;
                for (let item of _data["caregivers"])
                    this.caregivers!.push(CaregiverConversionPersonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaregiverConversionCompleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverConversionCompleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.caregivers)) {
            data["caregivers"] = [];
            for (let item of this.caregivers)
                data["caregivers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICaregiverConversionCompleteRequest {
    caregivers?: CaregiverConversionPersonDto[] | undefined;
}

export class CaregiverConversionPersonDto implements ICaregiverConversionPersonDto {
    caregiverConversionId?: number | undefined;
    providerOneID?: string | undefined;
    ssn?: string | undefined;
    hireDate?: Date | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    languageCode?: string | undefined;
    gender?: string | undefined;
    maritalStatus?: string | undefined;
    phoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    dateOfBirth?: Date | undefined;
    conversionStatusId?: number | undefined;
    isComplete?: boolean;
    isEdited?: boolean;
    errorStatus?: string | undefined;
    description?: string | undefined;
    caregiverAddressDetails?: CaregiverConversionAddressDto[] | undefined;

    constructor(data?: ICaregiverConversionPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverConversionId = _data["caregiverConversionId"];
            this.providerOneID = _data["providerOneID"];
            this.ssn = _data["ssn"];
            this.hireDate = _data["hireDate"] ? new Date(_data["hireDate"].toString()) : <any>undefined;
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.languageCode = _data["languageCode"];
            this.gender = _data["gender"];
            this.maritalStatus = _data["maritalStatus"];
            this.phoneNumber = _data["phoneNumber"];
            this.cellPhoneNumber = _data["cellPhoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.conversionStatusId = _data["conversionStatusId"];
            this.isComplete = _data["isComplete"];
            this.isEdited = _data["isEdited"];
            this.errorStatus = _data["errorStatus"];
            this.description = _data["description"];
            if (Array.isArray(_data["caregiverAddressDetails"])) {
                this.caregiverAddressDetails = [] as any;
                for (let item of _data["caregiverAddressDetails"])
                    this.caregiverAddressDetails!.push(CaregiverConversionAddressDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaregiverConversionPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverConversionPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverConversionId"] = this.caregiverConversionId;
        data["providerOneID"] = this.providerOneID;
        data["ssn"] = this.ssn;
        data["hireDate"] = this.hireDate ? this.hireDate.toISOString() : <any>undefined;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["languageCode"] = this.languageCode;
        data["gender"] = this.gender;
        data["maritalStatus"] = this.maritalStatus;
        data["phoneNumber"] = this.phoneNumber;
        data["cellPhoneNumber"] = this.cellPhoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["conversionStatusId"] = this.conversionStatusId;
        data["isComplete"] = this.isComplete;
        data["isEdited"] = this.isEdited;
        data["errorStatus"] = this.errorStatus;
        data["description"] = this.description;
        if (Array.isArray(this.caregiverAddressDetails)) {
            data["caregiverAddressDetails"] = [];
            for (let item of this.caregiverAddressDetails)
                data["caregiverAddressDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICaregiverConversionPersonDto {
    caregiverConversionId?: number | undefined;
    providerOneID?: string | undefined;
    ssn?: string | undefined;
    hireDate?: Date | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    languageCode?: string | undefined;
    gender?: string | undefined;
    maritalStatus?: string | undefined;
    phoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    dateOfBirth?: Date | undefined;
    conversionStatusId?: number | undefined;
    isComplete?: boolean;
    isEdited?: boolean;
    errorStatus?: string | undefined;
    description?: string | undefined;
    caregiverAddressDetails?: CaregiverConversionAddressDto[] | undefined;
}

export class CaregiverConversionResponse implements ICaregiverConversionResponse {
    caregiverDetails?: CaregiverConversionPersonDto[] | undefined;

    constructor(data?: ICaregiverConversionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["caregiverDetails"])) {
                this.caregiverDetails = [] as any;
                for (let item of _data["caregiverDetails"])
                    this.caregiverDetails!.push(CaregiverConversionPersonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaregiverConversionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverConversionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.caregiverDetails)) {
            data["caregiverDetails"] = [];
            for (let item of this.caregiverDetails)
                data["caregiverDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICaregiverConversionResponse {
    caregiverDetails?: CaregiverConversionPersonDto[] | undefined;
}

export class CaregiverConversionUpdateRequest implements ICaregiverConversionUpdateRequest {
    caregiverDetails?: CaregiverConversionPersonDto;

    constructor(data?: ICaregiverConversionUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverDetails = _data["caregiverDetails"] ? CaregiverConversionPersonDto.fromJS(_data["caregiverDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CaregiverConversionUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverConversionUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverDetails"] = this.caregiverDetails ? this.caregiverDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICaregiverConversionUpdateRequest {
    caregiverDetails?: CaregiverConversionPersonDto;
}

export class CaregiverDemographicDetails implements ICaregiverDemographicDetails {
    providerOneId?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: ICaregiverDemographicDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerOneId = _data["providerOneId"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): CaregiverDemographicDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverDemographicDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerOneId"] = this.providerOneId;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface ICaregiverDemographicDetails {
    providerOneId?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
}

export class CaregiverDetails implements ICaregiverDetails {
    caregiver?: CareGiverDto;
    caregiverEmployerMapping?: CaregiverEmployerMapping[] | undefined;

    constructor(data?: ICaregiverDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiver = _data["caregiver"] ? CareGiverDto.fromJS(_data["caregiver"]) : <any>undefined;
            if (Array.isArray(_data["caregiverEmployerMapping"])) {
                this.caregiverEmployerMapping = [] as any;
                for (let item of _data["caregiverEmployerMapping"])
                    this.caregiverEmployerMapping!.push(CaregiverEmployerMapping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaregiverDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiver"] = this.caregiver ? this.caregiver.toJSON() : <any>undefined;
        if (Array.isArray(this.caregiverEmployerMapping)) {
            data["caregiverEmployerMapping"] = [];
            for (let item of this.caregiverEmployerMapping)
                data["caregiverEmployerMapping"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICaregiverDetails {
    caregiver?: CareGiverDto;
    caregiverEmployerMapping?: CaregiverEmployerMapping[] | undefined;
}

export class CaregiverEmployerFilterRequest implements ICaregiverEmployerFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    id?: string | undefined;
    caregiverIds?: string[] | undefined;

    constructor(data?: ICaregiverEmployerFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            this.id = _data["id"];
            if (Array.isArray(_data["caregiverIds"])) {
                this.caregiverIds = [] as any;
                for (let item of _data["caregiverIds"])
                    this.caregiverIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CaregiverEmployerFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverEmployerFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        data["id"] = this.id;
        if (Array.isArray(this.caregiverIds)) {
            data["caregiverIds"] = [];
            for (let item of this.caregiverIds)
                data["caregiverIds"].push(item);
        }
        return data;
    }
}

export interface ICaregiverEmployerFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    id?: string | undefined;
    caregiverIds?: string[] | undefined;
}

export class CaregiverEmployerList implements ICaregiverEmployerList {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number;
    name?: string | undefined;
    ein?: string | undefined;
    displayName?: string | undefined;
    ecn?: string | undefined;
    dateBegin?: Date | undefined;
    dateEnd?: Date | undefined;
    relation?: string | undefined;

    constructor(data?: ICaregiverEmployerList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.ein = _data["ein"];
            this.displayName = _data["displayName"];
            this.ecn = _data["ecn"];
            this.dateBegin = _data["dateBegin"] ? new Date(_data["dateBegin"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            this.relation = _data["relation"];
        }
    }

    static fromJS(data: any): CaregiverEmployerList {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverEmployerList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["id"] = this.id;
        data["name"] = this.name;
        data["ein"] = this.ein;
        data["displayName"] = this.displayName;
        data["ecn"] = this.ecn;
        data["dateBegin"] = this.dateBegin ? this.dateBegin.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["relation"] = this.relation;
        return data;
    }
}

export interface ICaregiverEmployerList {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number;
    name?: string | undefined;
    ein?: string | undefined;
    displayName?: string | undefined;
    ecn?: string | undefined;
    dateBegin?: Date | undefined;
    dateEnd?: Date | undefined;
    relation?: string | undefined;
}

export class CaregiverEmployerLkpDTO implements ICaregiverEmployerLkpDTO {
    id?: number;
    code?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    caregiverName?: string | undefined;
    employerFirstName?: string | undefined;
    employerLastName?: string | undefined;
    employerName?: string | undefined;
    relationshipId?: number;
    caregiverEmployerMappingId?: number;

    constructor(data?: ICaregiverEmployerLkpDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.caregiverFirstName = _data["caregiverFirstName"];
            this.caregiverLastName = _data["caregiverLastName"];
            this.caregiverName = _data["caregiverName"];
            this.employerFirstName = _data["employerFirstName"];
            this.employerLastName = _data["employerLastName"];
            this.employerName = _data["employerName"];
            this.relationshipId = _data["relationshipId"];
            this.caregiverEmployerMappingId = _data["caregiverEmployerMappingId"];
        }
    }

    static fromJS(data: any): CaregiverEmployerLkpDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverEmployerLkpDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["caregiverFirstName"] = this.caregiverFirstName;
        data["caregiverLastName"] = this.caregiverLastName;
        data["caregiverName"] = this.caregiverName;
        data["employerFirstName"] = this.employerFirstName;
        data["employerLastName"] = this.employerLastName;
        data["employerName"] = this.employerName;
        data["relationshipId"] = this.relationshipId;
        data["caregiverEmployerMappingId"] = this.caregiverEmployerMappingId;
        return data;
    }
}

export interface ICaregiverEmployerLkpDTO {
    id?: number;
    code?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    caregiverName?: string | undefined;
    employerFirstName?: string | undefined;
    employerLastName?: string | undefined;
    employerName?: string | undefined;
    relationshipId?: number;
    caregiverEmployerMappingId?: number;
}

export class CaregiverEmployerLkpDTOGridResponseBase implements ICaregiverEmployerLkpDTOGridResponseBase {
    items?: CaregiverEmployerLkpDTO[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CaregiverEmployerLkpDTO;

    constructor(data?: ICaregiverEmployerLkpDTOGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CaregiverEmployerLkpDTO.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? CaregiverEmployerLkpDTO.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CaregiverEmployerLkpDTOGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverEmployerLkpDTOGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICaregiverEmployerLkpDTOGridResponseBase {
    items?: CaregiverEmployerLkpDTO[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CaregiverEmployerLkpDTO;
}

export class CaregiverEmployerMapping implements ICaregiverEmployerMapping {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    caregiverEmployerMappingId?: number | undefined;
    employerId?: number | undefined;
    employer?: string | undefined;
    statusStartDate?: Date;
    statusEndDate?: Date | undefined;
    status?: string | undefined;
    payorId?: number | undefined;
    payorName?: string | undefined;
    dateId?: number | undefined;
    caregiverId?: number | undefined;
    caregiverPersonId?: string | undefined;
    nbrPersonalExemptions?: number | undefined;
    workLocation?: string | undefined;
    allowedHours?: number | undefined;
    eligibleForHoliday?: boolean | undefined;
    payService?: boolean | undefined;
    onHold?: boolean | undefined;
    employerBeginDate?: Date | undefined;
    employerEndDate?: Date | undefined;
    employerName?: string | undefined;
    empEmployerOfRecordRelId?: number;
    employerEmployerOfRecordRelcode?: string | undefined;
    empEmployerOfRecordRelName?: string | undefined;
    ein?: string | undefined;
    maritalStatus?: string | undefined;
    relationshipId?: number;
    permanentWWL?: number | undefined;
    termReason?: string | undefined;

    constructor(data?: ICaregiverEmployerMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.caregiverEmployerMappingId = _data["caregiverEmployerMappingId"];
            this.employerId = _data["employerId"];
            this.employer = _data["employer"];
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.payorId = _data["payorId"];
            this.payorName = _data["payorName"];
            this.dateId = _data["dateId"];
            this.caregiverId = _data["caregiverId"];
            this.caregiverPersonId = _data["caregiverPersonId"];
            this.nbrPersonalExemptions = _data["nbrPersonalExemptions"];
            this.workLocation = _data["workLocation"];
            this.allowedHours = _data["allowedHours"];
            this.eligibleForHoliday = _data["eligibleForHoliday"];
            this.payService = _data["payService"];
            this.onHold = _data["onHold"];
            this.employerBeginDate = _data["employerBeginDate"] ? new Date(_data["employerBeginDate"].toString()) : <any>undefined;
            this.employerEndDate = _data["employerEndDate"] ? new Date(_data["employerEndDate"].toString()) : <any>undefined;
            this.employerName = _data["employerName"];
            this.empEmployerOfRecordRelId = _data["empEmployerOfRecordRelId"];
            this.employerEmployerOfRecordRelcode = _data["employerEmployerOfRecordRelcode"];
            this.empEmployerOfRecordRelName = _data["empEmployerOfRecordRelName"];
            this.ein = _data["ein"];
            this.maritalStatus = _data["maritalStatus"];
            this.relationshipId = _data["relationshipId"];
            this.permanentWWL = _data["permanentWWL"];
            this.termReason = _data["termReason"];
        }
    }

    static fromJS(data: any): CaregiverEmployerMapping {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverEmployerMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["caregiverEmployerMappingId"] = this.caregiverEmployerMappingId;
        data["employerId"] = this.employerId;
        data["employer"] = this.employer;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["payorId"] = this.payorId;
        data["payorName"] = this.payorName;
        data["dateId"] = this.dateId;
        data["caregiverId"] = this.caregiverId;
        data["caregiverPersonId"] = this.caregiverPersonId;
        data["nbrPersonalExemptions"] = this.nbrPersonalExemptions;
        data["workLocation"] = this.workLocation;
        data["allowedHours"] = this.allowedHours;
        data["eligibleForHoliday"] = this.eligibleForHoliday;
        data["payService"] = this.payService;
        data["onHold"] = this.onHold;
        data["employerBeginDate"] = this.employerBeginDate ? this.employerBeginDate.toISOString() : <any>undefined;
        data["employerEndDate"] = this.employerEndDate ? this.employerEndDate.toISOString() : <any>undefined;
        data["employerName"] = this.employerName;
        data["empEmployerOfRecordRelId"] = this.empEmployerOfRecordRelId;
        data["employerEmployerOfRecordRelcode"] = this.employerEmployerOfRecordRelcode;
        data["empEmployerOfRecordRelName"] = this.empEmployerOfRecordRelName;
        data["ein"] = this.ein;
        data["maritalStatus"] = this.maritalStatus;
        data["relationshipId"] = this.relationshipId;
        data["permanentWWL"] = this.permanentWWL;
        data["termReason"] = this.termReason;
        return data;
    }
}

export interface ICaregiverEmployerMapping {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    caregiverEmployerMappingId?: number | undefined;
    employerId?: number | undefined;
    employer?: string | undefined;
    statusStartDate?: Date;
    statusEndDate?: Date | undefined;
    status?: string | undefined;
    payorId?: number | undefined;
    payorName?: string | undefined;
    dateId?: number | undefined;
    caregiverId?: number | undefined;
    caregiverPersonId?: string | undefined;
    nbrPersonalExemptions?: number | undefined;
    workLocation?: string | undefined;
    allowedHours?: number | undefined;
    eligibleForHoliday?: boolean | undefined;
    payService?: boolean | undefined;
    onHold?: boolean | undefined;
    employerBeginDate?: Date | undefined;
    employerEndDate?: Date | undefined;
    employerName?: string | undefined;
    empEmployerOfRecordRelId?: number;
    employerEmployerOfRecordRelcode?: string | undefined;
    empEmployerOfRecordRelName?: string | undefined;
    ein?: string | undefined;
    maritalStatus?: string | undefined;
    relationshipId?: number;
    permanentWWL?: number | undefined;
    termReason?: string | undefined;
}

export class CaregiverEmployerMappingDetails implements ICaregiverEmployerMappingDetails {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    caregiverEmployerMappingId?: number | undefined;
    employerId?: number | undefined;
    employer?: string | undefined;
    payorId?: number | undefined;
    payorName?: string | undefined;
    employerName?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    isDefaultEmployer?: boolean;
    ein?: string | undefined;

    constructor(data?: ICaregiverEmployerMappingDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.caregiverEmployerMappingId = _data["caregiverEmployerMappingId"];
            this.employerId = _data["employerId"];
            this.employer = _data["employer"];
            this.payorId = _data["payorId"];
            this.payorName = _data["payorName"];
            this.employerName = _data["employerName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.isDefaultEmployer = _data["isDefaultEmployer"];
            this.ein = _data["ein"];
        }
    }

    static fromJS(data: any): CaregiverEmployerMappingDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverEmployerMappingDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["caregiverEmployerMappingId"] = this.caregiverEmployerMappingId;
        data["employerId"] = this.employerId;
        data["employer"] = this.employer;
        data["payorId"] = this.payorId;
        data["payorName"] = this.payorName;
        data["employerName"] = this.employerName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isDefaultEmployer"] = this.isDefaultEmployer;
        data["ein"] = this.ein;
        return data;
    }
}

export interface ICaregiverEmployerMappingDetails {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    caregiverEmployerMappingId?: number | undefined;
    employerId?: number | undefined;
    employer?: string | undefined;
    payorId?: number | undefined;
    payorName?: string | undefined;
    employerName?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    isDefaultEmployer?: boolean;
    ein?: string | undefined;
}

export class CaregiverEmployerMappingRequest implements ICaregiverEmployerMappingRequest {
    caregiverEmployerMappingIds?: number[] | undefined;

    constructor(data?: ICaregiverEmployerMappingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["caregiverEmployerMappingIds"])) {
                this.caregiverEmployerMappingIds = [] as any;
                for (let item of _data["caregiverEmployerMappingIds"])
                    this.caregiverEmployerMappingIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CaregiverEmployerMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverEmployerMappingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.caregiverEmployerMappingIds)) {
            data["caregiverEmployerMappingIds"] = [];
            for (let item of this.caregiverEmployerMappingIds)
                data["caregiverEmployerMappingIds"].push(item);
        }
        return data;
    }
}

export interface ICaregiverEmployerMappingRequest {
    caregiverEmployerMappingIds?: number[] | undefined;
}

export class CaregiverEmployerOfRecordList implements ICaregiverEmployerOfRecordList {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number;
    name?: string | undefined;
    ein?: string | undefined;
    dateBegin?: Date | undefined;
    dateEnd?: Date | undefined;
    personId?: string | undefined;
    relationshipToParticipant?: string | undefined;

    constructor(data?: ICaregiverEmployerOfRecordList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.ein = _data["ein"];
            this.dateBegin = _data["dateBegin"] ? new Date(_data["dateBegin"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            this.personId = _data["personId"];
            this.relationshipToParticipant = _data["relationshipToParticipant"];
        }
    }

    static fromJS(data: any): CaregiverEmployerOfRecordList {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverEmployerOfRecordList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["id"] = this.id;
        data["name"] = this.name;
        data["ein"] = this.ein;
        data["dateBegin"] = this.dateBegin ? this.dateBegin.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["personId"] = this.personId;
        data["relationshipToParticipant"] = this.relationshipToParticipant;
        return data;
    }
}

export interface ICaregiverEmployerOfRecordList {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number;
    name?: string | undefined;
    ein?: string | undefined;
    dateBegin?: Date | undefined;
    dateEnd?: Date | undefined;
    personId?: string | undefined;
    relationshipToParticipant?: string | undefined;
}

export class CaregiverEmployerRelDates implements ICaregiverEmployerRelDates {
    id?: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    employerEmployerOfRecordRelationId?: number;
    employerEmployerOfRecordRelationCode?: string | undefined;
    employerEmployerOfRecordRelationName?: string | undefined;
    termReason?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: ICaregiverEmployerRelDates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.employerEmployerOfRecordRelationId = _data["employerEmployerOfRecordRelationId"];
            this.employerEmployerOfRecordRelationCode = _data["employerEmployerOfRecordRelationCode"];
            this.employerEmployerOfRecordRelationName = _data["employerEmployerOfRecordRelationName"];
            this.termReason = _data["termReason"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CaregiverEmployerRelDates {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverEmployerRelDates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["employerEmployerOfRecordRelationId"] = this.employerEmployerOfRecordRelationId;
        data["employerEmployerOfRecordRelationCode"] = this.employerEmployerOfRecordRelationCode;
        data["employerEmployerOfRecordRelationName"] = this.employerEmployerOfRecordRelationName;
        data["termReason"] = this.termReason;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ICaregiverEmployerRelDates {
    id?: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    employerEmployerOfRecordRelationId?: number;
    employerEmployerOfRecordRelationCode?: string | undefined;
    employerEmployerOfRecordRelationName?: string | undefined;
    termReason?: string | undefined;
    isDeleted?: boolean;
}

export class CaregiverEmployerRelResponse implements ICaregiverEmployerRelResponse {
    caregiverId?: number;
    employerId?: number;
    caregiverEmployerRelId?: number;
    payorId?: number;
    relationshipId?: number;
    externalId?: string | undefined;
    nbrPersonalExemptions?: number | undefined;
    workLocation?: string | undefined;
    allowedHours?: number | undefined;
    eligibleForHoliday?: boolean | undefined;
    payService?: boolean | undefined;
    onHold?: boolean | undefined;
    maritalStatus?: string | undefined;
    permanentWWL?: number | undefined;
    employerRelationships?: CaregiverEmployerRelDates[] | undefined;

    constructor(data?: ICaregiverEmployerRelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.employerId = _data["employerId"];
            this.caregiverEmployerRelId = _data["caregiverEmployerRelId"];
            this.payorId = _data["payorId"];
            this.relationshipId = _data["relationshipId"];
            this.externalId = _data["externalId"];
            this.nbrPersonalExemptions = _data["nbrPersonalExemptions"];
            this.workLocation = _data["workLocation"];
            this.allowedHours = _data["allowedHours"];
            this.eligibleForHoliday = _data["eligibleForHoliday"];
            this.payService = _data["payService"];
            this.onHold = _data["onHold"];
            this.maritalStatus = _data["maritalStatus"];
            this.permanentWWL = _data["permanentWWL"];
            if (Array.isArray(_data["employerRelationships"])) {
                this.employerRelationships = [] as any;
                for (let item of _data["employerRelationships"])
                    this.employerRelationships!.push(CaregiverEmployerRelDates.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaregiverEmployerRelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverEmployerRelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["employerId"] = this.employerId;
        data["caregiverEmployerRelId"] = this.caregiverEmployerRelId;
        data["payorId"] = this.payorId;
        data["relationshipId"] = this.relationshipId;
        data["externalId"] = this.externalId;
        data["nbrPersonalExemptions"] = this.nbrPersonalExemptions;
        data["workLocation"] = this.workLocation;
        data["allowedHours"] = this.allowedHours;
        data["eligibleForHoliday"] = this.eligibleForHoliday;
        data["payService"] = this.payService;
        data["onHold"] = this.onHold;
        data["maritalStatus"] = this.maritalStatus;
        data["permanentWWL"] = this.permanentWWL;
        if (Array.isArray(this.employerRelationships)) {
            data["employerRelationships"] = [];
            for (let item of this.employerRelationships)
                data["employerRelationships"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICaregiverEmployerRelResponse {
    caregiverId?: number;
    employerId?: number;
    caregiverEmployerRelId?: number;
    payorId?: number;
    relationshipId?: number;
    externalId?: string | undefined;
    nbrPersonalExemptions?: number | undefined;
    workLocation?: string | undefined;
    allowedHours?: number | undefined;
    eligibleForHoliday?: boolean | undefined;
    payService?: boolean | undefined;
    onHold?: boolean | undefined;
    maritalStatus?: string | undefined;
    permanentWWL?: number | undefined;
    employerRelationships?: CaregiverEmployerRelDates[] | undefined;
}

export class CaregiverEmployerRelationshipStartDateResponse implements ICaregiverEmployerRelationshipStartDateResponse {
    caregiverPersonId?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    caregiverName?: string | undefined;
    employerFirstName?: string | undefined;
    employerLastName?: string | undefined;
    employerName?: string | undefined;
    ecn?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    relation?: string | undefined;

    constructor(data?: ICaregiverEmployerRelationshipStartDateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverPersonId = _data["caregiverPersonId"];
            this.caregiverFirstName = _data["caregiverFirstName"];
            this.caregiverLastName = _data["caregiverLastName"];
            this.caregiverName = _data["caregiverName"];
            this.employerFirstName = _data["employerFirstName"];
            this.employerLastName = _data["employerLastName"];
            this.employerName = _data["employerName"];
            this.ecn = _data["ecn"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.relation = _data["relation"];
        }
    }

    static fromJS(data: any): CaregiverEmployerRelationshipStartDateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverEmployerRelationshipStartDateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverPersonId"] = this.caregiverPersonId;
        data["caregiverFirstName"] = this.caregiverFirstName;
        data["caregiverLastName"] = this.caregiverLastName;
        data["caregiverName"] = this.caregiverName;
        data["employerFirstName"] = this.employerFirstName;
        data["employerLastName"] = this.employerLastName;
        data["employerName"] = this.employerName;
        data["ecn"] = this.ecn;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["relation"] = this.relation;
        return data;
    }
}

export interface ICaregiverEmployerRelationshipStartDateResponse {
    caregiverPersonId?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    caregiverName?: string | undefined;
    employerFirstName?: string | undefined;
    employerLastName?: string | undefined;
    employerName?: string | undefined;
    ecn?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    relation?: string | undefined;
}

export class CaregiverFilterRequest implements ICaregiverFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    id?: string | undefined;
    payors?: number[] | undefined;

    constructor(data?: ICaregiverFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            this.id = _data["id"];
            if (Array.isArray(_data["payors"])) {
                this.payors = [] as any;
                for (let item of _data["payors"])
                    this.payors!.push(item);
            }
        }
    }

    static fromJS(data: any): CaregiverFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        data["id"] = this.id;
        if (Array.isArray(this.payors)) {
            data["payors"] = [];
            for (let item of this.payors)
                data["payors"].push(item);
        }
        return data;
    }
}

export interface ICaregiverFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    id?: string | undefined;
    payors?: number[] | undefined;
}

export class CaregiverGracePeriod implements ICaregiverGracePeriod {
    id?: number | undefined;
    caregiverEmployerMappingId?: number;
    gracePeriodDays?: number;
    startDate?: Date;
    endDate?: Date;
    isDeleted?: boolean;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    readonly isActive?: boolean;

    constructor(data?: ICaregiverGracePeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caregiverEmployerMappingId = _data["caregiverEmployerMappingId"];
            this.gracePeriodDays = _data["gracePeriodDays"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            (<any>this).isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CaregiverGracePeriod {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverGracePeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caregiverEmployerMappingId"] = this.caregiverEmployerMappingId;
        data["gracePeriodDays"] = this.gracePeriodDays;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICaregiverGracePeriod {
    id?: number | undefined;
    caregiverEmployerMappingId?: number;
    gracePeriodDays?: number;
    startDate?: Date;
    endDate?: Date;
    isDeleted?: boolean;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    isActive?: boolean;
}

export class CaregiverGracePeriodRequest implements ICaregiverGracePeriodRequest {
    serviceDate?: Date | undefined;
    serviceCode?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;

    constructor(data?: ICaregiverGracePeriodRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.serviceCode = _data["serviceCode"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
        }
    }

    static fromJS(data: any): CaregiverGracePeriodRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverGracePeriodRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        data["serviceCode"] = this.serviceCode;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        return data;
    }
}

export interface ICaregiverGracePeriodRequest {
    serviceDate?: Date | undefined;
    serviceCode?: string | undefined;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
}

export class CaregiverHistory implements ICaregiverHistory {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number;
    caregiverId?: number;
    name?: string | undefined;
    payor?: string | undefined;
    ein?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    statusChangeReason?: string | undefined;
    employerEmployerOfRecordRelation?: string | undefined;
    numberPersonalExemptions?: number;
    workLocation?: string | undefined;
    maritalStatus?: string | undefined;
    eligibleForHoliday?: boolean;
    payService?: boolean;
    onHold?: boolean;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ICaregiverHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.id = _data["id"];
            this.caregiverId = _data["caregiverId"];
            this.name = _data["name"];
            this.payor = _data["payor"];
            this.ein = _data["ein"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.statusChangeReason = _data["statusChangeReason"];
            this.employerEmployerOfRecordRelation = _data["employerEmployerOfRecordRelation"];
            this.numberPersonalExemptions = _data["numberPersonalExemptions"];
            this.workLocation = _data["workLocation"];
            this.maritalStatus = _data["maritalStatus"];
            this.eligibleForHoliday = _data["eligibleForHoliday"];
            this.payService = _data["payService"];
            this.onHold = _data["onHold"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): CaregiverHistory {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["id"] = this.id;
        data["caregiverId"] = this.caregiverId;
        data["name"] = this.name;
        data["payor"] = this.payor;
        data["ein"] = this.ein;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["statusChangeReason"] = this.statusChangeReason;
        data["employerEmployerOfRecordRelation"] = this.employerEmployerOfRecordRelation;
        data["numberPersonalExemptions"] = this.numberPersonalExemptions;
        data["workLocation"] = this.workLocation;
        data["maritalStatus"] = this.maritalStatus;
        data["eligibleForHoliday"] = this.eligibleForHoliday;
        data["payService"] = this.payService;
        data["onHold"] = this.onHold;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ICaregiverHistory {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number;
    caregiverId?: number;
    name?: string | undefined;
    payor?: string | undefined;
    ein?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    statusChangeReason?: string | undefined;
    employerEmployerOfRecordRelation?: string | undefined;
    numberPersonalExemptions?: number;
    workLocation?: string | undefined;
    maritalStatus?: string | undefined;
    eligibleForHoliday?: boolean;
    payService?: boolean;
    onHold?: boolean;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class CaregiverLkpDTO implements ICaregiverLkpDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    caregiverId?: string | undefined;
    caregiverName?: string | undefined;

    constructor(data?: ICaregiverLkpDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.caregiverId = _data["caregiverId"];
            this.caregiverName = _data["caregiverName"];
        }
    }

    static fromJS(data: any): CaregiverLkpDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverLkpDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["caregiverId"] = this.caregiverId;
        data["caregiverName"] = this.caregiverName;
        return data;
    }
}

export interface ICaregiverLkpDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    caregiverId?: string | undefined;
    caregiverName?: string | undefined;
}

export class CaregiverLkpDTOGridResponseBase implements ICaregiverLkpDTOGridResponseBase {
    items?: CaregiverLkpDTO[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CaregiverLkpDTO;

    constructor(data?: ICaregiverLkpDTOGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CaregiverLkpDTO.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? CaregiverLkpDTO.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CaregiverLkpDTOGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverLkpDTOGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICaregiverLkpDTOGridResponseBase {
    items?: CaregiverLkpDTO[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CaregiverLkpDTO;
}

export class CaregiverParticipantLiveInDatesRequest implements ICaregiverParticipantLiveInDatesRequest {
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: ICaregiverParticipantLiveInDatesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CaregiverParticipantLiveInDatesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverParticipantLiveInDatesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICaregiverParticipantLiveInDatesRequest {
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class CaregiverParticipantLiveInDatesResponse implements ICaregiverParticipantLiveInDatesResponse {
    startDate?: Date;
    endDate?: Date | undefined;

    constructor(data?: ICaregiverParticipantLiveInDatesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CaregiverParticipantLiveInDatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverParticipantLiveInDatesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICaregiverParticipantLiveInDatesResponse {
    startDate?: Date;
    endDate?: Date | undefined;
}

export class CaregiverParticipantProspectResponse implements ICaregiverParticipantProspectResponse {
    caregiverParticipantProspectId?: number;
    personId?: number;
    participantId?: number | undefined;
    providerOneId?: string | undefined;
    clientAge?: string | undefined;
    relationshipToClientId?: number | undefined;
    isAuthRepresentative?: boolean | undefined;
    clientFirstName?: string | undefined;
    clientLastName?: string | undefined;
    ficaAttestationId?: number | undefined;
    ficaConfirmationStatus?: AttestationStatus;
    isFica?: boolean | undefined;
    ficaStartDate?: Date | undefined;
    ficaEndDate?: Date | undefined;
    is20147?: boolean | undefined;
    startDate20147?: Date | undefined;
    endDate20147?: Date | undefined;
    isLiveIn?: boolean | undefined;
    liveInStartDate?: Date | undefined;
    liveInEndDate?: Date | undefined;
    isFicaChild?: boolean | undefined;
    ficaChildStartDate?: Date | undefined;
    ficaChildEndDate?: Date | undefined;
    relationshipStatus?: string | undefined;
    relationshipStartDate?: Date | undefined;
    relationshipEndDate?: Date | undefined;
    difficultyOfCareAttestationId?: number | undefined;
    difficultyOfCareConfirmationStatus?: AttestationStatus;
    liveInExemptionConfirmationStatus?: AttestationStatus;
    liveInExemptionAttestationId?: number | undefined;
    requestRelationshipConfirmationStatus?: AttestationStatus;
    isProcessed?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: ICaregiverParticipantProspectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverParticipantProspectId = _data["caregiverParticipantProspectId"];
            this.personId = _data["personId"];
            this.participantId = _data["participantId"];
            this.providerOneId = _data["providerOneId"];
            this.clientAge = _data["clientAge"];
            this.relationshipToClientId = _data["relationshipToClientId"];
            this.isAuthRepresentative = _data["isAuthRepresentative"];
            this.clientFirstName = _data["clientFirstName"];
            this.clientLastName = _data["clientLastName"];
            this.ficaAttestationId = _data["ficaAttestationId"];
            this.ficaConfirmationStatus = _data["ficaConfirmationStatus"];
            this.isFica = _data["isFica"];
            this.ficaStartDate = _data["ficaStartDate"] ? new Date(_data["ficaStartDate"].toString()) : <any>undefined;
            this.ficaEndDate = _data["ficaEndDate"] ? new Date(_data["ficaEndDate"].toString()) : <any>undefined;
            this.is20147 = _data["is20147"];
            this.startDate20147 = _data["startDate20147"] ? new Date(_data["startDate20147"].toString()) : <any>undefined;
            this.endDate20147 = _data["endDate20147"] ? new Date(_data["endDate20147"].toString()) : <any>undefined;
            this.isLiveIn = _data["isLiveIn"];
            this.liveInStartDate = _data["liveInStartDate"] ? new Date(_data["liveInStartDate"].toString()) : <any>undefined;
            this.liveInEndDate = _data["liveInEndDate"] ? new Date(_data["liveInEndDate"].toString()) : <any>undefined;
            this.isFicaChild = _data["isFicaChild"];
            this.ficaChildStartDate = _data["ficaChildStartDate"] ? new Date(_data["ficaChildStartDate"].toString()) : <any>undefined;
            this.ficaChildEndDate = _data["ficaChildEndDate"] ? new Date(_data["ficaChildEndDate"].toString()) : <any>undefined;
            this.relationshipStatus = _data["relationshipStatus"];
            this.relationshipStartDate = _data["relationshipStartDate"] ? new Date(_data["relationshipStartDate"].toString()) : <any>undefined;
            this.relationshipEndDate = _data["relationshipEndDate"] ? new Date(_data["relationshipEndDate"].toString()) : <any>undefined;
            this.difficultyOfCareAttestationId = _data["difficultyOfCareAttestationId"];
            this.difficultyOfCareConfirmationStatus = _data["difficultyOfCareConfirmationStatus"];
            this.liveInExemptionConfirmationStatus = _data["liveInExemptionConfirmationStatus"];
            this.liveInExemptionAttestationId = _data["liveInExemptionAttestationId"];
            this.requestRelationshipConfirmationStatus = _data["requestRelationshipConfirmationStatus"];
            this.isProcessed = _data["isProcessed"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CaregiverParticipantProspectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverParticipantProspectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverParticipantProspectId"] = this.caregiverParticipantProspectId;
        data["personId"] = this.personId;
        data["participantId"] = this.participantId;
        data["providerOneId"] = this.providerOneId;
        data["clientAge"] = this.clientAge;
        data["relationshipToClientId"] = this.relationshipToClientId;
        data["isAuthRepresentative"] = this.isAuthRepresentative;
        data["clientFirstName"] = this.clientFirstName;
        data["clientLastName"] = this.clientLastName;
        data["ficaAttestationId"] = this.ficaAttestationId;
        data["ficaConfirmationStatus"] = this.ficaConfirmationStatus;
        data["isFica"] = this.isFica;
        data["ficaStartDate"] = this.ficaStartDate ? this.ficaStartDate.toISOString() : <any>undefined;
        data["ficaEndDate"] = this.ficaEndDate ? this.ficaEndDate.toISOString() : <any>undefined;
        data["is20147"] = this.is20147;
        data["startDate20147"] = this.startDate20147 ? this.startDate20147.toISOString() : <any>undefined;
        data["endDate20147"] = this.endDate20147 ? this.endDate20147.toISOString() : <any>undefined;
        data["isLiveIn"] = this.isLiveIn;
        data["liveInStartDate"] = this.liveInStartDate ? this.liveInStartDate.toISOString() : <any>undefined;
        data["liveInEndDate"] = this.liveInEndDate ? this.liveInEndDate.toISOString() : <any>undefined;
        data["isFicaChild"] = this.isFicaChild;
        data["ficaChildStartDate"] = this.ficaChildStartDate ? this.ficaChildStartDate.toISOString() : <any>undefined;
        data["ficaChildEndDate"] = this.ficaChildEndDate ? this.ficaChildEndDate.toISOString() : <any>undefined;
        data["relationshipStatus"] = this.relationshipStatus;
        data["relationshipStartDate"] = this.relationshipStartDate ? this.relationshipStartDate.toISOString() : <any>undefined;
        data["relationshipEndDate"] = this.relationshipEndDate ? this.relationshipEndDate.toISOString() : <any>undefined;
        data["difficultyOfCareAttestationId"] = this.difficultyOfCareAttestationId;
        data["difficultyOfCareConfirmationStatus"] = this.difficultyOfCareConfirmationStatus;
        data["liveInExemptionConfirmationStatus"] = this.liveInExemptionConfirmationStatus;
        data["liveInExemptionAttestationId"] = this.liveInExemptionAttestationId;
        data["requestRelationshipConfirmationStatus"] = this.requestRelationshipConfirmationStatus;
        data["isProcessed"] = this.isProcessed;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICaregiverParticipantProspectResponse {
    caregiverParticipantProspectId?: number;
    personId?: number;
    participantId?: number | undefined;
    providerOneId?: string | undefined;
    clientAge?: string | undefined;
    relationshipToClientId?: number | undefined;
    isAuthRepresentative?: boolean | undefined;
    clientFirstName?: string | undefined;
    clientLastName?: string | undefined;
    ficaAttestationId?: number | undefined;
    ficaConfirmationStatus?: AttestationStatus;
    isFica?: boolean | undefined;
    ficaStartDate?: Date | undefined;
    ficaEndDate?: Date | undefined;
    is20147?: boolean | undefined;
    startDate20147?: Date | undefined;
    endDate20147?: Date | undefined;
    isLiveIn?: boolean | undefined;
    liveInStartDate?: Date | undefined;
    liveInEndDate?: Date | undefined;
    isFicaChild?: boolean | undefined;
    ficaChildStartDate?: Date | undefined;
    ficaChildEndDate?: Date | undefined;
    relationshipStatus?: string | undefined;
    relationshipStartDate?: Date | undefined;
    relationshipEndDate?: Date | undefined;
    difficultyOfCareAttestationId?: number | undefined;
    difficultyOfCareConfirmationStatus?: AttestationStatus;
    liveInExemptionConfirmationStatus?: AttestationStatus;
    liveInExemptionAttestationId?: number | undefined;
    requestRelationshipConfirmationStatus?: AttestationStatus;
    isProcessed?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class CaregiverParticipantRelAttestaionStatusDetailsRequest implements ICaregiverParticipantRelAttestaionStatusDetailsRequest {
    caregiverPersonId?: string | undefined;
    participantPersonId?: string | undefined;
    relationshipToClientId?: number | undefined;
    isAuthRepresentative?: boolean | undefined;
    userEmail?: string | undefined;
    attestationStatus?: AttestationStatus;

    constructor(data?: ICaregiverParticipantRelAttestaionStatusDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverPersonId = _data["caregiverPersonId"];
            this.participantPersonId = _data["participantPersonId"];
            this.relationshipToClientId = _data["relationshipToClientId"];
            this.isAuthRepresentative = _data["isAuthRepresentative"];
            this.userEmail = _data["userEmail"];
            this.attestationStatus = _data["attestationStatus"];
        }
    }

    static fromJS(data: any): CaregiverParticipantRelAttestaionStatusDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverParticipantRelAttestaionStatusDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverPersonId"] = this.caregiverPersonId;
        data["participantPersonId"] = this.participantPersonId;
        data["relationshipToClientId"] = this.relationshipToClientId;
        data["isAuthRepresentative"] = this.isAuthRepresentative;
        data["userEmail"] = this.userEmail;
        data["attestationStatus"] = this.attestationStatus;
        return data;
    }
}

export interface ICaregiverParticipantRelAttestaionStatusDetailsRequest {
    caregiverPersonId?: string | undefined;
    participantPersonId?: string | undefined;
    relationshipToClientId?: number | undefined;
    isAuthRepresentative?: boolean | undefined;
    userEmail?: string | undefined;
    attestationStatus?: AttestationStatus;
}

export class CaregiverParticipantRelAttestationRequest implements ICaregiverParticipantRelAttestationRequest {
    caregiverPersonId?: string | undefined;
    participantPersonIds?: string[] | undefined;

    constructor(data?: ICaregiverParticipantRelAttestationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverPersonId = _data["caregiverPersonId"];
            if (Array.isArray(_data["participantPersonIds"])) {
                this.participantPersonIds = [] as any;
                for (let item of _data["participantPersonIds"])
                    this.participantPersonIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CaregiverParticipantRelAttestationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverParticipantRelAttestationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverPersonId"] = this.caregiverPersonId;
        if (Array.isArray(this.participantPersonIds)) {
            data["participantPersonIds"] = [];
            for (let item of this.participantPersonIds)
                data["participantPersonIds"].push(item);
        }
        return data;
    }
}

export interface ICaregiverParticipantRelAttestationRequest {
    caregiverPersonId?: string | undefined;
    participantPersonIds?: string[] | undefined;
}

export class CaregiverParticipantRelAttestationResponse implements ICaregiverParticipantRelAttestationResponse {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    participantId?: string | undefined;
    relationshipConfirmation?: AttestationStatus;
    readonly relationshipConfirmationText?: string | undefined;
    relationshipConfirmationModel?: Int32ComboboxModel;
    ficaConfirmation?: AttestationStatus;
    readonly ficaConfirmationText?: string | undefined;
    docConfirmation?: AttestationStatus;
    readonly docConfirmationText?: string | undefined;
    leConfirmation?: AttestationStatus;
    readonly leConfirmationText?: string | undefined;
    participantName?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantAge?: number | undefined;
    providerOneId?: string | undefined;
    qualificationRoleType?: string | undefined;
    relationshipToClient?: string | undefined;
    isAuthorizedRepresentative?: boolean | undefined;
    readonly isAuthorizedRepresentativeText?: string | undefined;
    caregiverParticipantMappingId?: number | undefined;
    caregiverId?: number | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    caregiverName?: string | undefined;
    testAuthEndDate?: Date | undefined;
    createdOn?: Date | undefined;
    qualificationRoleTypeId?: number | undefined;
    qualificationRoleTypeName?: string | undefined;

    constructor(data?: ICaregiverParticipantRelAttestationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.participantId = _data["participantId"];
            this.relationshipConfirmation = _data["relationshipConfirmation"];
            (<any>this).relationshipConfirmationText = _data["relationshipConfirmationText"];
            this.relationshipConfirmationModel = _data["relationshipConfirmationModel"] ? Int32ComboboxModel.fromJS(_data["relationshipConfirmationModel"]) : <any>undefined;
            this.ficaConfirmation = _data["ficaConfirmation"];
            (<any>this).ficaConfirmationText = _data["ficaConfirmationText"];
            this.docConfirmation = _data["docConfirmation"];
            (<any>this).docConfirmationText = _data["docConfirmationText"];
            this.leConfirmation = _data["leConfirmation"];
            (<any>this).leConfirmationText = _data["leConfirmationText"];
            this.participantName = _data["participantName"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.participantAge = _data["participantAge"];
            this.providerOneId = _data["providerOneId"];
            this.qualificationRoleType = _data["qualificationRoleType"];
            this.relationshipToClient = _data["relationshipToClient"];
            this.isAuthorizedRepresentative = _data["isAuthorizedRepresentative"];
            (<any>this).isAuthorizedRepresentativeText = _data["isAuthorizedRepresentativeText"];
            this.caregiverParticipantMappingId = _data["caregiverParticipantMappingId"];
            this.caregiverId = _data["caregiverId"];
            this.caregiverFirstName = _data["caregiverFirstName"];
            this.caregiverLastName = _data["caregiverLastName"];
            this.caregiverName = _data["caregiverName"];
            this.testAuthEndDate = _data["testAuthEndDate"] ? new Date(_data["testAuthEndDate"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.qualificationRoleTypeId = _data["qualificationRoleTypeId"];
            this.qualificationRoleTypeName = _data["qualificationRoleTypeName"];
        }
    }

    static fromJS(data: any): CaregiverParticipantRelAttestationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverParticipantRelAttestationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["participantId"] = this.participantId;
        data["relationshipConfirmation"] = this.relationshipConfirmation;
        data["relationshipConfirmationText"] = this.relationshipConfirmationText;
        data["relationshipConfirmationModel"] = this.relationshipConfirmationModel ? this.relationshipConfirmationModel.toJSON() : <any>undefined;
        data["ficaConfirmation"] = this.ficaConfirmation;
        data["ficaConfirmationText"] = this.ficaConfirmationText;
        data["docConfirmation"] = this.docConfirmation;
        data["docConfirmationText"] = this.docConfirmationText;
        data["leConfirmation"] = this.leConfirmation;
        data["leConfirmationText"] = this.leConfirmationText;
        data["participantName"] = this.participantName;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["participantAge"] = this.participantAge;
        data["providerOneId"] = this.providerOneId;
        data["qualificationRoleType"] = this.qualificationRoleType;
        data["relationshipToClient"] = this.relationshipToClient;
        data["isAuthorizedRepresentative"] = this.isAuthorizedRepresentative;
        data["isAuthorizedRepresentativeText"] = this.isAuthorizedRepresentativeText;
        data["caregiverParticipantMappingId"] = this.caregiverParticipantMappingId;
        data["caregiverId"] = this.caregiverId;
        data["caregiverFirstName"] = this.caregiverFirstName;
        data["caregiverLastName"] = this.caregiverLastName;
        data["caregiverName"] = this.caregiverName;
        data["testAuthEndDate"] = this.testAuthEndDate ? this.testAuthEndDate.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["qualificationRoleTypeId"] = this.qualificationRoleTypeId;
        data["qualificationRoleTypeName"] = this.qualificationRoleTypeName;
        return data;
    }
}

export interface ICaregiverParticipantRelAttestationResponse {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    participantId?: string | undefined;
    relationshipConfirmation?: AttestationStatus;
    relationshipConfirmationText?: string | undefined;
    relationshipConfirmationModel?: Int32ComboboxModel;
    ficaConfirmation?: AttestationStatus;
    ficaConfirmationText?: string | undefined;
    docConfirmation?: AttestationStatus;
    docConfirmationText?: string | undefined;
    leConfirmation?: AttestationStatus;
    leConfirmationText?: string | undefined;
    participantName?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantAge?: number | undefined;
    providerOneId?: string | undefined;
    qualificationRoleType?: string | undefined;
    relationshipToClient?: string | undefined;
    isAuthorizedRepresentative?: boolean | undefined;
    isAuthorizedRepresentativeText?: string | undefined;
    caregiverParticipantMappingId?: number | undefined;
    caregiverId?: number | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    caregiverName?: string | undefined;
    testAuthEndDate?: Date | undefined;
    createdOn?: Date | undefined;
    qualificationRoleTypeId?: number | undefined;
    qualificationRoleTypeName?: string | undefined;
}

export class CaregiverParticipantRelAttestationstatusDetailsRequest implements ICaregiverParticipantRelAttestationstatusDetailsRequest {
    caregiverPersonId?: string | undefined;
    participantPersonId?: string | undefined;
    attestationType?: string | undefined;

    constructor(data?: ICaregiverParticipantRelAttestationstatusDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverPersonId = _data["caregiverPersonId"];
            this.participantPersonId = _data["participantPersonId"];
            this.attestationType = _data["attestationType"];
        }
    }

    static fromJS(data: any): CaregiverParticipantRelAttestationstatusDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverParticipantRelAttestationstatusDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverPersonId"] = this.caregiverPersonId;
        data["participantPersonId"] = this.participantPersonId;
        data["attestationType"] = this.attestationType;
        return data;
    }
}

export interface ICaregiverParticipantRelAttestationstatusDetailsRequest {
    caregiverPersonId?: string | undefined;
    participantPersonId?: string | undefined;
    attestationType?: string | undefined;
}

export class CaregiverParticipantRelQuestionnaireDetailsDto implements ICaregiverParticipantRelQuestionnaireDetailsDto {
    attestationResponseDetailId?: number;
    componentDetailId?: number;
    optionDetailId?: number;
    componentId?: number;
    optionId?: number;

    constructor(data?: ICaregiverParticipantRelQuestionnaireDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attestationResponseDetailId = _data["attestationResponseDetailId"];
            this.componentDetailId = _data["componentDetailId"];
            this.optionDetailId = _data["optionDetailId"];
            this.componentId = _data["componentId"];
            this.optionId = _data["optionId"];
        }
    }

    static fromJS(data: any): CaregiverParticipantRelQuestionnaireDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverParticipantRelQuestionnaireDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attestationResponseDetailId"] = this.attestationResponseDetailId;
        data["componentDetailId"] = this.componentDetailId;
        data["optionDetailId"] = this.optionDetailId;
        data["componentId"] = this.componentId;
        data["optionId"] = this.optionId;
        return data;
    }
}

export interface ICaregiverParticipantRelQuestionnaireDetailsDto {
    attestationResponseDetailId?: number;
    componentDetailId?: number;
    optionDetailId?: number;
    componentId?: number;
    optionId?: number;
}

export class CaregiverParticipantRelQuestionnaireDto implements ICaregiverParticipantRelQuestionnaireDto {
    attestationResponseId?: number | undefined;
    attestationVersion?: number;
    participantPersonId?: string | undefined;
    caregiverPersonId?: string | undefined;
    confirmationDate?: Date;
    languageCode?: string | undefined;
    userEmail?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    companyId?: number;
    attestationResponseDetails?: CaregiverParticipantRelQuestionnaireDetailsDto[] | undefined;
    attestationResponses?: AttestationResponse[] | undefined;

    constructor(data?: ICaregiverParticipantRelQuestionnaireDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attestationResponseId = _data["attestationResponseId"];
            this.attestationVersion = _data["attestationVersion"];
            this.participantPersonId = _data["participantPersonId"];
            this.caregiverPersonId = _data["caregiverPersonId"];
            this.confirmationDate = _data["confirmationDate"] ? new Date(_data["confirmationDate"].toString()) : <any>undefined;
            this.languageCode = _data["languageCode"];
            this.userEmail = _data["userEmail"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["attestationResponseDetails"])) {
                this.attestationResponseDetails = [] as any;
                for (let item of _data["attestationResponseDetails"])
                    this.attestationResponseDetails!.push(CaregiverParticipantRelQuestionnaireDetailsDto.fromJS(item));
            }
            if (Array.isArray(_data["attestationResponses"])) {
                this.attestationResponses = [] as any;
                for (let item of _data["attestationResponses"])
                    this.attestationResponses!.push(AttestationResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaregiverParticipantRelQuestionnaireDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverParticipantRelQuestionnaireDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attestationResponseId"] = this.attestationResponseId;
        data["attestationVersion"] = this.attestationVersion;
        data["participantPersonId"] = this.participantPersonId;
        data["caregiverPersonId"] = this.caregiverPersonId;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : <any>undefined;
        data["languageCode"] = this.languageCode;
        data["userEmail"] = this.userEmail;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["companyId"] = this.companyId;
        if (Array.isArray(this.attestationResponseDetails)) {
            data["attestationResponseDetails"] = [];
            for (let item of this.attestationResponseDetails)
                data["attestationResponseDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.attestationResponses)) {
            data["attestationResponses"] = [];
            for (let item of this.attestationResponses)
                data["attestationResponses"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICaregiverParticipantRelQuestionnaireDto {
    attestationResponseId?: number | undefined;
    attestationVersion?: number;
    participantPersonId?: string | undefined;
    caregiverPersonId?: string | undefined;
    confirmationDate?: Date;
    languageCode?: string | undefined;
    userEmail?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    companyId?: number;
    attestationResponseDetails?: CaregiverParticipantRelQuestionnaireDetailsDto[] | undefined;
    attestationResponses?: AttestationResponse[] | undefined;
}

export class CaregiverParticipantRelStatusDateRange implements ICaregiverParticipantRelStatusDateRange {
    startDate?: Date;
    endDate?: Date;
    status?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: ICaregiverParticipantRelStatusDateRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CaregiverParticipantRelStatusDateRange {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverParticipantRelStatusDateRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICaregiverParticipantRelStatusDateRange {
    startDate?: Date;
    endDate?: Date;
    status?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class CaregiverParticipantRelationConfirmationRequestDto implements ICaregiverParticipantRelationConfirmationRequestDto {
    isInterestedAndEligible?: boolean;
    wdEmployeeID?: string | undefined;
    clientReqCounter?: number;

    constructor(data?: ICaregiverParticipantRelationConfirmationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isInterestedAndEligible = _data["isInterestedAndEligible"];
            this.wdEmployeeID = _data["wdEmployeeID"];
            this.clientReqCounter = _data["clientReqCounter"];
        }
    }

    static fromJS(data: any): CaregiverParticipantRelationConfirmationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverParticipantRelationConfirmationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isInterestedAndEligible"] = this.isInterestedAndEligible;
        data["wdEmployeeID"] = this.wdEmployeeID;
        data["clientReqCounter"] = this.clientReqCounter;
        return data;
    }
}

export interface ICaregiverParticipantRelationConfirmationRequestDto {
    isInterestedAndEligible?: boolean;
    wdEmployeeID?: string | undefined;
    clientReqCounter?: number;
}

export enum CaregiverParticipantRelationship {
    LR = "LR",
    NR = "NR",
    OTH = "OTH",
    PE = "PE",
    PG = "PG",
    SE = "SE",
    SIB = "SIB",
    UG = "UG",
    CU1 = "CU1",
    CU2 = "CU2",
    PSF = "PSF",
    NE = "NE",
    AC = "AC",
    RDP = "RDP",
    OBR = "OBR",
    LRP = "LRP",
    LRS = "LRS",
    PAR = "PAR",
    SPO = "SPO",
    ANT = "ANT",
    UNC = "UNC",
    COU = "COU",
    NIC = "NIC",
    NEP = "NEP",
    GRC = "GRC",
    GRP = "GRP",
}

export class CaregiverParticipantRelationshipModel implements ICaregiverParticipantRelationshipModel {
    caregiverParticipantRelationshipId?: number | undefined;
    caregiverParticipantMappingId?: number | undefined;
    relationship?: CaregiverParticipantRelationship;
    startDate?: Date;
    endDate?: Date | undefined;
    companyId?: number | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    isDeleted?: boolean;
    isFamilial?: boolean;

    constructor(data?: ICaregiverParticipantRelationshipModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverParticipantRelationshipId = _data["caregiverParticipantRelationshipId"];
            this.caregiverParticipantMappingId = _data["caregiverParticipantMappingId"];
            this.relationship = _data["relationship"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.companyId = _data["companyId"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.isFamilial = _data["isFamilial"];
        }
    }

    static fromJS(data: any): CaregiverParticipantRelationshipModel {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverParticipantRelationshipModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverParticipantRelationshipId"] = this.caregiverParticipantRelationshipId;
        data["caregiverParticipantMappingId"] = this.caregiverParticipantMappingId;
        data["relationship"] = this.relationship;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["companyId"] = this.companyId;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["isFamilial"] = this.isFamilial;
        return data;
    }
}

export interface ICaregiverParticipantRelationshipModel {
    caregiverParticipantRelationshipId?: number | undefined;
    caregiverParticipantMappingId?: number | undefined;
    relationship?: CaregiverParticipantRelationship;
    startDate?: Date;
    endDate?: Date | undefined;
    companyId?: number | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    isDeleted?: boolean;
    isFamilial?: boolean;
}

export class CaregiverParticipantRelationshipModelResponseModelWithData implements ICaregiverParticipantRelationshipModelResponseModelWithData {
    isSuccess?: boolean;
    message?: string | undefined;
    items?: CaregiverParticipantRelationshipModel[] | undefined;
    data?: CaregiverParticipantRelationshipModel;

    constructor(data?: ICaregiverParticipantRelationshipModelResponseModelWithData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CaregiverParticipantRelationshipModel.fromJS(item));
            }
            this.data = _data["data"] ? CaregiverParticipantRelationshipModel.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CaregiverParticipantRelationshipModelResponseModelWithData {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverParticipantRelationshipModelResponseModelWithData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICaregiverParticipantRelationshipModelResponseModelWithData {
    isSuccess?: boolean;
    message?: string | undefined;
    items?: CaregiverParticipantRelationshipModel[] | undefined;
    data?: CaregiverParticipantRelationshipModel;
}

export class CaregiverParticipantRelationshipStartDateResponse implements ICaregiverParticipantRelationshipStartDateResponse {
    caregiverPersonId?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    caregiverName?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantName?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;

    constructor(data?: ICaregiverParticipantRelationshipStartDateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverPersonId = _data["caregiverPersonId"];
            this.caregiverFirstName = _data["caregiverFirstName"];
            this.caregiverLastName = _data["caregiverLastName"];
            this.caregiverName = _data["caregiverName"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.participantName = _data["participantName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CaregiverParticipantRelationshipStartDateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverParticipantRelationshipStartDateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverPersonId"] = this.caregiverPersonId;
        data["caregiverFirstName"] = this.caregiverFirstName;
        data["caregiverLastName"] = this.caregiverLastName;
        data["caregiverName"] = this.caregiverName;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["participantName"] = this.participantName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICaregiverParticipantRelationshipStartDateResponse {
    caregiverPersonId?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    caregiverName?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantName?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
}

export class CaregiverParticipantRelationshipsResponse implements ICaregiverParticipantRelationshipsResponse {
    relationships?: CaregiverParticipantRelationshipModel[] | undefined;

    constructor(data?: ICaregiverParticipantRelationshipsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["relationships"])) {
                this.relationships = [] as any;
                for (let item of _data["relationships"])
                    this.relationships!.push(CaregiverParticipantRelationshipModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaregiverParticipantRelationshipsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverParticipantRelationshipsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.relationships)) {
            data["relationships"] = [];
            for (let item of this.relationships)
                data["relationships"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICaregiverParticipantRelationshipsResponse {
    relationships?: CaregiverParticipantRelationshipModel[] | undefined;
}

export class CaregiverParticipantReqRelConfirmationStatusDetailsDto implements ICaregiverParticipantReqRelConfirmationStatusDetailsDto {
    caregiverProspectRelationRequest?: CaregiverParticipantRelationConfirmationRequestDto;
    caregiverParticipantRelAttestationDetails?: CaregiverParticipantRelAttestationResponse[] | undefined;

    constructor(data?: ICaregiverParticipantReqRelConfirmationStatusDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverProspectRelationRequest = _data["caregiverProspectRelationRequest"] ? CaregiverParticipantRelationConfirmationRequestDto.fromJS(_data["caregiverProspectRelationRequest"]) : <any>undefined;
            if (Array.isArray(_data["caregiverParticipantRelAttestationDetails"])) {
                this.caregiverParticipantRelAttestationDetails = [] as any;
                for (let item of _data["caregiverParticipantRelAttestationDetails"])
                    this.caregiverParticipantRelAttestationDetails!.push(CaregiverParticipantRelAttestationResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaregiverParticipantReqRelConfirmationStatusDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverParticipantReqRelConfirmationStatusDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverProspectRelationRequest"] = this.caregiverProspectRelationRequest ? this.caregiverProspectRelationRequest.toJSON() : <any>undefined;
        if (Array.isArray(this.caregiverParticipantRelAttestationDetails)) {
            data["caregiverParticipantRelAttestationDetails"] = [];
            for (let item of this.caregiverParticipantRelAttestationDetails)
                data["caregiverParticipantRelAttestationDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICaregiverParticipantReqRelConfirmationStatusDetailsDto {
    caregiverProspectRelationRequest?: CaregiverParticipantRelationConfirmationRequestDto;
    caregiverParticipantRelAttestationDetails?: CaregiverParticipantRelAttestationResponse[] | undefined;
}

export class CaregiverParticipantRequestRelationConfirmationDto implements ICaregiverParticipantRequestRelationConfirmationDto {
    caregiverParticipantProspectId?: number;
    caregiverProspectId?: number | undefined;
    personFirstName?: string | undefined;
    personLastName?: string | undefined;
    caregiverProspectName?: string | undefined;
    personType?: string | undefined;
    providerOneId?: string | undefined;
    participantAge?: string | undefined;
    relationshipToClientId?: number | undefined;
    isAuthRepresentative?: boolean | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantPersonId?: number | undefined;
    ficaConfirmationStatus?: AttestationStatus;
    readonly ficaConfirmationText?: string | undefined;
    ficaAttestationId?: number | undefined;
    isFICA?: boolean;
    ficaStartDate?: Date | undefined;
    ficaEndDate?: Date | undefined;
    is20147?: boolean;
    twenty147StartDate?: Date | undefined;
    twenty147EndDate?: Date | undefined;
    isLiveIn?: boolean;
    liveInStartDate?: Date | undefined;
    liveInEndDate?: Date | undefined;
    isFicaChild?: boolean;
    ficaChildStartDate?: Date | undefined;
    ficaChildEndDate?: Date | undefined;
    relationshipStatus?: string | undefined;
    relationshipStatusModel?: StringComboboxModel;
    relationshipStartDate?: Date | undefined;
    relationshipEndDate?: Date | undefined;
    difficultyOfCareConfirmationStatus?: AttestationStatus;
    readonly difficultyOfCareConfirmationText?: string | undefined;
    difficultyOfCareAttestationId?: number | undefined;
    relationshipConfirmation?: AttestationStatus;
    readonly relationshipConfirmationText?: string | undefined;
    relationshipConfirmationModel?: Int32ComboboxModel;
    caregiverId?: number | undefined;
    participantId?: number | undefined;
    userEmail?: string | undefined;
    isProcessed?: boolean;
    attestationResponseId?: number;
    relationshipAttestationStatusEnum?: AttestationStatus;
    readonly relationshipAttestationStatus?: string | undefined;
    dateRequested?: Date;
    fromV4?: boolean;
    readonly activeRelationshipStatus?: boolean;

    constructor(data?: ICaregiverParticipantRequestRelationConfirmationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverParticipantProspectId = _data["caregiverParticipantProspectId"];
            this.caregiverProspectId = _data["caregiverProspectId"];
            this.personFirstName = _data["personFirstName"];
            this.personLastName = _data["personLastName"];
            this.caregiverProspectName = _data["caregiverProspectName"];
            this.personType = _data["personType"];
            this.providerOneId = _data["providerOneId"];
            this.participantAge = _data["participantAge"];
            this.relationshipToClientId = _data["relationshipToClientId"];
            this.isAuthRepresentative = _data["isAuthRepresentative"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.participantPersonId = _data["participantPersonId"];
            this.ficaConfirmationStatus = _data["ficaConfirmationStatus"];
            (<any>this).ficaConfirmationText = _data["ficaConfirmationText"];
            this.ficaAttestationId = _data["ficaAttestationId"];
            this.isFICA = _data["isFICA"];
            this.ficaStartDate = _data["ficaStartDate"] ? new Date(_data["ficaStartDate"].toString()) : <any>undefined;
            this.ficaEndDate = _data["ficaEndDate"] ? new Date(_data["ficaEndDate"].toString()) : <any>undefined;
            this.is20147 = _data["is20147"];
            this.twenty147StartDate = _data["twenty147StartDate"] ? new Date(_data["twenty147StartDate"].toString()) : <any>undefined;
            this.twenty147EndDate = _data["twenty147EndDate"] ? new Date(_data["twenty147EndDate"].toString()) : <any>undefined;
            this.isLiveIn = _data["isLiveIn"];
            this.liveInStartDate = _data["liveInStartDate"] ? new Date(_data["liveInStartDate"].toString()) : <any>undefined;
            this.liveInEndDate = _data["liveInEndDate"] ? new Date(_data["liveInEndDate"].toString()) : <any>undefined;
            this.isFicaChild = _data["isFicaChild"];
            this.ficaChildStartDate = _data["ficaChildStartDate"] ? new Date(_data["ficaChildStartDate"].toString()) : <any>undefined;
            this.ficaChildEndDate = _data["ficaChildEndDate"] ? new Date(_data["ficaChildEndDate"].toString()) : <any>undefined;
            this.relationshipStatus = _data["relationshipStatus"];
            this.relationshipStatusModel = _data["relationshipStatusModel"] ? StringComboboxModel.fromJS(_data["relationshipStatusModel"]) : <any>undefined;
            this.relationshipStartDate = _data["relationshipStartDate"] ? new Date(_data["relationshipStartDate"].toString()) : <any>undefined;
            this.relationshipEndDate = _data["relationshipEndDate"] ? new Date(_data["relationshipEndDate"].toString()) : <any>undefined;
            this.difficultyOfCareConfirmationStatus = _data["difficultyOfCareConfirmationStatus"];
            (<any>this).difficultyOfCareConfirmationText = _data["difficultyOfCareConfirmationText"];
            this.difficultyOfCareAttestationId = _data["difficultyOfCareAttestationId"];
            this.relationshipConfirmation = _data["relationshipConfirmation"];
            (<any>this).relationshipConfirmationText = _data["relationshipConfirmationText"];
            this.relationshipConfirmationModel = _data["relationshipConfirmationModel"] ? Int32ComboboxModel.fromJS(_data["relationshipConfirmationModel"]) : <any>undefined;
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            this.userEmail = _data["userEmail"];
            this.isProcessed = _data["isProcessed"];
            this.attestationResponseId = _data["attestationResponseId"];
            this.relationshipAttestationStatusEnum = _data["relationshipAttestationStatusEnum"];
            (<any>this).relationshipAttestationStatus = _data["relationshipAttestationStatus"];
            this.dateRequested = _data["dateRequested"] ? new Date(_data["dateRequested"].toString()) : <any>undefined;
            this.fromV4 = _data["fromV4"];
            (<any>this).activeRelationshipStatus = _data["activeRelationshipStatus"];
        }
    }

    static fromJS(data: any): CaregiverParticipantRequestRelationConfirmationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverParticipantRequestRelationConfirmationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverParticipantProspectId"] = this.caregiverParticipantProspectId;
        data["caregiverProspectId"] = this.caregiverProspectId;
        data["personFirstName"] = this.personFirstName;
        data["personLastName"] = this.personLastName;
        data["caregiverProspectName"] = this.caregiverProspectName;
        data["personType"] = this.personType;
        data["providerOneId"] = this.providerOneId;
        data["participantAge"] = this.participantAge;
        data["relationshipToClientId"] = this.relationshipToClientId;
        data["isAuthRepresentative"] = this.isAuthRepresentative;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["participantPersonId"] = this.participantPersonId;
        data["ficaConfirmationStatus"] = this.ficaConfirmationStatus;
        data["ficaConfirmationText"] = this.ficaConfirmationText;
        data["ficaAttestationId"] = this.ficaAttestationId;
        data["isFICA"] = this.isFICA;
        data["ficaStartDate"] = this.ficaStartDate ? this.ficaStartDate.toISOString() : <any>undefined;
        data["ficaEndDate"] = this.ficaEndDate ? this.ficaEndDate.toISOString() : <any>undefined;
        data["is20147"] = this.is20147;
        data["twenty147StartDate"] = this.twenty147StartDate ? this.twenty147StartDate.toISOString() : <any>undefined;
        data["twenty147EndDate"] = this.twenty147EndDate ? this.twenty147EndDate.toISOString() : <any>undefined;
        data["isLiveIn"] = this.isLiveIn;
        data["liveInStartDate"] = this.liveInStartDate ? this.liveInStartDate.toISOString() : <any>undefined;
        data["liveInEndDate"] = this.liveInEndDate ? this.liveInEndDate.toISOString() : <any>undefined;
        data["isFicaChild"] = this.isFicaChild;
        data["ficaChildStartDate"] = this.ficaChildStartDate ? this.ficaChildStartDate.toISOString() : <any>undefined;
        data["ficaChildEndDate"] = this.ficaChildEndDate ? this.ficaChildEndDate.toISOString() : <any>undefined;
        data["relationshipStatus"] = this.relationshipStatus;
        data["relationshipStatusModel"] = this.relationshipStatusModel ? this.relationshipStatusModel.toJSON() : <any>undefined;
        data["relationshipStartDate"] = this.relationshipStartDate ? this.relationshipStartDate.toISOString() : <any>undefined;
        data["relationshipEndDate"] = this.relationshipEndDate ? this.relationshipEndDate.toISOString() : <any>undefined;
        data["difficultyOfCareConfirmationStatus"] = this.difficultyOfCareConfirmationStatus;
        data["difficultyOfCareConfirmationText"] = this.difficultyOfCareConfirmationText;
        data["difficultyOfCareAttestationId"] = this.difficultyOfCareAttestationId;
        data["relationshipConfirmation"] = this.relationshipConfirmation;
        data["relationshipConfirmationText"] = this.relationshipConfirmationText;
        data["relationshipConfirmationModel"] = this.relationshipConfirmationModel ? this.relationshipConfirmationModel.toJSON() : <any>undefined;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        data["userEmail"] = this.userEmail;
        data["isProcessed"] = this.isProcessed;
        data["attestationResponseId"] = this.attestationResponseId;
        data["relationshipAttestationStatusEnum"] = this.relationshipAttestationStatusEnum;
        data["relationshipAttestationStatus"] = this.relationshipAttestationStatus;
        data["dateRequested"] = this.dateRequested ? this.dateRequested.toISOString() : <any>undefined;
        data["fromV4"] = this.fromV4;
        data["activeRelationshipStatus"] = this.activeRelationshipStatus;
        return data;
    }
}

export interface ICaregiverParticipantRequestRelationConfirmationDto {
    caregiverParticipantProspectId?: number;
    caregiverProspectId?: number | undefined;
    personFirstName?: string | undefined;
    personLastName?: string | undefined;
    caregiverProspectName?: string | undefined;
    personType?: string | undefined;
    providerOneId?: string | undefined;
    participantAge?: string | undefined;
    relationshipToClientId?: number | undefined;
    isAuthRepresentative?: boolean | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantPersonId?: number | undefined;
    ficaConfirmationStatus?: AttestationStatus;
    ficaConfirmationText?: string | undefined;
    ficaAttestationId?: number | undefined;
    isFICA?: boolean;
    ficaStartDate?: Date | undefined;
    ficaEndDate?: Date | undefined;
    is20147?: boolean;
    twenty147StartDate?: Date | undefined;
    twenty147EndDate?: Date | undefined;
    isLiveIn?: boolean;
    liveInStartDate?: Date | undefined;
    liveInEndDate?: Date | undefined;
    isFicaChild?: boolean;
    ficaChildStartDate?: Date | undefined;
    ficaChildEndDate?: Date | undefined;
    relationshipStatus?: string | undefined;
    relationshipStatusModel?: StringComboboxModel;
    relationshipStartDate?: Date | undefined;
    relationshipEndDate?: Date | undefined;
    difficultyOfCareConfirmationStatus?: AttestationStatus;
    difficultyOfCareConfirmationText?: string | undefined;
    difficultyOfCareAttestationId?: number | undefined;
    relationshipConfirmation?: AttestationStatus;
    relationshipConfirmationText?: string | undefined;
    relationshipConfirmationModel?: Int32ComboboxModel;
    caregiverId?: number | undefined;
    participantId?: number | undefined;
    userEmail?: string | undefined;
    isProcessed?: boolean;
    attestationResponseId?: number;
    relationshipAttestationStatusEnum?: AttestationStatus;
    relationshipAttestationStatus?: string | undefined;
    dateRequested?: Date;
    fromV4?: boolean;
    activeRelationshipStatus?: boolean;
}

export class CaregiverParticipantRequestRelationConfirmationDtoResultSet implements ICaregiverParticipantRequestRelationConfirmationDtoResultSet {
    totalRecords?: number;
    data?: CaregiverParticipantRequestRelationConfirmationDto[] | undefined;

    constructor(data?: ICaregiverParticipantRequestRelationConfirmationDtoResultSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CaregiverParticipantRequestRelationConfirmationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaregiverParticipantRequestRelationConfirmationDtoResultSet {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverParticipantRequestRelationConfirmationDtoResultSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICaregiverParticipantRequestRelationConfirmationDtoResultSet {
    totalRecords?: number;
    data?: CaregiverParticipantRequestRelationConfirmationDto[] | undefined;
}

export class CaregiverProfile implements ICaregiverProfile {
    phoneDetails?: PhoneDetail[] | undefined;
    physicalAddresses?: AddressDTO[] | undefined;
    mailingAddresses?: AddressDTO[] | undefined;
    ivrAddresses?: AddressDTO[] | undefined;
    externalKeys?: ExternalKeyDTO[] | undefined;
    id?: number;
    personId?: string | undefined;
    status?: string | undefined;
    readonly personName?: string | undefined;
    ssn?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    physicalAddress?: string | undefined;
    mailingAddress?: string | undefined;
    ivrAddress?: string | undefined;
    companyCode?: string | undefined;
    unmaskedSsn?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    ivrPin?: string | undefined;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    coordinatorPersonFirstName?: string | undefined;
    coordinatorPersonLastName?: string | undefined;
    coordinatorPersonName?: string | undefined;
    lastV4LoginOn?: Date | undefined;
    isSsnValidated?: boolean | undefined;
    ssnValidationOverrideOn?: Date | undefined;
    ssnValidationOverrideBy?: string | undefined;
    caregiverId?: number;
    solomonId?: string | undefined;
    backgroundCheck?: string | undefined;
    npi?: string | undefined;
    stateUniqueId?: string | undefined;
    paymentMethod?: string | undefined;
    lastPayDate?: Date | undefined;
    rateStatus?: string | undefined;
    rateIconStatus?: IconStatus;
    relationIconStatus?: IconStatus;
    payCycleStart?: Date | undefined;
    payCycleEnd?: Date | undefined;
    relationStatus?: string | undefined;
    red?: number | undefined;
    yellow?: number | undefined;
    green?: number | undefined;
    blue?: number | undefined;
    caregiverEmployerId?: string | undefined;
    caregiverEmployerIds?: string[] | undefined;
    providerOneId?: string | undefined;
    workdayId?: string | undefined;

    constructor(data?: ICaregiverProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["phoneDetails"])) {
                this.phoneDetails = [] as any;
                for (let item of _data["phoneDetails"])
                    this.phoneDetails!.push(PhoneDetail.fromJS(item));
            }
            if (Array.isArray(_data["physicalAddresses"])) {
                this.physicalAddresses = [] as any;
                for (let item of _data["physicalAddresses"])
                    this.physicalAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["mailingAddresses"])) {
                this.mailingAddresses = [] as any;
                for (let item of _data["mailingAddresses"])
                    this.mailingAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["ivrAddresses"])) {
                this.ivrAddresses = [] as any;
                for (let item of _data["ivrAddresses"])
                    this.ivrAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["externalKeys"])) {
                this.externalKeys = [] as any;
                for (let item of _data["externalKeys"])
                    this.externalKeys!.push(ExternalKeyDTO.fromJS(item));
            }
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.status = _data["status"];
            (<any>this).personName = _data["personName"];
            this.ssn = _data["ssn"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.gender = _data["gender"];
            this.ethnicity = _data["ethnicity"];
            this.race = _data["race"];
            this.maritalStatus = _data["maritalStatus"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.physicalAddress = _data["physicalAddress"];
            this.mailingAddress = _data["mailingAddress"];
            this.ivrAddress = _data["ivrAddress"];
            this.companyCode = _data["companyCode"];
            this.unmaskedSsn = _data["unmaskedSsn"];
            this.onboarded = _data["onboarded"];
            this.isFirstLoginComplete = _data["isFirstLoginComplete"];
            this.ivrPin = _data["ivrPin"];
            this.coordinatorPersonId = _data["coordinatorPersonId"];
            this.internalUserObjectId = _data["internalUserObjectId"];
            this.coordinatorPersonFirstName = _data["coordinatorPersonFirstName"];
            this.coordinatorPersonLastName = _data["coordinatorPersonLastName"];
            this.coordinatorPersonName = _data["coordinatorPersonName"];
            this.lastV4LoginOn = _data["lastV4LoginOn"] ? new Date(_data["lastV4LoginOn"].toString()) : <any>undefined;
            this.isSsnValidated = _data["isSsnValidated"];
            this.ssnValidationOverrideOn = _data["ssnValidationOverrideOn"] ? new Date(_data["ssnValidationOverrideOn"].toString()) : <any>undefined;
            this.ssnValidationOverrideBy = _data["ssnValidationOverrideBy"];
            this.caregiverId = _data["caregiverId"];
            this.solomonId = _data["solomonId"];
            this.backgroundCheck = _data["backgroundCheck"];
            this.npi = _data["npi"];
            this.stateUniqueId = _data["stateUniqueId"];
            this.paymentMethod = _data["paymentMethod"];
            this.lastPayDate = _data["lastPayDate"] ? new Date(_data["lastPayDate"].toString()) : <any>undefined;
            this.rateStatus = _data["rateStatus"];
            this.rateIconStatus = _data["rateIconStatus"];
            this.relationIconStatus = _data["relationIconStatus"];
            this.payCycleStart = _data["payCycleStart"] ? new Date(_data["payCycleStart"].toString()) : <any>undefined;
            this.payCycleEnd = _data["payCycleEnd"] ? new Date(_data["payCycleEnd"].toString()) : <any>undefined;
            this.relationStatus = _data["relationStatus"];
            this.red = _data["red"];
            this.yellow = _data["yellow"];
            this.green = _data["green"];
            this.blue = _data["blue"];
            this.caregiverEmployerId = _data["caregiverEmployerId"];
            if (Array.isArray(_data["caregiverEmployerIds"])) {
                this.caregiverEmployerIds = [] as any;
                for (let item of _data["caregiverEmployerIds"])
                    this.caregiverEmployerIds!.push(item);
            }
            this.providerOneId = _data["providerOneId"];
            this.workdayId = _data["workdayId"];
        }
    }

    static fromJS(data: any): CaregiverProfile {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phoneDetails)) {
            data["phoneDetails"] = [];
            for (let item of this.phoneDetails)
                data["phoneDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.physicalAddresses)) {
            data["physicalAddresses"] = [];
            for (let item of this.physicalAddresses)
                data["physicalAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.mailingAddresses)) {
            data["mailingAddresses"] = [];
            for (let item of this.mailingAddresses)
                data["mailingAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.ivrAddresses)) {
            data["ivrAddresses"] = [];
            for (let item of this.ivrAddresses)
                data["ivrAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.externalKeys)) {
            data["externalKeys"] = [];
            for (let item of this.externalKeys)
                data["externalKeys"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["status"] = this.status;
        data["personName"] = this.personName;
        data["ssn"] = this.ssn;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["gender"] = this.gender;
        data["ethnicity"] = this.ethnicity;
        data["race"] = this.race;
        data["maritalStatus"] = this.maritalStatus;
        data["preferredLanguage"] = this.preferredLanguage;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["physicalAddress"] = this.physicalAddress;
        data["mailingAddress"] = this.mailingAddress;
        data["ivrAddress"] = this.ivrAddress;
        data["companyCode"] = this.companyCode;
        data["unmaskedSsn"] = this.unmaskedSsn;
        data["onboarded"] = this.onboarded;
        data["isFirstLoginComplete"] = this.isFirstLoginComplete;
        data["ivrPin"] = this.ivrPin;
        data["coordinatorPersonId"] = this.coordinatorPersonId;
        data["internalUserObjectId"] = this.internalUserObjectId;
        data["coordinatorPersonFirstName"] = this.coordinatorPersonFirstName;
        data["coordinatorPersonLastName"] = this.coordinatorPersonLastName;
        data["coordinatorPersonName"] = this.coordinatorPersonName;
        data["lastV4LoginOn"] = this.lastV4LoginOn ? this.lastV4LoginOn.toISOString() : <any>undefined;
        data["isSsnValidated"] = this.isSsnValidated;
        data["ssnValidationOverrideOn"] = this.ssnValidationOverrideOn ? this.ssnValidationOverrideOn.toISOString() : <any>undefined;
        data["ssnValidationOverrideBy"] = this.ssnValidationOverrideBy;
        data["caregiverId"] = this.caregiverId;
        data["solomonId"] = this.solomonId;
        data["backgroundCheck"] = this.backgroundCheck;
        data["npi"] = this.npi;
        data["stateUniqueId"] = this.stateUniqueId;
        data["paymentMethod"] = this.paymentMethod;
        data["lastPayDate"] = this.lastPayDate ? this.lastPayDate.toISOString() : <any>undefined;
        data["rateStatus"] = this.rateStatus;
        data["rateIconStatus"] = this.rateIconStatus;
        data["relationIconStatus"] = this.relationIconStatus;
        data["payCycleStart"] = this.payCycleStart ? this.payCycleStart.toISOString() : <any>undefined;
        data["payCycleEnd"] = this.payCycleEnd ? this.payCycleEnd.toISOString() : <any>undefined;
        data["relationStatus"] = this.relationStatus;
        data["red"] = this.red;
        data["yellow"] = this.yellow;
        data["green"] = this.green;
        data["blue"] = this.blue;
        data["caregiverEmployerId"] = this.caregiverEmployerId;
        if (Array.isArray(this.caregiverEmployerIds)) {
            data["caregiverEmployerIds"] = [];
            for (let item of this.caregiverEmployerIds)
                data["caregiverEmployerIds"].push(item);
        }
        data["providerOneId"] = this.providerOneId;
        data["workdayId"] = this.workdayId;
        return data;
    }
}

export interface ICaregiverProfile {
    phoneDetails?: PhoneDetail[] | undefined;
    physicalAddresses?: AddressDTO[] | undefined;
    mailingAddresses?: AddressDTO[] | undefined;
    ivrAddresses?: AddressDTO[] | undefined;
    externalKeys?: ExternalKeyDTO[] | undefined;
    id?: number;
    personId?: string | undefined;
    status?: string | undefined;
    personName?: string | undefined;
    ssn?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    physicalAddress?: string | undefined;
    mailingAddress?: string | undefined;
    ivrAddress?: string | undefined;
    companyCode?: string | undefined;
    unmaskedSsn?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    ivrPin?: string | undefined;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    coordinatorPersonFirstName?: string | undefined;
    coordinatorPersonLastName?: string | undefined;
    coordinatorPersonName?: string | undefined;
    lastV4LoginOn?: Date | undefined;
    isSsnValidated?: boolean | undefined;
    ssnValidationOverrideOn?: Date | undefined;
    ssnValidationOverrideBy?: string | undefined;
    caregiverId?: number;
    solomonId?: string | undefined;
    backgroundCheck?: string | undefined;
    npi?: string | undefined;
    stateUniqueId?: string | undefined;
    paymentMethod?: string | undefined;
    lastPayDate?: Date | undefined;
    rateStatus?: string | undefined;
    rateIconStatus?: IconStatus;
    relationIconStatus?: IconStatus;
    payCycleStart?: Date | undefined;
    payCycleEnd?: Date | undefined;
    relationStatus?: string | undefined;
    red?: number | undefined;
    yellow?: number | undefined;
    green?: number | undefined;
    blue?: number | undefined;
    caregiverEmployerId?: string | undefined;
    caregiverEmployerIds?: string[] | undefined;
    providerOneId?: string | undefined;
    workdayId?: string | undefined;
}

export class CaregiverProspectI9DateAndStatusHistory implements ICaregiverProspectI9DateAndStatusHistory {
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    updatedBy?: string | undefined;
    sequenceNumber?: number | undefined;
    entityId?: string | undefined;
    caregiverProspectId?: number;
    i9Date?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    updatedOn?: Date;

    constructor(data?: ICaregiverProspectI9DateAndStatusHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.entityId = _data["entityId"];
            this.caregiverProspectId = _data["caregiverProspectId"];
            this.i9Date = _data["i9Date"] ? new Date(_data["i9Date"].toString()) : <any>undefined;
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CaregiverProspectI9DateAndStatusHistory {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverProspectI9DateAndStatusHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["sequenceNumber"] = this.sequenceNumber;
        data["entityId"] = this.entityId;
        data["caregiverProspectId"] = this.caregiverProspectId;
        data["i9Date"] = this.i9Date ? this.i9Date.toISOString() : <any>undefined;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICaregiverProspectI9DateAndStatusHistory {
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    updatedBy?: string | undefined;
    sequenceNumber?: number | undefined;
    entityId?: string | undefined;
    caregiverProspectId?: number;
    i9Date?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    updatedOn?: Date;
}

export class CaregiverProspectRequest implements ICaregiverProspectRequest {
    personId?: string | undefined;
    cdcnState?: string | undefined;
    caregiverProspectStatus?: CaregiverProspectStatus[] | undefined;
    interestedEligibleDate?: Date | undefined;
    isInterestedEligible?: boolean;

    constructor(data?: ICaregiverProspectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.cdcnState = _data["cdcnState"];
            if (Array.isArray(_data["caregiverProspectStatus"])) {
                this.caregiverProspectStatus = [] as any;
                for (let item of _data["caregiverProspectStatus"])
                    this.caregiverProspectStatus!.push(CaregiverProspectStatus.fromJS(item));
            }
            this.interestedEligibleDate = _data["interestedEligibleDate"] ? new Date(_data["interestedEligibleDate"].toString()) : <any>undefined;
            this.isInterestedEligible = _data["isInterestedEligible"];
        }
    }

    static fromJS(data: any): CaregiverProspectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverProspectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["cdcnState"] = this.cdcnState;
        if (Array.isArray(this.caregiverProspectStatus)) {
            data["caregiverProspectStatus"] = [];
            for (let item of this.caregiverProspectStatus)
                data["caregiverProspectStatus"].push(item.toJSON());
        }
        data["interestedEligibleDate"] = this.interestedEligibleDate ? this.interestedEligibleDate.toISOString() : <any>undefined;
        data["isInterestedEligible"] = this.isInterestedEligible;
        return data;
    }
}

export interface ICaregiverProspectRequest {
    personId?: string | undefined;
    cdcnState?: string | undefined;
    caregiverProspectStatus?: CaregiverProspectStatus[] | undefined;
    interestedEligibleDate?: Date | undefined;
    isInterestedEligible?: boolean;
}

export class CaregiverProspectResponse implements ICaregiverProspectResponse {
    phoneDetails?: PhoneDetail[] | undefined;
    physicalAddresses?: AddressDTO[] | undefined;
    mailingAddresses?: AddressDTO[] | undefined;
    ivrAddresses?: AddressDTO[] | undefined;
    externalKeys?: ExternalKeyDTO[] | undefined;
    id?: number;
    personId?: string | undefined;
    status?: string | undefined;
    readonly personName?: string | undefined;
    ssn?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    physicalAddress?: string | undefined;
    mailingAddress?: string | undefined;
    ivrAddress?: string | undefined;
    companyCode?: string | undefined;
    unmaskedSsn?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    ivrPin?: string | undefined;
    paymentMethod?: string | undefined;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    coordinatorPersonFirstName?: string | undefined;
    coordinatorPersonLastName?: string | undefined;
    coordinatorPersonName?: string | undefined;
    lastV4LoginOn?: Date | undefined;
    isSsnValidated?: boolean | undefined;
    ssnValidationOverrideOn?: Date | undefined;
    ssnValidationOverrideBy?: string | undefined;
    cdcnState?: string | undefined;
    interestedEligibleDate?: Date | undefined;
    isInterestedEligible?: boolean;

    constructor(data?: ICaregiverProspectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["phoneDetails"])) {
                this.phoneDetails = [] as any;
                for (let item of _data["phoneDetails"])
                    this.phoneDetails!.push(PhoneDetail.fromJS(item));
            }
            if (Array.isArray(_data["physicalAddresses"])) {
                this.physicalAddresses = [] as any;
                for (let item of _data["physicalAddresses"])
                    this.physicalAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["mailingAddresses"])) {
                this.mailingAddresses = [] as any;
                for (let item of _data["mailingAddresses"])
                    this.mailingAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["ivrAddresses"])) {
                this.ivrAddresses = [] as any;
                for (let item of _data["ivrAddresses"])
                    this.ivrAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["externalKeys"])) {
                this.externalKeys = [] as any;
                for (let item of _data["externalKeys"])
                    this.externalKeys!.push(ExternalKeyDTO.fromJS(item));
            }
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.status = _data["status"];
            (<any>this).personName = _data["personName"];
            this.ssn = _data["ssn"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.gender = _data["gender"];
            this.ethnicity = _data["ethnicity"];
            this.race = _data["race"];
            this.maritalStatus = _data["maritalStatus"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.physicalAddress = _data["physicalAddress"];
            this.mailingAddress = _data["mailingAddress"];
            this.ivrAddress = _data["ivrAddress"];
            this.companyCode = _data["companyCode"];
            this.unmaskedSsn = _data["unmaskedSsn"];
            this.onboarded = _data["onboarded"];
            this.isFirstLoginComplete = _data["isFirstLoginComplete"];
            this.ivrPin = _data["ivrPin"];
            this.paymentMethod = _data["paymentMethod"];
            this.coordinatorPersonId = _data["coordinatorPersonId"];
            this.internalUserObjectId = _data["internalUserObjectId"];
            this.coordinatorPersonFirstName = _data["coordinatorPersonFirstName"];
            this.coordinatorPersonLastName = _data["coordinatorPersonLastName"];
            this.coordinatorPersonName = _data["coordinatorPersonName"];
            this.lastV4LoginOn = _data["lastV4LoginOn"] ? new Date(_data["lastV4LoginOn"].toString()) : <any>undefined;
            this.isSsnValidated = _data["isSsnValidated"];
            this.ssnValidationOverrideOn = _data["ssnValidationOverrideOn"] ? new Date(_data["ssnValidationOverrideOn"].toString()) : <any>undefined;
            this.ssnValidationOverrideBy = _data["ssnValidationOverrideBy"];
            this.cdcnState = _data["cdcnState"];
            this.interestedEligibleDate = _data["interestedEligibleDate"] ? new Date(_data["interestedEligibleDate"].toString()) : <any>undefined;
            this.isInterestedEligible = _data["isInterestedEligible"];
        }
    }

    static fromJS(data: any): CaregiverProspectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverProspectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phoneDetails)) {
            data["phoneDetails"] = [];
            for (let item of this.phoneDetails)
                data["phoneDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.physicalAddresses)) {
            data["physicalAddresses"] = [];
            for (let item of this.physicalAddresses)
                data["physicalAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.mailingAddresses)) {
            data["mailingAddresses"] = [];
            for (let item of this.mailingAddresses)
                data["mailingAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.ivrAddresses)) {
            data["ivrAddresses"] = [];
            for (let item of this.ivrAddresses)
                data["ivrAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.externalKeys)) {
            data["externalKeys"] = [];
            for (let item of this.externalKeys)
                data["externalKeys"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["status"] = this.status;
        data["personName"] = this.personName;
        data["ssn"] = this.ssn;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["gender"] = this.gender;
        data["ethnicity"] = this.ethnicity;
        data["race"] = this.race;
        data["maritalStatus"] = this.maritalStatus;
        data["preferredLanguage"] = this.preferredLanguage;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["physicalAddress"] = this.physicalAddress;
        data["mailingAddress"] = this.mailingAddress;
        data["ivrAddress"] = this.ivrAddress;
        data["companyCode"] = this.companyCode;
        data["unmaskedSsn"] = this.unmaskedSsn;
        data["onboarded"] = this.onboarded;
        data["isFirstLoginComplete"] = this.isFirstLoginComplete;
        data["ivrPin"] = this.ivrPin;
        data["paymentMethod"] = this.paymentMethod;
        data["coordinatorPersonId"] = this.coordinatorPersonId;
        data["internalUserObjectId"] = this.internalUserObjectId;
        data["coordinatorPersonFirstName"] = this.coordinatorPersonFirstName;
        data["coordinatorPersonLastName"] = this.coordinatorPersonLastName;
        data["coordinatorPersonName"] = this.coordinatorPersonName;
        data["lastV4LoginOn"] = this.lastV4LoginOn ? this.lastV4LoginOn.toISOString() : <any>undefined;
        data["isSsnValidated"] = this.isSsnValidated;
        data["ssnValidationOverrideOn"] = this.ssnValidationOverrideOn ? this.ssnValidationOverrideOn.toISOString() : <any>undefined;
        data["ssnValidationOverrideBy"] = this.ssnValidationOverrideBy;
        data["cdcnState"] = this.cdcnState;
        data["interestedEligibleDate"] = this.interestedEligibleDate ? this.interestedEligibleDate.toISOString() : <any>undefined;
        data["isInterestedEligible"] = this.isInterestedEligible;
        return data;
    }
}

export interface ICaregiverProspectResponse {
    phoneDetails?: PhoneDetail[] | undefined;
    physicalAddresses?: AddressDTO[] | undefined;
    mailingAddresses?: AddressDTO[] | undefined;
    ivrAddresses?: AddressDTO[] | undefined;
    externalKeys?: ExternalKeyDTO[] | undefined;
    id?: number;
    personId?: string | undefined;
    status?: string | undefined;
    personName?: string | undefined;
    ssn?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    physicalAddress?: string | undefined;
    mailingAddress?: string | undefined;
    ivrAddress?: string | undefined;
    companyCode?: string | undefined;
    unmaskedSsn?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    ivrPin?: string | undefined;
    paymentMethod?: string | undefined;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    coordinatorPersonFirstName?: string | undefined;
    coordinatorPersonLastName?: string | undefined;
    coordinatorPersonName?: string | undefined;
    lastV4LoginOn?: Date | undefined;
    isSsnValidated?: boolean | undefined;
    ssnValidationOverrideOn?: Date | undefined;
    ssnValidationOverrideBy?: string | undefined;
    cdcnState?: string | undefined;
    interestedEligibleDate?: Date | undefined;
    isInterestedEligible?: boolean;
}

export class CaregiverProspectStatus implements ICaregiverProspectStatus {
    caregiverProspectStatusId?: number;
    caregiverProspectId?: number;
    statusStartDate?: Date;
    statusEndDate?: Date | undefined;
    termReason?: string | undefined;

    constructor(data?: ICaregiverProspectStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverProspectStatusId = _data["caregiverProspectStatusId"];
            this.caregiverProspectId = _data["caregiverProspectId"];
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.termReason = _data["termReason"];
        }
    }

    static fromJS(data: any): CaregiverProspectStatus {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverProspectStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverProspectStatusId"] = this.caregiverProspectStatusId;
        data["caregiverProspectId"] = this.caregiverProspectId;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["termReason"] = this.termReason;
        return data;
    }
}

export interface ICaregiverProspectStatus {
    caregiverProspectStatusId?: number;
    caregiverProspectId?: number;
    statusStartDate?: Date;
    statusEndDate?: Date | undefined;
    termReason?: string | undefined;
}

export class CaregiverQualification implements ICaregiverQualification {
    qualificationName?: string | undefined;
    caregiverQualificationMappingId?: number;
    okToWorkDayRanges?: DayRange[] | undefined;
    notOkToWorkDayRanges?: DayRange[] | undefined;

    constructor(data?: ICaregiverQualification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationName = _data["qualificationName"];
            this.caregiverQualificationMappingId = _data["caregiverQualificationMappingId"];
            if (Array.isArray(_data["okToWorkDayRanges"])) {
                this.okToWorkDayRanges = [] as any;
                for (let item of _data["okToWorkDayRanges"])
                    this.okToWorkDayRanges!.push(DayRange.fromJS(item));
            }
            if (Array.isArray(_data["notOkToWorkDayRanges"])) {
                this.notOkToWorkDayRanges = [] as any;
                for (let item of _data["notOkToWorkDayRanges"])
                    this.notOkToWorkDayRanges!.push(DayRange.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaregiverQualification {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverQualification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationName"] = this.qualificationName;
        data["caregiverQualificationMappingId"] = this.caregiverQualificationMappingId;
        if (Array.isArray(this.okToWorkDayRanges)) {
            data["okToWorkDayRanges"] = [];
            for (let item of this.okToWorkDayRanges)
                data["okToWorkDayRanges"].push(item.toJSON());
        }
        if (Array.isArray(this.notOkToWorkDayRanges)) {
            data["notOkToWorkDayRanges"] = [];
            for (let item of this.notOkToWorkDayRanges)
                data["notOkToWorkDayRanges"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICaregiverQualification {
    qualificationName?: string | undefined;
    caregiverQualificationMappingId?: number;
    okToWorkDayRanges?: DayRange[] | undefined;
    notOkToWorkDayRanges?: DayRange[] | undefined;
}

export class CaregiverQualificationGridRequest implements ICaregiverQualificationGridRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    caregiverId?: number;
    isUnpaged?: boolean;

    constructor(data?: ICaregiverQualificationGridRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            this.caregiverId = _data["caregiverId"];
            this.isUnpaged = _data["isUnpaged"];
        }
    }

    static fromJS(data: any): CaregiverQualificationGridRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverQualificationGridRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        data["caregiverId"] = this.caregiverId;
        data["isUnpaged"] = this.isUnpaged;
        return data;
    }
}

export interface ICaregiverQualificationGridRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    caregiverId?: number;
    isUnpaged?: boolean;
}

export class CaregiverQualificationNotifyRequest implements ICaregiverQualificationNotifyRequest {
    startDate?: Date;
    endDate?: Date;
    companyCode?: string | undefined;
    companyId?: number;

    constructor(data?: ICaregiverQualificationNotifyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.companyCode = _data["companyCode"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): CaregiverQualificationNotifyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverQualificationNotifyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["companyCode"] = this.companyCode;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface ICaregiverQualificationNotifyRequest {
    startDate?: Date;
    endDate?: Date;
    companyCode?: string | undefined;
    companyId?: number;
}

export class CaregiverQualificationNotifyResponse implements ICaregiverQualificationNotifyResponse {
    caregiverPersonId?: string | undefined;
    startDate?: Date;
    expirationDate?: Date;
    qualificationType?: string | undefined;
    category?: string | undefined;
    trainingServiceCode?: number | undefined;
    continuingTrainingServiceCode?: number | undefined;
    continuingTrainingDays?: number | undefined;
    hasContinuation?: boolean;
    qualificationRoleRank?: number;
    lastQualificationCompleteDate?: Date | undefined;

    constructor(data?: ICaregiverQualificationNotifyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverPersonId = _data["caregiverPersonId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.qualificationType = _data["qualificationType"];
            this.category = _data["category"];
            this.trainingServiceCode = _data["trainingServiceCode"];
            this.continuingTrainingServiceCode = _data["continuingTrainingServiceCode"];
            this.continuingTrainingDays = _data["continuingTrainingDays"];
            this.hasContinuation = _data["hasContinuation"];
            this.qualificationRoleRank = _data["qualificationRoleRank"];
            this.lastQualificationCompleteDate = _data["lastQualificationCompleteDate"] ? new Date(_data["lastQualificationCompleteDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CaregiverQualificationNotifyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverQualificationNotifyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverPersonId"] = this.caregiverPersonId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["qualificationType"] = this.qualificationType;
        data["category"] = this.category;
        data["trainingServiceCode"] = this.trainingServiceCode;
        data["continuingTrainingServiceCode"] = this.continuingTrainingServiceCode;
        data["continuingTrainingDays"] = this.continuingTrainingDays;
        data["hasContinuation"] = this.hasContinuation;
        data["qualificationRoleRank"] = this.qualificationRoleRank;
        data["lastQualificationCompleteDate"] = this.lastQualificationCompleteDate ? this.lastQualificationCompleteDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICaregiverQualificationNotifyResponse {
    caregiverPersonId?: string | undefined;
    startDate?: Date;
    expirationDate?: Date;
    qualificationType?: string | undefined;
    category?: string | undefined;
    trainingServiceCode?: number | undefined;
    continuingTrainingServiceCode?: number | undefined;
    continuingTrainingDays?: number | undefined;
    hasContinuation?: boolean;
    qualificationRoleRank?: number;
    lastQualificationCompleteDate?: Date | undefined;
}

export class CaregiverQualificationStartResponse implements ICaregiverQualificationStartResponse {
    caregiverPersonId?: string | undefined;
    startDate?: Date;
    expirationDate?: Date;
    qualificationType?: string | undefined;
    category?: string | undefined;

    constructor(data?: ICaregiverQualificationStartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverPersonId = _data["caregiverPersonId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.qualificationType = _data["qualificationType"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): CaregiverQualificationStartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverQualificationStartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverPersonId"] = this.caregiverPersonId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["qualificationType"] = this.qualificationType;
        data["category"] = this.category;
        return data;
    }
}

export interface ICaregiverQualificationStartResponse {
    caregiverPersonId?: string | undefined;
    startDate?: Date;
    expirationDate?: Date;
    qualificationType?: string | undefined;
    category?: string | undefined;
}

export class CaregiverQualificationType implements ICaregiverQualificationType {
    caregiverQualificationMappingId?: number;
    qualificationTypeId?: number;
    qualificationType?: string | undefined;
    description?: string | undefined;
    category?: string | undefined;
    expirationDate?: Date | undefined;
    overrideDate?: Date | undefined;
    expires?: boolean;
    trainingServiceCode?: number;
    qualificationHours?: number;
    qualificationServiceCode?: string | undefined;
    startDate?: Date;
    externalQualificationId?: string | undefined;
    trainingProgramField?: string | undefined;
    trainingProgramDisplayText?: string | undefined;
    trainingProgramCode?: string | undefined;
    status?: number;
    statusText?: string | undefined;
    statusCode?: string | undefined;
    lepProvisionalQualification?: boolean;
    qualificationStatusDate?: Date | undefined;
    trainingTransferIndicator?: boolean;
    firstQualificationCompleteDate?: Date | undefined;
    lastQualificationCompleteDate?: Date | undefined;
    trainingEntity?: string | undefined;
    applicationDate?: Date | undefined;
    transferReason?: number;
    transferReasonText?: string | undefined;
    transferReasonCode?: string | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    participantId?: number | undefined;
    participantName?: string | undefined;
    gracePeriodQualification?: string | undefined;

    constructor(data?: ICaregiverQualificationType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverQualificationMappingId = _data["caregiverQualificationMappingId"];
            this.qualificationTypeId = _data["qualificationTypeId"];
            this.qualificationType = _data["qualificationType"];
            this.description = _data["description"];
            this.category = _data["category"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.overrideDate = _data["overrideDate"] ? new Date(_data["overrideDate"].toString()) : <any>undefined;
            this.expires = _data["expires"];
            this.trainingServiceCode = _data["trainingServiceCode"];
            this.qualificationHours = _data["qualificationHours"];
            this.qualificationServiceCode = _data["qualificationServiceCode"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.externalQualificationId = _data["externalQualificationId"];
            this.trainingProgramField = _data["trainingProgramField"];
            this.trainingProgramDisplayText = _data["trainingProgramDisplayText"];
            this.trainingProgramCode = _data["trainingProgramCode"];
            this.status = _data["status"];
            this.statusText = _data["statusText"];
            this.statusCode = _data["statusCode"];
            this.lepProvisionalQualification = _data["lepProvisionalQualification"];
            this.qualificationStatusDate = _data["qualificationStatusDate"] ? new Date(_data["qualificationStatusDate"].toString()) : <any>undefined;
            this.trainingTransferIndicator = _data["trainingTransferIndicator"];
            this.firstQualificationCompleteDate = _data["firstQualificationCompleteDate"] ? new Date(_data["firstQualificationCompleteDate"].toString()) : <any>undefined;
            this.lastQualificationCompleteDate = _data["lastQualificationCompleteDate"] ? new Date(_data["lastQualificationCompleteDate"].toString()) : <any>undefined;
            this.trainingEntity = _data["trainingEntity"];
            this.applicationDate = _data["applicationDate"] ? new Date(_data["applicationDate"].toString()) : <any>undefined;
            this.transferReason = _data["transferReason"];
            this.transferReasonText = _data["transferReasonText"];
            this.transferReasonCode = _data["transferReasonCode"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.participantId = _data["participantId"];
            this.participantName = _data["participantName"];
            this.gracePeriodQualification = _data["gracePeriodQualification"];
        }
    }

    static fromJS(data: any): CaregiverQualificationType {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverQualificationType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverQualificationMappingId"] = this.caregiverQualificationMappingId;
        data["qualificationTypeId"] = this.qualificationTypeId;
        data["qualificationType"] = this.qualificationType;
        data["description"] = this.description;
        data["category"] = this.category;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["overrideDate"] = this.overrideDate ? this.overrideDate.toISOString() : <any>undefined;
        data["expires"] = this.expires;
        data["trainingServiceCode"] = this.trainingServiceCode;
        data["qualificationHours"] = this.qualificationHours;
        data["qualificationServiceCode"] = this.qualificationServiceCode;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["externalQualificationId"] = this.externalQualificationId;
        data["trainingProgramField"] = this.trainingProgramField;
        data["trainingProgramDisplayText"] = this.trainingProgramDisplayText;
        data["trainingProgramCode"] = this.trainingProgramCode;
        data["status"] = this.status;
        data["statusText"] = this.statusText;
        data["statusCode"] = this.statusCode;
        data["lepProvisionalQualification"] = this.lepProvisionalQualification;
        data["qualificationStatusDate"] = this.qualificationStatusDate ? this.qualificationStatusDate.toISOString() : <any>undefined;
        data["trainingTransferIndicator"] = this.trainingTransferIndicator;
        data["firstQualificationCompleteDate"] = this.firstQualificationCompleteDate ? this.firstQualificationCompleteDate.toISOString() : <any>undefined;
        data["lastQualificationCompleteDate"] = this.lastQualificationCompleteDate ? this.lastQualificationCompleteDate.toISOString() : <any>undefined;
        data["trainingEntity"] = this.trainingEntity;
        data["applicationDate"] = this.applicationDate ? this.applicationDate.toISOString() : <any>undefined;
        data["transferReason"] = this.transferReason;
        data["transferReasonText"] = this.transferReasonText;
        data["transferReasonCode"] = this.transferReasonCode;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["participantId"] = this.participantId;
        data["participantName"] = this.participantName;
        data["gracePeriodQualification"] = this.gracePeriodQualification;
        return data;
    }
}

export interface ICaregiverQualificationType {
    caregiverQualificationMappingId?: number;
    qualificationTypeId?: number;
    qualificationType?: string | undefined;
    description?: string | undefined;
    category?: string | undefined;
    expirationDate?: Date | undefined;
    overrideDate?: Date | undefined;
    expires?: boolean;
    trainingServiceCode?: number;
    qualificationHours?: number;
    qualificationServiceCode?: string | undefined;
    startDate?: Date;
    externalQualificationId?: string | undefined;
    trainingProgramField?: string | undefined;
    trainingProgramDisplayText?: string | undefined;
    trainingProgramCode?: string | undefined;
    status?: number;
    statusText?: string | undefined;
    statusCode?: string | undefined;
    lepProvisionalQualification?: boolean;
    qualificationStatusDate?: Date | undefined;
    trainingTransferIndicator?: boolean;
    firstQualificationCompleteDate?: Date | undefined;
    lastQualificationCompleteDate?: Date | undefined;
    trainingEntity?: string | undefined;
    applicationDate?: Date | undefined;
    transferReason?: number;
    transferReasonText?: string | undefined;
    transferReasonCode?: string | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    participantId?: number | undefined;
    participantName?: string | undefined;
    gracePeriodQualification?: string | undefined;
}

export class CaregiverQualificationTypeExpirationDateRequest implements ICaregiverQualificationTypeExpirationDateRequest {
    birthDate?: Date;
    expirationType?: string | undefined;
    expirationDays?: number;
    startDate?: Date;
    expires?: boolean;

    constructor(data?: ICaregiverQualificationTypeExpirationDateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.expirationType = _data["expirationType"];
            this.expirationDays = _data["expirationDays"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.expires = _data["expires"];
        }
    }

    static fromJS(data: any): CaregiverQualificationTypeExpirationDateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverQualificationTypeExpirationDateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["expirationType"] = this.expirationType;
        data["expirationDays"] = this.expirationDays;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["expires"] = this.expires;
        return data;
    }
}

export interface ICaregiverQualificationTypeExpirationDateRequest {
    birthDate?: Date;
    expirationType?: string | undefined;
    expirationDays?: number;
    startDate?: Date;
    expires?: boolean;
}

export class CaregiverQualificationTypeGridResponseBase implements ICaregiverQualificationTypeGridResponseBase {
    items?: CaregiverQualificationType[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CaregiverQualificationType;

    constructor(data?: ICaregiverQualificationTypeGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CaregiverQualificationType.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? CaregiverQualificationType.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CaregiverQualificationTypeGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverQualificationTypeGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICaregiverQualificationTypeGridResponseBase {
    items?: CaregiverQualificationType[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CaregiverQualificationType;
}

export class CaregiverQualificationTypeMapping implements ICaregiverQualificationTypeMapping {
    caregiverQualificationMappingId?: number;
    caregiverId?: number | undefined;
    personId?: string | undefined;
    qualificationTypeId?: number;
    companyId?: number;
    expirationDate?: Date | undefined;
    overrideDate?: Date | undefined;
    expires?: boolean;
    startDate?: Date;
    isDeleted?: boolean;

    constructor(data?: ICaregiverQualificationTypeMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverQualificationMappingId = _data["caregiverQualificationMappingId"];
            this.caregiverId = _data["caregiverId"];
            this.personId = _data["personId"];
            this.qualificationTypeId = _data["qualificationTypeId"];
            this.companyId = _data["companyId"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.overrideDate = _data["overrideDate"] ? new Date(_data["overrideDate"].toString()) : <any>undefined;
            this.expires = _data["expires"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CaregiverQualificationTypeMapping {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverQualificationTypeMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverQualificationMappingId"] = this.caregiverQualificationMappingId;
        data["caregiverId"] = this.caregiverId;
        data["personId"] = this.personId;
        data["qualificationTypeId"] = this.qualificationTypeId;
        data["companyId"] = this.companyId;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["overrideDate"] = this.overrideDate ? this.overrideDate.toISOString() : <any>undefined;
        data["expires"] = this.expires;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ICaregiverQualificationTypeMapping {
    caregiverQualificationMappingId?: number;
    caregiverId?: number | undefined;
    personId?: string | undefined;
    qualificationTypeId?: number;
    companyId?: number;
    expirationDate?: Date | undefined;
    overrideDate?: Date | undefined;
    expires?: boolean;
    startDate?: Date;
    isDeleted?: boolean;
}

export class CaregiverQualificationTypeMappingRequest implements ICaregiverQualificationTypeMappingRequest {
    caregiverQualificationTypeMapping?: CaregiverQualificationTypeMapping;
    qualificationTypeCoursesMappingRequest?: QualificationTypeCoursesMappingRequest[] | undefined;
    externalQualificationId?: string | undefined;
    status?: number | undefined;
    lepProvisionalQualification?: boolean;
    qualificationStatusDate?: Date | undefined;
    trainingTransferIndicator?: boolean;
    firstQualificationCompleteDate?: Date | undefined;
    lastQualificationCompleteDate?: Date | undefined;
    trainingEntity?: string | undefined;
    courseCode?: string | undefined;
    className?: string | undefined;
    applicationDate?: Date | undefined;
    transferReason?: number | undefined;
    participantId?: number | undefined;

    constructor(data?: ICaregiverQualificationTypeMappingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverQualificationTypeMapping = _data["caregiverQualificationTypeMapping"] ? CaregiverQualificationTypeMapping.fromJS(_data["caregiverQualificationTypeMapping"]) : <any>undefined;
            if (Array.isArray(_data["qualificationTypeCoursesMappingRequest"])) {
                this.qualificationTypeCoursesMappingRequest = [] as any;
                for (let item of _data["qualificationTypeCoursesMappingRequest"])
                    this.qualificationTypeCoursesMappingRequest!.push(QualificationTypeCoursesMappingRequest.fromJS(item));
            }
            this.externalQualificationId = _data["externalQualificationId"];
            this.status = _data["status"];
            this.lepProvisionalQualification = _data["lepProvisionalQualification"];
            this.qualificationStatusDate = _data["qualificationStatusDate"] ? new Date(_data["qualificationStatusDate"].toString()) : <any>undefined;
            this.trainingTransferIndicator = _data["trainingTransferIndicator"];
            this.firstQualificationCompleteDate = _data["firstQualificationCompleteDate"] ? new Date(_data["firstQualificationCompleteDate"].toString()) : <any>undefined;
            this.lastQualificationCompleteDate = _data["lastQualificationCompleteDate"] ? new Date(_data["lastQualificationCompleteDate"].toString()) : <any>undefined;
            this.trainingEntity = _data["trainingEntity"];
            this.courseCode = _data["courseCode"];
            this.className = _data["className"];
            this.applicationDate = _data["applicationDate"] ? new Date(_data["applicationDate"].toString()) : <any>undefined;
            this.transferReason = _data["transferReason"];
            this.participantId = _data["participantId"];
        }
    }

    static fromJS(data: any): CaregiverQualificationTypeMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverQualificationTypeMappingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverQualificationTypeMapping"] = this.caregiverQualificationTypeMapping ? this.caregiverQualificationTypeMapping.toJSON() : <any>undefined;
        if (Array.isArray(this.qualificationTypeCoursesMappingRequest)) {
            data["qualificationTypeCoursesMappingRequest"] = [];
            for (let item of this.qualificationTypeCoursesMappingRequest)
                data["qualificationTypeCoursesMappingRequest"].push(item.toJSON());
        }
        data["externalQualificationId"] = this.externalQualificationId;
        data["status"] = this.status;
        data["lepProvisionalQualification"] = this.lepProvisionalQualification;
        data["qualificationStatusDate"] = this.qualificationStatusDate ? this.qualificationStatusDate.toISOString() : <any>undefined;
        data["trainingTransferIndicator"] = this.trainingTransferIndicator;
        data["firstQualificationCompleteDate"] = this.firstQualificationCompleteDate ? this.firstQualificationCompleteDate.toISOString() : <any>undefined;
        data["lastQualificationCompleteDate"] = this.lastQualificationCompleteDate ? this.lastQualificationCompleteDate.toISOString() : <any>undefined;
        data["trainingEntity"] = this.trainingEntity;
        data["courseCode"] = this.courseCode;
        data["className"] = this.className;
        data["applicationDate"] = this.applicationDate ? this.applicationDate.toISOString() : <any>undefined;
        data["transferReason"] = this.transferReason;
        data["participantId"] = this.participantId;
        return data;
    }
}

export interface ICaregiverQualificationTypeMappingRequest {
    caregiverQualificationTypeMapping?: CaregiverQualificationTypeMapping;
    qualificationTypeCoursesMappingRequest?: QualificationTypeCoursesMappingRequest[] | undefined;
    externalQualificationId?: string | undefined;
    status?: number | undefined;
    lepProvisionalQualification?: boolean;
    qualificationStatusDate?: Date | undefined;
    trainingTransferIndicator?: boolean;
    firstQualificationCompleteDate?: Date | undefined;
    lastQualificationCompleteDate?: Date | undefined;
    trainingEntity?: string | undefined;
    courseCode?: string | undefined;
    className?: string | undefined;
    applicationDate?: Date | undefined;
    transferReason?: number | undefined;
    participantId?: number | undefined;
}

export class CaregiverRelatedParticipantsRequest implements ICaregiverRelatedParticipantsRequest {
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    servDate?: Date;

    constructor(data?: ICaregiverRelatedParticipantsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            this.servDate = _data["servDate"] ? new Date(_data["servDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CaregiverRelatedParticipantsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverRelatedParticipantsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        data["servDate"] = this.servDate ? this.servDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICaregiverRelatedParticipantsRequest {
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    servDate?: Date;
}

export class CaregiverResponse implements ICaregiverResponse {
    caregiverPersonId?: string | undefined;
    servCode?: string | undefined;
    servCodeDescription?: string | undefined;
    isLiveIn?: boolean;
    isMileage?: boolean;
    tasks?: TaskResponse[] | undefined;

    constructor(data?: ICaregiverResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverPersonId = _data["caregiverPersonId"];
            this.servCode = _data["servCode"];
            this.servCodeDescription = _data["servCodeDescription"];
            this.isLiveIn = _data["isLiveIn"];
            this.isMileage = _data["isMileage"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(TaskResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaregiverResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverPersonId"] = this.caregiverPersonId;
        data["servCode"] = this.servCode;
        data["servCodeDescription"] = this.servCodeDescription;
        data["isLiveIn"] = this.isLiveIn;
        data["isMileage"] = this.isMileage;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICaregiverResponse {
    caregiverPersonId?: string | undefined;
    servCode?: string | undefined;
    servCodeDescription?: string | undefined;
    isLiveIn?: boolean;
    isMileage?: boolean;
    tasks?: TaskResponse[] | undefined;
}

export class CaregiverResponseV2 implements ICaregiverResponseV2 {
    caregiverId?: number;
    cdcnState?: string | undefined;
    area?: string | undefined;
    territory?: string | undefined;
    geoLocale?: string | undefined;
    companyId?: number | undefined;
    npi?: string | undefined;
    stateUniqueId?: string | undefined;
    renderingProviderFirstName?: string | undefined;
    renderingProviderLastName?: string | undefined;
    relationshipCounter?: number | undefined;
    canPaperTimesheet?: boolean | undefined;
    lepIndicator?: boolean | undefined;
    completedLearningDate?: Date | undefined;
    demographicsConfirmation?: string | undefined;
    trainingConfirmation?: string | undefined;
    backgroundCheckConfirmation?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;

    constructor(data?: ICaregiverResponseV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.cdcnState = _data["cdcnState"];
            this.area = _data["area"];
            this.territory = _data["territory"];
            this.geoLocale = _data["geoLocale"];
            this.companyId = _data["companyId"];
            this.npi = _data["npi"];
            this.stateUniqueId = _data["stateUniqueId"];
            this.renderingProviderFirstName = _data["renderingProviderFirstName"];
            this.renderingProviderLastName = _data["renderingProviderLastName"];
            this.relationshipCounter = _data["relationshipCounter"];
            this.canPaperTimesheet = _data["canPaperTimesheet"];
            this.lepIndicator = _data["lepIndicator"];
            this.completedLearningDate = _data["completedLearningDate"] ? new Date(_data["completedLearningDate"].toString()) : <any>undefined;
            this.demographicsConfirmation = _data["demographicsConfirmation"];
            this.trainingConfirmation = _data["trainingConfirmation"];
            this.backgroundCheckConfirmation = _data["backgroundCheckConfirmation"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): CaregiverResponseV2 {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverResponseV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["cdcnState"] = this.cdcnState;
        data["area"] = this.area;
        data["territory"] = this.territory;
        data["geoLocale"] = this.geoLocale;
        data["companyId"] = this.companyId;
        data["npi"] = this.npi;
        data["stateUniqueId"] = this.stateUniqueId;
        data["renderingProviderFirstName"] = this.renderingProviderFirstName;
        data["renderingProviderLastName"] = this.renderingProviderLastName;
        data["relationshipCounter"] = this.relationshipCounter;
        data["canPaperTimesheet"] = this.canPaperTimesheet;
        data["lepIndicator"] = this.lepIndicator;
        data["completedLearningDate"] = this.completedLearningDate ? this.completedLearningDate.toISOString() : <any>undefined;
        data["demographicsConfirmation"] = this.demographicsConfirmation;
        data["trainingConfirmation"] = this.trainingConfirmation;
        data["backgroundCheckConfirmation"] = this.backgroundCheckConfirmation;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ICaregiverResponseV2 {
    caregiverId?: number;
    cdcnState?: string | undefined;
    area?: string | undefined;
    territory?: string | undefined;
    geoLocale?: string | undefined;
    companyId?: number | undefined;
    npi?: string | undefined;
    stateUniqueId?: string | undefined;
    renderingProviderFirstName?: string | undefined;
    renderingProviderLastName?: string | undefined;
    relationshipCounter?: number | undefined;
    canPaperTimesheet?: boolean | undefined;
    lepIndicator?: boolean | undefined;
    completedLearningDate?: Date | undefined;
    demographicsConfirmation?: string | undefined;
    trainingConfirmation?: string | undefined;
    backgroundCheckConfirmation?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
}

export class CaregiverRoleTypePrereqSubRule implements ICaregiverRoleTypePrereqSubRule {
    id?: number;
    qualificationRoleTypeId?: number;
    qualificationRoleType?: string | undefined;
    qualificationTypeId?: number;
    qualificationType?: string | undefined;
    qualificationDescription?: string | undefined;
    isActive?: boolean;
    isDeleted?: boolean;
    startDateType?: string | undefined;
    startDateTypeID?: number;
    expirationDateType?: string | undefined;
    expirationDateTypeID?: number;
    expirationDays?: number | undefined;
    startDate?: Date;
    endDate?: Date;
    sequence?: number;
    preReqQualificationType?: string | undefined;
    preReqQualificationTypeId?: number;
    preReqQualificationDescription?: string | undefined;
    subRuleName?: string | undefined;
    companyId?: number;

    constructor(data?: ICaregiverRoleTypePrereqSubRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationRoleTypeId = _data["qualificationRoleTypeId"];
            this.qualificationRoleType = _data["qualificationRoleType"];
            this.qualificationTypeId = _data["qualificationTypeId"];
            this.qualificationType = _data["qualificationType"];
            this.qualificationDescription = _data["qualificationDescription"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.startDateType = _data["startDateType"];
            this.startDateTypeID = _data["startDateTypeID"];
            this.expirationDateType = _data["expirationDateType"];
            this.expirationDateTypeID = _data["expirationDateTypeID"];
            this.expirationDays = _data["expirationDays"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.sequence = _data["sequence"];
            this.preReqQualificationType = _data["preReqQualificationType"];
            this.preReqQualificationTypeId = _data["preReqQualificationTypeId"];
            this.preReqQualificationDescription = _data["preReqQualificationDescription"];
            this.subRuleName = _data["subRuleName"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): CaregiverRoleTypePrereqSubRule {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverRoleTypePrereqSubRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationRoleTypeId"] = this.qualificationRoleTypeId;
        data["qualificationRoleType"] = this.qualificationRoleType;
        data["qualificationTypeId"] = this.qualificationTypeId;
        data["qualificationType"] = this.qualificationType;
        data["qualificationDescription"] = this.qualificationDescription;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["startDateType"] = this.startDateType;
        data["startDateTypeID"] = this.startDateTypeID;
        data["expirationDateType"] = this.expirationDateType;
        data["expirationDateTypeID"] = this.expirationDateTypeID;
        data["expirationDays"] = this.expirationDays;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["sequence"] = this.sequence;
        data["preReqQualificationType"] = this.preReqQualificationType;
        data["preReqQualificationTypeId"] = this.preReqQualificationTypeId;
        data["preReqQualificationDescription"] = this.preReqQualificationDescription;
        data["subRuleName"] = this.subRuleName;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface ICaregiverRoleTypePrereqSubRule {
    id?: number;
    qualificationRoleTypeId?: number;
    qualificationRoleType?: string | undefined;
    qualificationTypeId?: number;
    qualificationType?: string | undefined;
    qualificationDescription?: string | undefined;
    isActive?: boolean;
    isDeleted?: boolean;
    startDateType?: string | undefined;
    startDateTypeID?: number;
    expirationDateType?: string | undefined;
    expirationDateTypeID?: number;
    expirationDays?: number | undefined;
    startDate?: Date;
    endDate?: Date;
    sequence?: number;
    preReqQualificationType?: string | undefined;
    preReqQualificationTypeId?: number;
    preReqQualificationDescription?: string | undefined;
    subRuleName?: string | undefined;
    companyId?: number;
}

export class CaregiverRoleTypeQualification implements ICaregiverRoleTypeQualification {
    id?: number | undefined;
    qualificationRoleTypeId?: number;
    qualificationRoleType?: string | undefined;
    qualificationTypeId?: number;
    qualificationType?: string | undefined;
    qualificationCategory?: string | undefined;
    isActive?: boolean;
    isRecurring?: boolean;
    serviceCode?: string | undefined;
    expirationType?: string | undefined;
    expirationDays?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    hasPreReq?: boolean;
    hasSubRule?: boolean;
    preReqQualificationType?: string | undefined;
    preReqQualificationTypeId?: number;
    firstCompletionDate?: Date | undefined;
    gracePeriodQualification?: string | undefined;
    sequence?: number | undefined;

    constructor(data?: ICaregiverRoleTypeQualification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationRoleTypeId = _data["qualificationRoleTypeId"];
            this.qualificationRoleType = _data["qualificationRoleType"];
            this.qualificationTypeId = _data["qualificationTypeId"];
            this.qualificationType = _data["qualificationType"];
            this.qualificationCategory = _data["qualificationCategory"];
            this.isActive = _data["isActive"];
            this.isRecurring = _data["isRecurring"];
            this.serviceCode = _data["serviceCode"];
            this.expirationType = _data["expirationType"];
            this.expirationDays = _data["expirationDays"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.hasPreReq = _data["hasPreReq"];
            this.hasSubRule = _data["hasSubRule"];
            this.preReqQualificationType = _data["preReqQualificationType"];
            this.preReqQualificationTypeId = _data["preReqQualificationTypeId"];
            this.firstCompletionDate = _data["firstCompletionDate"] ? new Date(_data["firstCompletionDate"].toString()) : <any>undefined;
            this.gracePeriodQualification = _data["gracePeriodQualification"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): CaregiverRoleTypeQualification {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverRoleTypeQualification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationRoleTypeId"] = this.qualificationRoleTypeId;
        data["qualificationRoleType"] = this.qualificationRoleType;
        data["qualificationTypeId"] = this.qualificationTypeId;
        data["qualificationType"] = this.qualificationType;
        data["qualificationCategory"] = this.qualificationCategory;
        data["isActive"] = this.isActive;
        data["isRecurring"] = this.isRecurring;
        data["serviceCode"] = this.serviceCode;
        data["expirationType"] = this.expirationType;
        data["expirationDays"] = this.expirationDays;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["hasPreReq"] = this.hasPreReq;
        data["hasSubRule"] = this.hasSubRule;
        data["preReqQualificationType"] = this.preReqQualificationType;
        data["preReqQualificationTypeId"] = this.preReqQualificationTypeId;
        data["firstCompletionDate"] = this.firstCompletionDate ? this.firstCompletionDate.toISOString() : <any>undefined;
        data["gracePeriodQualification"] = this.gracePeriodQualification;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface ICaregiverRoleTypeQualification {
    id?: number | undefined;
    qualificationRoleTypeId?: number;
    qualificationRoleType?: string | undefined;
    qualificationTypeId?: number;
    qualificationType?: string | undefined;
    qualificationCategory?: string | undefined;
    isActive?: boolean;
    isRecurring?: boolean;
    serviceCode?: string | undefined;
    expirationType?: string | undefined;
    expirationDays?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    hasPreReq?: boolean;
    hasSubRule?: boolean;
    preReqQualificationType?: string | undefined;
    preReqQualificationTypeId?: number;
    firstCompletionDate?: Date | undefined;
    gracePeriodQualification?: string | undefined;
    sequence?: number | undefined;
}

export class CaregiverRoleTypeQualificationList implements ICaregiverRoleTypeQualificationList {
    caregiverRoleTypeQualifications?: CaregiverRoleTypeQualification[] | undefined;
    caregiverRoleTypePrereqSubRules?: CaregiverRoleTypePrereqSubRule[] | undefined;

    constructor(data?: ICaregiverRoleTypeQualificationList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["caregiverRoleTypeQualifications"])) {
                this.caregiverRoleTypeQualifications = [] as any;
                for (let item of _data["caregiverRoleTypeQualifications"])
                    this.caregiverRoleTypeQualifications!.push(CaregiverRoleTypeQualification.fromJS(item));
            }
            if (Array.isArray(_data["caregiverRoleTypePrereqSubRules"])) {
                this.caregiverRoleTypePrereqSubRules = [] as any;
                for (let item of _data["caregiverRoleTypePrereqSubRules"])
                    this.caregiverRoleTypePrereqSubRules!.push(CaregiverRoleTypePrereqSubRule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaregiverRoleTypeQualificationList {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverRoleTypeQualificationList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.caregiverRoleTypeQualifications)) {
            data["caregiverRoleTypeQualifications"] = [];
            for (let item of this.caregiverRoleTypeQualifications)
                data["caregiverRoleTypeQualifications"].push(item.toJSON());
        }
        if (Array.isArray(this.caregiverRoleTypePrereqSubRules)) {
            data["caregiverRoleTypePrereqSubRules"] = [];
            for (let item of this.caregiverRoleTypePrereqSubRules)
                data["caregiverRoleTypePrereqSubRules"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICaregiverRoleTypeQualificationList {
    caregiverRoleTypeQualifications?: CaregiverRoleTypeQualification[] | undefined;
    caregiverRoleTypePrereqSubRules?: CaregiverRoleTypePrereqSubRule[] | undefined;
}

export class CaregiverWWL implements ICaregiverWWL {
    caregiverWWLId?: number;
    companyId?: number;
    caregiverEmployerMappingId?: number;
    workWeekLimit?: number;
    limitStartDate?: Date;
    limitEndDate?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
    isDeleted?: boolean;

    constructor(data?: ICaregiverWWL) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverWWLId = _data["caregiverWWLId"];
            this.companyId = _data["companyId"];
            this.caregiverEmployerMappingId = _data["caregiverEmployerMappingId"];
            this.workWeekLimit = _data["workWeekLimit"];
            this.limitStartDate = _data["limitStartDate"] ? new Date(_data["limitStartDate"].toString()) : <any>undefined;
            this.limitEndDate = _data["limitEndDate"] ? new Date(_data["limitEndDate"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CaregiverWWL {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverWWL();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverWWLId"] = this.caregiverWWLId;
        data["companyId"] = this.companyId;
        data["caregiverEmployerMappingId"] = this.caregiverEmployerMappingId;
        data["workWeekLimit"] = this.workWeekLimit;
        data["limitStartDate"] = this.limitStartDate ? this.limitStartDate.toISOString() : <any>undefined;
        data["limitEndDate"] = this.limitEndDate ? this.limitEndDate.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ICaregiverWWL {
    caregiverWWLId?: number;
    companyId?: number;
    caregiverEmployerMappingId?: number;
    workWeekLimit?: number;
    limitStartDate?: Date;
    limitEndDate?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
    isDeleted?: boolean;
}

export class CaregiverWWLByEmployerRequest implements ICaregiverWWLByEmployerRequest {
    caregiverId?: string | undefined;
    employerUniqueId?: string | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: ICaregiverWWLByEmployerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.employerUniqueId = _data["employerUniqueId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CaregiverWWLByEmployerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverWWLByEmployerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["employerUniqueId"] = this.employerUniqueId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICaregiverWWLByEmployerRequest {
    caregiverId?: string | undefined;
    employerUniqueId?: string | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class CaregiverWWLListRequest implements ICaregiverWWLListRequest {
    caregiverWWLs?: CaregiverWWL[] | undefined;
    permanentWWL?: number | undefined;
    caregiverEmployerMappingId?: number;

    constructor(data?: ICaregiverWWLListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["caregiverWWLs"])) {
                this.caregiverWWLs = [] as any;
                for (let item of _data["caregiverWWLs"])
                    this.caregiverWWLs!.push(CaregiverWWL.fromJS(item));
            }
            this.permanentWWL = _data["permanentWWL"];
            this.caregiverEmployerMappingId = _data["caregiverEmployerMappingId"];
        }
    }

    static fromJS(data: any): CaregiverWWLListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverWWLListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.caregiverWWLs)) {
            data["caregiverWWLs"] = [];
            for (let item of this.caregiverWWLs)
                data["caregiverWWLs"].push(item.toJSON());
        }
        data["permanentWWL"] = this.permanentWWL;
        data["caregiverEmployerMappingId"] = this.caregiverEmployerMappingId;
        return data;
    }
}

export interface ICaregiverWWLListRequest {
    caregiverWWLs?: CaregiverWWL[] | undefined;
    permanentWWL?: number | undefined;
    caregiverEmployerMappingId?: number;
}

export class CaregiverWWLListResponse implements ICaregiverWWLListResponse {
    caregiverWWLs?: CaregiverWWL[] | undefined;
    permanentWWL?: number | undefined;
    caregiverId?: string | undefined;

    constructor(data?: ICaregiverWWLListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["caregiverWWLs"])) {
                this.caregiverWWLs = [] as any;
                for (let item of _data["caregiverWWLs"])
                    this.caregiverWWLs!.push(CaregiverWWL.fromJS(item));
            }
            this.permanentWWL = _data["permanentWWL"];
            this.caregiverId = _data["caregiverId"];
        }
    }

    static fromJS(data: any): CaregiverWWLListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverWWLListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.caregiverWWLs)) {
            data["caregiverWWLs"] = [];
            for (let item of this.caregiverWWLs)
                data["caregiverWWLs"].push(item.toJSON());
        }
        data["permanentWWL"] = this.permanentWWL;
        data["caregiverId"] = this.caregiverId;
        return data;
    }
}

export interface ICaregiverWWLListResponse {
    caregiverWWLs?: CaregiverWWL[] | undefined;
    permanentWWL?: number | undefined;
    caregiverId?: string | undefined;
}

export class CaregiverWeeklyWWL implements ICaregiverWeeklyWWL {
    wwlHours?: number;
    calendarDate?: Date;

    constructor(data?: ICaregiverWeeklyWWL) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wwlHours = _data["wwlHours"];
            this.calendarDate = _data["calendarDate"] ? new Date(_data["calendarDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CaregiverWeeklyWWL {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverWeeklyWWL();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wwlHours"] = this.wwlHours;
        data["calendarDate"] = this.calendarDate ? this.calendarDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICaregiverWeeklyWWL {
    wwlHours?: number;
    calendarDate?: Date;
}

export class CaseLoadParticipant implements ICaseLoadParticipant {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    personId?: string | undefined;
    name?: string | undefined;
    participantId?: number;

    constructor(data?: ICaseLoadParticipant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.personId = _data["personId"];
            this.name = _data["name"];
            this.participantId = _data["participantId"];
        }
    }

    static fromJS(data: any): CaseLoadParticipant {
        data = typeof data === 'object' ? data : {};
        let result = new CaseLoadParticipant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["personId"] = this.personId;
        data["name"] = this.name;
        data["participantId"] = this.participantId;
        return data;
    }
}

export interface ICaseLoadParticipant {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    personId?: string | undefined;
    name?: string | undefined;
    participantId?: number;
}

export class CaseLoadParticipantGridResponseBase implements ICaseLoadParticipantGridResponseBase {
    items?: CaseLoadParticipant[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CaseLoadParticipant;

    constructor(data?: ICaseLoadParticipantGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CaseLoadParticipant.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? CaseLoadParticipant.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CaseLoadParticipantGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new CaseLoadParticipantGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICaseLoadParticipantGridResponseBase {
    items?: CaseLoadParticipant[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CaseLoadParticipant;
}

export class CaseManagerDTO implements ICaseManagerDTO {
    personStatus?: string | undefined;
    id?: number;
    personId?: string | undefined;
    status?: PeopleStatus;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    statusChangeReason?: string | undefined;
    ssn?: string | undefined;
    maritalStatus?: string | undefined;
    personStatusHistories?: PersonStatusHistory[] | undefined;
    caseManagerId?: number | undefined;
    solomonCaseManagerId?: string | undefined;

    constructor(data?: ICaseManagerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personStatus = _data["personStatus"];
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.status = _data["status"];
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.statusChangeReason = _data["statusChangeReason"];
            this.ssn = _data["ssn"];
            this.maritalStatus = _data["maritalStatus"];
            if (Array.isArray(_data["personStatusHistories"])) {
                this.personStatusHistories = [] as any;
                for (let item of _data["personStatusHistories"])
                    this.personStatusHistories!.push(PersonStatusHistory.fromJS(item));
            }
            this.caseManagerId = _data["caseManagerId"];
            this.solomonCaseManagerId = _data["solomonCaseManagerId"];
        }
    }

    static fromJS(data: any): CaseManagerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CaseManagerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personStatus"] = this.personStatus;
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["status"] = this.status;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["statusChangeReason"] = this.statusChangeReason;
        data["ssn"] = this.ssn;
        data["maritalStatus"] = this.maritalStatus;
        if (Array.isArray(this.personStatusHistories)) {
            data["personStatusHistories"] = [];
            for (let item of this.personStatusHistories)
                data["personStatusHistories"].push(item.toJSON());
        }
        data["caseManagerId"] = this.caseManagerId;
        data["solomonCaseManagerId"] = this.solomonCaseManagerId;
        return data;
    }
}

export interface ICaseManagerDTO {
    personStatus?: string | undefined;
    id?: number;
    personId?: string | undefined;
    status?: PeopleStatus;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    statusChangeReason?: string | undefined;
    ssn?: string | undefined;
    maritalStatus?: string | undefined;
    personStatusHistories?: PersonStatusHistory[] | undefined;
    caseManagerId?: number | undefined;
    solomonCaseManagerId?: string | undefined;
}

export class CaseManagerLkp implements ICaseManagerLkp {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    caseManagerPersonId?: number;
    caseManagerName?: string | undefined;
    caseManagerId?: number;

    constructor(data?: ICaseManagerLkp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.caseManagerPersonId = _data["caseManagerPersonId"];
            this.caseManagerName = _data["caseManagerName"];
            this.caseManagerId = _data["caseManagerId"];
        }
    }

    static fromJS(data: any): CaseManagerLkp {
        data = typeof data === 'object' ? data : {};
        let result = new CaseManagerLkp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["caseManagerPersonId"] = this.caseManagerPersonId;
        data["caseManagerName"] = this.caseManagerName;
        data["caseManagerId"] = this.caseManagerId;
        return data;
    }
}

export interface ICaseManagerLkp {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    caseManagerPersonId?: number;
    caseManagerName?: string | undefined;
    caseManagerId?: number;
}

export class CaseManagerLkpGridResponseBase implements ICaseManagerLkpGridResponseBase {
    items?: CaseManagerLkp[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CaseManagerLkp;

    constructor(data?: ICaseManagerLkpGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CaseManagerLkp.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? CaseManagerLkp.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CaseManagerLkpGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new CaseManagerLkpGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICaseManagerLkpGridResponseBase {
    items?: CaseManagerLkp[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CaseManagerLkp;
}

export class CaseManagerParticipantRelDto implements ICaseManagerParticipantRelDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    caseManagerAuthMappingId?: number;
    caseManagerName?: string | undefined;
    personId?: string | undefined;
    caseManagerId?: number;
    participantId?: number;
    authExternalId?: string | undefined;
    beginDate?: Date;
    endDate?: Date;

    constructor(data?: ICaseManagerParticipantRelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.caseManagerAuthMappingId = _data["caseManagerAuthMappingId"];
            this.caseManagerName = _data["caseManagerName"];
            this.personId = _data["personId"];
            this.caseManagerId = _data["caseManagerId"];
            this.participantId = _data["participantId"];
            this.authExternalId = _data["authExternalId"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CaseManagerParticipantRelDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseManagerParticipantRelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["caseManagerAuthMappingId"] = this.caseManagerAuthMappingId;
        data["caseManagerName"] = this.caseManagerName;
        data["personId"] = this.personId;
        data["caseManagerId"] = this.caseManagerId;
        data["participantId"] = this.participantId;
        data["authExternalId"] = this.authExternalId;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICaseManagerParticipantRelDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    caseManagerAuthMappingId?: number;
    caseManagerName?: string | undefined;
    personId?: string | undefined;
    caseManagerId?: number;
    participantId?: number;
    authExternalId?: string | undefined;
    beginDate?: Date;
    endDate?: Date;
}

export class CaseManagerParticipantRelDtoGridResponseBase implements ICaseManagerParticipantRelDtoGridResponseBase {
    items?: CaseManagerParticipantRelDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CaseManagerParticipantRelDto;

    constructor(data?: ICaseManagerParticipantRelDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CaseManagerParticipantRelDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? CaseManagerParticipantRelDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CaseManagerParticipantRelDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new CaseManagerParticipantRelDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICaseManagerParticipantRelDtoGridResponseBase {
    items?: CaseManagerParticipantRelDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CaseManagerParticipantRelDto;
}

export class CaseManagerProfileDetails implements ICaseManagerProfileDetails {
    phoneDetails?: PhoneDetail[] | undefined;
    physicalAddresses?: AddressDTO[] | undefined;
    mailingAddresses?: AddressDTO[] | undefined;
    ivrAddresses?: AddressDTO[] | undefined;
    externalKeys?: ExternalKeyDTO[] | undefined;
    id?: number;
    personId?: string | undefined;
    status?: string | undefined;
    readonly personName?: string | undefined;
    ssn?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    physicalAddress?: string | undefined;
    mailingAddress?: string | undefined;
    ivrAddress?: string | undefined;
    companyCode?: string | undefined;
    unmaskedSsn?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    ivrPin?: string | undefined;
    paymentMethod?: string | undefined;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    coordinatorPersonFirstName?: string | undefined;
    coordinatorPersonLastName?: string | undefined;
    coordinatorPersonName?: string | undefined;
    lastV4LoginOn?: Date | undefined;
    isSsnValidated?: boolean | undefined;
    ssnValidationOverrideOn?: Date | undefined;
    ssnValidationOverrideBy?: string | undefined;
    caseManagerId?: number;
    solomonId?: string | undefined;

    constructor(data?: ICaseManagerProfileDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["phoneDetails"])) {
                this.phoneDetails = [] as any;
                for (let item of _data["phoneDetails"])
                    this.phoneDetails!.push(PhoneDetail.fromJS(item));
            }
            if (Array.isArray(_data["physicalAddresses"])) {
                this.physicalAddresses = [] as any;
                for (let item of _data["physicalAddresses"])
                    this.physicalAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["mailingAddresses"])) {
                this.mailingAddresses = [] as any;
                for (let item of _data["mailingAddresses"])
                    this.mailingAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["ivrAddresses"])) {
                this.ivrAddresses = [] as any;
                for (let item of _data["ivrAddresses"])
                    this.ivrAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["externalKeys"])) {
                this.externalKeys = [] as any;
                for (let item of _data["externalKeys"])
                    this.externalKeys!.push(ExternalKeyDTO.fromJS(item));
            }
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.status = _data["status"];
            (<any>this).personName = _data["personName"];
            this.ssn = _data["ssn"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.gender = _data["gender"];
            this.ethnicity = _data["ethnicity"];
            this.race = _data["race"];
            this.maritalStatus = _data["maritalStatus"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.physicalAddress = _data["physicalAddress"];
            this.mailingAddress = _data["mailingAddress"];
            this.ivrAddress = _data["ivrAddress"];
            this.companyCode = _data["companyCode"];
            this.unmaskedSsn = _data["unmaskedSsn"];
            this.onboarded = _data["onboarded"];
            this.isFirstLoginComplete = _data["isFirstLoginComplete"];
            this.ivrPin = _data["ivrPin"];
            this.paymentMethod = _data["paymentMethod"];
            this.coordinatorPersonId = _data["coordinatorPersonId"];
            this.internalUserObjectId = _data["internalUserObjectId"];
            this.coordinatorPersonFirstName = _data["coordinatorPersonFirstName"];
            this.coordinatorPersonLastName = _data["coordinatorPersonLastName"];
            this.coordinatorPersonName = _data["coordinatorPersonName"];
            this.lastV4LoginOn = _data["lastV4LoginOn"] ? new Date(_data["lastV4LoginOn"].toString()) : <any>undefined;
            this.isSsnValidated = _data["isSsnValidated"];
            this.ssnValidationOverrideOn = _data["ssnValidationOverrideOn"] ? new Date(_data["ssnValidationOverrideOn"].toString()) : <any>undefined;
            this.ssnValidationOverrideBy = _data["ssnValidationOverrideBy"];
            this.caseManagerId = _data["caseManagerId"];
            this.solomonId = _data["solomonId"];
        }
    }

    static fromJS(data: any): CaseManagerProfileDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CaseManagerProfileDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phoneDetails)) {
            data["phoneDetails"] = [];
            for (let item of this.phoneDetails)
                data["phoneDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.physicalAddresses)) {
            data["physicalAddresses"] = [];
            for (let item of this.physicalAddresses)
                data["physicalAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.mailingAddresses)) {
            data["mailingAddresses"] = [];
            for (let item of this.mailingAddresses)
                data["mailingAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.ivrAddresses)) {
            data["ivrAddresses"] = [];
            for (let item of this.ivrAddresses)
                data["ivrAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.externalKeys)) {
            data["externalKeys"] = [];
            for (let item of this.externalKeys)
                data["externalKeys"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["status"] = this.status;
        data["personName"] = this.personName;
        data["ssn"] = this.ssn;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["gender"] = this.gender;
        data["ethnicity"] = this.ethnicity;
        data["race"] = this.race;
        data["maritalStatus"] = this.maritalStatus;
        data["preferredLanguage"] = this.preferredLanguage;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["physicalAddress"] = this.physicalAddress;
        data["mailingAddress"] = this.mailingAddress;
        data["ivrAddress"] = this.ivrAddress;
        data["companyCode"] = this.companyCode;
        data["unmaskedSsn"] = this.unmaskedSsn;
        data["onboarded"] = this.onboarded;
        data["isFirstLoginComplete"] = this.isFirstLoginComplete;
        data["ivrPin"] = this.ivrPin;
        data["paymentMethod"] = this.paymentMethod;
        data["coordinatorPersonId"] = this.coordinatorPersonId;
        data["internalUserObjectId"] = this.internalUserObjectId;
        data["coordinatorPersonFirstName"] = this.coordinatorPersonFirstName;
        data["coordinatorPersonLastName"] = this.coordinatorPersonLastName;
        data["coordinatorPersonName"] = this.coordinatorPersonName;
        data["lastV4LoginOn"] = this.lastV4LoginOn ? this.lastV4LoginOn.toISOString() : <any>undefined;
        data["isSsnValidated"] = this.isSsnValidated;
        data["ssnValidationOverrideOn"] = this.ssnValidationOverrideOn ? this.ssnValidationOverrideOn.toISOString() : <any>undefined;
        data["ssnValidationOverrideBy"] = this.ssnValidationOverrideBy;
        data["caseManagerId"] = this.caseManagerId;
        data["solomonId"] = this.solomonId;
        return data;
    }
}

export interface ICaseManagerProfileDetails {
    phoneDetails?: PhoneDetail[] | undefined;
    physicalAddresses?: AddressDTO[] | undefined;
    mailingAddresses?: AddressDTO[] | undefined;
    ivrAddresses?: AddressDTO[] | undefined;
    externalKeys?: ExternalKeyDTO[] | undefined;
    id?: number;
    personId?: string | undefined;
    status?: string | undefined;
    personName?: string | undefined;
    ssn?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    physicalAddress?: string | undefined;
    mailingAddress?: string | undefined;
    ivrAddress?: string | undefined;
    companyCode?: string | undefined;
    unmaskedSsn?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    ivrPin?: string | undefined;
    paymentMethod?: string | undefined;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    coordinatorPersonFirstName?: string | undefined;
    coordinatorPersonLastName?: string | undefined;
    coordinatorPersonName?: string | undefined;
    lastV4LoginOn?: Date | undefined;
    isSsnValidated?: boolean | undefined;
    ssnValidationOverrideOn?: Date | undefined;
    ssnValidationOverrideBy?: string | undefined;
    caseManagerId?: number;
    solomonId?: string | undefined;
}

export class CchDetails implements ICchDetails {
    shiftType?: string | undefined;
    hours?: number;
    logDate?: Date;
    cchEligible?: string | undefined;
    cch?: number;
    updatedOn?: Date;
    tcn?: string | undefined;

    constructor(data?: ICchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftType = _data["shiftType"];
            this.hours = _data["hours"];
            this.logDate = _data["logDate"] ? new Date(_data["logDate"].toString()) : <any>undefined;
            this.cchEligible = _data["cchEligible"];
            this.cch = _data["cch"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.tcn = _data["tcn"];
        }
    }

    static fromJS(data: any): CchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftType"] = this.shiftType;
        data["hours"] = this.hours;
        data["logDate"] = this.logDate ? this.logDate.toISOString() : <any>undefined;
        data["cchEligible"] = this.cchEligible;
        data["cch"] = this.cch;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["tcn"] = this.tcn;
        return data;
    }
}

export interface ICchDetails {
    shiftType?: string | undefined;
    hours?: number;
    logDate?: Date;
    cchEligible?: string | undefined;
    cch?: number;
    updatedOn?: Date;
    tcn?: string | undefined;
}

export class CchDetailsGridResponseBase implements ICchDetailsGridResponseBase {
    items?: CchDetails[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CchDetails;

    constructor(data?: ICchDetailsGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CchDetails.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? CchDetails.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CchDetailsGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new CchDetailsGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICchDetailsGridResponseBase {
    items?: CchDetails[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CchDetails;
}

export class CoPayListRequest implements ICoPayListRequest {
    coPayRequests?: CoPayRequest[] | undefined;
    participantPersonId?: string | undefined;

    constructor(data?: ICoPayListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["coPayRequests"])) {
                this.coPayRequests = [] as any;
                for (let item of _data["coPayRequests"])
                    this.coPayRequests!.push(CoPayRequest.fromJS(item));
            }
            this.participantPersonId = _data["participantPersonId"];
        }
    }

    static fromJS(data: any): CoPayListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CoPayListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.coPayRequests)) {
            data["coPayRequests"] = [];
            for (let item of this.coPayRequests)
                data["coPayRequests"].push(item.toJSON());
        }
        data["participantPersonId"] = this.participantPersonId;
        return data;
    }
}

export interface ICoPayListRequest {
    coPayRequests?: CoPayRequest[] | undefined;
    participantPersonId?: string | undefined;
}

export class CoPayRequest implements ICoPayRequest {
    patientPaySummaryID?: number;
    companyId?: number;
    serviceCode?: string | undefined;
    transactionDate?: Date;
    amount?: number;

    constructor(data?: ICoPayRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientPaySummaryID = _data["patientPaySummaryID"];
            this.companyId = _data["companyId"];
            this.serviceCode = _data["serviceCode"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): CoPayRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CoPayRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientPaySummaryID"] = this.patientPaySummaryID;
        data["companyId"] = this.companyId;
        data["serviceCode"] = this.serviceCode;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        return data;
    }
}

export interface ICoPayRequest {
    patientPaySummaryID?: number;
    companyId?: number;
    serviceCode?: string | undefined;
    transactionDate?: Date;
    amount?: number;
}

export class ColumnLevelChangeHistoryBase implements IColumnLevelChangeHistoryBase {
    previousColumnValue?: string | undefined;
    currentColumnValue?: string | undefined;
    columnName?: string | undefined;

    constructor(data?: IColumnLevelChangeHistoryBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.previousColumnValue = _data["previousColumnValue"];
            this.currentColumnValue = _data["currentColumnValue"];
            this.columnName = _data["columnName"];
        }
    }

    static fromJS(data: any): ColumnLevelChangeHistoryBase {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnLevelChangeHistoryBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["previousColumnValue"] = this.previousColumnValue;
        data["currentColumnValue"] = this.currentColumnValue;
        data["columnName"] = this.columnName;
        return data;
    }
}

export interface IColumnLevelChangeHistoryBase {
    previousColumnValue?: string | undefined;
    currentColumnValue?: string | undefined;
    columnName?: string | undefined;
}

export class ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase implements IColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase {
    readonly columnLevelChangeHistory?: ColumnLevelChangeHistoryBase[] | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;

    constructor(data?: IColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columnLevelChangeHistory"])) {
                (<any>this).columnLevelChangeHistory = [] as any;
                for (let item of _data["columnLevelChangeHistory"])
                    (<any>this).columnLevelChangeHistory!.push(ColumnLevelChangeHistoryBase.fromJS(item));
            }
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columnLevelChangeHistory)) {
            data["columnLevelChangeHistory"] = [];
            for (let item of this.columnLevelChangeHistory)
                data["columnLevelChangeHistory"].push(item.toJSON());
        }
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IColumnLevelChangeHistoryBaseSqlColumnLevelChangeHistoryBase {
    columnLevelChangeHistory?: ColumnLevelChangeHistoryBase[] | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
}

export class CommunicationEmailRequest implements ICommunicationEmailRequest {
    communicationEmail?: string | undefined;
    personId?: string | undefined;
    isDelete?: boolean;
    communicationEmailId?: number | undefined;

    constructor(data?: ICommunicationEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.communicationEmail = _data["communicationEmail"];
            this.personId = _data["personId"];
            this.isDelete = _data["isDelete"];
            this.communicationEmailId = _data["communicationEmailId"];
        }
    }

    static fromJS(data: any): CommunicationEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["communicationEmail"] = this.communicationEmail;
        data["personId"] = this.personId;
        data["isDelete"] = this.isDelete;
        data["communicationEmailId"] = this.communicationEmailId;
        return data;
    }
}

export interface ICommunicationEmailRequest {
    communicationEmail?: string | undefined;
    personId?: string | undefined;
    isDelete?: boolean;
    communicationEmailId?: number | undefined;
}

export class CommunicationEmailsHistoryResponse implements ICommunicationEmailsHistoryResponse {
    email?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ICommunicationEmailsHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): CommunicationEmailsHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationEmailsHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ICommunicationEmailsHistoryResponse {
    email?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class CommunicationEmailsResponse implements ICommunicationEmailsResponse {
    id?: string | undefined;
    email?: string | undefined;

    constructor(data?: ICommunicationEmailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CommunicationEmailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationEmailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        return data;
    }
}

export interface ICommunicationEmailsResponse {
    id?: string | undefined;
    email?: string | undefined;
}

export class CommunicationEmailsResponseIEnumerableApiResponse implements ICommunicationEmailsResponseIEnumerableApiResponse {
    message?: string | undefined;
    data?: CommunicationEmailsResponse[] | undefined;
    success?: boolean;

    constructor(data?: ICommunicationEmailsResponseIEnumerableApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CommunicationEmailsResponse.fromJS(item));
            }
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): CommunicationEmailsResponseIEnumerableApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationEmailsResponseIEnumerableApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["success"] = this.success;
        return data;
    }
}

export interface ICommunicationEmailsResponseIEnumerableApiResponse {
    message?: string | undefined;
    data?: CommunicationEmailsResponse[] | undefined;
    success?: boolean;
}

export class ComponentDetails implements IComponentDetails {
    componentId?: number;
    componentCode?: string | undefined;
    componentDetailId?: number;
    componentText?: string | undefined;
    componentType?: string | undefined;
    options?: OptionDetails[] | undefined;
    order?: number;

    constructor(data?: IComponentDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.componentCode = _data["componentCode"];
            this.componentDetailId = _data["componentDetailId"];
            this.componentText = _data["componentText"];
            this.componentType = _data["componentType"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(OptionDetails.fromJS(item));
            }
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): ComponentDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["componentCode"] = this.componentCode;
        data["componentDetailId"] = this.componentDetailId;
        data["componentText"] = this.componentText;
        data["componentType"] = this.componentType;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        data["order"] = this.order;
        return data;
    }
}

export interface IComponentDetails {
    componentId?: number;
    componentCode?: string | undefined;
    componentDetailId?: number;
    componentText?: string | undefined;
    componentType?: string | undefined;
    options?: OptionDetails[] | undefined;
    order?: number;
}

export class CourseDto implements ICourseDto {
    courseCodeId?: number;
    courseName?: string | undefined;
    courseCode?: string | undefined;

    constructor(data?: ICourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseCodeId = _data["courseCodeId"];
            this.courseName = _data["courseName"];
            this.courseCode = _data["courseCode"];
        }
    }

    static fromJS(data: any): CourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseCodeId"] = this.courseCodeId;
        data["courseName"] = this.courseName;
        data["courseCode"] = this.courseCode;
        return data;
    }
}

export interface ICourseDto {
    courseCodeId?: number;
    courseName?: string | undefined;
    courseCode?: string | undefined;
}

export class CredentialStatusTypeMapping implements ICredentialStatusTypeMapping {
    credentialStatusTypeMappingId?: number;
    credentialStatusId?: number;
    credentialStatusCode?: string | undefined;
    credentialStatusTypeCode?: string | undefined;
    credentialStatusTypeId?: number;

    constructor(data?: ICredentialStatusTypeMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.credentialStatusTypeMappingId = _data["credentialStatusTypeMappingId"];
            this.credentialStatusId = _data["credentialStatusId"];
            this.credentialStatusCode = _data["credentialStatusCode"];
            this.credentialStatusTypeCode = _data["credentialStatusTypeCode"];
            this.credentialStatusTypeId = _data["credentialStatusTypeId"];
        }
    }

    static fromJS(data: any): CredentialStatusTypeMapping {
        data = typeof data === 'object' ? data : {};
        let result = new CredentialStatusTypeMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["credentialStatusTypeMappingId"] = this.credentialStatusTypeMappingId;
        data["credentialStatusId"] = this.credentialStatusId;
        data["credentialStatusCode"] = this.credentialStatusCode;
        data["credentialStatusTypeCode"] = this.credentialStatusTypeCode;
        data["credentialStatusTypeId"] = this.credentialStatusTypeId;
        return data;
    }
}

export interface ICredentialStatusTypeMapping {
    credentialStatusTypeMappingId?: number;
    credentialStatusId?: number;
    credentialStatusCode?: string | undefined;
    credentialStatusTypeCode?: string | undefined;
    credentialStatusTypeId?: number;
}

export class CustEmpParticipant implements ICustEmpParticipant {
    custId?: string | undefined;
    employeeCount?: number;
    empIDs?: number[] | undefined;
    employees?: boolean[] | undefined;
    authServiceCodes?: boolean | undefined;
    nameFirst?: string | undefined;
    nameMiddle?: string | undefined;
    nameLast?: string | undefined;
    nameFull?: string | undefined;
    labelName?: string | undefined;
    residenceState?: string | undefined;
    status?: string | undefined;

    constructor(data?: ICustEmpParticipant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.custId = _data["custId"];
            this.employeeCount = _data["employeeCount"];
            if (Array.isArray(_data["empIDs"])) {
                this.empIDs = [] as any;
                for (let item of _data["empIDs"])
                    this.empIDs!.push(item);
            }
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(item);
            }
            this.authServiceCodes = _data["authServiceCodes"];
            this.nameFirst = _data["nameFirst"];
            this.nameMiddle = _data["nameMiddle"];
            this.nameLast = _data["nameLast"];
            this.nameFull = _data["nameFull"];
            this.labelName = _data["labelName"];
            this.residenceState = _data["residenceState"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CustEmpParticipant {
        data = typeof data === 'object' ? data : {};
        let result = new CustEmpParticipant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["custId"] = this.custId;
        data["employeeCount"] = this.employeeCount;
        if (Array.isArray(this.empIDs)) {
            data["empIDs"] = [];
            for (let item of this.empIDs)
                data["empIDs"].push(item);
        }
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item);
        }
        data["authServiceCodes"] = this.authServiceCodes;
        data["nameFirst"] = this.nameFirst;
        data["nameMiddle"] = this.nameMiddle;
        data["nameLast"] = this.nameLast;
        data["nameFull"] = this.nameFull;
        data["labelName"] = this.labelName;
        data["residenceState"] = this.residenceState;
        data["status"] = this.status;
        return data;
    }
}

export interface ICustEmpParticipant {
    custId?: string | undefined;
    employeeCount?: number;
    empIDs?: number[] | undefined;
    employees?: boolean[] | undefined;
    authServiceCodes?: boolean | undefined;
    nameFirst?: string | undefined;
    nameMiddle?: string | undefined;
    nameLast?: string | undefined;
    nameFull?: string | undefined;
    labelName?: string | undefined;
    residenceState?: string | undefined;
    status?: string | undefined;
}

export class CustEmpRelByIdResponseDto implements ICustEmpRelByIdResponseDto {
    id?: number;
    custId?: string | undefined;
    customerName?: string | undefined;
    custUId?: number;
    empId?: string | undefined;
    employeeName?: string | undefined;
    empUId?: number;
    birthDate?: Date | undefined;
    relationshipId?: number;
    status?: string | undefined;
    qualificationRoleTypeId?: number | undefined;
    qualificationRoleTypeName?: string | undefined;
    custEmpServiceTypeByIds?: CustEmpServiceTypeByIdDto[] | undefined;
    readonly exemptions?: ExemptionDto[] | undefined;
    readonly statusDateRanges?: DateRangeDto[] | undefined;
    readonly liveInDateRanges?: DateRangeDto[] | undefined;
    caregiverRelationshipConfirmation?: AttestationStatus;
    readonly caregiverRelationshipConfirmationText?: string | undefined;
    caregiverDifficultyOfCareConfirmation?: AttestationStatus;
    readonly caregiverDifficultyOfCareConfirmationText?: string | undefined;
    caregiverFICAConfirmation?: AttestationStatus;
    readonly caregiverFICAConfirmationText?: string | undefined;
    caregiverLEConfirmation?: AttestationStatus;
    readonly caregiverLEConfirmationText?: string | undefined;
    isAuthRepresentative?: boolean;
    attestRelationDescription?: string | undefined;
    testAuthEndDate?: Date | undefined;

    constructor(data?: ICustEmpRelByIdResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.custId = _data["custId"];
            this.customerName = _data["customerName"];
            this.custUId = _data["custUId"];
            this.empId = _data["empId"];
            this.employeeName = _data["employeeName"];
            this.empUId = _data["empUId"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.relationshipId = _data["relationshipId"];
            this.status = _data["status"];
            this.qualificationRoleTypeId = _data["qualificationRoleTypeId"];
            this.qualificationRoleTypeName = _data["qualificationRoleTypeName"];
            if (Array.isArray(_data["custEmpServiceTypeByIds"])) {
                this.custEmpServiceTypeByIds = [] as any;
                for (let item of _data["custEmpServiceTypeByIds"])
                    this.custEmpServiceTypeByIds!.push(CustEmpServiceTypeByIdDto.fromJS(item));
            }
            if (Array.isArray(_data["exemptions"])) {
                (<any>this).exemptions = [] as any;
                for (let item of _data["exemptions"])
                    (<any>this).exemptions!.push(ExemptionDto.fromJS(item));
            }
            if (Array.isArray(_data["statusDateRanges"])) {
                (<any>this).statusDateRanges = [] as any;
                for (let item of _data["statusDateRanges"])
                    (<any>this).statusDateRanges!.push(DateRangeDto.fromJS(item));
            }
            if (Array.isArray(_data["liveInDateRanges"])) {
                (<any>this).liveInDateRanges = [] as any;
                for (let item of _data["liveInDateRanges"])
                    (<any>this).liveInDateRanges!.push(DateRangeDto.fromJS(item));
            }
            this.caregiverRelationshipConfirmation = _data["caregiverRelationshipConfirmation"];
            (<any>this).caregiverRelationshipConfirmationText = _data["caregiverRelationshipConfirmationText"];
            this.caregiverDifficultyOfCareConfirmation = _data["caregiverDifficultyOfCareConfirmation"];
            (<any>this).caregiverDifficultyOfCareConfirmationText = _data["caregiverDifficultyOfCareConfirmationText"];
            this.caregiverFICAConfirmation = _data["caregiverFICAConfirmation"];
            (<any>this).caregiverFICAConfirmationText = _data["caregiverFICAConfirmationText"];
            this.caregiverLEConfirmation = _data["caregiverLEConfirmation"];
            (<any>this).caregiverLEConfirmationText = _data["caregiverLEConfirmationText"];
            this.isAuthRepresentative = _data["isAuthRepresentative"];
            this.attestRelationDescription = _data["attestRelationDescription"];
            this.testAuthEndDate = _data["testAuthEndDate"] ? new Date(_data["testAuthEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustEmpRelByIdResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustEmpRelByIdResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["custId"] = this.custId;
        data["customerName"] = this.customerName;
        data["custUId"] = this.custUId;
        data["empId"] = this.empId;
        data["employeeName"] = this.employeeName;
        data["empUId"] = this.empUId;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["relationshipId"] = this.relationshipId;
        data["status"] = this.status;
        data["qualificationRoleTypeId"] = this.qualificationRoleTypeId;
        data["qualificationRoleTypeName"] = this.qualificationRoleTypeName;
        if (Array.isArray(this.custEmpServiceTypeByIds)) {
            data["custEmpServiceTypeByIds"] = [];
            for (let item of this.custEmpServiceTypeByIds)
                data["custEmpServiceTypeByIds"].push(item.toJSON());
        }
        if (Array.isArray(this.exemptions)) {
            data["exemptions"] = [];
            for (let item of this.exemptions)
                data["exemptions"].push(item.toJSON());
        }
        if (Array.isArray(this.statusDateRanges)) {
            data["statusDateRanges"] = [];
            for (let item of this.statusDateRanges)
                data["statusDateRanges"].push(item.toJSON());
        }
        if (Array.isArray(this.liveInDateRanges)) {
            data["liveInDateRanges"] = [];
            for (let item of this.liveInDateRanges)
                data["liveInDateRanges"].push(item.toJSON());
        }
        data["caregiverRelationshipConfirmation"] = this.caregiverRelationshipConfirmation;
        data["caregiverRelationshipConfirmationText"] = this.caregiverRelationshipConfirmationText;
        data["caregiverDifficultyOfCareConfirmation"] = this.caregiverDifficultyOfCareConfirmation;
        data["caregiverDifficultyOfCareConfirmationText"] = this.caregiverDifficultyOfCareConfirmationText;
        data["caregiverFICAConfirmation"] = this.caregiverFICAConfirmation;
        data["caregiverFICAConfirmationText"] = this.caregiverFICAConfirmationText;
        data["caregiverLEConfirmation"] = this.caregiverLEConfirmation;
        data["caregiverLEConfirmationText"] = this.caregiverLEConfirmationText;
        data["isAuthRepresentative"] = this.isAuthRepresentative;
        data["attestRelationDescription"] = this.attestRelationDescription;
        data["testAuthEndDate"] = this.testAuthEndDate ? this.testAuthEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICustEmpRelByIdResponseDto {
    id?: number;
    custId?: string | undefined;
    customerName?: string | undefined;
    custUId?: number;
    empId?: string | undefined;
    employeeName?: string | undefined;
    empUId?: number;
    birthDate?: Date | undefined;
    relationshipId?: number;
    status?: string | undefined;
    qualificationRoleTypeId?: number | undefined;
    qualificationRoleTypeName?: string | undefined;
    custEmpServiceTypeByIds?: CustEmpServiceTypeByIdDto[] | undefined;
    exemptions?: ExemptionDto[] | undefined;
    statusDateRanges?: DateRangeDto[] | undefined;
    liveInDateRanges?: DateRangeDto[] | undefined;
    caregiverRelationshipConfirmation?: AttestationStatus;
    caregiverRelationshipConfirmationText?: string | undefined;
    caregiverDifficultyOfCareConfirmation?: AttestationStatus;
    caregiverDifficultyOfCareConfirmationText?: string | undefined;
    caregiverFICAConfirmation?: AttestationStatus;
    caregiverFICAConfirmationText?: string | undefined;
    caregiverLEConfirmation?: AttestationStatus;
    caregiverLEConfirmationText?: string | undefined;
    isAuthRepresentative?: boolean;
    attestRelationDescription?: string | undefined;
    testAuthEndDate?: Date | undefined;
}

export class CustEmpRelFilterRequest implements ICustEmpRelFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    custId?: number | undefined;
    empId?: number | undefined;
    ptpntPersonId?: string | undefined;
    cgvPersonId?: string | undefined;

    constructor(data?: ICustEmpRelFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            this.custId = _data["custId"];
            this.empId = _data["empId"];
            this.ptpntPersonId = _data["ptpntPersonId"];
            this.cgvPersonId = _data["cgvPersonId"];
        }
    }

    static fromJS(data: any): CustEmpRelFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CustEmpRelFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        data["custId"] = this.custId;
        data["empId"] = this.empId;
        data["ptpntPersonId"] = this.ptpntPersonId;
        data["cgvPersonId"] = this.cgvPersonId;
        return data;
    }
}

export interface ICustEmpRelFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    custId?: number | undefined;
    empId?: number | undefined;
    ptpntPersonId?: string | undefined;
    cgvPersonId?: string | undefined;
}

export class CustEmpRelResponseDto implements ICustEmpRelResponseDto {
    id?: number;
    custId?: string | undefined;
    customerFirstName?: string | undefined;
    customerLastName?: string | undefined;
    customerName?: string | undefined;
    insuredId?: string | undefined;
    empId?: string | undefined;
    employeeFirstName?: string | undefined;
    employeeLastName?: string | undefined;
    employeeName?: string | undefined;
    relationshipId?: number;
    code?: string | undefined;
    status?: string | undefined;
    serviceType?: string | undefined;
    personId?: string | undefined;
    participantPersonId?: string | undefined;
    participantEmployerId?: string | undefined;
    participantEmployerBeginDate?: Date;
    participantEmployerEndDate?: Date;
    caregiverPersonId?: string | undefined;
    caregiverStatus?: string | undefined;
    participantStatus?: string | undefined;
    caregiverId?: number;
    participantId?: number;
    relation?: string | undefined;
    firstDayWorked?: Date | undefined;
    lastDayWorked?: Date | undefined;
    firstDayPaid?: Date | undefined;
    lastDayPaid?: Date | undefined;
    qualificationRoleTypeId?: number;
    qualificationRoleTypeName?: string | undefined;
    isLiveIn?: boolean;
    isTwenty147?: boolean;
    isFica?: boolean;
    isFicaChild?: boolean;
    testAuthEndDate?: Date;

    constructor(data?: ICustEmpRelResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.custId = _data["custId"];
            this.customerFirstName = _data["customerFirstName"];
            this.customerLastName = _data["customerLastName"];
            this.customerName = _data["customerName"];
            this.insuredId = _data["insuredId"];
            this.empId = _data["empId"];
            this.employeeFirstName = _data["employeeFirstName"];
            this.employeeLastName = _data["employeeLastName"];
            this.employeeName = _data["employeeName"];
            this.relationshipId = _data["relationshipId"];
            this.code = _data["code"];
            this.status = _data["status"];
            this.serviceType = _data["serviceType"];
            this.personId = _data["personId"];
            this.participantPersonId = _data["participantPersonId"];
            this.participantEmployerId = _data["participantEmployerId"];
            this.participantEmployerBeginDate = _data["participantEmployerBeginDate"] ? new Date(_data["participantEmployerBeginDate"].toString()) : <any>undefined;
            this.participantEmployerEndDate = _data["participantEmployerEndDate"] ? new Date(_data["participantEmployerEndDate"].toString()) : <any>undefined;
            this.caregiverPersonId = _data["caregiverPersonId"];
            this.caregiverStatus = _data["caregiverStatus"];
            this.participantStatus = _data["participantStatus"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            this.relation = _data["relation"];
            this.firstDayWorked = _data["firstDayWorked"] ? new Date(_data["firstDayWorked"].toString()) : <any>undefined;
            this.lastDayWorked = _data["lastDayWorked"] ? new Date(_data["lastDayWorked"].toString()) : <any>undefined;
            this.firstDayPaid = _data["firstDayPaid"] ? new Date(_data["firstDayPaid"].toString()) : <any>undefined;
            this.lastDayPaid = _data["lastDayPaid"] ? new Date(_data["lastDayPaid"].toString()) : <any>undefined;
            this.qualificationRoleTypeId = _data["qualificationRoleTypeId"];
            this.qualificationRoleTypeName = _data["qualificationRoleTypeName"];
            this.isLiveIn = _data["isLiveIn"];
            this.isTwenty147 = _data["isTwenty147"];
            this.isFica = _data["isFica"];
            this.isFicaChild = _data["isFicaChild"];
            this.testAuthEndDate = _data["testAuthEndDate"] ? new Date(_data["testAuthEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustEmpRelResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustEmpRelResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["custId"] = this.custId;
        data["customerFirstName"] = this.customerFirstName;
        data["customerLastName"] = this.customerLastName;
        data["customerName"] = this.customerName;
        data["insuredId"] = this.insuredId;
        data["empId"] = this.empId;
        data["employeeFirstName"] = this.employeeFirstName;
        data["employeeLastName"] = this.employeeLastName;
        data["employeeName"] = this.employeeName;
        data["relationshipId"] = this.relationshipId;
        data["code"] = this.code;
        data["status"] = this.status;
        data["serviceType"] = this.serviceType;
        data["personId"] = this.personId;
        data["participantPersonId"] = this.participantPersonId;
        data["participantEmployerId"] = this.participantEmployerId;
        data["participantEmployerBeginDate"] = this.participantEmployerBeginDate ? this.participantEmployerBeginDate.toISOString() : <any>undefined;
        data["participantEmployerEndDate"] = this.participantEmployerEndDate ? this.participantEmployerEndDate.toISOString() : <any>undefined;
        data["caregiverPersonId"] = this.caregiverPersonId;
        data["caregiverStatus"] = this.caregiverStatus;
        data["participantStatus"] = this.participantStatus;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        data["relation"] = this.relation;
        data["firstDayWorked"] = this.firstDayWorked ? this.firstDayWorked.toISOString() : <any>undefined;
        data["lastDayWorked"] = this.lastDayWorked ? this.lastDayWorked.toISOString() : <any>undefined;
        data["firstDayPaid"] = this.firstDayPaid ? this.firstDayPaid.toISOString() : <any>undefined;
        data["lastDayPaid"] = this.lastDayPaid ? this.lastDayPaid.toISOString() : <any>undefined;
        data["qualificationRoleTypeId"] = this.qualificationRoleTypeId;
        data["qualificationRoleTypeName"] = this.qualificationRoleTypeName;
        data["isLiveIn"] = this.isLiveIn;
        data["isTwenty147"] = this.isTwenty147;
        data["isFica"] = this.isFica;
        data["isFicaChild"] = this.isFicaChild;
        data["testAuthEndDate"] = this.testAuthEndDate ? this.testAuthEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICustEmpRelResponseDto {
    id?: number;
    custId?: string | undefined;
    customerFirstName?: string | undefined;
    customerLastName?: string | undefined;
    customerName?: string | undefined;
    insuredId?: string | undefined;
    empId?: string | undefined;
    employeeFirstName?: string | undefined;
    employeeLastName?: string | undefined;
    employeeName?: string | undefined;
    relationshipId?: number;
    code?: string | undefined;
    status?: string | undefined;
    serviceType?: string | undefined;
    personId?: string | undefined;
    participantPersonId?: string | undefined;
    participantEmployerId?: string | undefined;
    participantEmployerBeginDate?: Date;
    participantEmployerEndDate?: Date;
    caregiverPersonId?: string | undefined;
    caregiverStatus?: string | undefined;
    participantStatus?: string | undefined;
    caregiverId?: number;
    participantId?: number;
    relation?: string | undefined;
    firstDayWorked?: Date | undefined;
    lastDayWorked?: Date | undefined;
    firstDayPaid?: Date | undefined;
    lastDayPaid?: Date | undefined;
    qualificationRoleTypeId?: number;
    qualificationRoleTypeName?: string | undefined;
    isLiveIn?: boolean;
    isTwenty147?: boolean;
    isFica?: boolean;
    isFicaChild?: boolean;
    testAuthEndDate?: Date;
}

export class CustEmpRelResponseDtoGridResponseBase implements ICustEmpRelResponseDtoGridResponseBase {
    items?: CustEmpRelResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CustEmpRelResponseDto;

    constructor(data?: ICustEmpRelResponseDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CustEmpRelResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? CustEmpRelResponseDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustEmpRelResponseDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new CustEmpRelResponseDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustEmpRelResponseDtoGridResponseBase {
    items?: CustEmpRelResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CustEmpRelResponseDto;
}

export class CustEmpRelationDto implements ICustEmpRelationDto {
    id?: number | undefined;
    custId!: number;
    empId!: number;
    relationShipId?: number | undefined;
    status!: string;
    qualificationRoleTypeId?: number | undefined;
    custEmpServiceType?: CustEmpServTypeDto[] | undefined;
    exemptions?: ExemptionDto[] | undefined;
    statusDateRanges?: DateRangeDto[] | undefined;
    liveInDateRanges?: DateRangeDto[] | undefined;
    caregiverFICAConfirmation?: AttestationStatus;
    caregiverDifficultyOfCareConfirmation?: AttestationStatus;
    caregiverRelationshipConfirmation?: AttestationStatus;
    caregiverLEConfirmation?: AttestationStatus;
    participantPersonId?: string | undefined;
    caregiverPersonId?: string | undefined;
    attestationDetails?: CaregiverParticipantRelAttestaionStatusDetailsRequest;
    testAuthEndDate?: Date | undefined;

    constructor(data?: ICustEmpRelationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.custId = _data["custId"];
            this.empId = _data["empId"];
            this.relationShipId = _data["relationShipId"];
            this.status = _data["status"];
            this.qualificationRoleTypeId = _data["qualificationRoleTypeId"];
            if (Array.isArray(_data["custEmpServiceType"])) {
                this.custEmpServiceType = [] as any;
                for (let item of _data["custEmpServiceType"])
                    this.custEmpServiceType!.push(CustEmpServTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["exemptions"])) {
                this.exemptions = [] as any;
                for (let item of _data["exemptions"])
                    this.exemptions!.push(ExemptionDto.fromJS(item));
            }
            if (Array.isArray(_data["statusDateRanges"])) {
                this.statusDateRanges = [] as any;
                for (let item of _data["statusDateRanges"])
                    this.statusDateRanges!.push(DateRangeDto.fromJS(item));
            }
            if (Array.isArray(_data["liveInDateRanges"])) {
                this.liveInDateRanges = [] as any;
                for (let item of _data["liveInDateRanges"])
                    this.liveInDateRanges!.push(DateRangeDto.fromJS(item));
            }
            this.caregiverFICAConfirmation = _data["caregiverFICAConfirmation"];
            this.caregiverDifficultyOfCareConfirmation = _data["caregiverDifficultyOfCareConfirmation"];
            this.caregiverRelationshipConfirmation = _data["caregiverRelationshipConfirmation"];
            this.caregiverLEConfirmation = _data["caregiverLEConfirmation"];
            this.participantPersonId = _data["participantPersonId"];
            this.caregiverPersonId = _data["caregiverPersonId"];
            this.attestationDetails = _data["attestationDetails"] ? CaregiverParticipantRelAttestaionStatusDetailsRequest.fromJS(_data["attestationDetails"]) : <any>undefined;
            this.testAuthEndDate = _data["testAuthEndDate"] ? new Date(_data["testAuthEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustEmpRelationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustEmpRelationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["custId"] = this.custId;
        data["empId"] = this.empId;
        data["relationShipId"] = this.relationShipId;
        data["status"] = this.status;
        data["qualificationRoleTypeId"] = this.qualificationRoleTypeId;
        if (Array.isArray(this.custEmpServiceType)) {
            data["custEmpServiceType"] = [];
            for (let item of this.custEmpServiceType)
                data["custEmpServiceType"].push(item.toJSON());
        }
        if (Array.isArray(this.exemptions)) {
            data["exemptions"] = [];
            for (let item of this.exemptions)
                data["exemptions"].push(item.toJSON());
        }
        if (Array.isArray(this.statusDateRanges)) {
            data["statusDateRanges"] = [];
            for (let item of this.statusDateRanges)
                data["statusDateRanges"].push(item.toJSON());
        }
        if (Array.isArray(this.liveInDateRanges)) {
            data["liveInDateRanges"] = [];
            for (let item of this.liveInDateRanges)
                data["liveInDateRanges"].push(item.toJSON());
        }
        data["caregiverFICAConfirmation"] = this.caregiverFICAConfirmation;
        data["caregiverDifficultyOfCareConfirmation"] = this.caregiverDifficultyOfCareConfirmation;
        data["caregiverRelationshipConfirmation"] = this.caregiverRelationshipConfirmation;
        data["caregiverLEConfirmation"] = this.caregiverLEConfirmation;
        data["participantPersonId"] = this.participantPersonId;
        data["caregiverPersonId"] = this.caregiverPersonId;
        data["attestationDetails"] = this.attestationDetails ? this.attestationDetails.toJSON() : <any>undefined;
        data["testAuthEndDate"] = this.testAuthEndDate ? this.testAuthEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICustEmpRelationDto {
    id?: number | undefined;
    custId: number;
    empId: number;
    relationShipId?: number | undefined;
    status: string;
    qualificationRoleTypeId?: number | undefined;
    custEmpServiceType?: CustEmpServTypeDto[] | undefined;
    exemptions?: ExemptionDto[] | undefined;
    statusDateRanges?: DateRangeDto[] | undefined;
    liveInDateRanges?: DateRangeDto[] | undefined;
    caregiverFICAConfirmation?: AttestationStatus;
    caregiverDifficultyOfCareConfirmation?: AttestationStatus;
    caregiverRelationshipConfirmation?: AttestationStatus;
    caregiverLEConfirmation?: AttestationStatus;
    participantPersonId?: string | undefined;
    caregiverPersonId?: string | undefined;
    attestationDetails?: CaregiverParticipantRelAttestaionStatusDetailsRequest;
    testAuthEndDate?: Date | undefined;
}

export class CustEmpServTypeDto implements ICustEmpServTypeDto {
    id?: number | undefined;
    custEmpId?: number;
    servTypeId?: number;

    constructor(data?: ICustEmpServTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.custEmpId = _data["custEmpId"];
            this.servTypeId = _data["servTypeId"];
        }
    }

    static fromJS(data: any): CustEmpServTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustEmpServTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["custEmpId"] = this.custEmpId;
        data["servTypeId"] = this.servTypeId;
        return data;
    }
}

export interface ICustEmpServTypeDto {
    id?: number | undefined;
    custEmpId?: number;
    servTypeId?: number;
}

export class CustEmpServiceTypeByIdDto implements ICustEmpServiceTypeByIdDto {
    servTypeId?: number;
    systemCode?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: ICustEmpServiceTypeByIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servTypeId = _data["servTypeId"];
            this.systemCode = _data["systemCode"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CustEmpServiceTypeByIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustEmpServiceTypeByIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servTypeId"] = this.servTypeId;
        data["systemCode"] = this.systemCode;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface ICustEmpServiceTypeByIdDto {
    servTypeId?: number;
    systemCode?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
}

export class CustRepRelByIdResponse implements ICustRepRelByIdResponse {
    id?: number;
    participantId?: number;
    participantPersonId?: string | undefined;
    solomonParticipantId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantName?: string | undefined;
    repId?: number;
    repPersonId?: string | undefined;
    repFirstName?: string | undefined;
    repLastName?: string | undefined;
    repName?: string | undefined;
    status?: string | undefined;
    statusStartDate?: Date;
    statusEndDate?: Date | undefined;
    relationshipId?: number | undefined;

    constructor(data?: ICustRepRelByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.participantId = _data["participantId"];
            this.participantPersonId = _data["participantPersonId"];
            this.solomonParticipantId = _data["solomonParticipantId"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.participantName = _data["participantName"];
            this.repId = _data["repId"];
            this.repPersonId = _data["repPersonId"];
            this.repFirstName = _data["repFirstName"];
            this.repLastName = _data["repLastName"];
            this.repName = _data["repName"];
            this.status = _data["status"];
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.relationshipId = _data["relationshipId"];
        }
    }

    static fromJS(data: any): CustRepRelByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustRepRelByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["participantId"] = this.participantId;
        data["participantPersonId"] = this.participantPersonId;
        data["solomonParticipantId"] = this.solomonParticipantId;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["participantName"] = this.participantName;
        data["repId"] = this.repId;
        data["repPersonId"] = this.repPersonId;
        data["repFirstName"] = this.repFirstName;
        data["repLastName"] = this.repLastName;
        data["repName"] = this.repName;
        data["status"] = this.status;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["relationshipId"] = this.relationshipId;
        return data;
    }
}

export interface ICustRepRelByIdResponse {
    id?: number;
    participantId?: number;
    participantPersonId?: string | undefined;
    solomonParticipantId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantName?: string | undefined;
    repId?: number;
    repPersonId?: string | undefined;
    repFirstName?: string | undefined;
    repLastName?: string | undefined;
    repName?: string | undefined;
    status?: string | undefined;
    statusStartDate?: Date;
    statusEndDate?: Date | undefined;
    relationshipId?: number | undefined;
}

export class CustRepRelFilterRequest implements ICustRepRelFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    custId?: number | undefined;
    repId?: number | undefined;

    constructor(data?: ICustRepRelFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            this.custId = _data["custId"];
            this.repId = _data["repId"];
        }
    }

    static fromJS(data: any): CustRepRelFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CustRepRelFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        data["custId"] = this.custId;
        data["repId"] = this.repId;
        return data;
    }
}

export interface ICustRepRelFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    custId?: number | undefined;
    repId?: number | undefined;
}

export class CustRepRelResponse implements ICustRepRelResponse {
    id?: number;
    participantId?: number;
    participantPersonId?: string | undefined;
    solomonParticipantId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantName?: string | undefined;
    repId?: number;
    repPersonId?: string | undefined;
    repFirstName?: string | undefined;
    repLastName?: string | undefined;
    repName?: string | undefined;
    status?: string | undefined;
    statusStartDate?: Date;
    statusEndDate?: Date | undefined;

    constructor(data?: ICustRepRelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.participantId = _data["participantId"];
            this.participantPersonId = _data["participantPersonId"];
            this.solomonParticipantId = _data["solomonParticipantId"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.participantName = _data["participantName"];
            this.repId = _data["repId"];
            this.repPersonId = _data["repPersonId"];
            this.repFirstName = _data["repFirstName"];
            this.repLastName = _data["repLastName"];
            this.repName = _data["repName"];
            this.status = _data["status"];
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustRepRelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustRepRelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["participantId"] = this.participantId;
        data["participantPersonId"] = this.participantPersonId;
        data["solomonParticipantId"] = this.solomonParticipantId;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["participantName"] = this.participantName;
        data["repId"] = this.repId;
        data["repPersonId"] = this.repPersonId;
        data["repFirstName"] = this.repFirstName;
        data["repLastName"] = this.repLastName;
        data["repName"] = this.repName;
        data["status"] = this.status;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICustRepRelResponse {
    id?: number;
    participantId?: number;
    participantPersonId?: string | undefined;
    solomonParticipantId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantName?: string | undefined;
    repId?: number;
    repPersonId?: string | undefined;
    repFirstName?: string | undefined;
    repLastName?: string | undefined;
    repName?: string | undefined;
    status?: string | undefined;
    statusStartDate?: Date;
    statusEndDate?: Date | undefined;
}

export class CustRepRelResponseGridResponseBase implements ICustRepRelResponseGridResponseBase {
    items?: CustRepRelResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CustRepRelResponse;

    constructor(data?: ICustRepRelResponseGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CustRepRelResponse.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? CustRepRelResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustRepRelResponseGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new CustRepRelResponseGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustRepRelResponseGridResponseBase {
    items?: CustRepRelResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: CustRepRelResponse;
}

export class CustRepRelationBulkRequest implements ICustRepRelationBulkRequest {
    requests?: CustRepRelationRequest[] | undefined;

    constructor(data?: ICustRepRelationBulkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["requests"])) {
                this.requests = [] as any;
                for (let item of _data["requests"])
                    this.requests!.push(CustRepRelationRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustRepRelationBulkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CustRepRelationBulkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requests)) {
            data["requests"] = [];
            for (let item of this.requests)
                data["requests"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustRepRelationBulkRequest {
    requests?: CustRepRelationRequest[] | undefined;
}

export class CustRepRelationRequest implements ICustRepRelationRequest {
    id?: number | undefined;
    participantId?: number;
    designatedRepresentativeId?: number;
    relationshipId?: number;
    status?: string | undefined;
    statusStartDate?: Date;
    statusEndDate?: Date | undefined;
    statusChangeReason?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: ICustRepRelationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.participantId = _data["participantId"];
            this.designatedRepresentativeId = _data["designatedRepresentativeId"];
            this.relationshipId = _data["relationshipId"];
            this.status = _data["status"];
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.statusChangeReason = _data["statusChangeReason"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CustRepRelationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CustRepRelationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["participantId"] = this.participantId;
        data["designatedRepresentativeId"] = this.designatedRepresentativeId;
        data["relationshipId"] = this.relationshipId;
        data["status"] = this.status;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["statusChangeReason"] = this.statusChangeReason;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ICustRepRelationRequest {
    id?: number | undefined;
    participantId?: number;
    designatedRepresentativeId?: number;
    relationshipId?: number;
    status?: string | undefined;
    statusStartDate?: Date;
    statusEndDate?: Date | undefined;
    statusChangeReason?: string | undefined;
    isDeleted?: boolean;
}

export class DateRangeDto implements IDateRangeDto {
    id?: number;
    status?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    isDeleted?: boolean;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;

    constructor(data?: IDateRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDateRangeDto {
    id?: number;
    status?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    isDeleted?: boolean;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
}

export class DateRangeDtoResponseModelWithData implements IDateRangeDtoResponseModelWithData {
    isSuccess?: boolean;
    message?: string | undefined;
    items?: DateRangeDto[] | undefined;
    data?: DateRangeDto;

    constructor(data?: IDateRangeDtoResponseModelWithData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DateRangeDto.fromJS(item));
            }
            this.data = _data["data"] ? DateRangeDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DateRangeDtoResponseModelWithData {
        data = typeof data === 'object' ? data : {};
        let result = new DateRangeDtoResponseModelWithData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDateRangeDtoResponseModelWithData {
    isSuccess?: boolean;
    message?: string | undefined;
    items?: DateRangeDto[] | undefined;
    data?: DateRangeDto;
}

export class DateRangeRequest implements IDateRangeRequest {
    id?: number;
    startDate?: Date;
    endDate?: Date | undefined;

    constructor(data?: IDateRangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateRangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DateRangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDateRangeRequest {
    id?: number;
    startDate?: Date;
    endDate?: Date | undefined;
}

export class DayRange implements IDayRange {
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IDayRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DayRange {
        data = typeof data === 'object' ? data : {};
        let result = new DayRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDayRange {
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class DeductionTypeDto implements IDeductionTypeDto {
    id?: number;
    dedId?: string | undefined;
    dedType?: string | undefined;
    state?: string | undefined;
    deductionTypeName?: string | undefined;

    constructor(data?: IDeductionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dedId = _data["dedId"];
            this.dedType = _data["dedType"];
            this.state = _data["state"];
            this.deductionTypeName = _data["deductionTypeName"];
        }
    }

    static fromJS(data: any): DeductionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeductionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dedId"] = this.dedId;
        data["dedType"] = this.dedType;
        data["state"] = this.state;
        data["deductionTypeName"] = this.deductionTypeName;
        return data;
    }
}

export interface IDeductionTypeDto {
    id?: number;
    dedId?: string | undefined;
    dedType?: string | undefined;
    state?: string | undefined;
    deductionTypeName?: string | undefined;
}

export class DesignatedRepresentativeProfile implements IDesignatedRepresentativeProfile {
    phoneDetails?: PhoneDetail[] | undefined;
    physicalAddresses?: AddressDTO[] | undefined;
    mailingAddresses?: AddressDTO[] | undefined;
    ivrAddresses?: AddressDTO[] | undefined;
    externalKeys?: ExternalKeyDTO[] | undefined;
    id?: number;
    personId?: string | undefined;
    status?: string | undefined;
    readonly personName?: string | undefined;
    ssn?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    physicalAddress?: string | undefined;
    mailingAddress?: string | undefined;
    ivrAddress?: string | undefined;
    companyCode?: string | undefined;
    unmaskedSsn?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    ivrPin?: string | undefined;
    paymentMethod?: string | undefined;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    coordinatorPersonFirstName?: string | undefined;
    coordinatorPersonLastName?: string | undefined;
    coordinatorPersonName?: string | undefined;
    lastV4LoginOn?: Date | undefined;
    isSsnValidated?: boolean | undefined;
    ssnValidationOverrideOn?: Date | undefined;
    ssnValidationOverrideBy?: string | undefined;
    relationship?: string | undefined;
    relation?: PersonStatus;

    constructor(data?: IDesignatedRepresentativeProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["phoneDetails"])) {
                this.phoneDetails = [] as any;
                for (let item of _data["phoneDetails"])
                    this.phoneDetails!.push(PhoneDetail.fromJS(item));
            }
            if (Array.isArray(_data["physicalAddresses"])) {
                this.physicalAddresses = [] as any;
                for (let item of _data["physicalAddresses"])
                    this.physicalAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["mailingAddresses"])) {
                this.mailingAddresses = [] as any;
                for (let item of _data["mailingAddresses"])
                    this.mailingAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["ivrAddresses"])) {
                this.ivrAddresses = [] as any;
                for (let item of _data["ivrAddresses"])
                    this.ivrAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["externalKeys"])) {
                this.externalKeys = [] as any;
                for (let item of _data["externalKeys"])
                    this.externalKeys!.push(ExternalKeyDTO.fromJS(item));
            }
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.status = _data["status"];
            (<any>this).personName = _data["personName"];
            this.ssn = _data["ssn"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.gender = _data["gender"];
            this.ethnicity = _data["ethnicity"];
            this.race = _data["race"];
            this.maritalStatus = _data["maritalStatus"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.physicalAddress = _data["physicalAddress"];
            this.mailingAddress = _data["mailingAddress"];
            this.ivrAddress = _data["ivrAddress"];
            this.companyCode = _data["companyCode"];
            this.unmaskedSsn = _data["unmaskedSsn"];
            this.onboarded = _data["onboarded"];
            this.isFirstLoginComplete = _data["isFirstLoginComplete"];
            this.ivrPin = _data["ivrPin"];
            this.paymentMethod = _data["paymentMethod"];
            this.coordinatorPersonId = _data["coordinatorPersonId"];
            this.internalUserObjectId = _data["internalUserObjectId"];
            this.coordinatorPersonFirstName = _data["coordinatorPersonFirstName"];
            this.coordinatorPersonLastName = _data["coordinatorPersonLastName"];
            this.coordinatorPersonName = _data["coordinatorPersonName"];
            this.lastV4LoginOn = _data["lastV4LoginOn"] ? new Date(_data["lastV4LoginOn"].toString()) : <any>undefined;
            this.isSsnValidated = _data["isSsnValidated"];
            this.ssnValidationOverrideOn = _data["ssnValidationOverrideOn"] ? new Date(_data["ssnValidationOverrideOn"].toString()) : <any>undefined;
            this.ssnValidationOverrideBy = _data["ssnValidationOverrideBy"];
            this.relationship = _data["relationship"];
            this.relation = _data["relation"];
        }
    }

    static fromJS(data: any): DesignatedRepresentativeProfile {
        data = typeof data === 'object' ? data : {};
        let result = new DesignatedRepresentativeProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phoneDetails)) {
            data["phoneDetails"] = [];
            for (let item of this.phoneDetails)
                data["phoneDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.physicalAddresses)) {
            data["physicalAddresses"] = [];
            for (let item of this.physicalAddresses)
                data["physicalAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.mailingAddresses)) {
            data["mailingAddresses"] = [];
            for (let item of this.mailingAddresses)
                data["mailingAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.ivrAddresses)) {
            data["ivrAddresses"] = [];
            for (let item of this.ivrAddresses)
                data["ivrAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.externalKeys)) {
            data["externalKeys"] = [];
            for (let item of this.externalKeys)
                data["externalKeys"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["status"] = this.status;
        data["personName"] = this.personName;
        data["ssn"] = this.ssn;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["gender"] = this.gender;
        data["ethnicity"] = this.ethnicity;
        data["race"] = this.race;
        data["maritalStatus"] = this.maritalStatus;
        data["preferredLanguage"] = this.preferredLanguage;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["physicalAddress"] = this.physicalAddress;
        data["mailingAddress"] = this.mailingAddress;
        data["ivrAddress"] = this.ivrAddress;
        data["companyCode"] = this.companyCode;
        data["unmaskedSsn"] = this.unmaskedSsn;
        data["onboarded"] = this.onboarded;
        data["isFirstLoginComplete"] = this.isFirstLoginComplete;
        data["ivrPin"] = this.ivrPin;
        data["paymentMethod"] = this.paymentMethod;
        data["coordinatorPersonId"] = this.coordinatorPersonId;
        data["internalUserObjectId"] = this.internalUserObjectId;
        data["coordinatorPersonFirstName"] = this.coordinatorPersonFirstName;
        data["coordinatorPersonLastName"] = this.coordinatorPersonLastName;
        data["coordinatorPersonName"] = this.coordinatorPersonName;
        data["lastV4LoginOn"] = this.lastV4LoginOn ? this.lastV4LoginOn.toISOString() : <any>undefined;
        data["isSsnValidated"] = this.isSsnValidated;
        data["ssnValidationOverrideOn"] = this.ssnValidationOverrideOn ? this.ssnValidationOverrideOn.toISOString() : <any>undefined;
        data["ssnValidationOverrideBy"] = this.ssnValidationOverrideBy;
        data["relationship"] = this.relationship;
        data["relation"] = this.relation;
        return data;
    }
}

export interface IDesignatedRepresentativeProfile {
    phoneDetails?: PhoneDetail[] | undefined;
    physicalAddresses?: AddressDTO[] | undefined;
    mailingAddresses?: AddressDTO[] | undefined;
    ivrAddresses?: AddressDTO[] | undefined;
    externalKeys?: ExternalKeyDTO[] | undefined;
    id?: number;
    personId?: string | undefined;
    status?: string | undefined;
    personName?: string | undefined;
    ssn?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    physicalAddress?: string | undefined;
    mailingAddress?: string | undefined;
    ivrAddress?: string | undefined;
    companyCode?: string | undefined;
    unmaskedSsn?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    ivrPin?: string | undefined;
    paymentMethod?: string | undefined;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    coordinatorPersonFirstName?: string | undefined;
    coordinatorPersonLastName?: string | undefined;
    coordinatorPersonName?: string | undefined;
    lastV4LoginOn?: Date | undefined;
    isSsnValidated?: boolean | undefined;
    ssnValidationOverrideOn?: Date | undefined;
    ssnValidationOverrideBy?: string | undefined;
    relationship?: string | undefined;
    relation?: PersonStatus;
}

export class DischargeReasons implements IDischargeReasons {
    id?: number;
    dischargeReasonName?: string | undefined;

    constructor(data?: IDischargeReasons) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dischargeReasonName = _data["dischargeReasonName"];
        }
    }

    static fromJS(data: any): DischargeReasons {
        data = typeof data === 'object' ? data : {};
        let result = new DischargeReasons();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dischargeReasonName"] = this.dischargeReasonName;
        return data;
    }
}

export interface IDischargeReasons {
    id?: number;
    dischargeReasonName?: string | undefined;
}

export class EmailHistory implements IEmailHistory {
    id?: number;
    email?: string | undefined;
    updatedDate?: Date;
    createdBy?: string | undefined;
    changeReason?: string | undefined;

    constructor(data?: IEmailHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.changeReason = _data["changeReason"];
        }
    }

    static fromJS(data: any): EmailHistory {
        data = typeof data === 'object' ? data : {};
        let result = new EmailHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["changeReason"] = this.changeReason;
        return data;
    }
}

export interface IEmailHistory {
    id?: number;
    email?: string | undefined;
    updatedDate?: Date;
    createdBy?: string | undefined;
    changeReason?: string | undefined;
}

export class EmployerAccounts implements IEmployerAccounts {
    employerDeductionId?: number;
    beginDate?: Date;
    endDate?: Date;
    deductionType?: string | undefined;
    accounts?: string | undefined;

    constructor(data?: IEmployerAccounts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employerDeductionId = _data["employerDeductionId"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.deductionType = _data["deductionType"];
            this.accounts = _data["accounts"];
        }
    }

    static fromJS(data: any): EmployerAccounts {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerAccounts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employerDeductionId"] = this.employerDeductionId;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["deductionType"] = this.deductionType;
        data["accounts"] = this.accounts;
        return data;
    }
}

export interface IEmployerAccounts {
    employerDeductionId?: number;
    beginDate?: Date;
    endDate?: Date;
    deductionType?: string | undefined;
    accounts?: string | undefined;
}

export class EmployerDeduction implements IEmployerDeduction {
    employerDeductionId?: number;
    employerId?: number;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    deductionStatus?: string | undefined;
    deductionStatusName?: string | undefined;
    deductionType?: string | undefined;
    deductionTypeName?: string | undefined;
    deductionId?: string | undefined;
    rptFreq?: string | undefined;
    rptFreqName?: string | undefined;
    lbltyDate?: Date | undefined;
    q1Rate?: number | undefined;
    q2Rate?: number | undefined;
    q3Rate?: number | undefined;
    q4Rate?: number | undefined;
    isDeleted?: boolean;

    constructor(data?: IEmployerDeduction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employerDeductionId = _data["employerDeductionId"];
            this.employerId = _data["employerId"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.deductionStatus = _data["deductionStatus"];
            this.deductionStatusName = _data["deductionStatusName"];
            this.deductionType = _data["deductionType"];
            this.deductionTypeName = _data["deductionTypeName"];
            this.deductionId = _data["deductionId"];
            this.rptFreq = _data["rptFreq"];
            this.rptFreqName = _data["rptFreqName"];
            this.lbltyDate = _data["lbltyDate"] ? new Date(_data["lbltyDate"].toString()) : <any>undefined;
            this.q1Rate = _data["q1Rate"];
            this.q2Rate = _data["q2Rate"];
            this.q3Rate = _data["q3Rate"];
            this.q4Rate = _data["q4Rate"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): EmployerDeduction {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerDeduction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employerDeductionId"] = this.employerDeductionId;
        data["employerId"] = this.employerId;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["deductionStatus"] = this.deductionStatus;
        data["deductionStatusName"] = this.deductionStatusName;
        data["deductionType"] = this.deductionType;
        data["deductionTypeName"] = this.deductionTypeName;
        data["deductionId"] = this.deductionId;
        data["rptFreq"] = this.rptFreq;
        data["rptFreqName"] = this.rptFreqName;
        data["lbltyDate"] = this.lbltyDate ? this.lbltyDate.toISOString() : <any>undefined;
        data["q1Rate"] = this.q1Rate;
        data["q2Rate"] = this.q2Rate;
        data["q3Rate"] = this.q3Rate;
        data["q4Rate"] = this.q4Rate;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IEmployerDeduction {
    employerDeductionId?: number;
    employerId?: number;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    deductionStatus?: string | undefined;
    deductionStatusName?: string | undefined;
    deductionType?: string | undefined;
    deductionTypeName?: string | undefined;
    deductionId?: string | undefined;
    rptFreq?: string | undefined;
    rptFreqName?: string | undefined;
    lbltyDate?: Date | undefined;
    q1Rate?: number | undefined;
    q2Rate?: number | undefined;
    q3Rate?: number | undefined;
    q4Rate?: number | undefined;
    isDeleted?: boolean;
}

export class EmployerDetails implements IEmployerDetails {
    employerDto?: EmployerResponse;
    employerDeductions?: EmployerDeduction[] | undefined;

    constructor(data?: IEmployerDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employerDto = _data["employerDto"] ? EmployerResponse.fromJS(_data["employerDto"]) : <any>undefined;
            if (Array.isArray(_data["employerDeductions"])) {
                this.employerDeductions = [] as any;
                for (let item of _data["employerDeductions"])
                    this.employerDeductions!.push(EmployerDeduction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployerDetails {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employerDto"] = this.employerDto ? this.employerDto.toJSON() : <any>undefined;
        if (Array.isArray(this.employerDeductions)) {
            data["employerDeductions"] = [];
            for (let item of this.employerDeductions)
                data["employerDeductions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmployerDetails {
    employerDto?: EmployerResponse;
    employerDeductions?: EmployerDeduction[] | undefined;
}

export class EmployerId implements IEmployerId {
    id?: number;

    constructor(data?: IEmployerId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmployerId {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEmployerId {
    id?: number;
}

export class EmployerIdApiResponse implements IEmployerIdApiResponse {
    message?: string | undefined;
    data?: EmployerId;
    success?: boolean;

    constructor(data?: IEmployerIdApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.data = _data["data"] ? EmployerId.fromJS(_data["data"]) : <any>undefined;
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): EmployerIdApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerIdApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["success"] = this.success;
        return data;
    }
}

export interface IEmployerIdApiResponse {
    message?: string | undefined;
    data?: EmployerId;
    success?: boolean;
}

export class EmployerOfRecordDetailHistoryResponse implements IEmployerOfRecordDetailHistoryResponse {
    field?: string | undefined;
    updatedFrom?: string | undefined;
    updatedTo?: string | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IEmployerOfRecordDetailHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.updatedFrom = _data["updatedFrom"];
            this.updatedTo = _data["updatedTo"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployerOfRecordDetailHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerOfRecordDetailHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["updatedFrom"] = this.updatedFrom;
        data["updatedTo"] = this.updatedTo;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmployerOfRecordDetailHistoryResponse {
    field?: string | undefined;
    updatedFrom?: string | undefined;
    updatedTo?: string | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class EmployerOfRecordDetailResponse implements IEmployerOfRecordDetailResponse {
    phoneDetails?: PhoneDetail[] | undefined;
    physicalAddresses?: AddressDTO[] | undefined;
    mailingAddresses?: AddressDTO[] | undefined;
    ivrAddresses?: AddressDTO[] | undefined;
    externalKeys?: ExternalKeyDTO[] | undefined;
    id?: number;
    personId?: string | undefined;
    status?: string | undefined;
    readonly personName?: string | undefined;
    ssn?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    physicalAddress?: string | undefined;
    mailingAddress?: string | undefined;
    ivrAddress?: string | undefined;
    companyCode?: string | undefined;
    unmaskedSsn?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    ivrPin?: string | undefined;
    paymentMethod?: string | undefined;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    coordinatorPersonFirstName?: string | undefined;
    coordinatorPersonLastName?: string | undefined;
    coordinatorPersonName?: string | undefined;
    lastV4LoginOn?: Date | undefined;
    isSsnValidated?: boolean | undefined;
    ssnValidationOverrideOn?: Date | undefined;
    ssnValidationOverrideBy?: string | undefined;
    employerOfRecordId?: number;
    solomonId?: string | undefined;
    suffix?: string | undefined;
    ein?: string | undefined;
    relationship?: string | undefined;
    relation?: PersonStatus;
    einList?: string[] | undefined;

    constructor(data?: IEmployerOfRecordDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["phoneDetails"])) {
                this.phoneDetails = [] as any;
                for (let item of _data["phoneDetails"])
                    this.phoneDetails!.push(PhoneDetail.fromJS(item));
            }
            if (Array.isArray(_data["physicalAddresses"])) {
                this.physicalAddresses = [] as any;
                for (let item of _data["physicalAddresses"])
                    this.physicalAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["mailingAddresses"])) {
                this.mailingAddresses = [] as any;
                for (let item of _data["mailingAddresses"])
                    this.mailingAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["ivrAddresses"])) {
                this.ivrAddresses = [] as any;
                for (let item of _data["ivrAddresses"])
                    this.ivrAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["externalKeys"])) {
                this.externalKeys = [] as any;
                for (let item of _data["externalKeys"])
                    this.externalKeys!.push(ExternalKeyDTO.fromJS(item));
            }
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.status = _data["status"];
            (<any>this).personName = _data["personName"];
            this.ssn = _data["ssn"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.gender = _data["gender"];
            this.ethnicity = _data["ethnicity"];
            this.race = _data["race"];
            this.maritalStatus = _data["maritalStatus"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.physicalAddress = _data["physicalAddress"];
            this.mailingAddress = _data["mailingAddress"];
            this.ivrAddress = _data["ivrAddress"];
            this.companyCode = _data["companyCode"];
            this.unmaskedSsn = _data["unmaskedSsn"];
            this.onboarded = _data["onboarded"];
            this.isFirstLoginComplete = _data["isFirstLoginComplete"];
            this.ivrPin = _data["ivrPin"];
            this.paymentMethod = _data["paymentMethod"];
            this.coordinatorPersonId = _data["coordinatorPersonId"];
            this.internalUserObjectId = _data["internalUserObjectId"];
            this.coordinatorPersonFirstName = _data["coordinatorPersonFirstName"];
            this.coordinatorPersonLastName = _data["coordinatorPersonLastName"];
            this.coordinatorPersonName = _data["coordinatorPersonName"];
            this.lastV4LoginOn = _data["lastV4LoginOn"] ? new Date(_data["lastV4LoginOn"].toString()) : <any>undefined;
            this.isSsnValidated = _data["isSsnValidated"];
            this.ssnValidationOverrideOn = _data["ssnValidationOverrideOn"] ? new Date(_data["ssnValidationOverrideOn"].toString()) : <any>undefined;
            this.ssnValidationOverrideBy = _data["ssnValidationOverrideBy"];
            this.employerOfRecordId = _data["employerOfRecordId"];
            this.solomonId = _data["solomonId"];
            this.suffix = _data["suffix"];
            this.ein = _data["ein"];
            this.relationship = _data["relationship"];
            this.relation = _data["relation"];
            if (Array.isArray(_data["einList"])) {
                this.einList = [] as any;
                for (let item of _data["einList"])
                    this.einList!.push(item);
            }
        }
    }

    static fromJS(data: any): EmployerOfRecordDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerOfRecordDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phoneDetails)) {
            data["phoneDetails"] = [];
            for (let item of this.phoneDetails)
                data["phoneDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.physicalAddresses)) {
            data["physicalAddresses"] = [];
            for (let item of this.physicalAddresses)
                data["physicalAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.mailingAddresses)) {
            data["mailingAddresses"] = [];
            for (let item of this.mailingAddresses)
                data["mailingAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.ivrAddresses)) {
            data["ivrAddresses"] = [];
            for (let item of this.ivrAddresses)
                data["ivrAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.externalKeys)) {
            data["externalKeys"] = [];
            for (let item of this.externalKeys)
                data["externalKeys"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["status"] = this.status;
        data["personName"] = this.personName;
        data["ssn"] = this.ssn;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["gender"] = this.gender;
        data["ethnicity"] = this.ethnicity;
        data["race"] = this.race;
        data["maritalStatus"] = this.maritalStatus;
        data["preferredLanguage"] = this.preferredLanguage;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["physicalAddress"] = this.physicalAddress;
        data["mailingAddress"] = this.mailingAddress;
        data["ivrAddress"] = this.ivrAddress;
        data["companyCode"] = this.companyCode;
        data["unmaskedSsn"] = this.unmaskedSsn;
        data["onboarded"] = this.onboarded;
        data["isFirstLoginComplete"] = this.isFirstLoginComplete;
        data["ivrPin"] = this.ivrPin;
        data["paymentMethod"] = this.paymentMethod;
        data["coordinatorPersonId"] = this.coordinatorPersonId;
        data["internalUserObjectId"] = this.internalUserObjectId;
        data["coordinatorPersonFirstName"] = this.coordinatorPersonFirstName;
        data["coordinatorPersonLastName"] = this.coordinatorPersonLastName;
        data["coordinatorPersonName"] = this.coordinatorPersonName;
        data["lastV4LoginOn"] = this.lastV4LoginOn ? this.lastV4LoginOn.toISOString() : <any>undefined;
        data["isSsnValidated"] = this.isSsnValidated;
        data["ssnValidationOverrideOn"] = this.ssnValidationOverrideOn ? this.ssnValidationOverrideOn.toISOString() : <any>undefined;
        data["ssnValidationOverrideBy"] = this.ssnValidationOverrideBy;
        data["employerOfRecordId"] = this.employerOfRecordId;
        data["solomonId"] = this.solomonId;
        data["suffix"] = this.suffix;
        data["ein"] = this.ein;
        data["relationship"] = this.relationship;
        data["relation"] = this.relation;
        if (Array.isArray(this.einList)) {
            data["einList"] = [];
            for (let item of this.einList)
                data["einList"].push(item);
        }
        return data;
    }
}

export interface IEmployerOfRecordDetailResponse {
    phoneDetails?: PhoneDetail[] | undefined;
    physicalAddresses?: AddressDTO[] | undefined;
    mailingAddresses?: AddressDTO[] | undefined;
    ivrAddresses?: AddressDTO[] | undefined;
    externalKeys?: ExternalKeyDTO[] | undefined;
    id?: number;
    personId?: string | undefined;
    status?: string | undefined;
    personName?: string | undefined;
    ssn?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    physicalAddress?: string | undefined;
    mailingAddress?: string | undefined;
    ivrAddress?: string | undefined;
    companyCode?: string | undefined;
    unmaskedSsn?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    ivrPin?: string | undefined;
    paymentMethod?: string | undefined;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    coordinatorPersonFirstName?: string | undefined;
    coordinatorPersonLastName?: string | undefined;
    coordinatorPersonName?: string | undefined;
    lastV4LoginOn?: Date | undefined;
    isSsnValidated?: boolean | undefined;
    ssnValidationOverrideOn?: Date | undefined;
    ssnValidationOverrideBy?: string | undefined;
    employerOfRecordId?: number;
    solomonId?: string | undefined;
    suffix?: string | undefined;
    ein?: string | undefined;
    relationship?: string | undefined;
    relation?: PersonStatus;
    einList?: string[] | undefined;
}

export class EmployerOfRecordEmployerMappingDetails implements IEmployerOfRecordEmployerMappingDetails {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number | undefined;
    employerOfRecordId?: number | undefined;
    employerId?: number | undefined;
    employerName?: string | undefined;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    employerPartRelId?: number | undefined;
    employerPartRelValue?: string | undefined;
    ein?: string | undefined;

    constructor(data?: IEmployerOfRecordEmployerMappingDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.id = _data["id"];
            this.employerOfRecordId = _data["employerOfRecordId"];
            this.employerId = _data["employerId"];
            this.employerName = _data["employerName"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.employerPartRelId = _data["employerPartRelId"];
            this.employerPartRelValue = _data["employerPartRelValue"];
            this.ein = _data["ein"];
        }
    }

    static fromJS(data: any): EmployerOfRecordEmployerMappingDetails {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerOfRecordEmployerMappingDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["id"] = this.id;
        data["employerOfRecordId"] = this.employerOfRecordId;
        data["employerId"] = this.employerId;
        data["employerName"] = this.employerName;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["employerPartRelId"] = this.employerPartRelId;
        data["employerPartRelValue"] = this.employerPartRelValue;
        data["ein"] = this.ein;
        return data;
    }
}

export interface IEmployerOfRecordEmployerMappingDetails {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number | undefined;
    employerOfRecordId?: number | undefined;
    employerId?: number | undefined;
    employerName?: string | undefined;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    employerPartRelId?: number | undefined;
    employerPartRelValue?: string | undefined;
    ein?: string | undefined;
}

export class EmployerOfRecordRequest implements IEmployerOfRecordRequest {
    personStatus?: string | undefined;
    id?: number;
    personId?: string | undefined;
    status?: PeopleStatus;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    statusChangeReason?: string | undefined;
    ssn?: string | undefined;
    maritalStatus?: string | undefined;
    personStatusHistories?: PersonStatusHistory[] | undefined;
    employerOfRecordId?: number | undefined;
    solomonEmployerOfRecordId?: string | undefined;
    cdcnStateId?: number | undefined;
    areaId?: number | undefined;
    terminationStatus?: string | undefined;
    terminationEventDate?: Date | undefined;
    terminationMemo?: string | undefined;
    employerOfRecordEmployerMappingDetails?: EmployerOfRecordEmployerMappingDetails[] | undefined;

    constructor(data?: IEmployerOfRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personStatus = _data["personStatus"];
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.status = _data["status"];
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.statusChangeReason = _data["statusChangeReason"];
            this.ssn = _data["ssn"];
            this.maritalStatus = _data["maritalStatus"];
            if (Array.isArray(_data["personStatusHistories"])) {
                this.personStatusHistories = [] as any;
                for (let item of _data["personStatusHistories"])
                    this.personStatusHistories!.push(PersonStatusHistory.fromJS(item));
            }
            this.employerOfRecordId = _data["employerOfRecordId"];
            this.solomonEmployerOfRecordId = _data["solomonEmployerOfRecordId"];
            this.cdcnStateId = _data["cdcnStateId"];
            this.areaId = _data["areaId"];
            this.terminationStatus = _data["terminationStatus"];
            this.terminationEventDate = _data["terminationEventDate"] ? new Date(_data["terminationEventDate"].toString()) : <any>undefined;
            this.terminationMemo = _data["terminationMemo"];
            if (Array.isArray(_data["employerOfRecordEmployerMappingDetails"])) {
                this.employerOfRecordEmployerMappingDetails = [] as any;
                for (let item of _data["employerOfRecordEmployerMappingDetails"])
                    this.employerOfRecordEmployerMappingDetails!.push(EmployerOfRecordEmployerMappingDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployerOfRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerOfRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personStatus"] = this.personStatus;
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["status"] = this.status;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["statusChangeReason"] = this.statusChangeReason;
        data["ssn"] = this.ssn;
        data["maritalStatus"] = this.maritalStatus;
        if (Array.isArray(this.personStatusHistories)) {
            data["personStatusHistories"] = [];
            for (let item of this.personStatusHistories)
                data["personStatusHistories"].push(item.toJSON());
        }
        data["employerOfRecordId"] = this.employerOfRecordId;
        data["solomonEmployerOfRecordId"] = this.solomonEmployerOfRecordId;
        data["cdcnStateId"] = this.cdcnStateId;
        data["areaId"] = this.areaId;
        data["terminationStatus"] = this.terminationStatus;
        data["terminationEventDate"] = this.terminationEventDate ? this.terminationEventDate.toISOString() : <any>undefined;
        data["terminationMemo"] = this.terminationMemo;
        if (Array.isArray(this.employerOfRecordEmployerMappingDetails)) {
            data["employerOfRecordEmployerMappingDetails"] = [];
            for (let item of this.employerOfRecordEmployerMappingDetails)
                data["employerOfRecordEmployerMappingDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmployerOfRecordRequest {
    personStatus?: string | undefined;
    id?: number;
    personId?: string | undefined;
    status?: PeopleStatus;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    statusChangeReason?: string | undefined;
    ssn?: string | undefined;
    maritalStatus?: string | undefined;
    personStatusHistories?: PersonStatusHistory[] | undefined;
    employerOfRecordId?: number | undefined;
    solomonEmployerOfRecordId?: string | undefined;
    cdcnStateId?: number | undefined;
    areaId?: number | undefined;
    terminationStatus?: string | undefined;
    terminationEventDate?: Date | undefined;
    terminationMemo?: string | undefined;
    employerOfRecordEmployerMappingDetails?: EmployerOfRecordEmployerMappingDetails[] | undefined;
}

export class EmployerOfRecordResponse implements IEmployerOfRecordResponse {
    employerOfRecordId?: number;
    personId?: string | undefined;
    solomonEmployerOfRecordId?: string | undefined;
    cdcnStateId?: number | undefined;
    areaId?: number | undefined;
    ivrPin?: string | undefined;
    personTypeStatus?: string | undefined;
    employerOfRecordStatus?: PeopleStatus;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    terminationStatus?: string | undefined;
    eventDate?: Date | undefined;
    memo?: string | undefined;
    lastDateWorked?: Date | undefined;
    lastDatePaid?: Date | undefined;
    ssn?: string | undefined;
    employerOfRecordEmployerDetails?: EmployerOfRecordEmployerMappingDetails[] | undefined;

    constructor(data?: IEmployerOfRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employerOfRecordId = _data["employerOfRecordId"];
            this.personId = _data["personId"];
            this.solomonEmployerOfRecordId = _data["solomonEmployerOfRecordId"];
            this.cdcnStateId = _data["cdcnStateId"];
            this.areaId = _data["areaId"];
            this.ivrPin = _data["ivrPin"];
            this.personTypeStatus = _data["personTypeStatus"];
            this.employerOfRecordStatus = _data["employerOfRecordStatus"];
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.terminationStatus = _data["terminationStatus"];
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.memo = _data["memo"];
            this.lastDateWorked = _data["lastDateWorked"] ? new Date(_data["lastDateWorked"].toString()) : <any>undefined;
            this.lastDatePaid = _data["lastDatePaid"] ? new Date(_data["lastDatePaid"].toString()) : <any>undefined;
            this.ssn = _data["ssn"];
            if (Array.isArray(_data["employerOfRecordEmployerDetails"])) {
                this.employerOfRecordEmployerDetails = [] as any;
                for (let item of _data["employerOfRecordEmployerDetails"])
                    this.employerOfRecordEmployerDetails!.push(EmployerOfRecordEmployerMappingDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployerOfRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerOfRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employerOfRecordId"] = this.employerOfRecordId;
        data["personId"] = this.personId;
        data["solomonEmployerOfRecordId"] = this.solomonEmployerOfRecordId;
        data["cdcnStateId"] = this.cdcnStateId;
        data["areaId"] = this.areaId;
        data["ivrPin"] = this.ivrPin;
        data["personTypeStatus"] = this.personTypeStatus;
        data["employerOfRecordStatus"] = this.employerOfRecordStatus;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["terminationStatus"] = this.terminationStatus;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["memo"] = this.memo;
        data["lastDateWorked"] = this.lastDateWorked ? this.lastDateWorked.toISOString() : <any>undefined;
        data["lastDatePaid"] = this.lastDatePaid ? this.lastDatePaid.toISOString() : <any>undefined;
        data["ssn"] = this.ssn;
        if (Array.isArray(this.employerOfRecordEmployerDetails)) {
            data["employerOfRecordEmployerDetails"] = [];
            for (let item of this.employerOfRecordEmployerDetails)
                data["employerOfRecordEmployerDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmployerOfRecordResponse {
    employerOfRecordId?: number;
    personId?: string | undefined;
    solomonEmployerOfRecordId?: string | undefined;
    cdcnStateId?: number | undefined;
    areaId?: number | undefined;
    ivrPin?: string | undefined;
    personTypeStatus?: string | undefined;
    employerOfRecordStatus?: PeopleStatus;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    terminationStatus?: string | undefined;
    eventDate?: Date | undefined;
    memo?: string | undefined;
    lastDateWorked?: Date | undefined;
    lastDatePaid?: Date | undefined;
    ssn?: string | undefined;
    employerOfRecordEmployerDetails?: EmployerOfRecordEmployerMappingDetails[] | undefined;
}

export class EmployerPartRelationshipType implements IEmployerPartRelationshipType {
    id?: number;
    description?: string | undefined;
    fullDescription?: string | undefined;

    constructor(data?: IEmployerPartRelationshipType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.fullDescription = _data["fullDescription"];
        }
    }

    static fromJS(data: any): EmployerPartRelationshipType {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerPartRelationshipType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["fullDescription"] = this.fullDescription;
        return data;
    }
}

export interface IEmployerPartRelationshipType {
    id?: number;
    description?: string | undefined;
    fullDescription?: string | undefined;
}

export class EmployerPayRateListRequest implements IEmployerPayRateListRequest {
    employerPayRatesList?: EmployerPayRatePeriodData[] | undefined;

    constructor(data?: IEmployerPayRateListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employerPayRatesList"])) {
                this.employerPayRatesList = [] as any;
                for (let item of _data["employerPayRatesList"])
                    this.employerPayRatesList!.push(EmployerPayRatePeriodData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployerPayRateListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerPayRateListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employerPayRatesList)) {
            data["employerPayRatesList"] = [];
            for (let item of this.employerPayRatesList)
                data["employerPayRatesList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmployerPayRateListRequest {
    employerPayRatesList?: EmployerPayRatePeriodData[] | undefined;
}

export class EmployerPayRatePeriodData implements IEmployerPayRatePeriodData {
    employerRateId?: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    isActive?: boolean;
    rate?: number;
    serviceCode?: number;
    employerId?: number;
    isDeleted?: boolean;

    constructor(data?: IEmployerPayRatePeriodData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employerRateId = _data["employerRateId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.rate = _data["rate"];
            this.serviceCode = _data["serviceCode"];
            this.employerId = _data["employerId"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): EmployerPayRatePeriodData {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerPayRatePeriodData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employerRateId"] = this.employerRateId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["rate"] = this.rate;
        data["serviceCode"] = this.serviceCode;
        data["employerId"] = this.employerId;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IEmployerPayRatePeriodData {
    employerRateId?: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    isActive?: boolean;
    rate?: number;
    serviceCode?: number;
    employerId?: number;
    isDeleted?: boolean;
}

export class EmployerPayRateSetupDto implements IEmployerPayRateSetupDto {
    payCalc?: PayCalcMethod;
    employerRateId?: number;
    startDate?: Date;
    endDate?: Date;
    rate?: number;
    serviceCode?: string | undefined;
    serviceCodeId?: number;
    isActive?: boolean;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IEmployerPayRateSetupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payCalc = _data["payCalc"];
            this.employerRateId = _data["employerRateId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.rate = _data["rate"];
            this.serviceCode = _data["serviceCode"];
            this.serviceCodeId = _data["serviceCodeId"];
            this.isActive = _data["isActive"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployerPayRateSetupDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerPayRateSetupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payCalc"] = this.payCalc;
        data["employerRateId"] = this.employerRateId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["rate"] = this.rate;
        data["serviceCode"] = this.serviceCode;
        data["serviceCodeId"] = this.serviceCodeId;
        data["isActive"] = this.isActive;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmployerPayRateSetupDto {
    payCalc?: PayCalcMethod;
    employerRateId?: number;
    startDate?: Date;
    endDate?: Date;
    rate?: number;
    serviceCode?: string | undefined;
    serviceCodeId?: number;
    isActive?: boolean;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class EmployerPayRateSetupDtoGridResponseBase implements IEmployerPayRateSetupDtoGridResponseBase {
    items?: EmployerPayRateSetupDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: EmployerPayRateSetupDto;

    constructor(data?: IEmployerPayRateSetupDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EmployerPayRateSetupDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? EmployerPayRateSetupDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployerPayRateSetupDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerPayRateSetupDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployerPayRateSetupDtoGridResponseBase {
    items?: EmployerPayRateSetupDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: EmployerPayRateSetupDto;
}

export class EmployerPayRateSetupGridRequest implements IEmployerPayRateSetupGridRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    employerId?: number;

    constructor(data?: IEmployerPayRateSetupGridRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            this.employerId = _data["employerId"];
        }
    }

    static fromJS(data: any): EmployerPayRateSetupGridRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerPayRateSetupGridRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        data["employerId"] = this.employerId;
        return data;
    }
}

export interface IEmployerPayRateSetupGridRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    employerId?: number;
}

export class EmployerRequest implements IEmployerRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    participantId?: number;
    includeIAEmployers?: boolean;

    constructor(data?: IEmployerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            this.participantId = _data["participantId"];
            this.includeIAEmployers = _data["includeIAEmployers"];
        }
    }

    static fromJS(data: any): EmployerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        data["participantId"] = this.participantId;
        data["includeIAEmployers"] = this.includeIAEmployers;
        return data;
    }
}

export interface IEmployerRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    participantId?: number;
    includeIAEmployers?: boolean;
}

export class EmployerResponse implements IEmployerResponse {
    id?: number;
    employerUniqueId?: string | undefined;
    employerName?: string | undefined;
    ein?: string | undefined;
    previouslyKnownAs?: string | undefined;
    city?: string | undefined;
    einStatus?: string | undefined;
    einStatusValue?: string | undefined;
    terminationStatus?: string | undefined;
    terminationStatusValue?: string | undefined;
    terminationMemo?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    state?: string | undefined;
    county?: string | undefined;
    zip?: string | undefined;
    status?: string | undefined;
    statusValue?: string | undefined;
    payOT?: boolean | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    previousEin?: string | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    accounts?: string | undefined;
    sutaRate?: number | undefined;
    personStatusHistories?: PersonStatusHistory[] | undefined;
    comments?: string | undefined;
    ssn?: string | undefined;
    dob?: Date | undefined;

    constructor(data?: IEmployerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employerUniqueId = _data["employerUniqueId"];
            this.employerName = _data["employerName"];
            this.ein = _data["ein"];
            this.previouslyKnownAs = _data["previouslyKnownAs"];
            this.city = _data["city"];
            this.einStatus = _data["einStatus"];
            this.einStatusValue = _data["einStatusValue"];
            this.terminationStatus = _data["terminationStatus"];
            this.terminationStatusValue = _data["terminationStatusValue"];
            this.terminationMemo = _data["terminationMemo"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.state = _data["state"];
            this.county = _data["county"];
            this.zip = _data["zip"];
            this.status = _data["status"];
            this.statusValue = _data["statusValue"];
            this.payOT = _data["payOT"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.previousEin = _data["previousEin"];
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.accounts = _data["accounts"];
            this.sutaRate = _data["sutaRate"];
            if (Array.isArray(_data["personStatusHistories"])) {
                this.personStatusHistories = [] as any;
                for (let item of _data["personStatusHistories"])
                    this.personStatusHistories!.push(PersonStatusHistory.fromJS(item));
            }
            this.comments = _data["comments"];
            this.ssn = _data["ssn"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employerUniqueId"] = this.employerUniqueId;
        data["employerName"] = this.employerName;
        data["ein"] = this.ein;
        data["previouslyKnownAs"] = this.previouslyKnownAs;
        data["city"] = this.city;
        data["einStatus"] = this.einStatus;
        data["einStatusValue"] = this.einStatusValue;
        data["terminationStatus"] = this.terminationStatus;
        data["terminationStatusValue"] = this.terminationStatusValue;
        data["terminationMemo"] = this.terminationMemo;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["state"] = this.state;
        data["county"] = this.county;
        data["zip"] = this.zip;
        data["status"] = this.status;
        data["statusValue"] = this.statusValue;
        data["payOT"] = this.payOT;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["previousEin"] = this.previousEin;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["accounts"] = this.accounts;
        data["sutaRate"] = this.sutaRate;
        if (Array.isArray(this.personStatusHistories)) {
            data["personStatusHistories"] = [];
            for (let item of this.personStatusHistories)
                data["personStatusHistories"].push(item.toJSON());
        }
        data["comments"] = this.comments;
        data["ssn"] = this.ssn;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmployerResponse {
    id?: number;
    employerUniqueId?: string | undefined;
    employerName?: string | undefined;
    ein?: string | undefined;
    previouslyKnownAs?: string | undefined;
    city?: string | undefined;
    einStatus?: string | undefined;
    einStatusValue?: string | undefined;
    terminationStatus?: string | undefined;
    terminationStatusValue?: string | undefined;
    terminationMemo?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    state?: string | undefined;
    county?: string | undefined;
    zip?: string | undefined;
    status?: string | undefined;
    statusValue?: string | undefined;
    payOT?: boolean | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    previousEin?: string | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    accounts?: string | undefined;
    sutaRate?: number | undefined;
    personStatusHistories?: PersonStatusHistory[] | undefined;
    comments?: string | undefined;
    ssn?: string | undefined;
    dob?: Date | undefined;
}

export class EmployerResponseGridResponseBase implements IEmployerResponseGridResponseBase {
    items?: EmployerResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: EmployerResponse;

    constructor(data?: IEmployerResponseGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EmployerResponse.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? EmployerResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployerResponseGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerResponseGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployerResponseGridResponseBase {
    items?: EmployerResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: EmployerResponse;
}

export class EmployerSearchRequest implements IEmployerSearchRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    companyId?: number;
    searchParam?: string | undefined;
    employerId?: number;
    userEmail?: string | undefined;
    company?: string | undefined;

    constructor(data?: IEmployerSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            this.companyId = _data["companyId"];
            this.searchParam = _data["searchParam"];
            this.employerId = _data["employerId"];
            this.userEmail = _data["userEmail"];
            this.company = _data["company"];
        }
    }

    static fromJS(data: any): EmployerSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        data["companyId"] = this.companyId;
        data["searchParam"] = this.searchParam;
        data["employerId"] = this.employerId;
        data["userEmail"] = this.userEmail;
        data["company"] = this.company;
        return data;
    }
}

export interface IEmployerSearchRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    companyId?: number;
    searchParam?: string | undefined;
    employerId?: number;
    userEmail?: string | undefined;
    company?: string | undefined;
}

export class EmployerStatusHistory implements IEmployerStatusHistory {
    personStatusId?: number;
    status?: string | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    employerId?: number;
    statusChangeReason?: string | undefined;
    personStatus?: string | undefined;

    constructor(data?: IEmployerStatusHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personStatusId = _data["personStatusId"];
            this.status = _data["status"];
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.employerId = _data["employerId"];
            this.statusChangeReason = _data["statusChangeReason"];
            this.personStatus = _data["personStatus"];
        }
    }

    static fromJS(data: any): EmployerStatusHistory {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerStatusHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personStatusId"] = this.personStatusId;
        data["status"] = this.status;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["employerId"] = this.employerId;
        data["statusChangeReason"] = this.statusChangeReason;
        data["personStatus"] = this.personStatus;
        return data;
    }
}

export interface IEmployerStatusHistory {
    personStatusId?: number;
    status?: string | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    employerId?: number;
    statusChangeReason?: string | undefined;
    personStatus?: string | undefined;
}

export class EmployerUsageRequest implements IEmployerUsageRequest {
    ids?: number[] | undefined;

    constructor(data?: IEmployerUsageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): EmployerUsageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerUsageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IEmployerUsageRequest {
    ids?: number[] | undefined;
}

export class Employers implements IEmployers {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number;
    employerName?: string | undefined;
    employerUniqueId?: string | undefined;
    ein?: string | undefined;
    ssn?: string | undefined;
    dob?: Date | undefined;

    constructor(data?: IEmployers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.id = _data["id"];
            this.employerName = _data["employerName"];
            this.employerUniqueId = _data["employerUniqueId"];
            this.ein = _data["ein"];
            this.ssn = _data["ssn"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Employers {
        data = typeof data === 'object' ? data : {};
        let result = new Employers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["id"] = this.id;
        data["employerName"] = this.employerName;
        data["employerUniqueId"] = this.employerUniqueId;
        data["ein"] = this.ein;
        data["ssn"] = this.ssn;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmployers {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number;
    employerName?: string | undefined;
    employerUniqueId?: string | undefined;
    ein?: string | undefined;
    ssn?: string | undefined;
    dob?: Date | undefined;
}

export class EmployersGridResponseBase implements IEmployersGridResponseBase {
    items?: Employers[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: Employers;

    constructor(data?: IEmployersGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Employers.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? Employers.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployersGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new EmployersGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployersGridResponseBase {
    items?: Employers[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: Employers;
}

export class EntityStatus implements IEntityStatus {
    id?: number | undefined;
    reason?: string | undefined;
    entityTypeId?: number;
    entityId?: number;
    entity?: string | undefined;
    statusTypeId?: number | undefined;
    statusType?: string | undefined;
    isActive?: boolean;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    isModifiable?: boolean;
    isDefault?: boolean;
    isOverlapAllowed?: boolean;
    isLegacy?: boolean;
    actions?: SystemActionMapping[] | undefined;

    constructor(data?: IEntityStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reason = _data["reason"];
            this.entityTypeId = _data["entityTypeId"];
            this.entityId = _data["entityId"];
            this.entity = _data["entity"];
            this.statusTypeId = _data["statusTypeId"];
            this.statusType = _data["statusType"];
            this.isActive = _data["isActive"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.isDeleted = _data["isDeleted"];
            this.isModifiable = _data["isModifiable"];
            this.isDefault = _data["isDefault"];
            this.isOverlapAllowed = _data["isOverlapAllowed"];
            this.isLegacy = _data["isLegacy"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(SystemActionMapping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntityStatus {
        data = typeof data === 'object' ? data : {};
        let result = new EntityStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reason"] = this.reason;
        data["entityTypeId"] = this.entityTypeId;
        data["entityId"] = this.entityId;
        data["entity"] = this.entity;
        data["statusTypeId"] = this.statusTypeId;
        data["statusType"] = this.statusType;
        data["isActive"] = this.isActive;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["isDeleted"] = this.isDeleted;
        data["isModifiable"] = this.isModifiable;
        data["isDefault"] = this.isDefault;
        data["isOverlapAllowed"] = this.isOverlapAllowed;
        data["isLegacy"] = this.isLegacy;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEntityStatus {
    id?: number | undefined;
    reason?: string | undefined;
    entityTypeId?: number;
    entityId?: number;
    entity?: string | undefined;
    statusTypeId?: number | undefined;
    statusType?: string | undefined;
    isActive?: boolean;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    isModifiable?: boolean;
    isDefault?: boolean;
    isOverlapAllowed?: boolean;
    isLegacy?: boolean;
    actions?: SystemActionMapping[] | undefined;
}

export class EntityStatusRequest implements IEntityStatusRequest {
    entityTypeId?: number;
    entityId?: number;
    entity?: string | undefined;

    constructor(data?: IEntityStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityTypeId = _data["entityTypeId"];
            this.entityId = _data["entityId"];
            this.entity = _data["entity"];
        }
    }

    static fromJS(data: any): EntityStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EntityStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityTypeId"] = this.entityTypeId;
        data["entityId"] = this.entityId;
        data["entity"] = this.entity;
        return data;
    }
}

export interface IEntityStatusRequest {
    entityTypeId?: number;
    entityId?: number;
    entity?: string | undefined;
}

export class EntityStatusResponse implements IEntityStatusResponse {
    id?: number | undefined;
    entityId?: number;
    entityTypeId?: number;
    caregiverParticipantMappingId?: number | undefined;
    entity?: string | undefined;
    entityType?: string | undefined;
    statusId?: number;
    reason?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    isOverlapAllowed?: boolean;
    skipValidation?: boolean;
    isLegacy?: boolean;
    overlapResolution?: string | undefined;
    isManual?: boolean;
    validationError?: string | undefined;
    relatedPersonId?: number | undefined;
    personStatusIntegrationId?: number;

    constructor(data?: IEntityStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityId = _data["entityId"];
            this.entityTypeId = _data["entityTypeId"];
            this.caregiverParticipantMappingId = _data["caregiverParticipantMappingId"];
            this.entity = _data["entity"];
            this.entityType = _data["entityType"];
            this.statusId = _data["statusId"];
            this.reason = _data["reason"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.isDeleted = _data["isDeleted"];
            this.isOverlapAllowed = _data["isOverlapAllowed"];
            this.skipValidation = _data["skipValidation"];
            this.isLegacy = _data["isLegacy"];
            this.overlapResolution = _data["overlapResolution"];
            this.isManual = _data["isManual"];
            this.validationError = _data["validationError"];
            this.relatedPersonId = _data["relatedPersonId"];
            this.personStatusIntegrationId = _data["personStatusIntegrationId"];
        }
    }

    static fromJS(data: any): EntityStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EntityStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityId"] = this.entityId;
        data["entityTypeId"] = this.entityTypeId;
        data["caregiverParticipantMappingId"] = this.caregiverParticipantMappingId;
        data["entity"] = this.entity;
        data["entityType"] = this.entityType;
        data["statusId"] = this.statusId;
        data["reason"] = this.reason;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["isDeleted"] = this.isDeleted;
        data["isOverlapAllowed"] = this.isOverlapAllowed;
        data["skipValidation"] = this.skipValidation;
        data["isLegacy"] = this.isLegacy;
        data["overlapResolution"] = this.overlapResolution;
        data["isManual"] = this.isManual;
        data["validationError"] = this.validationError;
        data["relatedPersonId"] = this.relatedPersonId;
        data["personStatusIntegrationId"] = this.personStatusIntegrationId;
        return data;
    }
}

export interface IEntityStatusResponse {
    id?: number | undefined;
    entityId?: number;
    entityTypeId?: number;
    caregiverParticipantMappingId?: number | undefined;
    entity?: string | undefined;
    entityType?: string | undefined;
    statusId?: number;
    reason?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    isOverlapAllowed?: boolean;
    skipValidation?: boolean;
    isLegacy?: boolean;
    overlapResolution?: string | undefined;
    isManual?: boolean;
    validationError?: string | undefined;
    relatedPersonId?: number | undefined;
    personStatusIntegrationId?: number;
}

export class EntityType implements IEntityType {
    entityTypeId?: number;
    type?: string | undefined;
    displayText?: string | undefined;

    constructor(data?: IEntityType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityTypeId = _data["entityTypeId"];
            this.type = _data["type"];
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): EntityType {
        data = typeof data === 'object' ? data : {};
        let result = new EntityType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityTypeId"] = this.entityTypeId;
        data["type"] = this.type;
        data["displayText"] = this.displayText;
        return data;
    }
}

export interface IEntityType {
    entityTypeId?: number;
    type?: string | undefined;
    displayText?: string | undefined;
}

export class EquivalentQualification implements IEquivalentQualification {
    serviceDate?: Date;
    qualificationTypeId?: number | undefined;
    equvQualificationTypeId?: number | undefined;
    equvQualificationTypeName?: string | undefined;
    isRequired?: boolean;

    constructor(data?: IEquivalentQualification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.qualificationTypeId = _data["qualificationTypeId"];
            this.equvQualificationTypeId = _data["equvQualificationTypeId"];
            this.equvQualificationTypeName = _data["equvQualificationTypeName"];
            this.isRequired = _data["isRequired"];
        }
    }

    static fromJS(data: any): EquivalentQualification {
        data = typeof data === 'object' ? data : {};
        let result = new EquivalentQualification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        data["qualificationTypeId"] = this.qualificationTypeId;
        data["equvQualificationTypeId"] = this.equvQualificationTypeId;
        data["equvQualificationTypeName"] = this.equvQualificationTypeName;
        data["isRequired"] = this.isRequired;
        return data;
    }
}

export interface IEquivalentQualification {
    serviceDate?: Date;
    qualificationTypeId?: number | undefined;
    equvQualificationTypeId?: number | undefined;
    equvQualificationTypeName?: string | undefined;
    isRequired?: boolean;
}

export class EventHarvestorRequest implements IEventHarvestorRequest {
    startDate?: Date;
    endDate?: Date;
    companyCode?: string | undefined;
    companyId?: number;

    constructor(data?: IEventHarvestorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.companyCode = _data["companyCode"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): EventHarvestorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EventHarvestorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["companyCode"] = this.companyCode;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IEventHarvestorRequest {
    startDate?: Date;
    endDate?: Date;
    companyCode?: string | undefined;
    companyId?: number;
}

export enum Exemption {
    Twenty147 = "Twenty147",
    Fica = "Fica",
    FicaChild = "FicaChild",
}

export enum ExemptionCategory {
    Fica = "Fica",
    Doc = "Doc",
}

export class ExemptionDto implements IExemptionDto {
    id?: number | undefined;
    exemp?: Exemption;
    displayText?: string | undefined;
    isDeleted?: boolean;
    startDate?: Date;
    endDate?: Date;
    exemptCategory?: ExemptionCategory;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IExemptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.exemp = _data["exemp"];
            this.displayText = _data["displayText"];
            this.isDeleted = _data["isDeleted"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.exemptCategory = _data["exemptCategory"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExemptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExemptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["exemp"] = this.exemp;
        data["displayText"] = this.displayText;
        data["isDeleted"] = this.isDeleted;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["exemptCategory"] = this.exemptCategory;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IExemptionDto {
    id?: number | undefined;
    exemp?: Exemption;
    displayText?: string | undefined;
    isDeleted?: boolean;
    startDate?: Date;
    endDate?: Date;
    exemptCategory?: ExemptionCategory;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class ExemptionDtoResponseModelWithData implements IExemptionDtoResponseModelWithData {
    isSuccess?: boolean;
    message?: string | undefined;
    items?: ExemptionDto[] | undefined;
    data?: ExemptionDto;

    constructor(data?: IExemptionDtoResponseModelWithData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExemptionDto.fromJS(item));
            }
            this.data = _data["data"] ? ExemptionDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExemptionDtoResponseModelWithData {
        data = typeof data === 'object' ? data : {};
        let result = new ExemptionDtoResponseModelWithData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExemptionDtoResponseModelWithData {
    isSuccess?: boolean;
    message?: string | undefined;
    items?: ExemptionDto[] | undefined;
    data?: ExemptionDto;
}

export class ExemptionRequest implements IExemptionRequest {
    id?: number;
    exemptionTypeId?: number;
    exemption?: Exemption;
    exemptionCategory?: ExemptionCategory;
    displayText?: string | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IExemptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.exemptionTypeId = _data["exemptionTypeId"];
            this.exemption = _data["exemption"];
            this.exemptionCategory = _data["exemptionCategory"];
            this.displayText = _data["displayText"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExemptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExemptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["exemptionTypeId"] = this.exemptionTypeId;
        data["exemption"] = this.exemption;
        data["exemptionCategory"] = this.exemptionCategory;
        data["displayText"] = this.displayText;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IExemptionRequest {
    id?: number;
    exemptionTypeId?: number;
    exemption?: Exemption;
    exemptionCategory?: ExemptionCategory;
    displayText?: string | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class ExportCaregiverParticipantProspectCommand implements IExportCaregiverParticipantProspectCommand {
    accessRights?: string[] | undefined;
    personId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    providerOneId?: string | undefined;
    relationshipConfirmationStatus?: AttestationStatus[] | undefined;
    filter?: FilterRequest;

    constructor(data?: IExportCaregiverParticipantProspectCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(item);
            }
            this.personId = _data["personId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.providerOneId = _data["providerOneId"];
            if (Array.isArray(_data["relationshipConfirmationStatus"])) {
                this.relationshipConfirmationStatus = [] as any;
                for (let item of _data["relationshipConfirmationStatus"])
                    this.relationshipConfirmationStatus!.push(item);
            }
            this.filter = _data["filter"] ? FilterRequest.fromJS(_data["filter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExportCaregiverParticipantProspectCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExportCaregiverParticipantProspectCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item);
        }
        data["personId"] = this.personId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["providerOneId"] = this.providerOneId;
        if (Array.isArray(this.relationshipConfirmationStatus)) {
            data["relationshipConfirmationStatus"] = [];
            for (let item of this.relationshipConfirmationStatus)
                data["relationshipConfirmationStatus"].push(item);
        }
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExportCaregiverParticipantProspectCommand {
    accessRights?: string[] | undefined;
    personId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    providerOneId?: string | undefined;
    relationshipConfirmationStatus?: AttestationStatus[] | undefined;
    filter?: FilterRequest;
}

export class ExternalEmailUpdateRequest implements IExternalEmailUpdateRequest {
    oldEmail!: string;
    newEmail!: string;
    personId!: string;

    constructor(data?: IExternalEmailUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldEmail = _data["oldEmail"];
            this.newEmail = _data["newEmail"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): ExternalEmailUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalEmailUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldEmail"] = this.oldEmail;
        data["newEmail"] = this.newEmail;
        data["personId"] = this.personId;
        return data;
    }
}

export interface IExternalEmailUpdateRequest {
    oldEmail: string;
    newEmail: string;
    personId: string;
}

export class ExternalEmailUpdateResponse implements IExternalEmailUpdateResponse {
    errorMessage?: string | undefined;
    isUpdated?: boolean;

    constructor(data?: IExternalEmailUpdateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.isUpdated = _data["isUpdated"];
        }
    }

    static fromJS(data: any): ExternalEmailUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalEmailUpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isUpdated"] = this.isUpdated;
        return data;
    }
}

export interface IExternalEmailUpdateResponse {
    errorMessage?: string | undefined;
    isUpdated?: boolean;
}

export class ExternalEmailValidationRequest implements IExternalEmailValidationRequest {
    email!: string;
    personId!: string;

    constructor(data?: IExternalEmailValidationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): ExternalEmailValidationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalEmailValidationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["personId"] = this.personId;
        return data;
    }
}

export interface IExternalEmailValidationRequest {
    email: string;
    personId: string;
}

export class ExternalEmailValidationResponse implements IExternalEmailValidationResponse {
    errorMessage?: string | undefined;
    existingAccount?: boolean;

    constructor(data?: IExternalEmailValidationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.existingAccount = _data["existingAccount"];
        }
    }

    static fromJS(data: any): ExternalEmailValidationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalEmailValidationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["existingAccount"] = this.existingAccount;
        return data;
    }
}

export interface IExternalEmailValidationResponse {
    errorMessage?: string | undefined;
    existingAccount?: boolean;
}

export class ExternalKeyDTO implements IExternalKeyDTO {
    code?: string | undefined;
    displayText?: string | undefined;
    keyValue?: string | undefined;
    entityType?: string | undefined;
    isEditable?: boolean;

    constructor(data?: IExternalKeyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.displayText = _data["displayText"];
            this.keyValue = _data["keyValue"];
            this.entityType = _data["entityType"];
            this.isEditable = _data["isEditable"];
        }
    }

    static fromJS(data: any): ExternalKeyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalKeyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["displayText"] = this.displayText;
        data["keyValue"] = this.keyValue;
        data["entityType"] = this.entityType;
        data["isEditable"] = this.isEditable;
        return data;
    }
}

export interface IExternalKeyDTO {
    code?: string | undefined;
    displayText?: string | undefined;
    keyValue?: string | undefined;
    entityType?: string | undefined;
    isEditable?: boolean;
}

export class ExternalKeyDeleteRequest implements IExternalKeyDeleteRequest {
    entityType!: string;
    identifier1!: string;
    identifier2?: string | undefined;
    identifier3?: string | undefined;
    code!: string;
    keyValue!: string;
    companyId!: number;

    constructor(data?: IExternalKeyDeleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            this.identifier1 = _data["identifier1"];
            this.identifier2 = _data["identifier2"];
            this.identifier3 = _data["identifier3"];
            this.code = _data["code"];
            this.keyValue = _data["keyValue"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): ExternalKeyDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalKeyDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        data["identifier1"] = this.identifier1;
        data["identifier2"] = this.identifier2;
        data["identifier3"] = this.identifier3;
        data["code"] = this.code;
        data["keyValue"] = this.keyValue;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IExternalKeyDeleteRequest {
    entityType: string;
    identifier1: string;
    identifier2?: string | undefined;
    identifier3?: string | undefined;
    code: string;
    keyValue: string;
    companyId: number;
}

export class ExternalKeyDeleteResponse implements IExternalKeyDeleteResponse {
    error?: string | undefined;
    hasError?: boolean;

    constructor(data?: IExternalKeyDeleteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
            this.hasError = _data["hasError"];
        }
    }

    static fromJS(data: any): ExternalKeyDeleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalKeyDeleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        data["hasError"] = this.hasError;
        return data;
    }
}

export interface IExternalKeyDeleteResponse {
    error?: string | undefined;
    hasError?: boolean;
}

export class ExternalKeyInsertRequest implements IExternalKeyInsertRequest {
    entityType!: string;
    identifier1!: string;
    identifier2?: string | undefined;
    identifier3?: string | undefined;
    code!: string;
    keyValue!: string;
    companyId!: number;

    constructor(data?: IExternalKeyInsertRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            this.identifier1 = _data["identifier1"];
            this.identifier2 = _data["identifier2"];
            this.identifier3 = _data["identifier3"];
            this.code = _data["code"];
            this.keyValue = _data["keyValue"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): ExternalKeyInsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalKeyInsertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        data["identifier1"] = this.identifier1;
        data["identifier2"] = this.identifier2;
        data["identifier3"] = this.identifier3;
        data["code"] = this.code;
        data["keyValue"] = this.keyValue;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IExternalKeyInsertRequest {
    entityType: string;
    identifier1: string;
    identifier2?: string | undefined;
    identifier3?: string | undefined;
    code: string;
    keyValue: string;
    companyId: number;
}

export class ExternalKeyInsertResponse implements IExternalKeyInsertResponse {
    error?: string | undefined;
    hasError?: boolean;

    constructor(data?: IExternalKeyInsertResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
            this.hasError = _data["hasError"];
        }
    }

    static fromJS(data: any): ExternalKeyInsertResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalKeyInsertResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        data["hasError"] = this.hasError;
        return data;
    }
}

export interface IExternalKeyInsertResponse {
    error?: string | undefined;
    hasError?: boolean;
}

export class ExternalKeyTypeRequest implements IExternalKeyTypeRequest {
    entityType!: string;
    companyId!: number;

    constructor(data?: IExternalKeyTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): ExternalKeyTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalKeyTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IExternalKeyTypeRequest {
    entityType: string;
    companyId: number;
}

export class ExternalKeyTypeResponse implements IExternalKeyTypeResponse {
    typeId?: number;
    code?: string | undefined;
    displayText?: string | undefined;
    entityType?: string | undefined;

    constructor(data?: IExternalKeyTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.code = _data["code"];
            this.displayText = _data["displayText"];
            this.entityType = _data["entityType"];
        }
    }

    static fromJS(data: any): ExternalKeyTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalKeyTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["code"] = this.code;
        data["displayText"] = this.displayText;
        data["entityType"] = this.entityType;
        return data;
    }
}

export interface IExternalKeyTypeResponse {
    typeId?: number;
    code?: string | undefined;
    displayText?: string | undefined;
    entityType?: string | undefined;
}

export class ExternalKeyValidateRequest implements IExternalKeyValidateRequest {
    entityType!: string;
    code!: string;
    keyValue!: string;
    companyId!: number;

    constructor(data?: IExternalKeyValidateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            this.code = _data["code"];
            this.keyValue = _data["keyValue"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): ExternalKeyValidateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalKeyValidateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        data["code"] = this.code;
        data["keyValue"] = this.keyValue;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IExternalKeyValidateRequest {
    entityType: string;
    code: string;
    keyValue: string;
    companyId: number;
}

export class ExternalKeyValidateResponse implements IExternalKeyValidateResponse {
    errorFlag?: number;
    error?: string | undefined;

    constructor(data?: IExternalKeyValidateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorFlag = _data["errorFlag"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ExternalKeyValidateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalKeyValidateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorFlag"] = this.errorFlag;
        data["error"] = this.error;
        return data;
    }
}

export interface IExternalKeyValidateResponse {
    errorFlag?: number;
    error?: string | undefined;
}

export class ExternalKeyValueRequest implements IExternalKeyValueRequest {
    entityType!: string;
    identifier1!: string;
    identifier2?: string | undefined;
    companyId!: number;

    constructor(data?: IExternalKeyValueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            this.identifier1 = _data["identifier1"];
            this.identifier2 = _data["identifier2"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): ExternalKeyValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalKeyValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        data["identifier1"] = this.identifier1;
        data["identifier2"] = this.identifier2;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IExternalKeyValueRequest {
    entityType: string;
    identifier1: string;
    identifier2?: string | undefined;
    companyId: number;
}

export class ExternalKeysResponseDto implements IExternalKeysResponseDto {
    keyvalue?: string | undefined;
    code?: string | undefined;
    displayText?: string | undefined;
    integrated?: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    isEditable?: boolean;
    type?: string | undefined;
    canEdit?: boolean;
    canDelete?: boolean;

    constructor(data?: IExternalKeysResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyvalue = _data["keyvalue"];
            this.code = _data["code"];
            this.displayText = _data["displayText"];
            this.integrated = _data["integrated"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.isEditable = _data["isEditable"];
            this.type = _data["type"];
            this.canEdit = _data["canEdit"];
            this.canDelete = _data["canDelete"];
        }
    }

    static fromJS(data: any): ExternalKeysResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalKeysResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyvalue"] = this.keyvalue;
        data["code"] = this.code;
        data["displayText"] = this.displayText;
        data["integrated"] = this.integrated;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isEditable"] = this.isEditable;
        data["type"] = this.type;
        data["canEdit"] = this.canEdit;
        data["canDelete"] = this.canDelete;
        return data;
    }
}

export interface IExternalKeysResponseDto {
    keyvalue?: string | undefined;
    code?: string | undefined;
    displayText?: string | undefined;
    integrated?: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    isEditable?: boolean;
    type?: string | undefined;
    canEdit?: boolean;
    canDelete?: boolean;
}

export class FileResultDto implements IFileResultDto {
    fileName?: string | undefined;
    content?: string | undefined;

    constructor(data?: IFileResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): FileResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["content"] = this.content;
        return data;
    }
}

export interface IFileResultDto {
    fileName?: string | undefined;
    content?: string | undefined;
}

export class FilterRequest implements IFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;

    constructor(data?: IFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): FilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface IFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
}

export enum Gender {
    M = "M",
    F = "F",
    U = "U",
}

export class GetAllCourseResponse implements IGetAllCourseResponse {
    courseCodeId?: number;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
    courseName?: string | undefined;
    courseCode?: string | undefined;
    isDeleted?: boolean | undefined;

    constructor(data?: IGetAllCourseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseCodeId = _data["courseCodeId"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.courseName = _data["courseName"];
            this.courseCode = _data["courseCode"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): GetAllCourseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllCourseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseCodeId"] = this.courseCodeId;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["courseName"] = this.courseName;
        data["courseCode"] = this.courseCode;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IGetAllCourseResponse {
    courseCodeId?: number;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
    courseName?: string | undefined;
    courseCode?: string | undefined;
    isDeleted?: boolean | undefined;
}

export class GetAllExternalKeysFilterRequest implements IGetAllExternalKeysFilterRequest {
    personType?: string | undefined;
    personId?: string | undefined;

    constructor(data?: IGetAllExternalKeysFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personType = _data["personType"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): GetAllExternalKeysFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllExternalKeysFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personType"] = this.personType;
        data["personId"] = this.personId;
        return data;
    }
}

export interface IGetAllExternalKeysFilterRequest {
    personType?: string | undefined;
    personId?: string | undefined;
}

export class GetAttestationCommand implements IGetAttestationCommand {
    accessRights?: string[] | undefined;
    typeCode?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    caregiverId?: number;

    constructor(data?: IGetAttestationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(item);
            }
            this.typeCode = _data["typeCode"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.caregiverId = _data["caregiverId"];
        }
    }

    static fromJS(data: any): GetAttestationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttestationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item);
        }
        data["typeCode"] = this.typeCode;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["caregiverId"] = this.caregiverId;
        return data;
    }
}

export interface IGetAttestationCommand {
    accessRights?: string[] | undefined;
    typeCode?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    caregiverId?: number;
}

export class GetCaregiverCourseResponse implements IGetCaregiverCourseResponse {
    trainingProgram?: string | undefined;
    courseName?: string | undefined;
    courseCode?: string | undefined;
    creditHours?: number;
    completedDate?: Date;
    trainingEntity?: string | undefined;
    transferReason?: string | undefined;
    caregiverId?: string | undefined;
    caregiverCourseMappingId?: number;
    createdBy?: string | undefined;
    createdOn?: Date;

    constructor(data?: IGetCaregiverCourseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainingProgram = _data["trainingProgram"];
            this.courseName = _data["courseName"];
            this.courseCode = _data["courseCode"];
            this.creditHours = _data["creditHours"];
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.trainingEntity = _data["trainingEntity"];
            this.transferReason = _data["transferReason"];
            this.caregiverId = _data["caregiverId"];
            this.caregiverCourseMappingId = _data["caregiverCourseMappingId"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCaregiverCourseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCaregiverCourseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainingProgram"] = this.trainingProgram;
        data["courseName"] = this.courseName;
        data["courseCode"] = this.courseCode;
        data["creditHours"] = this.creditHours;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["trainingEntity"] = this.trainingEntity;
        data["transferReason"] = this.transferReason;
        data["caregiverId"] = this.caregiverId;
        data["caregiverCourseMappingId"] = this.caregiverCourseMappingId;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetCaregiverCourseResponse {
    trainingProgram?: string | undefined;
    courseName?: string | undefined;
    courseCode?: string | undefined;
    creditHours?: number;
    completedDate?: Date;
    trainingEntity?: string | undefined;
    transferReason?: string | undefined;
    caregiverId?: string | undefined;
    caregiverCourseMappingId?: number;
    createdBy?: string | undefined;
    createdOn?: Date;
}

export class GetCaregiverParticipantProspectCommand implements IGetCaregiverParticipantProspectCommand {
    accessRights?: string[] | undefined;
    personId?: number;
    participantId?: number | undefined;
    clientFirstName?: string | undefined;
    clientLastName?: string | undefined;

    constructor(data?: IGetCaregiverParticipantProspectCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(item);
            }
            this.personId = _data["personId"];
            this.participantId = _data["participantId"];
            this.clientFirstName = _data["clientFirstName"];
            this.clientLastName = _data["clientLastName"];
        }
    }

    static fromJS(data: any): GetCaregiverParticipantProspectCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetCaregiverParticipantProspectCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item);
        }
        data["personId"] = this.personId;
        data["participantId"] = this.participantId;
        data["clientFirstName"] = this.clientFirstName;
        data["clientLastName"] = this.clientLastName;
        return data;
    }
}

export interface IGetCaregiverParticipantProspectCommand {
    accessRights?: string[] | undefined;
    personId?: number;
    participantId?: number | undefined;
    clientFirstName?: string | undefined;
    clientLastName?: string | undefined;
}

export class GetCaregiversAttestationStatusCommand implements IGetCaregiversAttestationStatusCommand {
    accessRights?: string[] | undefined;
    caregiverIds?: string[] | undefined;
    filterRequest?: FilterRequest;
    isUnapprovedCaregiverAttestation?: boolean;
    isUnapprovedCaregiverParticipantAttestation?: boolean;

    constructor(data?: IGetCaregiversAttestationStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(item);
            }
            if (Array.isArray(_data["caregiverIds"])) {
                this.caregiverIds = [] as any;
                for (let item of _data["caregiverIds"])
                    this.caregiverIds!.push(item);
            }
            this.filterRequest = _data["filterRequest"] ? FilterRequest.fromJS(_data["filterRequest"]) : <any>undefined;
            this.isUnapprovedCaregiverAttestation = _data["isUnapprovedCaregiverAttestation"];
            this.isUnapprovedCaregiverParticipantAttestation = _data["isUnapprovedCaregiverParticipantAttestation"];
        }
    }

    static fromJS(data: any): GetCaregiversAttestationStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetCaregiversAttestationStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item);
        }
        if (Array.isArray(this.caregiverIds)) {
            data["caregiverIds"] = [];
            for (let item of this.caregiverIds)
                data["caregiverIds"].push(item);
        }
        data["filterRequest"] = this.filterRequest ? this.filterRequest.toJSON() : <any>undefined;
        data["isUnapprovedCaregiverAttestation"] = this.isUnapprovedCaregiverAttestation;
        data["isUnapprovedCaregiverParticipantAttestation"] = this.isUnapprovedCaregiverParticipantAttestation;
        return data;
    }
}

export interface IGetCaregiversAttestationStatusCommand {
    accessRights?: string[] | undefined;
    caregiverIds?: string[] | undefined;
    filterRequest?: FilterRequest;
    isUnapprovedCaregiverAttestation?: boolean;
    isUnapprovedCaregiverParticipantAttestation?: boolean;
}

export class GetHistoryRequestBase implements IGetHistoryRequestBase {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    explicitColumns?: string[] | undefined;
    includeCreation?: boolean;

    constructor(data?: IGetHistoryRequestBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            if (Array.isArray(_data["explicitColumns"])) {
                this.explicitColumns = [] as any;
                for (let item of _data["explicitColumns"])
                    this.explicitColumns!.push(item);
            }
            this.includeCreation = _data["includeCreation"];
        }
    }

    static fromJS(data: any): GetHistoryRequestBase {
        data = typeof data === 'object' ? data : {};
        let result = new GetHistoryRequestBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        if (Array.isArray(this.explicitColumns)) {
            data["explicitColumns"] = [];
            for (let item of this.explicitColumns)
                data["explicitColumns"].push(item);
        }
        data["includeCreation"] = this.includeCreation;
        return data;
    }
}

export interface IGetHistoryRequestBase {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    explicitColumns?: string[] | undefined;
    includeCreation?: boolean;
}

export class GetNeededCaregiverQualificationsCommand implements IGetNeededCaregiverQualificationsCommand {
    accessRights?: string[] | undefined;
    caregiverId?: number;
    qualificationIds?: number[] | undefined;

    constructor(data?: IGetNeededCaregiverQualificationsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(item);
            }
            this.caregiverId = _data["caregiverId"];
            if (Array.isArray(_data["qualificationIds"])) {
                this.qualificationIds = [] as any;
                for (let item of _data["qualificationIds"])
                    this.qualificationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetNeededCaregiverQualificationsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetNeededCaregiverQualificationsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item);
        }
        data["caregiverId"] = this.caregiverId;
        if (Array.isArray(this.qualificationIds)) {
            data["qualificationIds"] = [];
            for (let item of this.qualificationIds)
                data["qualificationIds"].push(item);
        }
        return data;
    }
}

export interface IGetNeededCaregiverQualificationsCommand {
    accessRights?: string[] | undefined;
    caregiverId?: number;
    qualificationIds?: number[] | undefined;
}

export class GetPeopleDataForRulesRequest implements IGetPeopleDataForRulesRequest {
    serviceCode?: string | undefined;
    serviceDate?: Date;
    participantPersonId?: string | undefined;
    caregiverPersonId?: string | undefined;
    ecn?: string | undefined;

    constructor(data?: IGetPeopleDataForRulesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceCode = _data["serviceCode"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.participantPersonId = _data["participantPersonId"];
            this.caregiverPersonId = _data["caregiverPersonId"];
            this.ecn = _data["ecn"];
        }
    }

    static fromJS(data: any): GetPeopleDataForRulesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPeopleDataForRulesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCode"] = this.serviceCode;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        data["participantPersonId"] = this.participantPersonId;
        data["caregiverPersonId"] = this.caregiverPersonId;
        data["ecn"] = this.ecn;
        return data;
    }
}

export interface IGetPeopleDataForRulesRequest {
    serviceCode?: string | undefined;
    serviceDate?: Date;
    participantPersonId?: string | undefined;
    caregiverPersonId?: string | undefined;
    ecn?: string | undefined;
}

export class GetPersonByEmailIdCommand implements IGetPersonByEmailIdCommand {
    accessRights?: string[] | undefined;
    emailId?: string | undefined;

    constructor(data?: IGetPersonByEmailIdCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(item);
            }
            this.emailId = _data["emailId"];
        }
    }

    static fromJS(data: any): GetPersonByEmailIdCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetPersonByEmailIdCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item);
        }
        data["emailId"] = this.emailId;
        return data;
    }
}

export interface IGetPersonByEmailIdCommand {
    accessRights?: string[] | undefined;
    emailId?: string | undefined;
}

export class GetPersonByExternalKeyCommand implements IGetPersonByExternalKeyCommand {
    accessRights?: string[] | undefined;
    keyValue?: string | undefined;
    code?: string | undefined;

    constructor(data?: IGetPersonByExternalKeyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(item);
            }
            this.keyValue = _data["keyValue"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): GetPersonByExternalKeyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetPersonByExternalKeyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item);
        }
        data["keyValue"] = this.keyValue;
        data["code"] = this.code;
        return data;
    }
}

export interface IGetPersonByExternalKeyCommand {
    accessRights?: string[] | undefined;
    keyValue?: string | undefined;
    code?: string | undefined;
}

export class GetStatusConfigurationsByPersonCommand implements IGetStatusConfigurationsByPersonCommand {
    accessRights?: string[] | undefined;
    personId?: number;
    entityType?: string | undefined;
    serviceDate?: Date | undefined;

    constructor(data?: IGetStatusConfigurationsByPersonCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(item);
            }
            this.personId = _data["personId"];
            this.entityType = _data["entityType"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetStatusConfigurationsByPersonCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetStatusConfigurationsByPersonCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item);
        }
        data["personId"] = this.personId;
        data["entityType"] = this.entityType;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetStatusConfigurationsByPersonCommand {
    accessRights?: string[] | undefined;
    personId?: number;
    entityType?: string | undefined;
    serviceDate?: Date | undefined;
}

export class GracePeriodDateSpan implements IGracePeriodDateSpan {
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IGracePeriodDateSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GracePeriodDateSpan {
        data = typeof data === 'object' ? data : {};
        let result = new GracePeriodDateSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGracePeriodDateSpan {
    startDate?: Date;
    endDate?: Date;
}

export class GracePeriodOverrideResponse implements IGracePeriodOverrideResponse {
    employerBeginDate?: Date;
    employerEndDate?: Date;
    gracePeriodDays?: number | undefined;

    constructor(data?: IGracePeriodOverrideResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employerBeginDate = _data["employerBeginDate"] ? new Date(_data["employerBeginDate"].toString()) : <any>undefined;
            this.employerEndDate = _data["employerEndDate"] ? new Date(_data["employerEndDate"].toString()) : <any>undefined;
            this.gracePeriodDays = _data["gracePeriodDays"];
        }
    }

    static fromJS(data: any): GracePeriodOverrideResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GracePeriodOverrideResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employerBeginDate"] = this.employerBeginDate ? this.employerBeginDate.toISOString() : <any>undefined;
        data["employerEndDate"] = this.employerEndDate ? this.employerEndDate.toISOString() : <any>undefined;
        data["gracePeriodDays"] = this.gracePeriodDays;
        return data;
    }
}

export interface IGracePeriodOverrideResponse {
    employerBeginDate?: Date;
    employerEndDate?: Date;
    gracePeriodDays?: number | undefined;
}

export class History implements IHistory {
    id?: number;
    entityRecordId?: number;
    name?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    reason?: string | undefined;

    constructor(data?: IHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityRecordId = _data["entityRecordId"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): History {
        data = typeof data === 'object' ? data : {};
        let result = new History();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityRecordId"] = this.entityRecordId;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IHistory {
    id?: number;
    entityRecordId?: number;
    name?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    reason?: string | undefined;
}

export class HistoryRecord implements IHistoryRecord {
    field?: string | undefined;
    updatedFrom?: string | undefined;
    updatedTo?: string | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;

    constructor(data?: IHistoryRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.updatedFrom = _data["updatedFrom"];
            this.updatedTo = _data["updatedTo"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HistoryRecord {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["updatedFrom"] = this.updatedFrom;
        data["updatedTo"] = this.updatedTo;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHistoryRecord {
    field?: string | undefined;
    updatedFrom?: string | undefined;
    updatedTo?: string | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
}

export class HistoryRecordGridResponseBase implements IHistoryRecordGridResponseBase {
    items?: HistoryRecord[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: HistoryRecord;

    constructor(data?: IHistoryRecordGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HistoryRecord.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? HistoryRecord.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HistoryRecordGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryRecordGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHistoryRecordGridResponseBase {
    items?: HistoryRecord[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: HistoryRecord;
}

export class IActionResult implements IIActionResult {

    constructor(data?: IIActionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IActionResult {
        data = typeof data === 'object' ? data : {};
        let result = new IActionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIActionResult {
}

export class IVRPinAuthenticationDto implements IIVRPinAuthenticationDto {
    ivrPin?: string | undefined;
    personId?: string | undefined;
    companyId?: number;

    constructor(data?: IIVRPinAuthenticationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ivrPin = _data["ivrPin"];
            this.personId = _data["personId"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): IVRPinAuthenticationDto {
        data = typeof data === 'object' ? data : {};
        let result = new IVRPinAuthenticationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ivrPin"] = this.ivrPin;
        data["personId"] = this.personId;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IIVRPinAuthenticationDto {
    ivrPin?: string | undefined;
    personId?: string | undefined;
    companyId?: number;
}

export class IVRPinDto implements IIVRPinDto {
    isAuthenticated?: boolean;
    companyCode?: string | undefined;

    constructor(data?: IIVRPinDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAuthenticated = _data["isAuthenticated"];
            this.companyCode = _data["companyCode"];
        }
    }

    static fromJS(data: any): IVRPinDto {
        data = typeof data === 'object' ? data : {};
        let result = new IVRPinDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthenticated"] = this.isAuthenticated;
        data["companyCode"] = this.companyCode;
        return data;
    }
}

export interface IIVRPinDto {
    isAuthenticated?: boolean;
    companyCode?: string | undefined;
}

export enum IconStatus {
    None = "None",
    Yellow = "Yellow",
    Red = "Red",
    Green = "Green",
    Blue = "Blue",
}

export class ImpersonateUserDetail implements IImpersonateUserDetail {
    firstName?: string | undefined;
    lastName?: string | undefined;
    canImpersonate?: boolean;
    roleText?: string | undefined;
    roleName?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: IImpersonateUserDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.canImpersonate = _data["canImpersonate"];
            this.roleText = _data["roleText"];
            this.roleName = _data["roleName"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ImpersonateUserDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateUserDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["canImpersonate"] = this.canImpersonate;
        data["roleText"] = this.roleText;
        data["roleName"] = this.roleName;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IImpersonateUserDetail {
    firstName?: string | undefined;
    lastName?: string | undefined;
    canImpersonate?: boolean;
    roleText?: string | undefined;
    roleName?: string | undefined;
    isDeleted?: boolean;
}

export class Int32ComboboxModel implements IInt32ComboboxModel {
    id?: number;
    text?: string | undefined;

    constructor(data?: IInt32ComboboxModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): Int32ComboboxModel {
        data = typeof data === 'object' ? data : {};
        let result = new Int32ComboboxModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface IInt32ComboboxModel {
    id?: number;
    text?: string | undefined;
}

export class Int32Response implements IInt32Response {
    entity?: number;
    action?: Action;
    isSuccess?: boolean;

    constructor(data?: IInt32Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entity = _data["entity"];
            this.action = _data["action"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): Int32Response {
        data = typeof data === 'object' ? data : {};
        let result = new Int32Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity;
        data["action"] = this.action;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IInt32Response {
    entity?: number;
    action?: Action;
    isSuccess?: boolean;
}

export class Int64NullableApiResponse implements IInt64NullableApiResponse {
    message?: string | undefined;
    data?: number | undefined;
    success?: boolean;

    constructor(data?: IInt64NullableApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.data = _data["data"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): Int64NullableApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new Int64NullableApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["data"] = this.data;
        data["success"] = this.success;
        return data;
    }
}

export interface IInt64NullableApiResponse {
    message?: string | undefined;
    data?: number | undefined;
    success?: boolean;
}

export class InternalAuthorizationCaregiverDetails implements IInternalAuthorizationCaregiverDetails {
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    caregiverName?: string | undefined;
    caregiverId?: string | undefined;

    constructor(data?: IInternalAuthorizationCaregiverDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverFirstName = _data["caregiverFirstName"];
            this.caregiverLastName = _data["caregiverLastName"];
            this.caregiverName = _data["caregiverName"];
            this.caregiverId = _data["caregiverId"];
        }
    }

    static fromJS(data: any): InternalAuthorizationCaregiverDetails {
        data = typeof data === 'object' ? data : {};
        let result = new InternalAuthorizationCaregiverDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverFirstName"] = this.caregiverFirstName;
        data["caregiverLastName"] = this.caregiverLastName;
        data["caregiverName"] = this.caregiverName;
        data["caregiverId"] = this.caregiverId;
        return data;
    }
}

export interface IInternalAuthorizationCaregiverDetails {
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    caregiverName?: string | undefined;
    caregiverId?: string | undefined;
}

export class InternalAuthorizationEmployerDetails implements IInternalAuthorizationEmployerDetails {
    employerFirstName?: string | undefined;
    employerLastName?: string | undefined;
    employerName?: string | undefined;
    employer?: string | undefined;
    internalAuthorizationCaregiverDetails?: InternalAuthorizationCaregiverDetails[] | undefined;

    constructor(data?: IInternalAuthorizationEmployerDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employerFirstName = _data["employerFirstName"];
            this.employerLastName = _data["employerLastName"];
            this.employerName = _data["employerName"];
            this.employer = _data["employer"];
            if (Array.isArray(_data["internalAuthorizationCaregiverDetails"])) {
                this.internalAuthorizationCaregiverDetails = [] as any;
                for (let item of _data["internalAuthorizationCaregiverDetails"])
                    this.internalAuthorizationCaregiverDetails!.push(InternalAuthorizationCaregiverDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InternalAuthorizationEmployerDetails {
        data = typeof data === 'object' ? data : {};
        let result = new InternalAuthorizationEmployerDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employerFirstName"] = this.employerFirstName;
        data["employerLastName"] = this.employerLastName;
        data["employerName"] = this.employerName;
        data["employer"] = this.employer;
        if (Array.isArray(this.internalAuthorizationCaregiverDetails)) {
            data["internalAuthorizationCaregiverDetails"] = [];
            for (let item of this.internalAuthorizationCaregiverDetails)
                data["internalAuthorizationCaregiverDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInternalAuthorizationEmployerDetails {
    employerFirstName?: string | undefined;
    employerLastName?: string | undefined;
    employerName?: string | undefined;
    employer?: string | undefined;
    internalAuthorizationCaregiverDetails?: InternalAuthorizationCaregiverDetails[] | undefined;
}

export class InternalAuthorizationRelationships implements IInternalAuthorizationRelationships {
    internalAuthorizationEmployerDetails?: InternalAuthorizationEmployerDetails[] | undefined;

    constructor(data?: IInternalAuthorizationRelationships) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["internalAuthorizationEmployerDetails"])) {
                this.internalAuthorizationEmployerDetails = [] as any;
                for (let item of _data["internalAuthorizationEmployerDetails"])
                    this.internalAuthorizationEmployerDetails!.push(InternalAuthorizationEmployerDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InternalAuthorizationRelationships {
        data = typeof data === 'object' ? data : {};
        let result = new InternalAuthorizationRelationships();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.internalAuthorizationEmployerDetails)) {
            data["internalAuthorizationEmployerDetails"] = [];
            for (let item of this.internalAuthorizationEmployerDetails)
                data["internalAuthorizationEmployerDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInternalAuthorizationRelationships {
    internalAuthorizationEmployerDetails?: InternalAuthorizationEmployerDetails[] | undefined;
}

export class IsOkToWorkCommand implements IIsOkToWorkCommand {
    accessRights?: string[] | undefined;
    caregiverId?: number;
    participantIds?: number[] | undefined;
    serviceDates?: Date[] | undefined;
    operation?: string | undefined;
    qualificationRoleTypeId?: number | undefined;

    constructor(data?: IIsOkToWorkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(item);
            }
            this.caregiverId = _data["caregiverId"];
            if (Array.isArray(_data["participantIds"])) {
                this.participantIds = [] as any;
                for (let item of _data["participantIds"])
                    this.participantIds!.push(item);
            }
            if (Array.isArray(_data["serviceDates"])) {
                this.serviceDates = [] as any;
                for (let item of _data["serviceDates"])
                    this.serviceDates!.push(new Date(item));
            }
            this.operation = _data["operation"];
            this.qualificationRoleTypeId = _data["qualificationRole"];
        }
    }

    static fromJS(data: any): IsOkToWorkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new IsOkToWorkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item);
        }
        data["caregiverId"] = this.caregiverId;
        if (Array.isArray(this.participantIds)) {
            data["participantIds"] = [];
            for (let item of this.participantIds)
                data["participantIds"].push(item);
        }
        if (Array.isArray(this.serviceDates)) {
            data["serviceDates"] = [];
            for (let item of this.serviceDates)
                data["serviceDates"].push(item.toISOString());
        }
        data["operation"] = this.operation;
        data["qualificationRoleTypeId"] = this.qualificationRoleTypeId;
        return data;
    }
}

export interface IIsOkToWorkCommand {
    accessRights?: string[] | undefined;
    caregiverId?: number;
    participantIds?: number[] | undefined;
    serviceDates?: Date[] | undefined;
    operation?: string | undefined;
    qualificationRoleTypeId?: number | undefined;
}

export class LanguageDto implements ILanguageDto {
    code?: string | undefined;
    value?: string | undefined;

    constructor(data?: ILanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): LanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["value"] = this.value;
        return data;
    }
}

export interface ILanguageDto {
    code?: string | undefined;
    value?: string | undefined;
}

export class LastDates implements ILastDates {
    eventDate?: Date;
    lastDateWorked?: Date | undefined;
    lastDatePaid?: Date | undefined;

    constructor(data?: ILastDates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.lastDateWorked = _data["lastDateWorked"] ? new Date(_data["lastDateWorked"].toString()) : <any>undefined;
            this.lastDatePaid = _data["lastDatePaid"] ? new Date(_data["lastDatePaid"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LastDates {
        data = typeof data === 'object' ? data : {};
        let result = new LastDates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["lastDateWorked"] = this.lastDateWorked ? this.lastDateWorked.toISOString() : <any>undefined;
        data["lastDatePaid"] = this.lastDatePaid ? this.lastDatePaid.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILastDates {
    eventDate?: Date;
    lastDateWorked?: Date | undefined;
    lastDatePaid?: Date | undefined;
}

export class MasterConfigDto implements IMasterConfigDto {
    id?: number;
    category?: string | undefined;
    description?: string | undefined;
    code?: string | undefined;
    displayText?: string | undefined;
    companyId?: number;
    isDeleted?: boolean;

    constructor(data?: IMasterConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
            this.description = _data["description"];
            this.code = _data["code"];
            this.displayText = _data["displayText"];
            this.companyId = _data["companyId"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): MasterConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new MasterConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        data["description"] = this.description;
        data["code"] = this.code;
        data["displayText"] = this.displayText;
        data["companyId"] = this.companyId;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IMasterConfigDto {
    id?: number;
    category?: string | undefined;
    description?: string | undefined;
    code?: string | undefined;
    displayText?: string | undefined;
    companyId?: number;
    isDeleted?: boolean;
}

export class MasterConfigRequestDto implements IMasterConfigRequestDto {
    categories?: string[] | undefined;

    constructor(data?: IMasterConfigRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
        }
    }

    static fromJS(data: any): MasterConfigRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new MasterConfigRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        return data;
    }
}

export interface IMasterConfigRequestDto {
    categories?: string[] | undefined;
}

export class McoData implements IMcoData {
    personStatus?: string | undefined;
    id?: number;
    personId?: string | undefined;
    status?: PeopleStatus;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    statusChangeReason?: string | undefined;
    ssn?: string | undefined;
    maritalStatus?: string | undefined;
    personStatusHistories?: PersonStatusHistory[] | undefined;
    payorIds?: number[] | undefined;

    constructor(data?: IMcoData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personStatus = _data["personStatus"];
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.status = _data["status"];
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.statusChangeReason = _data["statusChangeReason"];
            this.ssn = _data["ssn"];
            this.maritalStatus = _data["maritalStatus"];
            if (Array.isArray(_data["personStatusHistories"])) {
                this.personStatusHistories = [] as any;
                for (let item of _data["personStatusHistories"])
                    this.personStatusHistories!.push(PersonStatusHistory.fromJS(item));
            }
            if (Array.isArray(_data["payorIds"])) {
                this.payorIds = [] as any;
                for (let item of _data["payorIds"])
                    this.payorIds!.push(item);
            }
        }
    }

    static fromJS(data: any): McoData {
        data = typeof data === 'object' ? data : {};
        let result = new McoData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personStatus"] = this.personStatus;
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["status"] = this.status;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["statusChangeReason"] = this.statusChangeReason;
        data["ssn"] = this.ssn;
        data["maritalStatus"] = this.maritalStatus;
        if (Array.isArray(this.personStatusHistories)) {
            data["personStatusHistories"] = [];
            for (let item of this.personStatusHistories)
                data["personStatusHistories"].push(item.toJSON());
        }
        if (Array.isArray(this.payorIds)) {
            data["payorIds"] = [];
            for (let item of this.payorIds)
                data["payorIds"].push(item);
        }
        return data;
    }
}

export interface IMcoData {
    personStatus?: string | undefined;
    id?: number;
    personId?: string | undefined;
    status?: PeopleStatus;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    statusChangeReason?: string | undefined;
    ssn?: string | undefined;
    maritalStatus?: string | undefined;
    personStatusHistories?: PersonStatusHistory[] | undefined;
    payorIds?: number[] | undefined;
}

export class McoDataGridResponseBase implements IMcoDataGridResponseBase {
    items?: McoData[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: McoData;

    constructor(data?: IMcoDataGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(McoData.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? McoData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): McoDataGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new McoDataGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMcoDataGridResponseBase {
    items?: McoData[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: McoData;
}

export class McoDetailResponse implements IMcoDetailResponse {
    phoneDetails?: PhoneDetail[] | undefined;
    physicalAddresses?: AddressDTO[] | undefined;
    mailingAddresses?: AddressDTO[] | undefined;
    ivrAddresses?: AddressDTO[] | undefined;
    externalKeys?: ExternalKeyDTO[] | undefined;
    id?: number;
    personId?: string | undefined;
    status?: string | undefined;
    readonly personName?: string | undefined;
    ssn?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    physicalAddress?: string | undefined;
    mailingAddress?: string | undefined;
    ivrAddress?: string | undefined;
    companyCode?: string | undefined;
    unmaskedSsn?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    ivrPin?: string | undefined;
    paymentMethod?: string | undefined;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    coordinatorPersonFirstName?: string | undefined;
    coordinatorPersonLastName?: string | undefined;
    coordinatorPersonName?: string | undefined;
    lastV4LoginOn?: Date | undefined;
    isSsnValidated?: boolean | undefined;
    ssnValidationOverrideOn?: Date | undefined;
    ssnValidationOverrideBy?: string | undefined;
    payorCount?: number;
    mcoId?: number;
    mcoStatus?: string | undefined;

    constructor(data?: IMcoDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["phoneDetails"])) {
                this.phoneDetails = [] as any;
                for (let item of _data["phoneDetails"])
                    this.phoneDetails!.push(PhoneDetail.fromJS(item));
            }
            if (Array.isArray(_data["physicalAddresses"])) {
                this.physicalAddresses = [] as any;
                for (let item of _data["physicalAddresses"])
                    this.physicalAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["mailingAddresses"])) {
                this.mailingAddresses = [] as any;
                for (let item of _data["mailingAddresses"])
                    this.mailingAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["ivrAddresses"])) {
                this.ivrAddresses = [] as any;
                for (let item of _data["ivrAddresses"])
                    this.ivrAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["externalKeys"])) {
                this.externalKeys = [] as any;
                for (let item of _data["externalKeys"])
                    this.externalKeys!.push(ExternalKeyDTO.fromJS(item));
            }
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.status = _data["status"];
            (<any>this).personName = _data["personName"];
            this.ssn = _data["ssn"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.gender = _data["gender"];
            this.ethnicity = _data["ethnicity"];
            this.race = _data["race"];
            this.maritalStatus = _data["maritalStatus"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.physicalAddress = _data["physicalAddress"];
            this.mailingAddress = _data["mailingAddress"];
            this.ivrAddress = _data["ivrAddress"];
            this.companyCode = _data["companyCode"];
            this.unmaskedSsn = _data["unmaskedSsn"];
            this.onboarded = _data["onboarded"];
            this.isFirstLoginComplete = _data["isFirstLoginComplete"];
            this.ivrPin = _data["ivrPin"];
            this.paymentMethod = _data["paymentMethod"];
            this.coordinatorPersonId = _data["coordinatorPersonId"];
            this.internalUserObjectId = _data["internalUserObjectId"];
            this.coordinatorPersonFirstName = _data["coordinatorPersonFirstName"];
            this.coordinatorPersonLastName = _data["coordinatorPersonLastName"];
            this.coordinatorPersonName = _data["coordinatorPersonName"];
            this.lastV4LoginOn = _data["lastV4LoginOn"] ? new Date(_data["lastV4LoginOn"].toString()) : <any>undefined;
            this.isSsnValidated = _data["isSsnValidated"];
            this.ssnValidationOverrideOn = _data["ssnValidationOverrideOn"] ? new Date(_data["ssnValidationOverrideOn"].toString()) : <any>undefined;
            this.ssnValidationOverrideBy = _data["ssnValidationOverrideBy"];
            this.payorCount = _data["payorCount"];
            this.mcoId = _data["mcoId"];
            this.mcoStatus = _data["mcoStatus"];
        }
    }

    static fromJS(data: any): McoDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new McoDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phoneDetails)) {
            data["phoneDetails"] = [];
            for (let item of this.phoneDetails)
                data["phoneDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.physicalAddresses)) {
            data["physicalAddresses"] = [];
            for (let item of this.physicalAddresses)
                data["physicalAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.mailingAddresses)) {
            data["mailingAddresses"] = [];
            for (let item of this.mailingAddresses)
                data["mailingAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.ivrAddresses)) {
            data["ivrAddresses"] = [];
            for (let item of this.ivrAddresses)
                data["ivrAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.externalKeys)) {
            data["externalKeys"] = [];
            for (let item of this.externalKeys)
                data["externalKeys"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["status"] = this.status;
        data["personName"] = this.personName;
        data["ssn"] = this.ssn;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["gender"] = this.gender;
        data["ethnicity"] = this.ethnicity;
        data["race"] = this.race;
        data["maritalStatus"] = this.maritalStatus;
        data["preferredLanguage"] = this.preferredLanguage;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["physicalAddress"] = this.physicalAddress;
        data["mailingAddress"] = this.mailingAddress;
        data["ivrAddress"] = this.ivrAddress;
        data["companyCode"] = this.companyCode;
        data["unmaskedSsn"] = this.unmaskedSsn;
        data["onboarded"] = this.onboarded;
        data["isFirstLoginComplete"] = this.isFirstLoginComplete;
        data["ivrPin"] = this.ivrPin;
        data["paymentMethod"] = this.paymentMethod;
        data["coordinatorPersonId"] = this.coordinatorPersonId;
        data["internalUserObjectId"] = this.internalUserObjectId;
        data["coordinatorPersonFirstName"] = this.coordinatorPersonFirstName;
        data["coordinatorPersonLastName"] = this.coordinatorPersonLastName;
        data["coordinatorPersonName"] = this.coordinatorPersonName;
        data["lastV4LoginOn"] = this.lastV4LoginOn ? this.lastV4LoginOn.toISOString() : <any>undefined;
        data["isSsnValidated"] = this.isSsnValidated;
        data["ssnValidationOverrideOn"] = this.ssnValidationOverrideOn ? this.ssnValidationOverrideOn.toISOString() : <any>undefined;
        data["ssnValidationOverrideBy"] = this.ssnValidationOverrideBy;
        data["payorCount"] = this.payorCount;
        data["mcoId"] = this.mcoId;
        data["mcoStatus"] = this.mcoStatus;
        return data;
    }
}

export interface IMcoDetailResponse {
    phoneDetails?: PhoneDetail[] | undefined;
    physicalAddresses?: AddressDTO[] | undefined;
    mailingAddresses?: AddressDTO[] | undefined;
    ivrAddresses?: AddressDTO[] | undefined;
    externalKeys?: ExternalKeyDTO[] | undefined;
    id?: number;
    personId?: string | undefined;
    status?: string | undefined;
    personName?: string | undefined;
    ssn?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    physicalAddress?: string | undefined;
    mailingAddress?: string | undefined;
    ivrAddress?: string | undefined;
    companyCode?: string | undefined;
    unmaskedSsn?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    ivrPin?: string | undefined;
    paymentMethod?: string | undefined;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    coordinatorPersonFirstName?: string | undefined;
    coordinatorPersonLastName?: string | undefined;
    coordinatorPersonName?: string | undefined;
    lastV4LoginOn?: Date | undefined;
    isSsnValidated?: boolean | undefined;
    ssnValidationOverrideOn?: Date | undefined;
    ssnValidationOverrideBy?: string | undefined;
    payorCount?: number;
    mcoId?: number;
    mcoStatus?: string | undefined;
}

export class McoPayorMapping implements IMcoPayorMapping {
    id?: number;
    mcoId?: number;
    payorId?: number;
    payorName?: string | undefined;
    payorDescription?: string | undefined;

    constructor(data?: IMcoPayorMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mcoId = _data["mcoId"];
            this.payorId = _data["payorId"];
            this.payorName = _data["payorName"];
            this.payorDescription = _data["payorDescription"];
        }
    }

    static fromJS(data: any): McoPayorMapping {
        data = typeof data === 'object' ? data : {};
        let result = new McoPayorMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mcoId"] = this.mcoId;
        data["payorId"] = this.payorId;
        data["payorName"] = this.payorName;
        data["payorDescription"] = this.payorDescription;
        return data;
    }
}

export interface IMcoPayorMapping {
    id?: number;
    mcoId?: number;
    payorId?: number;
    payorName?: string | undefined;
    payorDescription?: string | undefined;
}

export class McoPayorMappingGridResponseBase implements IMcoPayorMappingGridResponseBase {
    items?: McoPayorMapping[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: McoPayorMapping;

    constructor(data?: IMcoPayorMappingGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(McoPayorMapping.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? McoPayorMapping.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): McoPayorMappingGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new McoPayorMappingGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMcoPayorMappingGridResponseBase {
    items?: McoPayorMapping[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: McoPayorMapping;
}

export class McoRequest implements IMcoRequest {
    personId?: string | undefined;
    mcoId?: number;

    constructor(data?: IMcoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.mcoId = _data["mcoId"];
        }
    }

    static fromJS(data: any): McoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new McoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["mcoId"] = this.mcoId;
        return data;
    }
}

export interface IMcoRequest {
    personId?: string | undefined;
    mcoId?: number;
}

export class McoResponse implements IMcoResponse {
    mco?: McoData;
    payors?: McoPayorMapping[] | undefined;

    constructor(data?: IMcoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mco = _data["mco"] ? McoData.fromJS(_data["mco"]) : <any>undefined;
            if (Array.isArray(_data["payors"])) {
                this.payors = [] as any;
                for (let item of _data["payors"])
                    this.payors!.push(McoPayorMapping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): McoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new McoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mco"] = this.mco ? this.mco.toJSON() : <any>undefined;
        if (Array.isArray(this.payors)) {
            data["payors"] = [];
            for (let item of this.payors)
                data["payors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMcoResponse {
    mco?: McoData;
    payors?: McoPayorMapping[] | undefined;
}

export class NotificationOriginRequest implements INotificationOriginRequest {
    notificationGuid?: string;
    originatingPersonId?: string | undefined;
    originatingPersonType?: string | undefined;
    isPrimary?: boolean;

    constructor(data?: INotificationOriginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationGuid = _data["notificationGuid"];
            this.originatingPersonId = _data["originatingPersonId"];
            this.originatingPersonType = _data["originatingPersonType"];
            this.isPrimary = _data["isPrimary"];
        }
    }

    static fromJS(data: any): NotificationOriginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationOriginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationGuid"] = this.notificationGuid;
        data["originatingPersonId"] = this.originatingPersonId;
        data["originatingPersonType"] = this.originatingPersonType;
        data["isPrimary"] = this.isPrimary;
        return data;
    }
}

export interface INotificationOriginRequest {
    notificationGuid?: string;
    originatingPersonId?: string | undefined;
    originatingPersonType?: string | undefined;
    isPrimary?: boolean;
}

export class NotificationRequest implements INotificationRequest {
    recipientId?: string | undefined;
    recipientPersonType?: string | undefined;
    notificationDate?: Date;
    priority?: number;
    isRead?: boolean;
    notificationMessage?: string | undefined;
    notificationGuid?: string;
    eventName?: string | undefined;
    regardingId?: string | undefined;
    regardingName?: string | undefined;

    constructor(data?: INotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipientId = _data["recipientId"];
            this.recipientPersonType = _data["recipientPersonType"];
            this.notificationDate = _data["notificationDate"] ? new Date(_data["notificationDate"].toString()) : <any>undefined;
            this.priority = _data["priority"];
            this.isRead = _data["isRead"];
            this.notificationMessage = _data["notificationMessage"];
            this.notificationGuid = _data["notificationGuid"];
            this.eventName = _data["eventName"];
            this.regardingId = _data["regardingId"];
            this.regardingName = _data["regardingName"];
        }
    }

    static fromJS(data: any): NotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipientId"] = this.recipientId;
        data["recipientPersonType"] = this.recipientPersonType;
        data["notificationDate"] = this.notificationDate ? this.notificationDate.toISOString() : <any>undefined;
        data["priority"] = this.priority;
        data["isRead"] = this.isRead;
        data["notificationMessage"] = this.notificationMessage;
        data["notificationGuid"] = this.notificationGuid;
        data["eventName"] = this.eventName;
        data["regardingId"] = this.regardingId;
        data["regardingName"] = this.regardingName;
        return data;
    }
}

export interface INotificationRequest {
    recipientId?: string | undefined;
    recipientPersonType?: string | undefined;
    notificationDate?: Date;
    priority?: number;
    isRead?: boolean;
    notificationMessage?: string | undefined;
    notificationGuid?: string;
    eventName?: string | undefined;
    regardingId?: string | undefined;
    regardingName?: string | undefined;
}

export class NotificationStorageRequest implements INotificationStorageRequest {
    notificationRequest?: NotificationRequest;
    notificationOriginRequests?: NotificationOriginRequest[] | undefined;

    constructor(data?: INotificationStorageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationRequest = _data["notificationRequest"] ? NotificationRequest.fromJS(_data["notificationRequest"]) : <any>undefined;
            if (Array.isArray(_data["notificationOriginRequests"])) {
                this.notificationOriginRequests = [] as any;
                for (let item of _data["notificationOriginRequests"])
                    this.notificationOriginRequests!.push(NotificationOriginRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationStorageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationStorageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationRequest"] = this.notificationRequest ? this.notificationRequest.toJSON() : <any>undefined;
        if (Array.isArray(this.notificationOriginRequests)) {
            data["notificationOriginRequests"] = [];
            for (let item of this.notificationOriginRequests)
                data["notificationOriginRequests"].push(item.toJSON());
        }
        return data;
    }
}

export interface INotificationStorageRequest {
    notificationRequest?: NotificationRequest;
    notificationOriginRequests?: NotificationOriginRequest[] | undefined;
}

export class OkToWorkDate implements IOkToWorkDate {
    date?: Date;
    status?: boolean;
    missingQualificationIds?: number[] | undefined;
    readonly missingEquvQualificationIds?: QualificationDate[] | undefined;
    readonly requiredQualifications?: QualificationDate[] | undefined;

    constructor(data?: IOkToWorkDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.status = _data["status"];
            if (Array.isArray(_data["missingQualificationIds"])) {
                this.missingQualificationIds = [] as any;
                for (let item of _data["missingQualificationIds"])
                    this.missingQualificationIds!.push(item);
            }
            if (Array.isArray(_data["missingEquvQualificationIds"])) {
                (<any>this).missingEquvQualificationIds = [] as any;
                for (let item of _data["missingEquvQualificationIds"])
                    (<any>this).missingEquvQualificationIds!.push(QualificationDate.fromJS(item));
            }
            if (Array.isArray(_data["requiredQualifications"])) {
                (<any>this).requiredQualifications = [] as any;
                for (let item of _data["requiredQualifications"])
                    (<any>this).requiredQualifications!.push(QualificationDate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OkToWorkDate {
        data = typeof data === 'object' ? data : {};
        let result = new OkToWorkDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["status"] = this.status;
        if (Array.isArray(this.missingQualificationIds)) {
            data["missingQualificationIds"] = [];
            for (let item of this.missingQualificationIds)
                data["missingQualificationIds"].push(item);
        }
        if (Array.isArray(this.missingEquvQualificationIds)) {
            data["missingEquvQualificationIds"] = [];
            for (let item of this.missingEquvQualificationIds)
                data["missingEquvQualificationIds"].push(item.toJSON());
        }
        if (Array.isArray(this.requiredQualifications)) {
            data["requiredQualifications"] = [];
            for (let item of this.requiredQualifications)
                data["requiredQualifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOkToWorkDate {
    date?: Date;
    status?: boolean;
    missingQualificationIds?: number[] | undefined;
    missingEquvQualificationIds?: QualificationDate[] | undefined;
    requiredQualifications?: QualificationDate[] | undefined;
}

export class OkToWorkStatus implements IOkToWorkStatus {
    participantPersonId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    qualifications?: CaregiverQualification[] | undefined;

    constructor(data?: IOkToWorkStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantPersonId = _data["participantPersonId"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            if (Array.isArray(_data["qualifications"])) {
                this.qualifications = [] as any;
                for (let item of _data["qualifications"])
                    this.qualifications!.push(CaregiverQualification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OkToWorkStatus {
        data = typeof data === 'object' ? data : {};
        let result = new OkToWorkStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantPersonId"] = this.participantPersonId;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        if (Array.isArray(this.qualifications)) {
            data["qualifications"] = [];
            for (let item of this.qualifications)
                data["qualifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOkToWorkStatus {
    participantPersonId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    qualifications?: CaregiverQualification[] | undefined;
}

export class OkToWorkStatusRequest implements IOkToWorkStatusRequest {
    caregiverPersonId?: string | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IOkToWorkStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverPersonId = _data["caregiverPersonId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OkToWorkStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OkToWorkStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverPersonId"] = this.caregiverPersonId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOkToWorkStatusRequest {
    caregiverPersonId?: string | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class OkToWorkStatusResponse implements IOkToWorkStatusResponse {
    okToWorkStatuses?: OkToWorkStatus[] | undefined;

    constructor(data?: IOkToWorkStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["okToWorkStatuses"])) {
                this.okToWorkStatuses = [] as any;
                for (let item of _data["okToWorkStatuses"])
                    this.okToWorkStatuses!.push(OkToWorkStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OkToWorkStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OkToWorkStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.okToWorkStatuses)) {
            data["okToWorkStatuses"] = [];
            for (let item of this.okToWorkStatuses)
                data["okToWorkStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOkToWorkStatusResponse {
    okToWorkStatuses?: OkToWorkStatus[] | undefined;
}

export class OptionDetails implements IOptionDetails {
    componentId?: number;
    optionText?: string | undefined;
    optionCode?: string | undefined;
    optionDetailId?: number;
    optionId?: number;
    sortOrder?: number;

    constructor(data?: IOptionDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.optionText = _data["optionText"];
            this.optionCode = _data["optionCode"];
            this.optionDetailId = _data["optionDetailId"];
            this.optionId = _data["optionId"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): OptionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new OptionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["optionText"] = this.optionText;
        data["optionCode"] = this.optionCode;
        data["optionDetailId"] = this.optionDetailId;
        data["optionId"] = this.optionId;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IOptionDetails {
    componentId?: number;
    optionText?: string | undefined;
    optionCode?: string | undefined;
    optionDetailId?: number;
    optionId?: number;
    sortOrder?: number;
}

export class OvertimeEligibilityRequest implements IOvertimeEligibilityRequest {
    caregiverId?: string | undefined;
    employerId?: string | undefined;
    participantId?: string | undefined;
    serviceCode?: string | undefined;
    serviceDate?: Date;

    constructor(data?: IOvertimeEligibilityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.employerId = _data["employerId"];
            this.participantId = _data["participantId"];
            this.serviceCode = _data["serviceCode"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OvertimeEligibilityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OvertimeEligibilityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["employerId"] = this.employerId;
        data["participantId"] = this.participantId;
        data["serviceCode"] = this.serviceCode;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOvertimeEligibilityRequest {
    caregiverId?: string | undefined;
    employerId?: string | undefined;
    participantId?: string | undefined;
    serviceCode?: string | undefined;
    serviceDate?: Date;
}

export class OvertimeEligibilityResponse implements IOvertimeEligibilityResponse {
    employerOT?: boolean | undefined;
    payCalc?: PayCalcMethod;
    payRateOT?: boolean | undefined;
    servCodeOT?: boolean | undefined;

    constructor(data?: IOvertimeEligibilityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employerOT = _data["employerOT"];
            this.payCalc = _data["payCalc"];
            this.payRateOT = _data["payRateOT"];
            this.servCodeOT = _data["servCodeOT"];
        }
    }

    static fromJS(data: any): OvertimeEligibilityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OvertimeEligibilityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employerOT"] = this.employerOT;
        data["payCalc"] = this.payCalc;
        data["payRateOT"] = this.payRateOT;
        data["servCodeOT"] = this.servCodeOT;
        return data;
    }
}

export interface IOvertimeEligibilityResponse {
    employerOT?: boolean | undefined;
    payCalc?: PayCalcMethod;
    payRateOT?: boolean | undefined;
    servCodeOT?: boolean | undefined;
}

export class PCEmployerModel implements IPCEmployerModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number;
    programCoordinatorId?: number;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IPCEmployerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.id = _data["id"];
            this.programCoordinatorId = _data["programCoordinatorId"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PCEmployerModel {
        data = typeof data === 'object' ? data : {};
        let result = new PCEmployerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["id"] = this.id;
        data["programCoordinatorId"] = this.programCoordinatorId;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPCEmployerModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number;
    programCoordinatorId?: number;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class ParticipantAreaMapping implements IParticipantAreaMapping {
    participantAreaMappingId?: number;
    participantId?: number;
    areaStartDate?: Date | undefined;
    areaEndDate?: Date | undefined;
    area?: string | undefined;
    areaId?: number;
    isDeleted?: boolean;

    constructor(data?: IParticipantAreaMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantAreaMappingId = _data["participantAreaMappingId"];
            this.participantId = _data["participantId"];
            this.areaStartDate = _data["areaStartDate"] ? new Date(_data["areaStartDate"].toString()) : <any>undefined;
            this.areaEndDate = _data["areaEndDate"] ? new Date(_data["areaEndDate"].toString()) : <any>undefined;
            this.area = _data["area"];
            this.areaId = _data["areaId"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ParticipantAreaMapping {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantAreaMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantAreaMappingId"] = this.participantAreaMappingId;
        data["participantId"] = this.participantId;
        data["areaStartDate"] = this.areaStartDate ? this.areaStartDate.toISOString() : <any>undefined;
        data["areaEndDate"] = this.areaEndDate ? this.areaEndDate.toISOString() : <any>undefined;
        data["area"] = this.area;
        data["areaId"] = this.areaId;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IParticipantAreaMapping {
    participantAreaMappingId?: number;
    participantId?: number;
    areaStartDate?: Date | undefined;
    areaEndDate?: Date | undefined;
    area?: string | undefined;
    areaId?: number;
    isDeleted?: boolean;
}

export class ParticipantCaregiverExemption implements IParticipantCaregiverExemption {
    id?: number;
    exemptionTypeId?: number;
    exemption?: Exemption;
    exemptionCategory?: ExemptionCategory;
    displayText?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    isDeleted?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IParticipantCaregiverExemption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.exemptionTypeId = _data["exemptionTypeId"];
            this.exemption = _data["exemption"];
            this.exemptionCategory = _data["exemptionCategory"];
            this.displayText = _data["displayText"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ParticipantCaregiverExemption {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantCaregiverExemption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["exemptionTypeId"] = this.exemptionTypeId;
        data["exemption"] = this.exemption;
        data["exemptionCategory"] = this.exemptionCategory;
        data["displayText"] = this.displayText;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IParticipantCaregiverExemption {
    id?: number;
    exemptionTypeId?: number;
    exemption?: Exemption;
    exemptionCategory?: ExemptionCategory;
    displayText?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    isDeleted?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class ParticipantCaregiverLiveinDateRange implements IParticipantCaregiverLiveinDateRange {
    id?: number;
    startDate?: Date;
    endDate?: Date;
    isDeleted?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IParticipantCaregiverLiveinDateRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ParticipantCaregiverLiveinDateRange {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantCaregiverLiveinDateRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IParticipantCaregiverLiveinDateRange {
    id?: number;
    startDate?: Date;
    endDate?: Date;
    isDeleted?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class ParticipantCaregiverRelationResponse implements IParticipantCaregiverRelationResponse {
    participantId?: number;
    caregiverId?: number;
    caregiverParticipantRelId?: number;
    companyId?: number;
    qualificationRoleTypeId?: number | undefined;
    testAuthEndDate?: Date;
    relationshipId?: number | undefined;
    serviceTypes?: ParticipantCaregiverServiceType[] | undefined;
    liveinDateRanges?: ParticipantCaregiverLiveinDateRange[] | undefined;
    statusDateRanges?: ParticipantCaregiverStatusDateRange[] | undefined;
    relationshipDateRanges?: ParticipantCaregiverRelationshipDateRange[] | undefined;
    roleTypes?: ParticipantCaregiverRoleType[] | undefined;
    exemptions?: ParticipantCaregiverExemption[] | undefined;

    constructor(data?: IParticipantCaregiverRelationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.caregiverId = _data["caregiverId"];
            this.caregiverParticipantRelId = _data["caregiverParticipantRelId"];
            this.companyId = _data["companyId"];
            this.qualificationRoleTypeId = _data["qualificationRoleTypeId"];
            this.testAuthEndDate = _data["testAuthEndDate"] ? new Date(_data["testAuthEndDate"].toString()) : <any>undefined;
            this.relationshipId = _data["relationshipId"];
            if (Array.isArray(_data["serviceTypes"])) {
                this.serviceTypes = [] as any;
                for (let item of _data["serviceTypes"])
                    this.serviceTypes!.push(ParticipantCaregiverServiceType.fromJS(item));
            }
            if (Array.isArray(_data["liveinDateRanges"])) {
                this.liveinDateRanges = [] as any;
                for (let item of _data["liveinDateRanges"])
                    this.liveinDateRanges!.push(ParticipantCaregiverLiveinDateRange.fromJS(item));
            }
            if (Array.isArray(_data["statusDateRanges"])) {
                this.statusDateRanges = [] as any;
                for (let item of _data["statusDateRanges"])
                    this.statusDateRanges!.push(ParticipantCaregiverStatusDateRange.fromJS(item));
            }
            if (Array.isArray(_data["relationshipDateRanges"])) {
                this.relationshipDateRanges = [] as any;
                for (let item of _data["relationshipDateRanges"])
                    this.relationshipDateRanges!.push(ParticipantCaregiverRelationshipDateRange.fromJS(item));
            }
            if (Array.isArray(_data["roleTypes"])) {
                this.roleTypes = [] as any;
                for (let item of _data["roleTypes"])
                    this.roleTypes!.push(ParticipantCaregiverRoleType.fromJS(item));
            }
            if (Array.isArray(_data["exemptions"])) {
                this.exemptions = [] as any;
                for (let item of _data["exemptions"])
                    this.exemptions!.push(ParticipantCaregiverExemption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParticipantCaregiverRelationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantCaregiverRelationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["caregiverId"] = this.caregiverId;
        data["caregiverParticipantRelId"] = this.caregiverParticipantRelId;
        data["companyId"] = this.companyId;
        data["qualificationRoleTypeId"] = this.qualificationRoleTypeId;
        data["testAuthEndDate"] = this.testAuthEndDate ? this.testAuthEndDate.toISOString() : <any>undefined;
        data["relationshipId"] = this.relationshipId;
        if (Array.isArray(this.serviceTypes)) {
            data["serviceTypes"] = [];
            for (let item of this.serviceTypes)
                data["serviceTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.liveinDateRanges)) {
            data["liveinDateRanges"] = [];
            for (let item of this.liveinDateRanges)
                data["liveinDateRanges"].push(item.toJSON());
        }
        if (Array.isArray(this.statusDateRanges)) {
            data["statusDateRanges"] = [];
            for (let item of this.statusDateRanges)
                data["statusDateRanges"].push(item.toJSON());
        }
        if (Array.isArray(this.relationshipDateRanges)) {
            data["relationshipDateRanges"] = [];
            for (let item of this.relationshipDateRanges)
                data["relationshipDateRanges"].push(item.toJSON());
        }
        if (Array.isArray(this.roleTypes)) {
            data["roleTypes"] = [];
            for (let item of this.roleTypes)
                data["roleTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.exemptions)) {
            data["exemptions"] = [];
            for (let item of this.exemptions)
                data["exemptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IParticipantCaregiverRelationResponse {
    participantId?: number;
    caregiverId?: number;
    caregiverParticipantRelId?: number;
    companyId?: number;
    qualificationRoleTypeId?: number | undefined;
    testAuthEndDate?: Date;
    relationshipId?: number | undefined;
    serviceTypes?: ParticipantCaregiverServiceType[] | undefined;
    liveinDateRanges?: ParticipantCaregiverLiveinDateRange[] | undefined;
    statusDateRanges?: ParticipantCaregiverStatusDateRange[] | undefined;
    relationshipDateRanges?: ParticipantCaregiverRelationshipDateRange[] | undefined;
    roleTypes?: ParticipantCaregiverRoleType[] | undefined;
    exemptions?: ParticipantCaregiverExemption[] | undefined;
}

export class ParticipantCaregiverRelationshipDateRange implements IParticipantCaregiverRelationshipDateRange {
    id?: number;
    relationship?: CaregiverParticipantRelationship;
    startDate?: Date;
    endDate?: Date;
    isDeleted?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IParticipantCaregiverRelationshipDateRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.relationship = _data["relationship"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ParticipantCaregiverRelationshipDateRange {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantCaregiverRelationshipDateRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["relationship"] = this.relationship;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IParticipantCaregiverRelationshipDateRange {
    id?: number;
    relationship?: CaregiverParticipantRelationship;
    startDate?: Date;
    endDate?: Date;
    isDeleted?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class ParticipantCaregiverRoleType implements IParticipantCaregiverRoleType {
    id?: number;
    qualificationRoleTypeId?: number;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IParticipantCaregiverRoleType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationRoleTypeId = _data["qualificationRoleTypeId"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ParticipantCaregiverRoleType {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantCaregiverRoleType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationRoleTypeId"] = this.qualificationRoleTypeId;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IParticipantCaregiverRoleType {
    id?: number;
    qualificationRoleTypeId?: number;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class ParticipantCaregiverServiceType implements IParticipantCaregiverServiceType {
    serviceTypeId?: number;
    caregiverParticipantServiceTypeId?: number;
    isDeleted?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IParticipantCaregiverServiceType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceTypeId = _data["serviceTypeId"];
            this.caregiverParticipantServiceTypeId = _data["caregiverParticipantServiceTypeId"];
            this.isDeleted = _data["isDeleted"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ParticipantCaregiverServiceType {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantCaregiverServiceType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceTypeId"] = this.serviceTypeId;
        data["caregiverParticipantServiceTypeId"] = this.caregiverParticipantServiceTypeId;
        data["isDeleted"] = this.isDeleted;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IParticipantCaregiverServiceType {
    serviceTypeId?: number;
    caregiverParticipantServiceTypeId?: number;
    isDeleted?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class ParticipantCaregiverStatusDateRange implements IParticipantCaregiverStatusDateRange {
    id?: number;
    status?: PeopleStatus;
    isDeleted?: boolean;
    startDate?: Date;
    endDate?: Date;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IParticipantCaregiverStatusDateRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.isDeleted = _data["isDeleted"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ParticipantCaregiverStatusDateRange {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantCaregiverStatusDateRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["isDeleted"] = this.isDeleted;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IParticipantCaregiverStatusDateRange {
    id?: number;
    status?: PeopleStatus;
    isDeleted?: boolean;
    startDate?: Date;
    endDate?: Date;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class ParticipantCaseMgrFilterRequest implements IParticipantCaseMgrFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    participantId?: number | undefined;
    caseManagerId?: number | undefined;

    constructor(data?: IParticipantCaseMgrFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            this.participantId = _data["participantId"];
            this.caseManagerId = _data["caseManagerId"];
        }
    }

    static fromJS(data: any): ParticipantCaseMgrFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantCaseMgrFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        data["participantId"] = this.participantId;
        data["caseManagerId"] = this.caseManagerId;
        return data;
    }
}

export interface IParticipantCaseMgrFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    participantId?: number | undefined;
    caseManagerId?: number | undefined;
}

export class ParticipantCaseMgrRelRequest implements IParticipantCaseMgrRelRequest {
    caseManagerAuthMappingId?: number | undefined;
    caseManagerId?: number;
    participantId?: number;
    authExternalId?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;

    constructor(data?: IParticipantCaseMgrRelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseManagerAuthMappingId = _data["caseManagerAuthMappingId"];
            this.caseManagerId = _data["caseManagerId"];
            this.participantId = _data["participantId"];
            this.authExternalId = _data["authExternalId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ParticipantCaseMgrRelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantCaseMgrRelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseManagerAuthMappingId"] = this.caseManagerAuthMappingId;
        data["caseManagerId"] = this.caseManagerId;
        data["participantId"] = this.participantId;
        data["authExternalId"] = this.authExternalId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IParticipantCaseMgrRelRequest {
    caseManagerAuthMappingId?: number | undefined;
    caseManagerId?: number;
    participantId?: number;
    authExternalId?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
}

export class ParticipantCaseMgrRelResponse implements IParticipantCaseMgrRelResponse {
    caseManagerAuthMappingId?: number | undefined;
    caseManagerId?: number;
    caseManagerFirstName?: string | undefined;
    caseManagerLastName?: string | undefined;
    caseManagerName?: string | undefined;
    participantId?: number;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantName?: string | undefined;
    authExternalId?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    caseManagerPersonId?: number;
    participantPersonId?: string | undefined;

    constructor(data?: IParticipantCaseMgrRelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseManagerAuthMappingId = _data["caseManagerAuthMappingId"];
            this.caseManagerId = _data["caseManagerId"];
            this.caseManagerFirstName = _data["caseManagerFirstName"];
            this.caseManagerLastName = _data["caseManagerLastName"];
            this.caseManagerName = _data["caseManagerName"];
            this.participantId = _data["participantId"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.participantName = _data["participantName"];
            this.authExternalId = _data["authExternalId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.caseManagerPersonId = _data["caseManagerPersonId"];
            this.participantPersonId = _data["participantPersonId"];
        }
    }

    static fromJS(data: any): ParticipantCaseMgrRelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantCaseMgrRelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseManagerAuthMappingId"] = this.caseManagerAuthMappingId;
        data["caseManagerId"] = this.caseManagerId;
        data["caseManagerFirstName"] = this.caseManagerFirstName;
        data["caseManagerLastName"] = this.caseManagerLastName;
        data["caseManagerName"] = this.caseManagerName;
        data["participantId"] = this.participantId;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["participantName"] = this.participantName;
        data["authExternalId"] = this.authExternalId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["caseManagerPersonId"] = this.caseManagerPersonId;
        data["participantPersonId"] = this.participantPersonId;
        return data;
    }
}

export interface IParticipantCaseMgrRelResponse {
    caseManagerAuthMappingId?: number | undefined;
    caseManagerId?: number;
    caseManagerFirstName?: string | undefined;
    caseManagerLastName?: string | undefined;
    caseManagerName?: string | undefined;
    participantId?: number;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantName?: string | undefined;
    authExternalId?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    caseManagerPersonId?: number;
    participantPersonId?: string | undefined;
}

export class ParticipantCaseMgrRelResponseGridResponseBase implements IParticipantCaseMgrRelResponseGridResponseBase {
    items?: ParticipantCaseMgrRelResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ParticipantCaseMgrRelResponse;

    constructor(data?: IParticipantCaseMgrRelResponseGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ParticipantCaseMgrRelResponse.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? ParticipantCaseMgrRelResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ParticipantCaseMgrRelResponseGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantCaseMgrRelResponseGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IParticipantCaseMgrRelResponseGridResponseBase {
    items?: ParticipantCaseMgrRelResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ParticipantCaseMgrRelResponse;
}

export class ParticipantDesignatedRepresentative implements IParticipantDesignatedRepresentative {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    participantId?: number;
    designatedRepId?: number;
    status?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    participantName?: string | undefined;
    personId?: string | undefined;
    relation?: string | undefined;

    constructor(data?: IParticipantDesignatedRepresentative) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.participantId = _data["participantId"];
            this.designatedRepId = _data["designatedRepId"];
            this.status = _data["status"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.participantName = _data["participantName"];
            this.personId = _data["personId"];
            this.relation = _data["relation"];
        }
    }

    static fromJS(data: any): ParticipantDesignatedRepresentative {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantDesignatedRepresentative();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["participantId"] = this.participantId;
        data["designatedRepId"] = this.designatedRepId;
        data["status"] = this.status;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["participantName"] = this.participantName;
        data["personId"] = this.personId;
        data["relation"] = this.relation;
        return data;
    }
}

export interface IParticipantDesignatedRepresentative {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    participantId?: number;
    designatedRepId?: number;
    status?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    participantName?: string | undefined;
    personId?: string | undefined;
    relation?: string | undefined;
}

export class ParticipantEmployerMapping implements IParticipantEmployerMapping {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    participantEmployerMappingId?: number;
    participantId?: number;
    employerId?: number;
    employerName?: string | undefined;
    statusStartDate?: Date;
    statusEndDate?: Date | undefined;
    status?: string | undefined;
    programTypeId?: number;
    employerStartDate?: Date | undefined;
    employerEndDate?: Date | undefined;
    ein?: string | undefined;
    dateId?: number;

    constructor(data?: IParticipantEmployerMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.participantEmployerMappingId = _data["participantEmployerMappingId"];
            this.participantId = _data["participantId"];
            this.employerId = _data["employerId"];
            this.employerName = _data["employerName"];
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.programTypeId = _data["programTypeId"];
            this.employerStartDate = _data["employerStartDate"] ? new Date(_data["employerStartDate"].toString()) : <any>undefined;
            this.employerEndDate = _data["employerEndDate"] ? new Date(_data["employerEndDate"].toString()) : <any>undefined;
            this.ein = _data["ein"];
            this.dateId = _data["dateId"];
        }
    }

    static fromJS(data: any): ParticipantEmployerMapping {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantEmployerMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["participantEmployerMappingId"] = this.participantEmployerMappingId;
        data["participantId"] = this.participantId;
        data["employerId"] = this.employerId;
        data["employerName"] = this.employerName;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["programTypeId"] = this.programTypeId;
        data["employerStartDate"] = this.employerStartDate ? this.employerStartDate.toISOString() : <any>undefined;
        data["employerEndDate"] = this.employerEndDate ? this.employerEndDate.toISOString() : <any>undefined;
        data["ein"] = this.ein;
        data["dateId"] = this.dateId;
        return data;
    }
}

export interface IParticipantEmployerMapping {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    participantEmployerMappingId?: number;
    participantId?: number;
    employerId?: number;
    employerName?: string | undefined;
    statusStartDate?: Date;
    statusEndDate?: Date | undefined;
    status?: string | undefined;
    programTypeId?: number;
    employerStartDate?: Date | undefined;
    employerEndDate?: Date | undefined;
    ein?: string | undefined;
    dateId?: number;
}

export class ParticipantExpiryTasksRequest implements IParticipantExpiryTasksRequest {
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IParticipantExpiryTasksRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ParticipantExpiryTasksRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantExpiryTasksRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IParticipantExpiryTasksRequest {
    startDate?: Date;
    endDate?: Date;
}

export class ParticipantExpiryTasksResponse implements IParticipantExpiryTasksResponse {
    participantPersonId?: string | undefined;
    payorId?: string | undefined;
    taskCode?: string | undefined;
    taskDescription?: string | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IParticipantExpiryTasksResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantPersonId = _data["participantPersonId"];
            this.payorId = _data["payorId"];
            this.taskCode = _data["taskCode"];
            this.taskDescription = _data["taskDescription"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ParticipantExpiryTasksResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantExpiryTasksResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantPersonId"] = this.participantPersonId;
        data["payorId"] = this.payorId;
        data["taskCode"] = this.taskCode;
        data["taskDescription"] = this.taskDescription;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IParticipantExpiryTasksResponse {
    participantPersonId?: string | undefined;
    payorId?: string | undefined;
    taskCode?: string | undefined;
    taskDescription?: string | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class ParticipantHistory implements IParticipantHistory {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number;
    participantId?: number;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    statusChangeReason?: string | undefined;
    programEmployerType?: string | undefined;

    constructor(data?: IParticipantHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.id = _data["id"];
            this.participantId = _data["participantId"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.statusChangeReason = _data["statusChangeReason"];
            this.programEmployerType = _data["programEmployerType"];
        }
    }

    static fromJS(data: any): ParticipantHistory {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["id"] = this.id;
        data["participantId"] = this.participantId;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["statusChangeReason"] = this.statusChangeReason;
        data["programEmployerType"] = this.programEmployerType;
        return data;
    }
}

export interface IParticipantHistory {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number;
    participantId?: number;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    statusChangeReason?: string | undefined;
    programEmployerType?: string | undefined;
}

export class ParticipantIcon implements IParticipantIcon {
    red?: number;
    yellow?: number;
    green?: number;

    constructor(data?: IParticipantIcon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.red = _data["red"];
            this.yellow = _data["yellow"];
            this.green = _data["green"];
        }
    }

    static fromJS(data: any): ParticipantIcon {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantIcon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["red"] = this.red;
        data["yellow"] = this.yellow;
        data["green"] = this.green;
        return data;
    }
}

export interface IParticipantIcon {
    red?: number;
    yellow?: number;
    green?: number;
}

export class ParticipantPaidCaregiversRequest implements IParticipantPaidCaregiversRequest {
    participantId?: string | undefined;
    startDate?: Date;

    constructor(data?: IParticipantPaidCaregiversRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ParticipantPaidCaregiversRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantPaidCaregiversRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IParticipantPaidCaregiversRequest {
    participantId?: string | undefined;
    startDate?: Date;
}

export class ParticipantPayor implements IParticipantPayor {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number;
    payorId?: string | undefined;
    payorName?: string | undefined;
    participantName?: string | undefined;

    constructor(data?: IParticipantPayor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.id = _data["id"];
            this.payorId = _data["payorId"];
            this.payorName = _data["payorName"];
            this.participantName = _data["participantName"];
        }
    }

    static fromJS(data: any): ParticipantPayor {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantPayor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["id"] = this.id;
        data["payorId"] = this.payorId;
        data["payorName"] = this.payorName;
        data["participantName"] = this.participantName;
        return data;
    }
}

export interface IParticipantPayor {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number;
    payorId?: string | undefined;
    payorName?: string | undefined;
    participantName?: string | undefined;
}

export class ParticipantRelationshipData implements IParticipantRelationshipData {
    participantId?: number;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    readonly participantName?: string | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IParticipantRelationshipData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            (<any>this).participantName = _data["participantName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ParticipantRelationshipData {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantRelationshipData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["participantName"] = this.participantName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IParticipantRelationshipData {
    participantId?: number;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantName?: string | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class ParticipantResponse implements IParticipantResponse {
    phoneDetails?: PhoneDetail[] | undefined;
    physicalAddresses?: AddressDTO[] | undefined;
    mailingAddresses?: AddressDTO[] | undefined;
    ivrAddresses?: AddressDTO[] | undefined;
    externalKeys?: ExternalKeyDTO[] | undefined;
    id?: number;
    personId?: string | undefined;
    status?: string | undefined;
    readonly personName?: string | undefined;
    ssn?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    physicalAddress?: string | undefined;
    mailingAddress?: string | undefined;
    ivrAddress?: string | undefined;
    companyCode?: string | undefined;
    unmaskedSsn?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    paymentMethod?: string | undefined;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    coordinatorPersonFirstName?: string | undefined;
    coordinatorPersonLastName?: string | undefined;
    coordinatorPersonName?: string | undefined;
    lastV4LoginOn?: Date | undefined;
    isSsnValidated?: boolean | undefined;
    ssnValidationOverrideOn?: Date | undefined;
    ssnValidationOverrideBy?: string | undefined;
    participantId?: number;
    solomonId?: string | undefined;
    insuredId?: string | undefined;
    insuredRecordId?: string | undefined;
    agencyId?: number;
    agencyCode?: string | undefined;
    agencyName?: string | undefined;
    fipsCode?: string | undefined;
    fipsDescription?: string | undefined;
    district?: string | undefined;
    payor?: string | undefined;
    passportId?: string | undefined;
    ivrPin?: string | undefined;
    liveinExempt?: string | undefined;
    payCycleStart?: Date;
    payCycleEnd?: Date;
    relationIcon?: ParticipantIcon;
    administrationId?: number | undefined;
    administrationCode?: string | undefined;

    constructor(data?: IParticipantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["phoneDetails"])) {
                this.phoneDetails = [] as any;
                for (let item of _data["phoneDetails"])
                    this.phoneDetails!.push(PhoneDetail.fromJS(item));
            }
            if (Array.isArray(_data["physicalAddresses"])) {
                this.physicalAddresses = [] as any;
                for (let item of _data["physicalAddresses"])
                    this.physicalAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["mailingAddresses"])) {
                this.mailingAddresses = [] as any;
                for (let item of _data["mailingAddresses"])
                    this.mailingAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["ivrAddresses"])) {
                this.ivrAddresses = [] as any;
                for (let item of _data["ivrAddresses"])
                    this.ivrAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["externalKeys"])) {
                this.externalKeys = [] as any;
                for (let item of _data["externalKeys"])
                    this.externalKeys!.push(ExternalKeyDTO.fromJS(item));
            }
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.status = _data["status"];
            (<any>this).personName = _data["personName"];
            this.ssn = _data["ssn"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.gender = _data["gender"];
            this.ethnicity = _data["ethnicity"];
            this.race = _data["race"];
            this.maritalStatus = _data["maritalStatus"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.physicalAddress = _data["physicalAddress"];
            this.mailingAddress = _data["mailingAddress"];
            this.ivrAddress = _data["ivrAddress"];
            this.companyCode = _data["companyCode"];
            this.unmaskedSsn = _data["unmaskedSsn"];
            this.onboarded = _data["onboarded"];
            this.isFirstLoginComplete = _data["isFirstLoginComplete"];
            this.paymentMethod = _data["paymentMethod"];
            this.coordinatorPersonId = _data["coordinatorPersonId"];
            this.internalUserObjectId = _data["internalUserObjectId"];
            this.coordinatorPersonFirstName = _data["coordinatorPersonFirstName"];
            this.coordinatorPersonLastName = _data["coordinatorPersonLastName"];
            this.coordinatorPersonName = _data["coordinatorPersonName"];
            this.lastV4LoginOn = _data["lastV4LoginOn"] ? new Date(_data["lastV4LoginOn"].toString()) : <any>undefined;
            this.isSsnValidated = _data["isSsnValidated"];
            this.ssnValidationOverrideOn = _data["ssnValidationOverrideOn"] ? new Date(_data["ssnValidationOverrideOn"].toString()) : <any>undefined;
            this.ssnValidationOverrideBy = _data["ssnValidationOverrideBy"];
            this.participantId = _data["participantId"];
            this.solomonId = _data["solomonId"];
            this.insuredId = _data["insuredId"];
            this.insuredRecordId = _data["insuredRecordId"];
            this.agencyId = _data["agencyId"];
            this.agencyCode = _data["agencyCode"];
            this.agencyName = _data["agencyName"];
            this.fipsCode = _data["fipsCode"];
            this.fipsDescription = _data["fipsDescription"];
            this.district = _data["district"];
            this.payor = _data["payor"];
            this.passportId = _data["passportId"];
            this.ivrPin = _data["ivrPin"];
            this.liveinExempt = _data["liveinExempt"];
            this.payCycleStart = _data["payCycleStart"] ? new Date(_data["payCycleStart"].toString()) : <any>undefined;
            this.payCycleEnd = _data["payCycleEnd"] ? new Date(_data["payCycleEnd"].toString()) : <any>undefined;
            this.relationIcon = _data["relationIcon"] ? ParticipantIcon.fromJS(_data["relationIcon"]) : <any>undefined;
            this.administrationId = _data["administrationId"];
            this.administrationCode = _data["administrationCode"];
        }
    }

    static fromJS(data: any): ParticipantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phoneDetails)) {
            data["phoneDetails"] = [];
            for (let item of this.phoneDetails)
                data["phoneDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.physicalAddresses)) {
            data["physicalAddresses"] = [];
            for (let item of this.physicalAddresses)
                data["physicalAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.mailingAddresses)) {
            data["mailingAddresses"] = [];
            for (let item of this.mailingAddresses)
                data["mailingAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.ivrAddresses)) {
            data["ivrAddresses"] = [];
            for (let item of this.ivrAddresses)
                data["ivrAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.externalKeys)) {
            data["externalKeys"] = [];
            for (let item of this.externalKeys)
                data["externalKeys"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["status"] = this.status;
        data["personName"] = this.personName;
        data["ssn"] = this.ssn;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["gender"] = this.gender;
        data["ethnicity"] = this.ethnicity;
        data["race"] = this.race;
        data["maritalStatus"] = this.maritalStatus;
        data["preferredLanguage"] = this.preferredLanguage;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["physicalAddress"] = this.physicalAddress;
        data["mailingAddress"] = this.mailingAddress;
        data["ivrAddress"] = this.ivrAddress;
        data["companyCode"] = this.companyCode;
        data["unmaskedSsn"] = this.unmaskedSsn;
        data["onboarded"] = this.onboarded;
        data["isFirstLoginComplete"] = this.isFirstLoginComplete;
        data["paymentMethod"] = this.paymentMethod;
        data["coordinatorPersonId"] = this.coordinatorPersonId;
        data["internalUserObjectId"] = this.internalUserObjectId;
        data["coordinatorPersonFirstName"] = this.coordinatorPersonFirstName;
        data["coordinatorPersonLastName"] = this.coordinatorPersonLastName;
        data["coordinatorPersonName"] = this.coordinatorPersonName;
        data["lastV4LoginOn"] = this.lastV4LoginOn ? this.lastV4LoginOn.toISOString() : <any>undefined;
        data["isSsnValidated"] = this.isSsnValidated;
        data["ssnValidationOverrideOn"] = this.ssnValidationOverrideOn ? this.ssnValidationOverrideOn.toISOString() : <any>undefined;
        data["ssnValidationOverrideBy"] = this.ssnValidationOverrideBy;
        data["participantId"] = this.participantId;
        data["solomonId"] = this.solomonId;
        data["insuredId"] = this.insuredId;
        data["insuredRecordId"] = this.insuredRecordId;
        data["agencyId"] = this.agencyId;
        data["agencyCode"] = this.agencyCode;
        data["agencyName"] = this.agencyName;
        data["fipsCode"] = this.fipsCode;
        data["fipsDescription"] = this.fipsDescription;
        data["district"] = this.district;
        data["payor"] = this.payor;
        data["passportId"] = this.passportId;
        data["ivrPin"] = this.ivrPin;
        data["liveinExempt"] = this.liveinExempt;
        data["payCycleStart"] = this.payCycleStart ? this.payCycleStart.toISOString() : <any>undefined;
        data["payCycleEnd"] = this.payCycleEnd ? this.payCycleEnd.toISOString() : <any>undefined;
        data["relationIcon"] = this.relationIcon ? this.relationIcon.toJSON() : <any>undefined;
        data["administrationId"] = this.administrationId;
        data["administrationCode"] = this.administrationCode;
        return data;
    }
}

export interface IParticipantResponse {
    phoneDetails?: PhoneDetail[] | undefined;
    physicalAddresses?: AddressDTO[] | undefined;
    mailingAddresses?: AddressDTO[] | undefined;
    ivrAddresses?: AddressDTO[] | undefined;
    externalKeys?: ExternalKeyDTO[] | undefined;
    id?: number;
    personId?: string | undefined;
    status?: string | undefined;
    personName?: string | undefined;
    ssn?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    physicalAddress?: string | undefined;
    mailingAddress?: string | undefined;
    ivrAddress?: string | undefined;
    companyCode?: string | undefined;
    unmaskedSsn?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    paymentMethod?: string | undefined;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    coordinatorPersonFirstName?: string | undefined;
    coordinatorPersonLastName?: string | undefined;
    coordinatorPersonName?: string | undefined;
    lastV4LoginOn?: Date | undefined;
    isSsnValidated?: boolean | undefined;
    ssnValidationOverrideOn?: Date | undefined;
    ssnValidationOverrideBy?: string | undefined;
    participantId?: number;
    solomonId?: string | undefined;
    insuredId?: string | undefined;
    insuredRecordId?: string | undefined;
    agencyId?: number;
    agencyCode?: string | undefined;
    agencyName?: string | undefined;
    fipsCode?: string | undefined;
    fipsDescription?: string | undefined;
    district?: string | undefined;
    payor?: string | undefined;
    passportId?: string | undefined;
    ivrPin?: string | undefined;
    liveinExempt?: string | undefined;
    payCycleStart?: Date;
    payCycleEnd?: Date;
    relationIcon?: ParticipantIcon;
    administrationId?: number | undefined;
    administrationCode?: string | undefined;
}

export class ParticipantResponseV2 implements IParticipantResponseV2 {
    participantId?: number;
    cdcnStateId?: number | undefined;
    areaId?: number | undefined;
    agencyId?: number | undefined;
    fipsCode?: string | undefined;
    geoLocale?: string | undefined;
    companyId?: number;
    referralDate?: Date | undefined;
    dischargeDate?: Date | undefined;
    dischargeReasonId?: number | undefined;
    administration?: number | undefined;
    attendingProviderNumber?: string | undefined;
    referringProviderNumber?: string | undefined;
    passportId?: number | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
    advancedDirective?: AdvancedDirective[] | undefined;
    participantTerritories?: ParticipantTerritoryRelation[] | undefined;

    constructor(data?: IParticipantResponseV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.cdcnStateId = _data["cdcnStateId"];
            this.areaId = _data["areaId"];
            this.agencyId = _data["agencyId"];
            this.fipsCode = _data["fipsCode"];
            this.geoLocale = _data["geoLocale"];
            this.companyId = _data["companyId"];
            this.referralDate = _data["referralDate"] ? new Date(_data["referralDate"].toString()) : <any>undefined;
            this.dischargeDate = _data["dischargeDate"] ? new Date(_data["dischargeDate"].toString()) : <any>undefined;
            this.dischargeReasonId = _data["dischargeReasonId"];
            this.administration = _data["administration"];
            this.attendingProviderNumber = _data["attendingProviderNumber"];
            this.referringProviderNumber = _data["referringProviderNumber"];
            this.passportId = _data["passportId"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["advancedDirective"])) {
                this.advancedDirective = [] as any;
                for (let item of _data["advancedDirective"])
                    this.advancedDirective!.push(AdvancedDirective.fromJS(item));
            }
            if (Array.isArray(_data["participantTerritories"])) {
                this.participantTerritories = [] as any;
                for (let item of _data["participantTerritories"])
                    this.participantTerritories!.push(ParticipantTerritoryRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParticipantResponseV2 {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantResponseV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["cdcnStateId"] = this.cdcnStateId;
        data["areaId"] = this.areaId;
        data["agencyId"] = this.agencyId;
        data["fipsCode"] = this.fipsCode;
        data["geoLocale"] = this.geoLocale;
        data["companyId"] = this.companyId;
        data["referralDate"] = this.referralDate ? this.referralDate.toISOString() : <any>undefined;
        data["dischargeDate"] = this.dischargeDate ? this.dischargeDate.toISOString() : <any>undefined;
        data["dischargeReasonId"] = this.dischargeReasonId;
        data["administration"] = this.administration;
        data["attendingProviderNumber"] = this.attendingProviderNumber;
        data["referringProviderNumber"] = this.referringProviderNumber;
        data["passportId"] = this.passportId;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.advancedDirective)) {
            data["advancedDirective"] = [];
            for (let item of this.advancedDirective)
                data["advancedDirective"].push(item.toJSON());
        }
        if (Array.isArray(this.participantTerritories)) {
            data["participantTerritories"] = [];
            for (let item of this.participantTerritories)
                data["participantTerritories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IParticipantResponseV2 {
    participantId?: number;
    cdcnStateId?: number | undefined;
    areaId?: number | undefined;
    agencyId?: number | undefined;
    fipsCode?: string | undefined;
    geoLocale?: string | undefined;
    companyId?: number;
    referralDate?: Date | undefined;
    dischargeDate?: Date | undefined;
    dischargeReasonId?: number | undefined;
    administration?: number | undefined;
    attendingProviderNumber?: string | undefined;
    referringProviderNumber?: string | undefined;
    passportId?: number | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
    advancedDirective?: AdvancedDirective[] | undefined;
    participantTerritories?: ParticipantTerritoryRelation[] | undefined;
}

export class ParticipantServiceFacilitator implements IParticipantServiceFacilitator {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    emailId?: string | undefined;
    participantId?: number;
    roleName?: string | undefined;
    serviceFacilitatorId?: number;
    serviceFacilitatorName?: string | undefined;

    constructor(data?: IParticipantServiceFacilitator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.emailId = _data["emailId"];
            this.participantId = _data["participantId"];
            this.roleName = _data["roleName"];
            this.serviceFacilitatorId = _data["serviceFacilitatorId"];
            this.serviceFacilitatorName = _data["serviceFacilitatorName"];
        }
    }

    static fromJS(data: any): ParticipantServiceFacilitator {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantServiceFacilitator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["emailId"] = this.emailId;
        data["participantId"] = this.participantId;
        data["roleName"] = this.roleName;
        data["serviceFacilitatorId"] = this.serviceFacilitatorId;
        data["serviceFacilitatorName"] = this.serviceFacilitatorName;
        return data;
    }
}

export interface IParticipantServiceFacilitator {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    emailId?: string | undefined;
    participantId?: number;
    roleName?: string | undefined;
    serviceFacilitatorId?: number;
    serviceFacilitatorName?: string | undefined;
}

export class ParticipantTaskListRequest implements IParticipantTaskListRequest {
    participantTasks?: ParticipantTaskRequest[] | undefined;
    solomonParticipantId?: string | undefined;

    constructor(data?: IParticipantTaskListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["participantTasks"])) {
                this.participantTasks = [] as any;
                for (let item of _data["participantTasks"])
                    this.participantTasks!.push(ParticipantTaskRequest.fromJS(item));
            }
            this.solomonParticipantId = _data["solomonParticipantId"];
        }
    }

    static fromJS(data: any): ParticipantTaskListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantTaskListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.participantTasks)) {
            data["participantTasks"] = [];
            for (let item of this.participantTasks)
                data["participantTasks"].push(item.toJSON());
        }
        data["solomonParticipantId"] = this.solomonParticipantId;
        return data;
    }
}

export interface IParticipantTaskListRequest {
    participantTasks?: ParticipantTaskRequest[] | undefined;
    solomonParticipantId?: string | undefined;
}

export class ParticipantTaskListResponse implements IParticipantTaskListResponse {
    participantTasks?: ParticipantTaskResponse[] | undefined;

    constructor(data?: IParticipantTaskListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["participantTasks"])) {
                this.participantTasks = [] as any;
                for (let item of _data["participantTasks"])
                    this.participantTasks!.push(ParticipantTaskResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParticipantTaskListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantTaskListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.participantTasks)) {
            data["participantTasks"] = [];
            for (let item of this.participantTasks)
                data["participantTasks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IParticipantTaskListResponse {
    participantTasks?: ParticipantTaskResponse[] | undefined;
}

export class ParticipantTaskRequest implements IParticipantTaskRequest {
    participantTaskId?: number;
    companyId?: number;
    participantId?: number;
    payorId?: number;
    taskCodeId?: number;
    description?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    status?: boolean;

    constructor(data?: IParticipantTaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantTaskId = _data["participantTaskId"];
            this.companyId = _data["companyId"];
            this.participantId = _data["participantId"];
            this.payorId = _data["payorId"];
            this.taskCodeId = _data["taskCodeId"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ParticipantTaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantTaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantTaskId"] = this.participantTaskId;
        data["companyId"] = this.companyId;
        data["participantId"] = this.participantId;
        data["payorId"] = this.payorId;
        data["taskCodeId"] = this.taskCodeId;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IParticipantTaskRequest {
    participantTaskId?: number;
    companyId?: number;
    participantId?: number;
    payorId?: number;
    taskCodeId?: number;
    description?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    status?: boolean;
}

export class ParticipantTaskResponse implements IParticipantTaskResponse {
    participantTaskId?: number;
    companyId?: number;
    participantId?: number;
    payorId?: number;
    taskCodeId?: number;
    taskCode?: string | undefined;
    taskDescription?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    status?: boolean;

    constructor(data?: IParticipantTaskResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantTaskId = _data["participantTaskId"];
            this.companyId = _data["companyId"];
            this.participantId = _data["participantId"];
            this.payorId = _data["payorId"];
            this.taskCodeId = _data["taskCodeId"];
            this.taskCode = _data["taskCode"];
            this.taskDescription = _data["taskDescription"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ParticipantTaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantTaskResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantTaskId"] = this.participantTaskId;
        data["companyId"] = this.companyId;
        data["participantId"] = this.participantId;
        data["payorId"] = this.payorId;
        data["taskCodeId"] = this.taskCodeId;
        data["taskCode"] = this.taskCode;
        data["taskDescription"] = this.taskDescription;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IParticipantTaskResponse {
    participantTaskId?: number;
    companyId?: number;
    participantId?: number;
    payorId?: number;
    taskCodeId?: number;
    taskCode?: string | undefined;
    taskDescription?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    status?: boolean;
}

export class ParticipantTerritoryMapping implements IParticipantTerritoryMapping {
    participantTerritoryMappingId?: number;
    participantId?: number;
    territoryStartDate?: Date | undefined;
    territoryEndDate?: Date | undefined;
    territory?: string | undefined;
    territoryId?: number;

    constructor(data?: IParticipantTerritoryMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantTerritoryMappingId = _data["participantTerritoryMappingId"];
            this.participantId = _data["participantId"];
            this.territoryStartDate = _data["territoryStartDate"] ? new Date(_data["territoryStartDate"].toString()) : <any>undefined;
            this.territoryEndDate = _data["territoryEndDate"] ? new Date(_data["territoryEndDate"].toString()) : <any>undefined;
            this.territory = _data["territory"];
            this.territoryId = _data["territoryId"];
        }
    }

    static fromJS(data: any): ParticipantTerritoryMapping {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantTerritoryMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantTerritoryMappingId"] = this.participantTerritoryMappingId;
        data["participantId"] = this.participantId;
        data["territoryStartDate"] = this.territoryStartDate ? this.territoryStartDate.toISOString() : <any>undefined;
        data["territoryEndDate"] = this.territoryEndDate ? this.territoryEndDate.toISOString() : <any>undefined;
        data["territory"] = this.territory;
        data["territoryId"] = this.territoryId;
        return data;
    }
}

export interface IParticipantTerritoryMapping {
    participantTerritoryMappingId?: number;
    participantId?: number;
    territoryStartDate?: Date | undefined;
    territoryEndDate?: Date | undefined;
    territory?: string | undefined;
    territoryId?: number;
}

export class ParticipantTerritoryRelation implements IParticipantTerritoryRelation {
    participantTerritoryRelId?: number;
    territory?: string | undefined;
    territoryId?: number;
    territoryStartDate?: Date;
    territoryEndDate?: Date | undefined;

    constructor(data?: IParticipantTerritoryRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantTerritoryRelId = _data["participantTerritoryRelId"];
            this.territory = _data["territory"];
            this.territoryId = _data["territoryId"];
            this.territoryStartDate = _data["territoryStartDate"] ? new Date(_data["territoryStartDate"].toString()) : <any>undefined;
            this.territoryEndDate = _data["territoryEndDate"] ? new Date(_data["territoryEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ParticipantTerritoryRelation {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantTerritoryRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantTerritoryRelId"] = this.participantTerritoryRelId;
        data["territory"] = this.territory;
        data["territoryId"] = this.territoryId;
        data["territoryStartDate"] = this.territoryStartDate ? this.territoryStartDate.toISOString() : <any>undefined;
        data["territoryEndDate"] = this.territoryEndDate ? this.territoryEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IParticipantTerritoryRelation {
    participantTerritoryRelId?: number;
    territory?: string | undefined;
    territoryId?: number;
    territoryStartDate?: Date;
    territoryEndDate?: Date | undefined;
}

export class Participants implements IParticipants {
    personStatus?: string | undefined;
    id?: number;
    personId?: string | undefined;
    status?: PeopleStatus;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    statusChangeReason?: string | undefined;
    ssn?: string | undefined;
    maritalStatus?: string | undefined;
    personStatusHistories?: PersonStatusHistory[] | undefined;
    participantId?: number | undefined;
    solomonParticipantId?: string | undefined;
    cdcnStateId?: number | undefined;
    areaId?: number | undefined;
    territoryId?: number | undefined;
    territoryStartDate?: Date | undefined;
    territoryEndDate?: Date | undefined;
    attendingProviderNumber?: string | undefined;
    referringProviderNumber?: string | undefined;
    passportId?: string | undefined;
    ivrPin?: string | undefined;
    geoLocale?: string | undefined;
    referralDate?: Date | undefined;
    employerId?: number | undefined;
    employerEin?: string | undefined;
    employerStartDate?: Date | undefined;
    employerEndDate?: Date | undefined;
    dischargeDate?: Date | undefined;
    dischargeReasonId?: number | undefined;
    programEmployerTypeId?: number | undefined;
    user?: string | undefined;
    insuredId?: string | undefined;
    insuredRecordId?: string | undefined;
    administrationId?: number | undefined;
    administrationCode?: string | undefined;
    participantTerritory?: ParticipantTerritoryMapping[] | undefined;
    participantEmployer?: ParticipantEmployerMapping[] | undefined;
    advancedDirectives?: AdvancedDirective[] | undefined;
    participantAreaMapping?: ParticipantAreaMapping[] | undefined;

    constructor(data?: IParticipants) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personStatus = _data["personStatus"];
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.status = _data["status"];
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.statusChangeReason = _data["statusChangeReason"];
            this.ssn = _data["ssn"];
            this.maritalStatus = _data["maritalStatus"];
            if (Array.isArray(_data["personStatusHistories"])) {
                this.personStatusHistories = [] as any;
                for (let item of _data["personStatusHistories"])
                    this.personStatusHistories!.push(PersonStatusHistory.fromJS(item));
            }
            this.participantId = _data["participantId"];
            this.solomonParticipantId = _data["solomonParticipantId"];
            this.cdcnStateId = _data["cdcnStateId"];
            this.areaId = _data["areaId"];
            this.territoryId = _data["territoryId"];
            this.territoryStartDate = _data["territoryStartDate"] ? new Date(_data["territoryStartDate"].toString()) : <any>undefined;
            this.territoryEndDate = _data["territoryEndDate"] ? new Date(_data["territoryEndDate"].toString()) : <any>undefined;
            this.attendingProviderNumber = _data["attendingProviderNumber"];
            this.referringProviderNumber = _data["referringProviderNumber"];
            this.passportId = _data["passportId"];
            this.ivrPin = _data["ivrPin"];
            this.geoLocale = _data["geoLocale"];
            this.referralDate = _data["referralDate"] ? new Date(_data["referralDate"].toString()) : <any>undefined;
            this.employerId = _data["employerId"];
            this.employerEin = _data["employerEin"];
            this.employerStartDate = _data["employerStartDate"] ? new Date(_data["employerStartDate"].toString()) : <any>undefined;
            this.employerEndDate = _data["employerEndDate"] ? new Date(_data["employerEndDate"].toString()) : <any>undefined;
            this.dischargeDate = _data["dischargeDate"] ? new Date(_data["dischargeDate"].toString()) : <any>undefined;
            this.dischargeReasonId = _data["dischargeReasonId"];
            this.programEmployerTypeId = _data["programEmployerTypeId"];
            this.user = _data["user"];
            this.insuredId = _data["insuredId"];
            this.insuredRecordId = _data["insuredRecordId"];
            this.administrationId = _data["administrationId"];
            this.administrationCode = _data["administrationCode"];
            if (Array.isArray(_data["participantTerritory"])) {
                this.participantTerritory = [] as any;
                for (let item of _data["participantTerritory"])
                    this.participantTerritory!.push(ParticipantTerritoryMapping.fromJS(item));
            }
            if (Array.isArray(_data["participantEmployer"])) {
                this.participantEmployer = [] as any;
                for (let item of _data["participantEmployer"])
                    this.participantEmployer!.push(ParticipantEmployerMapping.fromJS(item));
            }
            if (Array.isArray(_data["advancedDirectives"])) {
                this.advancedDirectives = [] as any;
                for (let item of _data["advancedDirectives"])
                    this.advancedDirectives!.push(AdvancedDirective.fromJS(item));
            }
            if (Array.isArray(_data["participantAreaMapping"])) {
                this.participantAreaMapping = [] as any;
                for (let item of _data["participantAreaMapping"])
                    this.participantAreaMapping!.push(ParticipantAreaMapping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Participants {
        data = typeof data === 'object' ? data : {};
        let result = new Participants();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personStatus"] = this.personStatus;
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["status"] = this.status;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["statusChangeReason"] = this.statusChangeReason;
        data["ssn"] = this.ssn;
        data["maritalStatus"] = this.maritalStatus;
        if (Array.isArray(this.personStatusHistories)) {
            data["personStatusHistories"] = [];
            for (let item of this.personStatusHistories)
                data["personStatusHistories"].push(item.toJSON());
        }
        data["participantId"] = this.participantId;
        data["solomonParticipantId"] = this.solomonParticipantId;
        data["cdcnStateId"] = this.cdcnStateId;
        data["areaId"] = this.areaId;
        data["territoryId"] = this.territoryId;
        data["territoryStartDate"] = this.territoryStartDate ? this.territoryStartDate.toISOString() : <any>undefined;
        data["territoryEndDate"] = this.territoryEndDate ? this.territoryEndDate.toISOString() : <any>undefined;
        data["attendingProviderNumber"] = this.attendingProviderNumber;
        data["referringProviderNumber"] = this.referringProviderNumber;
        data["passportId"] = this.passportId;
        data["ivrPin"] = this.ivrPin;
        data["geoLocale"] = this.geoLocale;
        data["referralDate"] = this.referralDate ? this.referralDate.toISOString() : <any>undefined;
        data["employerId"] = this.employerId;
        data["employerEin"] = this.employerEin;
        data["employerStartDate"] = this.employerStartDate ? this.employerStartDate.toISOString() : <any>undefined;
        data["employerEndDate"] = this.employerEndDate ? this.employerEndDate.toISOString() : <any>undefined;
        data["dischargeDate"] = this.dischargeDate ? this.dischargeDate.toISOString() : <any>undefined;
        data["dischargeReasonId"] = this.dischargeReasonId;
        data["programEmployerTypeId"] = this.programEmployerTypeId;
        data["user"] = this.user;
        data["insuredId"] = this.insuredId;
        data["insuredRecordId"] = this.insuredRecordId;
        data["administrationId"] = this.administrationId;
        data["administrationCode"] = this.administrationCode;
        if (Array.isArray(this.participantTerritory)) {
            data["participantTerritory"] = [];
            for (let item of this.participantTerritory)
                data["participantTerritory"].push(item.toJSON());
        }
        if (Array.isArray(this.participantEmployer)) {
            data["participantEmployer"] = [];
            for (let item of this.participantEmployer)
                data["participantEmployer"].push(item.toJSON());
        }
        if (Array.isArray(this.advancedDirectives)) {
            data["advancedDirectives"] = [];
            for (let item of this.advancedDirectives)
                data["advancedDirectives"].push(item.toJSON());
        }
        if (Array.isArray(this.participantAreaMapping)) {
            data["participantAreaMapping"] = [];
            for (let item of this.participantAreaMapping)
                data["participantAreaMapping"].push(item.toJSON());
        }
        return data;
    }
}

export interface IParticipants {
    personStatus?: string | undefined;
    id?: number;
    personId?: string | undefined;
    status?: PeopleStatus;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    statusChangeReason?: string | undefined;
    ssn?: string | undefined;
    maritalStatus?: string | undefined;
    personStatusHistories?: PersonStatusHistory[] | undefined;
    participantId?: number | undefined;
    solomonParticipantId?: string | undefined;
    cdcnStateId?: number | undefined;
    areaId?: number | undefined;
    territoryId?: number | undefined;
    territoryStartDate?: Date | undefined;
    territoryEndDate?: Date | undefined;
    attendingProviderNumber?: string | undefined;
    referringProviderNumber?: string | undefined;
    passportId?: string | undefined;
    ivrPin?: string | undefined;
    geoLocale?: string | undefined;
    referralDate?: Date | undefined;
    employerId?: number | undefined;
    employerEin?: string | undefined;
    employerStartDate?: Date | undefined;
    employerEndDate?: Date | undefined;
    dischargeDate?: Date | undefined;
    dischargeReasonId?: number | undefined;
    programEmployerTypeId?: number | undefined;
    user?: string | undefined;
    insuredId?: string | undefined;
    insuredRecordId?: string | undefined;
    administrationId?: number | undefined;
    administrationCode?: string | undefined;
    participantTerritory?: ParticipantTerritoryMapping[] | undefined;
    participantEmployer?: ParticipantEmployerMapping[] | undefined;
    advancedDirectives?: AdvancedDirective[] | undefined;
    participantAreaMapping?: ParticipantAreaMapping[] | undefined;
}

export class PatientPaySummaryDetails implements IPatientPaySummaryDetails {
    patientPaySummaryID?: number | undefined;
    svcCode?: string | undefined;
    transactionDate?: Date | undefined;
    amount?: number;
    payorIntegrationKey?: string | undefined;
    exLedgerID?: string | undefined;
    exLedgerType?: string | undefined;
    clientId?: string | undefined;
    participantPersonId?: string | undefined;
    isSummaryRecordExist?: boolean;
    type?: string | undefined;
    subType?: string | undefined;
    isLedge?: boolean;
    externalRecordId?: string | undefined;
    servLnStartDate?: Date | undefined;
    servLnEndDate?: Date | undefined;
    isValid?: boolean;

    constructor(data?: IPatientPaySummaryDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientPaySummaryID = _data["patientPaySummaryID"];
            this.svcCode = _data["svcCode"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.payorIntegrationKey = _data["payorIntegrationKey"];
            this.exLedgerID = _data["exLedgerID"];
            this.exLedgerType = _data["exLedgerType"];
            this.clientId = _data["clientId"];
            this.participantPersonId = _data["participantPersonId"];
            this.isSummaryRecordExist = _data["isSummaryRecordExist"];
            this.type = _data["type"];
            this.subType = _data["subType"];
            this.isLedge = _data["isLedge"];
            this.externalRecordId = _data["externalRecordId"];
            this.servLnStartDate = _data["servLnStartDate"] ? new Date(_data["servLnStartDate"].toString()) : <any>undefined;
            this.servLnEndDate = _data["servLnEndDate"] ? new Date(_data["servLnEndDate"].toString()) : <any>undefined;
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): PatientPaySummaryDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPaySummaryDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientPaySummaryID"] = this.patientPaySummaryID;
        data["svcCode"] = this.svcCode;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["payorIntegrationKey"] = this.payorIntegrationKey;
        data["exLedgerID"] = this.exLedgerID;
        data["exLedgerType"] = this.exLedgerType;
        data["clientId"] = this.clientId;
        data["participantPersonId"] = this.participantPersonId;
        data["isSummaryRecordExist"] = this.isSummaryRecordExist;
        data["type"] = this.type;
        data["subType"] = this.subType;
        data["isLedge"] = this.isLedge;
        data["externalRecordId"] = this.externalRecordId;
        data["servLnStartDate"] = this.servLnStartDate ? this.servLnStartDate.toISOString() : <any>undefined;
        data["servLnEndDate"] = this.servLnEndDate ? this.servLnEndDate.toISOString() : <any>undefined;
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface IPatientPaySummaryDetails {
    patientPaySummaryID?: number | undefined;
    svcCode?: string | undefined;
    transactionDate?: Date | undefined;
    amount?: number;
    payorIntegrationKey?: string | undefined;
    exLedgerID?: string | undefined;
    exLedgerType?: string | undefined;
    clientId?: string | undefined;
    participantPersonId?: string | undefined;
    isSummaryRecordExist?: boolean;
    type?: string | undefined;
    subType?: string | undefined;
    isLedge?: boolean;
    externalRecordId?: string | undefined;
    servLnStartDate?: Date | undefined;
    servLnEndDate?: Date | undefined;
    isValid?: boolean;
}

export enum PayCalcMethod {
    EMPE = "EMPE",
    NONE = "NONE",
    CH = "CH",
    EMPR = "EMPR",
}

export class PcLookUp implements IPcLookUp {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    personId?: string | undefined;
    programCoordinatorId?: number | undefined;
    personInternalId?: number | undefined;
    name?: string | undefined;
    status?: string | undefined;

    constructor(data?: IPcLookUp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.personId = _data["personId"];
            this.programCoordinatorId = _data["programCoordinatorId"];
            this.personInternalId = _data["personInternalId"];
            this.name = _data["name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): PcLookUp {
        data = typeof data === 'object' ? data : {};
        let result = new PcLookUp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["personId"] = this.personId;
        data["programCoordinatorId"] = this.programCoordinatorId;
        data["personInternalId"] = this.personInternalId;
        data["name"] = this.name;
        data["status"] = this.status;
        return data;
    }
}

export interface IPcLookUp {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    personId?: string | undefined;
    programCoordinatorId?: number | undefined;
    personInternalId?: number | undefined;
    name?: string | undefined;
    status?: string | undefined;
}

export class PeopleBlastRequest implements IPeopleBlastRequest {
    personId?: string | undefined;
    role?: string | undefined;
    email?: string | undefined;

    constructor(data?: IPeopleBlastRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.role = _data["role"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): PeopleBlastRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PeopleBlastRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["role"] = this.role;
        data["email"] = this.email;
        return data;
    }
}

export interface IPeopleBlastRequest {
    personId?: string | undefined;
    role?: string | undefined;
    email?: string | undefined;
}

export class PeopleGridResponse implements IPeopleGridResponse {
    items?: PeopleResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PeopleResponse;
    personResponse?: PersonResponse;

    constructor(data?: IPeopleGridResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PeopleResponse.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? PeopleResponse.fromJS(_data["data"]) : <any>undefined;
            this.personResponse = _data["personResponse"] ? PersonResponse.fromJS(_data["personResponse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PeopleGridResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PeopleGridResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["personResponse"] = this.personResponse ? this.personResponse.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPeopleGridResponse {
    items?: PeopleResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PeopleResponse;
    personResponse?: PersonResponse;
}

export class PeopleRelation implements IPeopleRelation {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    personId?: string | undefined;
    email?: string | undefined;
    personType?: string | undefined;
    personName?: string | undefined;

    constructor(data?: IPeopleRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.personId = _data["personId"];
            this.email = _data["email"];
            this.personType = _data["personType"];
            this.personName = _data["personName"];
        }
    }

    static fromJS(data: any): PeopleRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PeopleRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["personId"] = this.personId;
        data["email"] = this.email;
        data["personType"] = this.personType;
        data["personName"] = this.personName;
        return data;
    }
}

export interface IPeopleRelation {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    personId?: string | undefined;
    email?: string | undefined;
    personType?: string | undefined;
    personName?: string | undefined;
}

export class PeopleRelationMultiLevel implements IPeopleRelationMultiLevel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    originatingPersonId?: string | undefined;
    recepientPersonId?: string | undefined;
    recepientPersonEmail?: string | undefined;
    recepientPersonType?: string | undefined;
    recepientPersonName?: string | undefined;

    constructor(data?: IPeopleRelationMultiLevel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.originatingPersonId = _data["originatingPersonId"];
            this.recepientPersonId = _data["recepientPersonId"];
            this.recepientPersonEmail = _data["recepientPersonEmail"];
            this.recepientPersonType = _data["recepientPersonType"];
            this.recepientPersonName = _data["recepientPersonName"];
        }
    }

    static fromJS(data: any): PeopleRelationMultiLevel {
        data = typeof data === 'object' ? data : {};
        let result = new PeopleRelationMultiLevel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["originatingPersonId"] = this.originatingPersonId;
        data["recepientPersonId"] = this.recepientPersonId;
        data["recepientPersonEmail"] = this.recepientPersonEmail;
        data["recepientPersonType"] = this.recepientPersonType;
        data["recepientPersonName"] = this.recepientPersonName;
        return data;
    }
}

export interface IPeopleRelationMultiLevel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    originatingPersonId?: string | undefined;
    recepientPersonId?: string | undefined;
    recepientPersonEmail?: string | undefined;
    recepientPersonType?: string | undefined;
    recepientPersonName?: string | undefined;
}

export class PeopleResponse implements IPeopleResponse {
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    readonly name?: string | undefined;
    homePhoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;
    status?: string | undefined;
    state?: string | undefined;
    ssn?: string | undefined;
    personId?: string | undefined;
    emailId?: string | undefined;
    role?: string | undefined;
    dob?: Date | undefined;
    onBoarded?: boolean;
    participantId?: number;

    constructor(data?: IPeopleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            (<any>this).name = _data["name"];
            this.homePhoneNumber = _data["homePhoneNumber"];
            this.cellPhoneNumber = _data["cellPhoneNumber"];
            this.status = _data["status"];
            this.state = _data["state"];
            this.ssn = _data["ssn"];
            this.personId = _data["personId"];
            this.emailId = _data["emailId"];
            this.role = _data["role"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.onBoarded = _data["onBoarded"];
            this.participantId = _data["participantId"];
        }
    }

    static fromJS(data: any): PeopleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PeopleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["name"] = this.name;
        data["homePhoneNumber"] = this.homePhoneNumber;
        data["cellPhoneNumber"] = this.cellPhoneNumber;
        data["status"] = this.status;
        data["state"] = this.state;
        data["ssn"] = this.ssn;
        data["personId"] = this.personId;
        data["emailId"] = this.emailId;
        data["role"] = this.role;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["onBoarded"] = this.onBoarded;
        data["participantId"] = this.participantId;
        return data;
    }
}

export interface IPeopleResponse {
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    name?: string | undefined;
    homePhoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;
    status?: string | undefined;
    state?: string | undefined;
    ssn?: string | undefined;
    personId?: string | undefined;
    emailId?: string | undefined;
    role?: string | undefined;
    dob?: Date | undefined;
    onBoarded?: boolean;
    participantId?: number;
}

export enum PeopleStatus {
    None = "None",
    AC = "AC",
    IA = "IA",
    IC = "IC",
    OH = "OH",
    TR = "TR",
}

export class PersonAddressPhone implements IPersonAddressPhone {
    phoneDetails?: PhoneDetail[] | undefined;
    physicalAddresses?: AddressDTO[] | undefined;
    mailingAddresses?: AddressDTO[] | undefined;
    ivrAddresses?: AddressDTO[] | undefined;
    externalKeys?: ExternalKeyDTO[] | undefined;
    ivrPin?: string | undefined;

    constructor(data?: IPersonAddressPhone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["phoneDetails"])) {
                this.phoneDetails = [] as any;
                for (let item of _data["phoneDetails"])
                    this.phoneDetails!.push(PhoneDetail.fromJS(item));
            }
            if (Array.isArray(_data["physicalAddresses"])) {
                this.physicalAddresses = [] as any;
                for (let item of _data["physicalAddresses"])
                    this.physicalAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["mailingAddresses"])) {
                this.mailingAddresses = [] as any;
                for (let item of _data["mailingAddresses"])
                    this.mailingAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["ivrAddresses"])) {
                this.ivrAddresses = [] as any;
                for (let item of _data["ivrAddresses"])
                    this.ivrAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["externalKeys"])) {
                this.externalKeys = [] as any;
                for (let item of _data["externalKeys"])
                    this.externalKeys!.push(ExternalKeyDTO.fromJS(item));
            }
            this.ivrPin = _data["ivrPin"];
        }
    }

    static fromJS(data: any): PersonAddressPhone {
        data = typeof data === 'object' ? data : {};
        let result = new PersonAddressPhone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phoneDetails)) {
            data["phoneDetails"] = [];
            for (let item of this.phoneDetails)
                data["phoneDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.physicalAddresses)) {
            data["physicalAddresses"] = [];
            for (let item of this.physicalAddresses)
                data["physicalAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.mailingAddresses)) {
            data["mailingAddresses"] = [];
            for (let item of this.mailingAddresses)
                data["mailingAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.ivrAddresses)) {
            data["ivrAddresses"] = [];
            for (let item of this.ivrAddresses)
                data["ivrAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.externalKeys)) {
            data["externalKeys"] = [];
            for (let item of this.externalKeys)
                data["externalKeys"].push(item.toJSON());
        }
        data["ivrPin"] = this.ivrPin;
        return data;
    }
}

export interface IPersonAddressPhone {
    phoneDetails?: PhoneDetail[] | undefined;
    physicalAddresses?: AddressDTO[] | undefined;
    mailingAddresses?: AddressDTO[] | undefined;
    ivrAddresses?: AddressDTO[] | undefined;
    externalKeys?: ExternalKeyDTO[] | undefined;
    ivrPin?: string | undefined;
}

export class PersonAgenciesDto implements IPersonAgenciesDto {
    personStatus?: string | undefined;
    id?: number;
    personId?: string | undefined;
    status?: PeopleStatus;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    statusChangeReason?: string | undefined;
    ssn?: string | undefined;
    maritalStatus?: string | undefined;
    personStatusHistories?: PersonStatusHistory[] | undefined;
    agencyPersonMappings?: AgencyPersonMapping[] | undefined;

    constructor(data?: IPersonAgenciesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personStatus = _data["personStatus"];
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.status = _data["status"];
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.statusChangeReason = _data["statusChangeReason"];
            this.ssn = _data["ssn"];
            this.maritalStatus = _data["maritalStatus"];
            if (Array.isArray(_data["personStatusHistories"])) {
                this.personStatusHistories = [] as any;
                for (let item of _data["personStatusHistories"])
                    this.personStatusHistories!.push(PersonStatusHistory.fromJS(item));
            }
            if (Array.isArray(_data["agencyPersonMappings"])) {
                this.agencyPersonMappings = [] as any;
                for (let item of _data["agencyPersonMappings"])
                    this.agencyPersonMappings!.push(AgencyPersonMapping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PersonAgenciesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonAgenciesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personStatus"] = this.personStatus;
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["status"] = this.status;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["statusChangeReason"] = this.statusChangeReason;
        data["ssn"] = this.ssn;
        data["maritalStatus"] = this.maritalStatus;
        if (Array.isArray(this.personStatusHistories)) {
            data["personStatusHistories"] = [];
            for (let item of this.personStatusHistories)
                data["personStatusHistories"].push(item.toJSON());
        }
        if (Array.isArray(this.agencyPersonMappings)) {
            data["agencyPersonMappings"] = [];
            for (let item of this.agencyPersonMappings)
                data["agencyPersonMappings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPersonAgenciesDto {
    personStatus?: string | undefined;
    id?: number;
    personId?: string | undefined;
    status?: PeopleStatus;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    statusChangeReason?: string | undefined;
    ssn?: string | undefined;
    maritalStatus?: string | undefined;
    personStatusHistories?: PersonStatusHistory[] | undefined;
    agencyPersonMappings?: AgencyPersonMapping[] | undefined;
}

export class PersonDetailsResponse implements IPersonDetailsResponse {
    id?: number;
    personId?: string | undefined;
    status?: string | undefined;
    email?: string | undefined;
    phone?: PhoneDetail[] | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    nameSuffix?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    addresses?: AddressDTO[] | undefined;
    personStatusHistories?: PersonStatusHistory[] | undefined;
    unmaskedSsn?: string | undefined;
    ivrPin?: string | undefined;
    paymentMethod?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    coordinatorPersonFirstName?: string | undefined;
    coordinatorPersonLastName?: string | undefined;
    coordinatorPersonName?: string | undefined;

    constructor(data?: IPersonDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.status = _data["status"];
            this.email = _data["email"];
            if (Array.isArray(_data["phone"])) {
                this.phone = [] as any;
                for (let item of _data["phone"])
                    this.phone!.push(PhoneDetail.fromJS(item));
            }
            this.gender = _data["gender"];
            this.ethnicity = _data["ethnicity"];
            this.race = _data["race"];
            this.maritalStatus = _data["maritalStatus"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.nameSuffix = _data["nameSuffix"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["personStatusHistories"])) {
                this.personStatusHistories = [] as any;
                for (let item of _data["personStatusHistories"])
                    this.personStatusHistories!.push(PersonStatusHistory.fromJS(item));
            }
            this.unmaskedSsn = _data["unmaskedSsn"];
            this.ivrPin = _data["ivrPin"];
            this.paymentMethod = _data["paymentMethod"];
            this.onboarded = _data["onboarded"];
            this.isFirstLoginComplete = _data["isFirstLoginComplete"];
            this.coordinatorPersonId = _data["coordinatorPersonId"];
            this.internalUserObjectId = _data["internalUserObjectId"];
            this.coordinatorPersonFirstName = _data["coordinatorPersonFirstName"];
            this.coordinatorPersonLastName = _data["coordinatorPersonLastName"];
            this.coordinatorPersonName = _data["coordinatorPersonName"];
        }
    }

    static fromJS(data: any): PersonDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PersonDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["status"] = this.status;
        data["email"] = this.email;
        if (Array.isArray(this.phone)) {
            data["phone"] = [];
            for (let item of this.phone)
                data["phone"].push(item.toJSON());
        }
        data["gender"] = this.gender;
        data["ethnicity"] = this.ethnicity;
        data["race"] = this.race;
        data["maritalStatus"] = this.maritalStatus;
        data["preferredLanguage"] = this.preferredLanguage;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["nameSuffix"] = this.nameSuffix;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.personStatusHistories)) {
            data["personStatusHistories"] = [];
            for (let item of this.personStatusHistories)
                data["personStatusHistories"].push(item.toJSON());
        }
        data["unmaskedSsn"] = this.unmaskedSsn;
        data["ivrPin"] = this.ivrPin;
        data["paymentMethod"] = this.paymentMethod;
        data["onboarded"] = this.onboarded;
        data["isFirstLoginComplete"] = this.isFirstLoginComplete;
        data["coordinatorPersonId"] = this.coordinatorPersonId;
        data["internalUserObjectId"] = this.internalUserObjectId;
        data["coordinatorPersonFirstName"] = this.coordinatorPersonFirstName;
        data["coordinatorPersonLastName"] = this.coordinatorPersonLastName;
        data["coordinatorPersonName"] = this.coordinatorPersonName;
        return data;
    }
}

export interface IPersonDetailsResponse {
    id?: number;
    personId?: string | undefined;
    status?: string | undefined;
    email?: string | undefined;
    phone?: PhoneDetail[] | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    nameSuffix?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    addresses?: AddressDTO[] | undefined;
    personStatusHistories?: PersonStatusHistory[] | undefined;
    unmaskedSsn?: string | undefined;
    ivrPin?: string | undefined;
    paymentMethod?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    coordinatorPersonFirstName?: string | undefined;
    coordinatorPersonLastName?: string | undefined;
    coordinatorPersonName?: string | undefined;
}

export class PersonEmailFilterDto implements IPersonEmailFilterDto {
    filterRequest?: FilterRequest;
    email?: string | undefined;

    constructor(data?: IPersonEmailFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterRequest = _data["filterRequest"] ? FilterRequest.fromJS(_data["filterRequest"]) : <any>undefined;
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): PersonEmailFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonEmailFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterRequest"] = this.filterRequest ? this.filterRequest.toJSON() : <any>undefined;
        data["email"] = this.email;
        return data;
    }
}

export interface IPersonEmailFilterDto {
    filterRequest?: FilterRequest;
    email?: string | undefined;
}

export class PersonExternalKeyDto implements IPersonExternalKeyDto {
    personExternalKeyMappingId?: number | undefined;
    code?: string | undefined;
    keyValue?: string | undefined;
    entityType?: string | undefined;

    constructor(data?: IPersonExternalKeyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personExternalKeyMappingId = _data["personExternalKeyMappingId"];
            this.code = _data["code"];
            this.keyValue = _data["keyValue"];
            this.entityType = _data["entityType"];
        }
    }

    static fromJS(data: any): PersonExternalKeyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonExternalKeyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personExternalKeyMappingId"] = this.personExternalKeyMappingId;
        data["code"] = this.code;
        data["keyValue"] = this.keyValue;
        data["entityType"] = this.entityType;
        return data;
    }
}

export interface IPersonExternalKeyDto {
    personExternalKeyMappingId?: number | undefined;
    code?: string | undefined;
    keyValue?: string | undefined;
    entityType?: string | undefined;
}

export class PersonIdByExternalKeyRequest implements IPersonIdByExternalKeyRequest {
    caregiverProvId?: string | undefined;
    participantProvId?: string | undefined;
    companyCode?: string | undefined;

    constructor(data?: IPersonIdByExternalKeyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverProvId = _data["caregiverProvId"];
            this.participantProvId = _data["participantProvId"];
            this.companyCode = _data["companyCode"];
        }
    }

    static fromJS(data: any): PersonIdByExternalKeyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PersonIdByExternalKeyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverProvId"] = this.caregiverProvId;
        data["participantProvId"] = this.participantProvId;
        data["companyCode"] = this.companyCode;
        return data;
    }
}

export interface IPersonIdByExternalKeyRequest {
    caregiverProvId?: string | undefined;
    participantProvId?: string | undefined;
    companyCode?: string | undefined;
}

export class PersonIdResponse implements IPersonIdResponse {
    personId?: string | undefined;

    constructor(data?: IPersonIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): PersonIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PersonIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        return data;
    }
}

export interface IPersonIdResponse {
    personId?: string | undefined;
}

export class PersonPhoneAddress implements IPersonPhoneAddress {
    addressDTO?: AddressDTO;
    phoneDetail?: PhoneDetail[] | undefined;

    constructor(data?: IPersonPhoneAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressDTO = _data["addressDTO"] ? AddressDTO.fromJS(_data["addressDTO"]) : <any>undefined;
            if (Array.isArray(_data["phoneDetail"])) {
                this.phoneDetail = [] as any;
                for (let item of _data["phoneDetail"])
                    this.phoneDetail!.push(PhoneDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PersonPhoneAddress {
        data = typeof data === 'object' ? data : {};
        let result = new PersonPhoneAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressDTO"] = this.addressDTO ? this.addressDTO.toJSON() : <any>undefined;
        if (Array.isArray(this.phoneDetail)) {
            data["phoneDetail"] = [];
            for (let item of this.phoneDetail)
                data["phoneDetail"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPersonPhoneAddress {
    addressDTO?: AddressDTO;
    phoneDetail?: PhoneDetail[] | undefined;
}

export class PersonProvId implements IPersonProvId {
    personId?: string | undefined;
    provId?: string | undefined;

    constructor(data?: IPersonProvId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.provId = _data["provId"];
        }
    }

    static fromJS(data: any): PersonProvId {
        data = typeof data === 'object' ? data : {};
        let result = new PersonProvId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["provId"] = this.provId;
        return data;
    }
}

export interface IPersonProvId {
    personId?: string | undefined;
    provId?: string | undefined;
}

export class PersonProvIdResponse implements IPersonProvIdResponse {
    participants?: PersonProvId[] | undefined;
    caregivers?: PersonProvId[] | undefined;

    constructor(data?: IPersonProvIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(PersonProvId.fromJS(item));
            }
            if (Array.isArray(_data["caregivers"])) {
                this.caregivers = [] as any;
                for (let item of _data["caregivers"])
                    this.caregivers!.push(PersonProvId.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PersonProvIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PersonProvIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        if (Array.isArray(this.caregivers)) {
            data["caregivers"] = [];
            for (let item of this.caregivers)
                data["caregivers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPersonProvIdResponse {
    participants?: PersonProvId[] | undefined;
    caregivers?: PersonProvId[] | undefined;
}

export class PersonRequestDto implements IPersonRequestDto {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    role?: string | undefined;
    companyId?: number | undefined;
    authStartDate?: Date | undefined;
    authEndDate?: Date | undefined;
    dateOfBirth?: Date | undefined;
    emailId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    ssn?: string | undefined;
    npi?: string | undefined;
    insuredId?: string | undefined;
    identifier?: string | undefined;
    phoneNumber?: string | undefined;
    coordinatorPersonId?: string | undefined;

    constructor(data?: IPersonRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            this.role = _data["role"];
            this.companyId = _data["companyId"];
            this.authStartDate = _data["authStartDate"] ? new Date(_data["authStartDate"].toString()) : <any>undefined;
            this.authEndDate = _data["authEndDate"] ? new Date(_data["authEndDate"].toString()) : <any>undefined;
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.emailId = _data["emailId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.ssn = _data["ssn"];
            this.npi = _data["npi"];
            this.insuredId = _data["insuredId"];
            this.identifier = _data["identifier"];
            this.phoneNumber = _data["phoneNumber"];
            this.coordinatorPersonId = _data["coordinatorPersonId"];
        }
    }

    static fromJS(data: any): PersonRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        data["role"] = this.role;
        data["companyId"] = this.companyId;
        data["authStartDate"] = this.authStartDate ? this.authStartDate.toISOString() : <any>undefined;
        data["authEndDate"] = this.authEndDate ? this.authEndDate.toISOString() : <any>undefined;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["emailId"] = this.emailId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["ssn"] = this.ssn;
        data["npi"] = this.npi;
        data["insuredId"] = this.insuredId;
        data["identifier"] = this.identifier;
        data["phoneNumber"] = this.phoneNumber;
        data["coordinatorPersonId"] = this.coordinatorPersonId;
        return data;
    }
}

export interface IPersonRequestDto {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    role?: string | undefined;
    companyId?: number | undefined;
    authStartDate?: Date | undefined;
    authEndDate?: Date | undefined;
    dateOfBirth?: Date | undefined;
    emailId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    ssn?: string | undefined;
    npi?: string | undefined;
    insuredId?: string | undefined;
    identifier?: string | undefined;
    phoneNumber?: string | undefined;
    coordinatorPersonId?: string | undefined;
}

export class PersonResponse implements IPersonResponse {
    totalCount?: number;
    personId?: string | undefined;

    constructor(data?: IPersonResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): PersonResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PersonResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["personId"] = this.personId;
        return data;
    }
}

export interface IPersonResponse {
    totalCount?: number;
    personId?: string | undefined;
}

export class PersonResponseDto implements IPersonResponseDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    personId?: string | undefined;
    name?: string | undefined;
    solomonId?: string | undefined;
    externalId?: string | undefined;
    role?: string | undefined;
    phoneNumber?: string | undefined;
    emailId?: string | undefined;
    insuredId?: string | undefined;
    impersonate?: string | undefined;
    participantId?: number;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;

    constructor(data?: IPersonResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.personId = _data["personId"];
            this.name = _data["name"];
            this.solomonId = _data["solomonId"];
            this.externalId = _data["externalId"];
            this.role = _data["role"];
            this.phoneNumber = _data["phoneNumber"];
            this.emailId = _data["emailId"];
            this.insuredId = _data["insuredId"];
            this.impersonate = _data["impersonate"];
            this.participantId = _data["participantId"];
            this.onboarded = _data["onboarded"];
            this.isFirstLoginComplete = _data["isFirstLoginComplete"];
        }
    }

    static fromJS(data: any): PersonResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["personId"] = this.personId;
        data["name"] = this.name;
        data["solomonId"] = this.solomonId;
        data["externalId"] = this.externalId;
        data["role"] = this.role;
        data["phoneNumber"] = this.phoneNumber;
        data["emailId"] = this.emailId;
        data["insuredId"] = this.insuredId;
        data["impersonate"] = this.impersonate;
        data["participantId"] = this.participantId;
        data["onboarded"] = this.onboarded;
        data["isFirstLoginComplete"] = this.isFirstLoginComplete;
        return data;
    }
}

export interface IPersonResponseDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    personId?: string | undefined;
    name?: string | undefined;
    solomonId?: string | undefined;
    externalId?: string | undefined;
    role?: string | undefined;
    phoneNumber?: string | undefined;
    emailId?: string | undefined;
    insuredId?: string | undefined;
    impersonate?: string | undefined;
    participantId?: number;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
}

export class PersonResponseDtoGridResponseBase implements IPersonResponseDtoGridResponseBase {
    items?: PersonResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PersonResponseDto;

    constructor(data?: IPersonResponseDtoGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PersonResponseDto.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? PersonResponseDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PersonResponseDtoGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new PersonResponseDtoGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPersonResponseDtoGridResponseBase {
    items?: PersonResponseDto[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PersonResponseDto;
}

export class PersonResponseV2 implements IPersonResponseV2 {
    personId?: number;
    companyId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    suffix?: string | undefined;
    email?: string | undefined;
    birthDate?: Date | undefined;
    ssn?: string | undefined;
    ivrPin?: string | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    preferredLanguage?: string | undefined;
    writtenLanguage?: string | undefined;
    allowAutoOnboard?: boolean;
    coordinatorPersonId?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    address?: AddressDTO[] | undefined;
    phone?: PhoneDtoV2[] | undefined;
    externalKeys?: PersonExternalKeyDto[] | undefined;
    personType?: string[] | undefined;

    constructor(data?: IPersonResponseV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.companyId = _data["companyId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.suffix = _data["suffix"];
            this.email = _data["email"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.ssn = _data["ssn"];
            this.ivrPin = _data["ivrPin"];
            this.gender = _data["gender"];
            this.ethnicity = _data["ethnicity"];
            this.race = _data["race"];
            this.maritalStatus = _data["maritalStatus"];
            this.onboarded = _data["onboarded"];
            this.isFirstLoginComplete = _data["isFirstLoginComplete"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.writtenLanguage = _data["writtenLanguage"];
            this.allowAutoOnboard = _data["allowAutoOnboard"];
            this.coordinatorPersonId = _data["coordinatorPersonId"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            if (Array.isArray(_data["address"])) {
                this.address = [] as any;
                for (let item of _data["address"])
                    this.address!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["phone"])) {
                this.phone = [] as any;
                for (let item of _data["phone"])
                    this.phone!.push(PhoneDtoV2.fromJS(item));
            }
            if (Array.isArray(_data["externalKeys"])) {
                this.externalKeys = [] as any;
                for (let item of _data["externalKeys"])
                    this.externalKeys!.push(PersonExternalKeyDto.fromJS(item));
            }
            if (Array.isArray(_data["personType"])) {
                this.personType = [] as any;
                for (let item of _data["personType"])
                    this.personType!.push(item);
            }
        }
    }

    static fromJS(data: any): PersonResponseV2 {
        data = typeof data === 'object' ? data : {};
        let result = new PersonResponseV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["companyId"] = this.companyId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["suffix"] = this.suffix;
        data["email"] = this.email;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["ssn"] = this.ssn;
        data["ivrPin"] = this.ivrPin;
        data["gender"] = this.gender;
        data["ethnicity"] = this.ethnicity;
        data["race"] = this.race;
        data["maritalStatus"] = this.maritalStatus;
        data["onboarded"] = this.onboarded;
        data["isFirstLoginComplete"] = this.isFirstLoginComplete;
        data["preferredLanguage"] = this.preferredLanguage;
        data["writtenLanguage"] = this.writtenLanguage;
        data["allowAutoOnboard"] = this.allowAutoOnboard;
        data["coordinatorPersonId"] = this.coordinatorPersonId;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        if (Array.isArray(this.address)) {
            data["address"] = [];
            for (let item of this.address)
                data["address"].push(item.toJSON());
        }
        if (Array.isArray(this.phone)) {
            data["phone"] = [];
            for (let item of this.phone)
                data["phone"].push(item.toJSON());
        }
        if (Array.isArray(this.externalKeys)) {
            data["externalKeys"] = [];
            for (let item of this.externalKeys)
                data["externalKeys"].push(item.toJSON());
        }
        if (Array.isArray(this.personType)) {
            data["personType"] = [];
            for (let item of this.personType)
                data["personType"].push(item);
        }
        return data;
    }
}

export interface IPersonResponseV2 {
    personId?: number;
    companyId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    suffix?: string | undefined;
    email?: string | undefined;
    birthDate?: Date | undefined;
    ssn?: string | undefined;
    ivrPin?: string | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    preferredLanguage?: string | undefined;
    writtenLanguage?: string | undefined;
    allowAutoOnboard?: boolean;
    coordinatorPersonId?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    address?: AddressDTO[] | undefined;
    phone?: PhoneDtoV2[] | undefined;
    externalKeys?: PersonExternalKeyDto[] | undefined;
    personType?: string[] | undefined;
}

export class PersonRoleResponse implements IPersonRoleResponse {
    personId?: string | undefined;
    roleId?: number;
    role?: string | undefined;

    constructor(data?: IPersonRoleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.roleId = _data["roleId"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): PersonRoleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PersonRoleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["roleId"] = this.roleId;
        data["role"] = this.role;
        return data;
    }
}

export interface IPersonRoleResponse {
    personId?: string | undefined;
    roleId?: number;
    role?: string | undefined;
}

export enum PersonStatus {
    None = "None",
    Warning = "Warning",
    Error = "Error",
    Success = "Success",
    BlueWarning = "BlueWarning",
}

export class PersonStatusHistory implements IPersonStatusHistory {
    personStatusId?: number;
    status?: string | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    personInternalId?: number;
    statusChangeReason?: string | undefined;
    personStatus?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;

    constructor(data?: IPersonStatusHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personStatusId = _data["personStatusId"];
            this.status = _data["status"];
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.personInternalId = _data["personInternalId"];
            this.statusChangeReason = _data["statusChangeReason"];
            this.personStatus = _data["personStatus"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): PersonStatusHistory {
        data = typeof data === 'object' ? data : {};
        let result = new PersonStatusHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personStatusId"] = this.personStatusId;
        data["status"] = this.status;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["personInternalId"] = this.personInternalId;
        data["statusChangeReason"] = this.statusChangeReason;
        data["personStatus"] = this.personStatus;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IPersonStatusHistory {
    personStatusId?: number;
    status?: string | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    personInternalId?: number;
    statusChangeReason?: string | undefined;
    personStatus?: string | undefined;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
}

export class PersonType implements IPersonType {
    personStatus?: string | undefined;
    id?: number;
    personId?: string | undefined;
    status?: PeopleStatus;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    statusChangeReason?: string | undefined;
    ssn?: string | undefined;
    maritalStatus?: string | undefined;
    personStatusHistories?: PersonStatusHistory[] | undefined;

    constructor(data?: IPersonType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personStatus = _data["personStatus"];
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.status = _data["status"];
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.statusChangeReason = _data["statusChangeReason"];
            this.ssn = _data["ssn"];
            this.maritalStatus = _data["maritalStatus"];
            if (Array.isArray(_data["personStatusHistories"])) {
                this.personStatusHistories = [] as any;
                for (let item of _data["personStatusHistories"])
                    this.personStatusHistories!.push(PersonStatusHistory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PersonType {
        data = typeof data === 'object' ? data : {};
        let result = new PersonType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personStatus"] = this.personStatus;
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["status"] = this.status;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["statusChangeReason"] = this.statusChangeReason;
        data["ssn"] = this.ssn;
        data["maritalStatus"] = this.maritalStatus;
        if (Array.isArray(this.personStatusHistories)) {
            data["personStatusHistories"] = [];
            for (let item of this.personStatusHistories)
                data["personStatusHistories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPersonType {
    personStatus?: string | undefined;
    id?: number;
    personId?: string | undefined;
    status?: PeopleStatus;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    statusChangeReason?: string | undefined;
    ssn?: string | undefined;
    maritalStatus?: string | undefined;
    personStatusHistories?: PersonStatusHistory[] | undefined;
}

export class PersonTypeDeleteResponse implements IPersonTypeDeleteResponse {
    authorizationCount?: number;
    relationshipCount?: number;
    status?: number;
    message?: string | undefined;

    constructor(data?: IPersonTypeDeleteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorizationCount = _data["authorizationCount"];
            this.relationshipCount = _data["relationshipCount"];
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PersonTypeDeleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PersonTypeDeleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorizationCount"] = this.authorizationCount;
        data["relationshipCount"] = this.relationshipCount;
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }
}

export interface IPersonTypeDeleteResponse {
    authorizationCount?: number;
    relationshipCount?: number;
    status?: number;
    message?: string | undefined;
}

export class PersonTypeResponse implements IPersonTypeResponse {
    personId?: string | undefined;
    roleType?: string | undefined;
    roleTypeDisplayText?: string | undefined;
    status?: string | undefined;
    participantId?: number;

    constructor(data?: IPersonTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.roleType = _data["roleType"];
            this.roleTypeDisplayText = _data["roleTypeDisplayText"];
            this.status = _data["status"];
            this.participantId = _data["participantId"];
        }
    }

    static fromJS(data: any): PersonTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PersonTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["roleType"] = this.roleType;
        data["roleTypeDisplayText"] = this.roleTypeDisplayText;
        data["status"] = this.status;
        data["participantId"] = this.participantId;
        return data;
    }
}

export interface IPersonTypeResponse {
    personId?: string | undefined;
    roleType?: string | undefined;
    roleTypeDisplayText?: string | undefined;
    status?: string | undefined;
    participantId?: number;
}

export enum PersonTypes {
    DesignatedRepresentative = "DesignatedRepresentative",
    AgencyAdmin = "AgencyAdmin",
    ServiceFacilitator = "ServiceFacilitator",
    Participant = "Participant",
    Caregiver = "Caregiver",
    EmployerOfRecord = "EmployerOfRecord",
    MCO = "MCO",
    Coordinator = "Coordinator",
    CaseManager = "CaseManager",
    CaregiverProspect = "CaregiverProspect",
}

export enum Phone {
    CellPhone = "CellPhone",
    HomePhone = "HomePhone",
    IvrPhone = "IvrPhone",
}

export class PhoneDetail implements IPhoneDetail {
    type?: Phone;
    number?: string | undefined;
    extension?: string | undefined;
    personId?: string | undefined;
    personInternalId?: number;
    personPhoneId?: number | undefined;
    phoneType?: string | undefined;
    isDefault?: boolean;
    isIVR?: boolean;
    isSMSCapable?: boolean;

    constructor(data?: IPhoneDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.number = _data["number"];
            this.extension = _data["extension"];
            this.personId = _data["personId"];
            this.personInternalId = _data["personInternalId"];
            this.personPhoneId = _data["personPhoneId"];
            this.phoneType = _data["phoneType"];
            this.isDefault = _data["isDefault"];
            this.isIVR = _data["isIVR"];
            this.isSMSCapable = _data["isSMSCapable"];
        }
    }

    static fromJS(data: any): PhoneDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["number"] = this.number;
        data["extension"] = this.extension;
        data["personId"] = this.personId;
        data["personInternalId"] = this.personInternalId;
        data["personPhoneId"] = this.personPhoneId;
        data["phoneType"] = this.phoneType;
        data["isDefault"] = this.isDefault;
        data["isIVR"] = this.isIVR;
        data["isSMSCapable"] = this.isSMSCapable;
        return data;
    }
}

export interface IPhoneDetail {
    type?: Phone;
    number?: string | undefined;
    extension?: string | undefined;
    personId?: string | undefined;
    personInternalId?: number;
    personPhoneId?: number | undefined;
    phoneType?: string | undefined;
    isDefault?: boolean;
    isIVR?: boolean;
    isSMSCapable?: boolean;
}

export class PhoneDtoV2 implements IPhoneDtoV2 {
    type?: string | undefined;
    extension?: string | undefined;
    phoneId?: number;
    number?: string | undefined;
    isDefault?: boolean;

    constructor(data?: IPhoneDtoV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.extension = _data["extension"];
            this.phoneId = _data["phoneId"];
            this.number = _data["number"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): PhoneDtoV2 {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneDtoV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["extension"] = this.extension;
        data["phoneId"] = this.phoneId;
        data["number"] = this.number;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IPhoneDtoV2 {
    type?: string | undefined;
    extension?: string | undefined;
    phoneId?: number;
    number?: string | undefined;
    isDefault?: boolean;
}

export class PhoneHistoryResponse implements IPhoneHistoryResponse {
    personId?: string | undefined;
    phoneType?: string | undefined;
    extension?: string | undefined;
    personPhoneId?: number;
    phoneNumber?: string | undefined;
    isDefault?: boolean;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IPhoneHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.phoneType = _data["phoneType"];
            this.extension = _data["extension"];
            this.personPhoneId = _data["personPhoneId"];
            this.phoneNumber = _data["phoneNumber"];
            this.isDefault = _data["isDefault"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PhoneHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["phoneType"] = this.phoneType;
        data["extension"] = this.extension;
        data["personPhoneId"] = this.personPhoneId;
        data["phoneNumber"] = this.phoneNumber;
        data["isDefault"] = this.isDefault;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPhoneHistoryResponse {
    personId?: string | undefined;
    phoneType?: string | undefined;
    extension?: string | undefined;
    personPhoneId?: number;
    phoneNumber?: string | undefined;
    isDefault?: boolean;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class PortalActions implements IPortalActions {
    startDate?: Date;
    endDate?: Date;
    reason?: string | undefined;
    reasonId?: number;
    caregiverParticipantMappingId?: number;
    status?: string | undefined;
    statusId?: number;
    actions?: ActionDetails[] | undefined;
    personId?: string | undefined;
    associatedPerson?: AssociatedPerson;
    hiddenPerson?: string | undefined;

    constructor(data?: IPortalActions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.reasonId = _data["reasonId"];
            this.caregiverParticipantMappingId = _data["caregiverParticipantMappingId"];
            this.status = _data["status"];
            this.statusId = _data["statusId"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(ActionDetails.fromJS(item));
            }
            this.personId = _data["personId"];
            this.associatedPerson = _data["associatedPerson"] ? AssociatedPerson.fromJS(_data["associatedPerson"]) : <any>undefined;
            this.hiddenPerson = _data["hiddenPerson"];
        }
    }

    static fromJS(data: any): PortalActions {
        data = typeof data === 'object' ? data : {};
        let result = new PortalActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        data["reasonId"] = this.reasonId;
        data["caregiverParticipantMappingId"] = this.caregiverParticipantMappingId;
        data["status"] = this.status;
        data["statusId"] = this.statusId;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        data["personId"] = this.personId;
        data["associatedPerson"] = this.associatedPerson ? this.associatedPerson.toJSON() : <any>undefined;
        data["hiddenPerson"] = this.hiddenPerson;
        return data;
    }
}

export interface IPortalActions {
    startDate?: Date;
    endDate?: Date;
    reason?: string | undefined;
    reasonId?: number;
    caregiverParticipantMappingId?: number;
    status?: string | undefined;
    statusId?: number;
    actions?: ActionDetails[] | undefined;
    personId?: string | undefined;
    associatedPerson?: AssociatedPerson;
    hiddenPerson?: string | undefined;
}

export class PortalUserDTO implements IPortalUserDTO {
    portalUserId?: number;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    state?: string | undefined;
    email?: string | undefined;
    birthDate?: Date | undefined;
    coordinatorPersonId?: string | undefined;
    ssn?: string | undefined;
    phoneNumber?: string | undefined;
    createdOn?: Date;
    personId?: string | undefined;
    role?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    zip?: string | undefined;
    cellphone?: string | undefined;
    landPhone?: string | undefined;
    phoneType?: string | undefined;
    addressType?: string | undefined;
    solomonId?: string | undefined;
    stateCode?: string | undefined;
    id?: number | undefined;
    preferredLanguage?: string | undefined;
    companyId?: number | undefined;
    isSsnValidated?: boolean;

    constructor(data?: IPortalUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.portalUserId = _data["portalUserId"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.state = _data["state"];
            this.email = _data["email"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.coordinatorPersonId = _data["coordinatorPersonId"];
            this.ssn = _data["ssn"];
            this.phoneNumber = _data["phoneNumber"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.personId = _data["personId"];
            this.role = _data["role"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.zip = _data["zip"];
            this.cellphone = _data["cellphone"];
            this.landPhone = _data["landPhone"];
            this.phoneType = _data["phoneType"];
            this.addressType = _data["addressType"];
            this.solomonId = _data["solomonId"];
            this.stateCode = _data["stateCode"];
            this.id = _data["id"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.companyId = _data["companyId"];
            this.isSsnValidated = _data["isSsnValidated"];
        }
    }

    static fromJS(data: any): PortalUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PortalUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["portalUserId"] = this.portalUserId;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["state"] = this.state;
        data["email"] = this.email;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["coordinatorPersonId"] = this.coordinatorPersonId;
        data["ssn"] = this.ssn;
        data["phoneNumber"] = this.phoneNumber;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["personId"] = this.personId;
        data["role"] = this.role;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["zip"] = this.zip;
        data["cellphone"] = this.cellphone;
        data["landPhone"] = this.landPhone;
        data["phoneType"] = this.phoneType;
        data["addressType"] = this.addressType;
        data["solomonId"] = this.solomonId;
        data["stateCode"] = this.stateCode;
        data["id"] = this.id;
        data["preferredLanguage"] = this.preferredLanguage;
        data["companyId"] = this.companyId;
        data["isSsnValidated"] = this.isSsnValidated;
        return data;
    }
}

export interface IPortalUserDTO {
    portalUserId?: number;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    state?: string | undefined;
    email?: string | undefined;
    birthDate?: Date | undefined;
    coordinatorPersonId?: string | undefined;
    ssn?: string | undefined;
    phoneNumber?: string | undefined;
    createdOn?: Date;
    personId?: string | undefined;
    role?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    zip?: string | undefined;
    cellphone?: string | undefined;
    landPhone?: string | undefined;
    phoneType?: string | undefined;
    addressType?: string | undefined;
    solomonId?: string | undefined;
    stateCode?: string | undefined;
    id?: number | undefined;
    preferredLanguage?: string | undefined;
    companyId?: number | undefined;
    isSsnValidated?: boolean;
}

export class PortalUserDTOGridResponseBase implements IPortalUserDTOGridResponseBase {
    items?: PortalUserDTO[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PortalUserDTO;

    constructor(data?: IPortalUserDTOGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PortalUserDTO.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? PortalUserDTO.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PortalUserDTOGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new PortalUserDTOGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPortalUserDTOGridResponseBase {
    items?: PortalUserDTO[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PortalUserDTO;
}

export class PortalUserDetails implements IPortalUserDetails {
    role?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    personId?: string | undefined;

    constructor(data?: IPortalUserDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): PortalUserDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PortalUserDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["personId"] = this.personId;
        return data;
    }
}

export interface IPortalUserDetails {
    role?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    personId?: string | undefined;
}

export class PortalUserFilterRequest implements IPortalUserFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    state?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;

    constructor(data?: IPortalUserFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            this.state = _data["state"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): PortalUserFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PortalUserFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        data["state"] = this.state;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        return data;
    }
}

export interface IPortalUserFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    state?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
}

export class PortalUserMappedRequest implements IPortalUserMappedRequest {
    userId?: string | undefined;
    personIds?: string[] | undefined;
    role?: string | undefined;

    constructor(data?: IPortalUserMappedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["personIds"])) {
                this.personIds = [] as any;
                for (let item of _data["personIds"])
                    this.personIds!.push(item);
            }
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): PortalUserMappedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PortalUserMappedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.personIds)) {
            data["personIds"] = [];
            for (let item of this.personIds)
                data["personIds"].push(item);
        }
        data["role"] = this.role;
        return data;
    }
}

export interface IPortalUserMappedRequest {
    userId?: string | undefined;
    personIds?: string[] | undefined;
    role?: string | undefined;
}

export class PortalUserMapping implements IPortalUserMapping {
    participantUserId?: string | undefined;
    mappedUserId?: string | undefined;
    mappedUserRole?: string | undefined;
    isHidden?: boolean;

    constructor(data?: IPortalUserMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantUserId = _data["participantUserId"];
            this.mappedUserId = _data["mappedUserId"];
            this.mappedUserRole = _data["mappedUserRole"];
            this.isHidden = _data["isHidden"];
        }
    }

    static fromJS(data: any): PortalUserMapping {
        data = typeof data === 'object' ? data : {};
        let result = new PortalUserMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantUserId"] = this.participantUserId;
        data["mappedUserId"] = this.mappedUserId;
        data["mappedUserRole"] = this.mappedUserRole;
        data["isHidden"] = this.isHidden;
        return data;
    }
}

export interface IPortalUserMapping {
    participantUserId?: string | undefined;
    mappedUserId?: string | undefined;
    mappedUserRole?: string | undefined;
    isHidden?: boolean;
}

export class PortalUserRequest implements IPortalUserRequest {
    userId?: string | undefined;
    personId?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    state?: string | undefined;
    email?: string | undefined;
    birthDate?: Date | undefined;
    ssn?: string | undefined;
    phoneNumber?: string | undefined;
    role?: string | undefined;
    activeRelationshipsOnly?: boolean;

    constructor(data?: IPortalUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.personId = _data["personId"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.state = _data["state"];
            this.email = _data["email"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.ssn = _data["ssn"];
            this.phoneNumber = _data["phoneNumber"];
            this.role = _data["role"];
            this.activeRelationshipsOnly = _data["activeRelationshipsOnly"];
        }
    }

    static fromJS(data: any): PortalUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PortalUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["personId"] = this.personId;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["state"] = this.state;
        data["email"] = this.email;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["ssn"] = this.ssn;
        data["phoneNumber"] = this.phoneNumber;
        data["role"] = this.role;
        data["activeRelationshipsOnly"] = this.activeRelationshipsOnly;
        return data;
    }
}

export interface IPortalUserRequest {
    userId?: string | undefined;
    personId?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    state?: string | undefined;
    email?: string | undefined;
    birthDate?: Date | undefined;
    ssn?: string | undefined;
    phoneNumber?: string | undefined;
    role?: string | undefined;
    activeRelationshipsOnly?: boolean;
}

export class PortalUserSetLastV4LoginOnRequest implements IPortalUserSetLastV4LoginOnRequest {
    personId?: string | undefined;

    constructor(data?: IPortalUserSetLastV4LoginOnRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): PortalUserSetLastV4LoginOnRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PortalUserSetLastV4LoginOnRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        return data;
    }
}

export interface IPortalUserSetLastV4LoginOnRequest {
    personId?: string | undefined;
}

export class PortalUserSsnValidationOverrideRequest implements IPortalUserSsnValidationOverrideRequest {
    personId?: string | undefined;
    clearOverride?: boolean;

    constructor(data?: IPortalUserSsnValidationOverrideRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.clearOverride = _data["clearOverride"];
        }
    }

    static fromJS(data: any): PortalUserSsnValidationOverrideRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PortalUserSsnValidationOverrideRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["clearOverride"] = this.clearOverride;
        return data;
    }
}

export interface IPortalUserSsnValidationOverrideRequest {
    personId?: string | undefined;
    clearOverride?: boolean;
}

export class PortalUserSsnValidationRequest implements IPortalUserSsnValidationRequest {
    personId?: string | undefined;
    ssn?: string | undefined;

    constructor(data?: IPortalUserSsnValidationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.ssn = _data["ssn"];
        }
    }

    static fromJS(data: any): PortalUserSsnValidationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PortalUserSsnValidationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["ssn"] = this.ssn;
        return data;
    }
}

export interface IPortalUserSsnValidationRequest {
    personId?: string | undefined;
    ssn?: string | undefined;
}

export class PortalUserSsnValidationResetRequest implements IPortalUserSsnValidationResetRequest {
    personId?: string | undefined;

    constructor(data?: IPortalUserSsnValidationResetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): PortalUserSsnValidationResetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PortalUserSsnValidationResetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        return data;
    }
}

export interface IPortalUserSsnValidationResetRequest {
    personId?: string | undefined;
}

export class PortalUsersRequest implements IPortalUsersRequest {
    portalUserId?: number;
    oldEmail?: string | undefined;
    newEmail?: string | undefined;
    personId?: string | undefined;

    constructor(data?: IPortalUsersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.portalUserId = _data["portalUserId"];
            this.oldEmail = _data["oldEmail"];
            this.newEmail = _data["newEmail"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): PortalUsersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PortalUsersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["portalUserId"] = this.portalUserId;
        data["oldEmail"] = this.oldEmail;
        data["newEmail"] = this.newEmail;
        data["personId"] = this.personId;
        return data;
    }
}

export interface IPortalUsersRequest {
    portalUserId?: number;
    oldEmail?: string | undefined;
    newEmail?: string | undefined;
    personId?: string | undefined;
}

export class PrimaryAddressPhone implements IPrimaryAddressPhone {
    personInternalId?: number;
    personAddressPhoneId?: number;
    entityType?: string | undefined;
    type?: string | undefined;

    constructor(data?: IPrimaryAddressPhone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personInternalId = _data["personInternalId"];
            this.personAddressPhoneId = _data["personAddressPhoneId"];
            this.entityType = _data["entityType"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): PrimaryAddressPhone {
        data = typeof data === 'object' ? data : {};
        let result = new PrimaryAddressPhone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personInternalId"] = this.personInternalId;
        data["personAddressPhoneId"] = this.personAddressPhoneId;
        data["entityType"] = this.entityType;
        data["type"] = this.type;
        return data;
    }
}

export interface IPrimaryAddressPhone {
    personInternalId?: number;
    personAddressPhoneId?: number;
    entityType?: string | undefined;
    type?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ProgramCoordinatorDto implements IProgramCoordinatorDto {
    personStatus?: string | undefined;
    id?: number;
    personId?: string | undefined;
    status?: PeopleStatus;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    statusChangeReason?: string | undefined;
    ssn?: string | undefined;
    maritalStatus?: string | undefined;
    personStatusHistories?: PersonStatusHistory[] | undefined;
    programCoordinatorId?: number | undefined;
    solomonProgramCoordinatorId?: string | undefined;
    employerId?: number | undefined;
    employerEin?: string | undefined;
    employerStartDate?: Date | undefined;
    employerEndDate?: Date | undefined;

    constructor(data?: IProgramCoordinatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personStatus = _data["personStatus"];
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.status = _data["status"];
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.statusChangeReason = _data["statusChangeReason"];
            this.ssn = _data["ssn"];
            this.maritalStatus = _data["maritalStatus"];
            if (Array.isArray(_data["personStatusHistories"])) {
                this.personStatusHistories = [] as any;
                for (let item of _data["personStatusHistories"])
                    this.personStatusHistories!.push(PersonStatusHistory.fromJS(item));
            }
            this.programCoordinatorId = _data["programCoordinatorId"];
            this.solomonProgramCoordinatorId = _data["solomonProgramCoordinatorId"];
            this.employerId = _data["employerId"];
            this.employerEin = _data["employerEin"];
            this.employerStartDate = _data["employerStartDate"] ? new Date(_data["employerStartDate"].toString()) : <any>undefined;
            this.employerEndDate = _data["employerEndDate"] ? new Date(_data["employerEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProgramCoordinatorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramCoordinatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personStatus"] = this.personStatus;
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["status"] = this.status;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["statusChangeReason"] = this.statusChangeReason;
        data["ssn"] = this.ssn;
        data["maritalStatus"] = this.maritalStatus;
        if (Array.isArray(this.personStatusHistories)) {
            data["personStatusHistories"] = [];
            for (let item of this.personStatusHistories)
                data["personStatusHistories"].push(item.toJSON());
        }
        data["programCoordinatorId"] = this.programCoordinatorId;
        data["solomonProgramCoordinatorId"] = this.solomonProgramCoordinatorId;
        data["employerId"] = this.employerId;
        data["employerEin"] = this.employerEin;
        data["employerStartDate"] = this.employerStartDate ? this.employerStartDate.toISOString() : <any>undefined;
        data["employerEndDate"] = this.employerEndDate ? this.employerEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProgramCoordinatorDto {
    personStatus?: string | undefined;
    id?: number;
    personId?: string | undefined;
    status?: PeopleStatus;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    statusChangeReason?: string | undefined;
    ssn?: string | undefined;
    maritalStatus?: string | undefined;
    personStatusHistories?: PersonStatusHistory[] | undefined;
    programCoordinatorId?: number | undefined;
    solomonProgramCoordinatorId?: string | undefined;
    employerId?: number | undefined;
    employerEin?: string | undefined;
    employerStartDate?: Date | undefined;
    employerEndDate?: Date | undefined;
}

export class ProgramCoordinatorProfile implements IProgramCoordinatorProfile {
    phoneDetails?: PhoneDetail[] | undefined;
    physicalAddresses?: AddressDTO[] | undefined;
    mailingAddresses?: AddressDTO[] | undefined;
    ivrAddresses?: AddressDTO[] | undefined;
    externalKeys?: ExternalKeyDTO[] | undefined;
    id?: number;
    personId?: string | undefined;
    status?: string | undefined;
    readonly personName?: string | undefined;
    ssn?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    physicalAddress?: string | undefined;
    mailingAddress?: string | undefined;
    ivrAddress?: string | undefined;
    companyCode?: string | undefined;
    unmaskedSsn?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    ivrPin?: string | undefined;
    paymentMethod?: string | undefined;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    coordinatorPersonFirstName?: string | undefined;
    coordinatorPersonLastName?: string | undefined;
    coordinatorPersonName?: string | undefined;
    lastV4LoginOn?: Date | undefined;
    isSsnValidated?: boolean | undefined;
    ssnValidationOverrideOn?: Date | undefined;
    ssnValidationOverrideBy?: string | undefined;
    programCoordinatorId?: number;
    solomonId?: string | undefined;

    constructor(data?: IProgramCoordinatorProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["phoneDetails"])) {
                this.phoneDetails = [] as any;
                for (let item of _data["phoneDetails"])
                    this.phoneDetails!.push(PhoneDetail.fromJS(item));
            }
            if (Array.isArray(_data["physicalAddresses"])) {
                this.physicalAddresses = [] as any;
                for (let item of _data["physicalAddresses"])
                    this.physicalAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["mailingAddresses"])) {
                this.mailingAddresses = [] as any;
                for (let item of _data["mailingAddresses"])
                    this.mailingAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["ivrAddresses"])) {
                this.ivrAddresses = [] as any;
                for (let item of _data["ivrAddresses"])
                    this.ivrAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["externalKeys"])) {
                this.externalKeys = [] as any;
                for (let item of _data["externalKeys"])
                    this.externalKeys!.push(ExternalKeyDTO.fromJS(item));
            }
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.status = _data["status"];
            (<any>this).personName = _data["personName"];
            this.ssn = _data["ssn"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.gender = _data["gender"];
            this.ethnicity = _data["ethnicity"];
            this.race = _data["race"];
            this.maritalStatus = _data["maritalStatus"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.physicalAddress = _data["physicalAddress"];
            this.mailingAddress = _data["mailingAddress"];
            this.ivrAddress = _data["ivrAddress"];
            this.companyCode = _data["companyCode"];
            this.unmaskedSsn = _data["unmaskedSsn"];
            this.onboarded = _data["onboarded"];
            this.isFirstLoginComplete = _data["isFirstLoginComplete"];
            this.ivrPin = _data["ivrPin"];
            this.paymentMethod = _data["paymentMethod"];
            this.coordinatorPersonId = _data["coordinatorPersonId"];
            this.internalUserObjectId = _data["internalUserObjectId"];
            this.coordinatorPersonFirstName = _data["coordinatorPersonFirstName"];
            this.coordinatorPersonLastName = _data["coordinatorPersonLastName"];
            this.coordinatorPersonName = _data["coordinatorPersonName"];
            this.lastV4LoginOn = _data["lastV4LoginOn"] ? new Date(_data["lastV4LoginOn"].toString()) : <any>undefined;
            this.isSsnValidated = _data["isSsnValidated"];
            this.ssnValidationOverrideOn = _data["ssnValidationOverrideOn"] ? new Date(_data["ssnValidationOverrideOn"].toString()) : <any>undefined;
            this.ssnValidationOverrideBy = _data["ssnValidationOverrideBy"];
            this.programCoordinatorId = _data["programCoordinatorId"];
            this.solomonId = _data["solomonId"];
        }
    }

    static fromJS(data: any): ProgramCoordinatorProfile {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramCoordinatorProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phoneDetails)) {
            data["phoneDetails"] = [];
            for (let item of this.phoneDetails)
                data["phoneDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.physicalAddresses)) {
            data["physicalAddresses"] = [];
            for (let item of this.physicalAddresses)
                data["physicalAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.mailingAddresses)) {
            data["mailingAddresses"] = [];
            for (let item of this.mailingAddresses)
                data["mailingAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.ivrAddresses)) {
            data["ivrAddresses"] = [];
            for (let item of this.ivrAddresses)
                data["ivrAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.externalKeys)) {
            data["externalKeys"] = [];
            for (let item of this.externalKeys)
                data["externalKeys"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["status"] = this.status;
        data["personName"] = this.personName;
        data["ssn"] = this.ssn;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["gender"] = this.gender;
        data["ethnicity"] = this.ethnicity;
        data["race"] = this.race;
        data["maritalStatus"] = this.maritalStatus;
        data["preferredLanguage"] = this.preferredLanguage;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["physicalAddress"] = this.physicalAddress;
        data["mailingAddress"] = this.mailingAddress;
        data["ivrAddress"] = this.ivrAddress;
        data["companyCode"] = this.companyCode;
        data["unmaskedSsn"] = this.unmaskedSsn;
        data["onboarded"] = this.onboarded;
        data["isFirstLoginComplete"] = this.isFirstLoginComplete;
        data["ivrPin"] = this.ivrPin;
        data["paymentMethod"] = this.paymentMethod;
        data["coordinatorPersonId"] = this.coordinatorPersonId;
        data["internalUserObjectId"] = this.internalUserObjectId;
        data["coordinatorPersonFirstName"] = this.coordinatorPersonFirstName;
        data["coordinatorPersonLastName"] = this.coordinatorPersonLastName;
        data["coordinatorPersonName"] = this.coordinatorPersonName;
        data["lastV4LoginOn"] = this.lastV4LoginOn ? this.lastV4LoginOn.toISOString() : <any>undefined;
        data["isSsnValidated"] = this.isSsnValidated;
        data["ssnValidationOverrideOn"] = this.ssnValidationOverrideOn ? this.ssnValidationOverrideOn.toISOString() : <any>undefined;
        data["ssnValidationOverrideBy"] = this.ssnValidationOverrideBy;
        data["programCoordinatorId"] = this.programCoordinatorId;
        data["solomonId"] = this.solomonId;
        return data;
    }
}

export interface IProgramCoordinatorProfile {
    phoneDetails?: PhoneDetail[] | undefined;
    physicalAddresses?: AddressDTO[] | undefined;
    mailingAddresses?: AddressDTO[] | undefined;
    ivrAddresses?: AddressDTO[] | undefined;
    externalKeys?: ExternalKeyDTO[] | undefined;
    id?: number;
    personId?: string | undefined;
    status?: string | undefined;
    personName?: string | undefined;
    ssn?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    physicalAddress?: string | undefined;
    mailingAddress?: string | undefined;
    ivrAddress?: string | undefined;
    companyCode?: string | undefined;
    unmaskedSsn?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    ivrPin?: string | undefined;
    paymentMethod?: string | undefined;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    coordinatorPersonFirstName?: string | undefined;
    coordinatorPersonLastName?: string | undefined;
    coordinatorPersonName?: string | undefined;
    lastV4LoginOn?: Date | undefined;
    isSsnValidated?: boolean | undefined;
    ssnValidationOverrideOn?: Date | undefined;
    ssnValidationOverrideBy?: string | undefined;
    programCoordinatorId?: number;
    solomonId?: string | undefined;
}

export class ProspectiveRelationshipDeleteRequest implements IProspectiveRelationshipDeleteRequest {
    caregiverParticipantProspectIds?: number[] | undefined;

    constructor(data?: IProspectiveRelationshipDeleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["caregiverParticipantProspectIds"])) {
                this.caregiverParticipantProspectIds = [] as any;
                for (let item of _data["caregiverParticipantProspectIds"])
                    this.caregiverParticipantProspectIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ProspectiveRelationshipDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectiveRelationshipDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.caregiverParticipantProspectIds)) {
            data["caregiverParticipantProspectIds"] = [];
            for (let item of this.caregiverParticipantProspectIds)
                data["caregiverParticipantProspectIds"].push(item);
        }
        return data;
    }
}

export interface IProspectiveRelationshipDeleteRequest {
    caregiverParticipantProspectIds?: number[] | undefined;
}

export class PtpPaidCaregiversDto implements IPtpPaidCaregiversDto {
    personId?: string | undefined;
    servCode?: string | undefined;
    description?: string | undefined;

    constructor(data?: IPtpPaidCaregiversDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.servCode = _data["servCode"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PtpPaidCaregiversDto {
        data = typeof data === 'object' ? data : {};
        let result = new PtpPaidCaregiversDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["servCode"] = this.servCode;
        data["description"] = this.description;
        return data;
    }
}

export interface IPtpPaidCaregiversDto {
    personId?: string | undefined;
    servCode?: string | undefined;
    description?: string | undefined;
}

export class Qualification implements IQualification {
    qualificationId?: number;
    qualificationCode?: number;
    displayText?: string | undefined;
    companyId?: number;

    constructor(data?: IQualification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationId = _data["qualificationId"];
            this.qualificationCode = _data["qualificationCode"];
            this.displayText = _data["displayText"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): Qualification {
        data = typeof data === 'object' ? data : {};
        let result = new Qualification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationId"] = this.qualificationId;
        data["qualificationCode"] = this.qualificationCode;
        data["displayText"] = this.displayText;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IQualification {
    qualificationId?: number;
    qualificationCode?: number;
    displayText?: string | undefined;
    companyId?: number;
}

export class QualificationCategoryDto implements IQualificationCategoryDto {
    categoryId?: number;
    categoryName?: string | undefined;
    isParticipantRequired?: boolean;

    constructor(data?: IQualificationCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.categoryName = _data["categoryName"];
            this.isParticipantRequired = _data["isParticipantRequired"];
        }
    }

    static fromJS(data: any): QualificationCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        data["isParticipantRequired"] = this.isParticipantRequired;
        return data;
    }
}

export interface IQualificationCategoryDto {
    categoryId?: number;
    categoryName?: string | undefined;
    isParticipantRequired?: boolean;
}

export class QualificationClassDto implements IQualificationClassDto {
    id?: number;
    qualificationClassId?: number;
    qualificationClassName?: string | undefined;
    qualificationClassDescription?: string | undefined;
    qualificationTypeId?: number;
    qualificationTypeName?: string | undefined;
    qualificationTypeDescription?: string | undefined;
    externalQualificationType?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    qualificationClassCategory?: string | undefined;
    qualificationTypeCategory?: string | undefined;
    qualificationTypeCategoryId?: number;
    ignoreEquivalentExpiresDate?: boolean;

    constructor(data?: IQualificationClassDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationClassId = _data["qualificationClassId"];
            this.qualificationClassName = _data["qualificationClassName"];
            this.qualificationClassDescription = _data["qualificationClassDescription"];
            this.qualificationTypeId = _data["qualificationTypeId"];
            this.qualificationTypeName = _data["qualificationTypeName"];
            this.qualificationTypeDescription = _data["qualificationTypeDescription"];
            this.externalQualificationType = _data["externalQualificationType"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.qualificationClassCategory = _data["qualificationClassCategory"];
            this.qualificationTypeCategory = _data["qualificationTypeCategory"];
            this.qualificationTypeCategoryId = _data["qualificationTypeCategoryId"];
            this.ignoreEquivalentExpiresDate = _data["ignoreEquivalentExpiresDate"];
        }
    }

    static fromJS(data: any): QualificationClassDto {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationClassDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationClassId"] = this.qualificationClassId;
        data["qualificationClassName"] = this.qualificationClassName;
        data["qualificationClassDescription"] = this.qualificationClassDescription;
        data["qualificationTypeId"] = this.qualificationTypeId;
        data["qualificationTypeName"] = this.qualificationTypeName;
        data["qualificationTypeDescription"] = this.qualificationTypeDescription;
        data["externalQualificationType"] = this.externalQualificationType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["qualificationClassCategory"] = this.qualificationClassCategory;
        data["qualificationTypeCategory"] = this.qualificationTypeCategory;
        data["qualificationTypeCategoryId"] = this.qualificationTypeCategoryId;
        data["ignoreEquivalentExpiresDate"] = this.ignoreEquivalentExpiresDate;
        return data;
    }
}

export interface IQualificationClassDto {
    id?: number;
    qualificationClassId?: number;
    qualificationClassName?: string | undefined;
    qualificationClassDescription?: string | undefined;
    qualificationTypeId?: number;
    qualificationTypeName?: string | undefined;
    qualificationTypeDescription?: string | undefined;
    externalQualificationType?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    qualificationClassCategory?: string | undefined;
    qualificationTypeCategory?: string | undefined;
    qualificationTypeCategoryId?: number;
    ignoreEquivalentExpiresDate?: boolean;
}

export class QualificationClassRequest implements IQualificationClassRequest {
    qualificationClassId?: number;
    qualificationTypes?: QualificationClassDto[] | undefined;

    constructor(data?: IQualificationClassRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationClassId = _data["qualificationClassId"];
            if (Array.isArray(_data["qualificationTypes"])) {
                this.qualificationTypes = [] as any;
                for (let item of _data["qualificationTypes"])
                    this.qualificationTypes!.push(QualificationClassDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QualificationClassRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationClassRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationClassId"] = this.qualificationClassId;
        if (Array.isArray(this.qualificationTypes)) {
            data["qualificationTypes"] = [];
            for (let item of this.qualificationTypes)
                data["qualificationTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQualificationClassRequest {
    qualificationClassId?: number;
    qualificationTypes?: QualificationClassDto[] | undefined;
}

export class QualificationDate implements IQualificationDate {
    serviceDate?: Date;
    qualificationTypeId?: number | undefined;
    qualificationTypeName?: string | undefined;
    participantId?: number | undefined;
    equvQualificationTypeId?: number | undefined;
    equivalentQualification?: EquivalentQualification[] | undefined;

    constructor(data?: IQualificationDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.qualificationTypeId = _data["qualificationTypeId"];
            this.qualificationTypeName = _data["qualificationTypeName"];
            this.participantId = _data["participantId"];
            this.equvQualificationTypeId = _data["equvQualificationTypeId"];
            if (Array.isArray(_data["equivalentQualification"])) {
                this.equivalentQualification = [] as any;
                for (let item of _data["equivalentQualification"])
                    this.equivalentQualification!.push(EquivalentQualification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QualificationDate {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        data["qualificationTypeId"] = this.qualificationTypeId;
        data["qualificationTypeName"] = this.qualificationTypeName;
        data["participantId"] = this.participantId;
        data["equvQualificationTypeId"] = this.equvQualificationTypeId;
        if (Array.isArray(this.equivalentQualification)) {
            data["equivalentQualification"] = [];
            for (let item of this.equivalentQualification)
                data["equivalentQualification"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQualificationDate {
    serviceDate?: Date;
    qualificationTypeId?: number | undefined;
    qualificationTypeName?: string | undefined;
    participantId?: number | undefined;
    equvQualificationTypeId?: number | undefined;
    equivalentQualification?: EquivalentQualification[] | undefined;
}

export class QualificationRole implements IQualificationRole {
    id?: number;
    qualificationRoleTypeId?: number;
    qualificationRoleType?: string | undefined;
    roleCategoryId?: number;
    roleCategory?: QualificationRoleCategory;
    readonly roleCategoryName?: string | undefined;
    roleRank?: number | undefined;
    externalGroup?: string | undefined;
    isActive?: boolean;
    isDefault?: boolean;
    startDate?: Date;
    endDate?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
    isParticipantRequired?: boolean;
    participantId?: number | undefined;
    readonly participantName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IQualificationRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qualificationRoleTypeId = _data["qualificationRoleTypeId"];
            this.qualificationRoleType = _data["qualificationRoleType"];
            this.roleCategoryId = _data["roleCategoryId"];
            this.roleCategory = _data["roleCategory"];
            (<any>this).roleCategoryName = _data["roleCategoryName"];
            this.roleRank = _data["roleRank"];
            this.externalGroup = _data["externalGroup"];
            this.isActive = _data["isActive"];
            this.isDefault = _data["isDefault"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.isParticipantRequired = _data["isParticipantRequired"];
            this.participantId = _data["participantId"];
            (<any>this).participantName = _data["participantName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): QualificationRole {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qualificationRoleTypeId"] = this.qualificationRoleTypeId;
        data["qualificationRoleType"] = this.qualificationRoleType;
        data["roleCategoryId"] = this.roleCategoryId;
        data["roleCategory"] = this.roleCategory;
        data["roleCategoryName"] = this.roleCategoryName;
        data["roleRank"] = this.roleRank;
        data["externalGroup"] = this.externalGroup;
        data["isActive"] = this.isActive;
        data["isDefault"] = this.isDefault;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["isParticipantRequired"] = this.isParticipantRequired;
        data["participantId"] = this.participantId;
        data["participantName"] = this.participantName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IQualificationRole {
    id?: number;
    qualificationRoleTypeId?: number;
    qualificationRoleType?: string | undefined;
    roleCategoryId?: number;
    roleCategory?: QualificationRoleCategory;
    roleCategoryName?: string | undefined;
    roleRank?: number | undefined;
    externalGroup?: string | undefined;
    isActive?: boolean;
    isDefault?: boolean;
    startDate?: Date;
    endDate?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
    isParticipantRequired?: boolean;
    participantId?: number | undefined;
    participantName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export enum QualificationRoleCategory {
    Training = "Training",
    Basic = "Basic",
    OkToDrive = "OkToDrive",
    ParticipantRelationship = "ParticipantRelationship",
}

export class QualificationRoleDto implements IQualificationRoleDto {
    id?: number | undefined;
    caregiverId?: number | undefined;
    qualificationRoleId?: number;
    startDate?: Date;
    endDate?: Date;
    caregiverPersonId?: string | undefined;
    qualificationRole?: string | undefined;
    isDeleted?: boolean;
    participantId?: number | undefined;
    isDraftRoleForRelation?: boolean;

    constructor(data?: IQualificationRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caregiverId = _data["caregiverId"];
            this.qualificationRoleId = _data["qualificationRoleId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.caregiverPersonId = _data["caregiverPersonId"];
            this.qualificationRole = _data["qualificationRole"];
            this.isDeleted = _data["isDeleted"];
            this.participantId = _data["participantId"];
            this.isDraftRoleForRelation = _data["isDraftRoleForRelation"];
        }
    }

    static fromJS(data: any): QualificationRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caregiverId"] = this.caregiverId;
        data["qualificationRoleId"] = this.qualificationRoleId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["caregiverPersonId"] = this.caregiverPersonId;
        data["qualificationRole"] = this.qualificationRole;
        data["isDeleted"] = this.isDeleted;
        data["participantId"] = this.participantId;
        data["isDraftRoleForRelation"] = this.isDraftRoleForRelation;
        return data;
    }
}

export interface IQualificationRoleDto {
    id?: number | undefined;
    caregiverId?: number | undefined;
    qualificationRoleId?: number;
    startDate?: Date;
    endDate?: Date;
    caregiverPersonId?: string | undefined;
    qualificationRole?: string | undefined;
    isDeleted?: boolean;
    participantId?: number | undefined;
    isDraftRoleForRelation?: boolean;
}

export class QualificationRoleTypeHistory implements IQualificationRoleTypeHistory {
    qualificationRoleType?: string | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    isDeleted?: string | undefined;

    constructor(data?: IQualificationRoleTypeHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationRoleType = _data["qualificationRoleType"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.isDeleted = (_data["isDeleted"] === true) ? "Yes" : "No";
        }
    }

    static fromJS(data: any): QualificationRoleTypeHistory {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationRoleTypeHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationRoleType"] = this.qualificationRoleType;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IQualificationRoleTypeHistory {
    qualificationRoleType?: string | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
}

export class QualificationRoleTypesRequest implements IQualificationRoleTypesRequest {
    qualificationRoleTypesList?: QualificationRole[] | undefined;

    constructor(data?: IQualificationRoleTypesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["qualificationRoleTypesList"])) {
                this.qualificationRoleTypesList = [] as any;
                for (let item of _data["qualificationRoleTypesList"])
                    this.qualificationRoleTypesList!.push(QualificationRole.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QualificationRoleTypesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationRoleTypesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.qualificationRoleTypesList)) {
            data["qualificationRoleTypesList"] = [];
            for (let item of this.qualificationRoleTypesList)
                data["qualificationRoleTypesList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQualificationRoleTypesRequest {
    qualificationRoleTypesList?: QualificationRole[] | undefined;
}

export class QualificationRoleVerification implements IQualificationRoleVerification {
    verified?: boolean;
    qualificationStatus?: QualificationStatus;
    caregiverQualificationTypeMappingId?: number | undefined;
    qualificationTypeId?: number | undefined;
    serviceCode?: string | undefined;
    expirationType?: string | undefined;
    expirationDays?: string | undefined;
    firstCompletionDate?: Date | undefined;

    constructor(data?: IQualificationRoleVerification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verified = _data["verified"];
            this.qualificationStatus = _data["qualificationStatus"];
            this.caregiverQualificationTypeMappingId = _data["caregiverQualificationTypeMappingId"];
            this.qualificationTypeId = _data["qualificationTypeId"];
            this.serviceCode = _data["serviceCode"];
            this.expirationType = _data["expirationType"];
            this.expirationDays = _data["expirationDays"];
            this.firstCompletionDate = _data["firstCompletionDate"] ? new Date(_data["firstCompletionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): QualificationRoleVerification {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationRoleVerification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verified"] = this.verified;
        data["qualificationStatus"] = this.qualificationStatus;
        data["caregiverQualificationTypeMappingId"] = this.caregiverQualificationTypeMappingId;
        data["qualificationTypeId"] = this.qualificationTypeId;
        data["serviceCode"] = this.serviceCode;
        data["expirationType"] = this.expirationType;
        data["expirationDays"] = this.expirationDays;
        data["firstCompletionDate"] = this.firstCompletionDate ? this.firstCompletionDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IQualificationRoleVerification {
    verified?: boolean;
    qualificationStatus?: QualificationStatus;
    caregiverQualificationTypeMappingId?: number | undefined;
    qualificationTypeId?: number | undefined;
    serviceCode?: string | undefined;
    expirationType?: string | undefined;
    expirationDays?: string | undefined;
    firstCompletionDate?: Date | undefined;
}

export class QualificationRoleVerificationArrayApiResponse implements IQualificationRoleVerificationArrayApiResponse {
    message?: string | undefined;
    data?: QualificationRoleVerification[] | undefined;
    success?: boolean;

    constructor(data?: IQualificationRoleVerificationArrayApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QualificationRoleVerification.fromJS(item));
            }
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): QualificationRoleVerificationArrayApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationRoleVerificationArrayApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["success"] = this.success;
        return data;
    }
}

export interface IQualificationRoleVerificationArrayApiResponse {
    message?: string | undefined;
    data?: QualificationRoleVerification[] | undefined;
    success?: boolean;
}

export enum QualificationStatus {
    NoCaregiverQualification = "NoCaregiverQualification",
    NoCaregiverRoleQualification = "NoCaregiverRoleQualification",
    QualificationExpired = "QualificationExpired",
    RecurringQualification = "RecurringQualification",
}

export class QualificationTypeCoursesDto implements IQualificationTypeCoursesDto {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    personId?: number;
    qualificationMappingId?: number;

    constructor(data?: IQualificationTypeCoursesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            this.personId = _data["personId"];
            this.qualificationMappingId = _data["qualificationMappingId"];
        }
    }

    static fromJS(data: any): QualificationTypeCoursesDto {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationTypeCoursesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        data["personId"] = this.personId;
        data["qualificationMappingId"] = this.qualificationMappingId;
        return data;
    }
}

export interface IQualificationTypeCoursesDto {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    personId?: number;
    qualificationMappingId?: number;
}

export class QualificationTypeCoursesMappingRequest implements IQualificationTypeCoursesMappingRequest {
    caregiverCourseMappingId?: number;
    caregiverQualificationMappingId?: number;
    caregiverId?: number;
    courseStatus?: string | undefined;
    courseCodeId?: number;
    creditHours?: number;
    completedDate?: Date;
    companyId?: number | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    isDeleted?: boolean;
    courseName?: string | undefined;
    courseCode?: string | undefined;

    constructor(data?: IQualificationTypeCoursesMappingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverCourseMappingId = _data["caregiverCourseMappingId"];
            this.caregiverQualificationMappingId = _data["caregiverQualificationMappingId"];
            this.caregiverId = _data["caregiverId"];
            this.courseStatus = _data["courseStatus"];
            this.courseCodeId = _data["courseCodeId"];
            this.creditHours = _data["creditHours"];
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.companyId = _data["companyId"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.courseName = _data["courseName"];
            this.courseCode = _data["courseCode"];
        }
    }

    static fromJS(data: any): QualificationTypeCoursesMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationTypeCoursesMappingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverCourseMappingId"] = this.caregiverCourseMappingId;
        data["caregiverQualificationMappingId"] = this.caregiverQualificationMappingId;
        data["caregiverId"] = this.caregiverId;
        data["courseStatus"] = this.courseStatus;
        data["courseCodeId"] = this.courseCodeId;
        data["creditHours"] = this.creditHours;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["companyId"] = this.companyId;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["courseName"] = this.courseName;
        data["courseCode"] = this.courseCode;
        return data;
    }
}

export interface IQualificationTypeCoursesMappingRequest {
    caregiverCourseMappingId?: number;
    caregiverQualificationMappingId?: number;
    caregiverId?: number;
    courseStatus?: string | undefined;
    courseCodeId?: number;
    creditHours?: number;
    completedDate?: Date;
    companyId?: number | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    isDeleted?: boolean;
    courseName?: string | undefined;
    courseCode?: string | undefined;
}

export class QualificationTypeCoursesMappingResponse implements IQualificationTypeCoursesMappingResponse {
    caregiverCourseMappingId?: number;
    caregiverQualificationMappingId?: number;
    caregiverId?: number;
    courseStatus?: string | undefined;
    courseCodeId?: number;
    courseName?: string | undefined;
    courseCode?: string | undefined;
    creditHours?: number;
    completedDate?: Date | undefined;
    companyId?: number | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    isDeleted?: boolean | undefined;

    constructor(data?: IQualificationTypeCoursesMappingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverCourseMappingId = _data["caregiverCourseMappingId"];
            this.caregiverQualificationMappingId = _data["caregiverQualificationMappingId"];
            this.caregiverId = _data["caregiverId"];
            this.courseStatus = _data["courseStatus"];
            this.courseCodeId = _data["courseCodeId"];
            this.courseName = _data["courseName"];
            this.courseCode = _data["courseCode"];
            this.creditHours = _data["creditHours"];
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.companyId = _data["companyId"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): QualificationTypeCoursesMappingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationTypeCoursesMappingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverCourseMappingId"] = this.caregiverCourseMappingId;
        data["caregiverQualificationMappingId"] = this.caregiverQualificationMappingId;
        data["caregiverId"] = this.caregiverId;
        data["courseStatus"] = this.courseStatus;
        data["courseCodeId"] = this.courseCodeId;
        data["courseName"] = this.courseName;
        data["courseCode"] = this.courseCode;
        data["creditHours"] = this.creditHours;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["companyId"] = this.companyId;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IQualificationTypeCoursesMappingResponse {
    caregiverCourseMappingId?: number;
    caregiverQualificationMappingId?: number;
    caregiverId?: number;
    courseStatus?: string | undefined;
    courseCodeId?: number;
    courseName?: string | undefined;
    courseCode?: string | undefined;
    creditHours?: number;
    completedDate?: Date | undefined;
    companyId?: number | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    isDeleted?: boolean | undefined;
}

export class QualificationTypeCoursesMappingResponseGridResponseBase implements IQualificationTypeCoursesMappingResponseGridResponseBase {
    items?: QualificationTypeCoursesMappingResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: QualificationTypeCoursesMappingResponse;

    constructor(data?: IQualificationTypeCoursesMappingResponseGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QualificationTypeCoursesMappingResponse.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? QualificationTypeCoursesMappingResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QualificationTypeCoursesMappingResponseGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationTypeCoursesMappingResponseGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IQualificationTypeCoursesMappingResponseGridResponseBase {
    items?: QualificationTypeCoursesMappingResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: QualificationTypeCoursesMappingResponse;
}

export class QualificationTypeDto implements IQualificationTypeDto {
    qualificationTypeId?: number;
    qualificationType?: string | undefined;
    description?: string | undefined;
    category?: string | undefined;
    categoryId?: number;
    expires?: boolean;
    shortDescription?: string | undefined;
    externalQualificationType?: string | undefined;
    expirationType?: string | undefined;
    expirationDays?: number | undefined;
    trainingServiceCode?: number | undefined;
    trainingHours?: number | undefined;
    continuingTrainingServiceCode?: number | undefined;
    continuingTrainingDays?: number | undefined;
    continuingTrainingServCodeName?: string | undefined;
    isRecurring?: boolean;
    isDefault?: boolean;
    isActive?: boolean;
    trainingServCodeName?: string | undefined;
    isParticipantRequired?: boolean;
    ignoreInternalAuth?: boolean;
    hasCourses?: boolean;
    gracePeriodQualification?: string | undefined;

    constructor(data?: IQualificationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationTypeId = _data["qualificationTypeId"];
            this.qualificationType = _data["qualificationType"];
            this.description = _data["description"];
            this.category = _data["category"];
            this.categoryId = _data["categoryId"];
            this.expires = _data["expires"];
            this.shortDescription = _data["shortDescription"];
            this.externalQualificationType = _data["externalQualificationType"];
            this.expirationType = _data["expirationType"];
            this.expirationDays = _data["expirationDays"];
            this.trainingServiceCode = _data["trainingServiceCode"];
            this.trainingHours = _data["trainingHours"];
            this.continuingTrainingServiceCode = _data["continuingTrainingServiceCode"];
            this.continuingTrainingDays = _data["continuingTrainingDays"];
            this.continuingTrainingServCodeName = _data["continuingTrainingServCodeName"];
            this.isRecurring = _data["isRecurring"];
            this.isDefault = _data["isDefault"];
            this.isActive = _data["isActive"];
            this.trainingServCodeName = _data["trainingServCodeName"];
            this.isParticipantRequired = _data["isParticipantRequired"];
            this.ignoreInternalAuth = _data["ignoreInternalAuth"];
            this.hasCourses = _data["hasCourses"];
            this.gracePeriodQualification = _data["gracePeriodQualification"];
        }
    }

    static fromJS(data: any): QualificationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationTypeId"] = this.qualificationTypeId;
        data["qualificationType"] = this.qualificationType;
        data["description"] = this.description;
        data["category"] = this.category;
        data["categoryId"] = this.categoryId;
        data["expires"] = this.expires;
        data["shortDescription"] = this.shortDescription;
        data["externalQualificationType"] = this.externalQualificationType;
        data["expirationType"] = this.expirationType;
        data["expirationDays"] = this.expirationDays;
        data["trainingServiceCode"] = this.trainingServiceCode;
        data["trainingHours"] = this.trainingHours;
        data["continuingTrainingServiceCode"] = this.continuingTrainingServiceCode;
        data["continuingTrainingDays"] = this.continuingTrainingDays;
        data["continuingTrainingServCodeName"] = this.continuingTrainingServCodeName;
        data["isRecurring"] = this.isRecurring;
        data["isDefault"] = this.isDefault;
        data["isActive"] = this.isActive;
        data["trainingServCodeName"] = this.trainingServCodeName;
        data["isParticipantRequired"] = this.isParticipantRequired;
        data["ignoreInternalAuth"] = this.ignoreInternalAuth;
        data["hasCourses"] = this.hasCourses;
        data["gracePeriodQualification"] = this.gracePeriodQualification;
        return data;
    }
}

export interface IQualificationTypeDto {
    qualificationTypeId?: number;
    qualificationType?: string | undefined;
    description?: string | undefined;
    category?: string | undefined;
    categoryId?: number;
    expires?: boolean;
    shortDescription?: string | undefined;
    externalQualificationType?: string | undefined;
    expirationType?: string | undefined;
    expirationDays?: number | undefined;
    trainingServiceCode?: number | undefined;
    trainingHours?: number | undefined;
    continuingTrainingServiceCode?: number | undefined;
    continuingTrainingDays?: number | undefined;
    continuingTrainingServCodeName?: string | undefined;
    isRecurring?: boolean;
    isDefault?: boolean;
    isActive?: boolean;
    trainingServCodeName?: string | undefined;
    isParticipantRequired?: boolean;
    ignoreInternalAuth?: boolean;
    hasCourses?: boolean;
    gracePeriodQualification?: string | undefined;
}

export class QualificationTypeInfo implements IQualificationTypeInfo {
    caregiverId?: string | undefined;
    qualificationTypeId?: number;
    startDate?: Date;
    expirationDate?: Date | undefined;
    overrideDate?: Date | undefined;
    expires?: boolean;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;

    constructor(data?: IQualificationTypeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.qualificationTypeId = _data["qualificationTypeId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.overrideDate = _data["overrideDate"] ? new Date(_data["overrideDate"].toString()) : <any>undefined;
            this.expires = _data["expires"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): QualificationTypeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationTypeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["qualificationTypeId"] = this.qualificationTypeId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["overrideDate"] = this.overrideDate ? this.overrideDate.toISOString() : <any>undefined;
        data["expires"] = this.expires;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IQualificationTypeInfo {
    caregiverId?: string | undefined;
    qualificationTypeId?: number;
    startDate?: Date;
    expirationDate?: Date | undefined;
    overrideDate?: Date | undefined;
    expires?: boolean;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
}

export class QualificationTypeRequest implements IQualificationTypeRequest {
    qualificationTypeId?: number;
    qualificationType?: string | undefined;
    description?: string | undefined;
    category?: string | undefined;
    categoryId?: number;
    expires?: boolean;
    shortDescription?: string | undefined;
    externalQualificationType?: string | undefined;
    expirationType?: string | undefined;
    expirationDays?: number | undefined;
    trainingServiceCode?: number | undefined;
    trainingHours?: number | undefined;
    continuingTrainingServiceCode?: number | undefined;
    continuingTrainingDays?: number | undefined;
    continuingTrainingServCodeName?: string | undefined;
    isRecurring?: boolean;
    isDefault?: boolean;
    isActive?: boolean;
    trainingServCodeName?: string | undefined;
    isParticipantRequired?: boolean;
    ignoreInternalAuth?: boolean;
    hasCourses?: boolean;
    gracePeriodQualification?: string | undefined;
    qualificationTypes?: QualificationClassDto[] | undefined;

    constructor(data?: IQualificationTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationTypeId = _data["qualificationTypeId"];
            this.qualificationType = _data["qualificationType"];
            this.description = _data["description"];
            this.category = _data["category"];
            this.categoryId = _data["categoryId"];
            this.expires = _data["expires"];
            this.shortDescription = _data["shortDescription"];
            this.externalQualificationType = _data["externalQualificationType"];
            this.expirationType = _data["expirationType"];
            this.expirationDays = _data["expirationDays"];
            this.trainingServiceCode = _data["trainingServiceCode"];
            this.trainingHours = _data["trainingHours"];
            this.continuingTrainingServiceCode = _data["continuingTrainingServiceCode"];
            this.continuingTrainingDays = _data["continuingTrainingDays"];
            this.continuingTrainingServCodeName = _data["continuingTrainingServCodeName"];
            this.isRecurring = _data["isRecurring"];
            this.isDefault = _data["isDefault"];
            this.isActive = _data["isActive"];
            this.trainingServCodeName = _data["trainingServCodeName"];
            this.isParticipantRequired = _data["isParticipantRequired"];
            this.ignoreInternalAuth = _data["ignoreInternalAuth"];
            this.hasCourses = _data["hasCourses"];
            this.gracePeriodQualification = _data["gracePeriodQualification"];
            if (Array.isArray(_data["qualificationTypes"])) {
                this.qualificationTypes = [] as any;
                for (let item of _data["qualificationTypes"])
                    this.qualificationTypes!.push(QualificationClassDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QualificationTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationTypeId"] = this.qualificationTypeId;
        data["qualificationType"] = this.qualificationType;
        data["description"] = this.description;
        data["category"] = this.category;
        data["categoryId"] = this.categoryId;
        data["expires"] = this.expires;
        data["shortDescription"] = this.shortDescription;
        data["externalQualificationType"] = this.externalQualificationType;
        data["expirationType"] = this.expirationType;
        data["expirationDays"] = this.expirationDays;
        data["trainingServiceCode"] = this.trainingServiceCode;
        data["trainingHours"] = this.trainingHours;
        data["continuingTrainingServiceCode"] = this.continuingTrainingServiceCode;
        data["continuingTrainingDays"] = this.continuingTrainingDays;
        data["continuingTrainingServCodeName"] = this.continuingTrainingServCodeName;
        data["isRecurring"] = this.isRecurring;
        data["isDefault"] = this.isDefault;
        data["isActive"] = this.isActive;
        data["trainingServCodeName"] = this.trainingServCodeName;
        data["isParticipantRequired"] = this.isParticipantRequired;
        data["ignoreInternalAuth"] = this.ignoreInternalAuth;
        data["hasCourses"] = this.hasCourses;
        data["gracePeriodQualification"] = this.gracePeriodQualification;
        if (Array.isArray(this.qualificationTypes)) {
            data["qualificationTypes"] = [];
            for (let item of this.qualificationTypes)
                data["qualificationTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQualificationTypeRequest {
    qualificationTypeId?: number;
    qualificationType?: string | undefined;
    description?: string | undefined;
    category?: string | undefined;
    categoryId?: number;
    expires?: boolean;
    shortDescription?: string | undefined;
    externalQualificationType?: string | undefined;
    expirationType?: string | undefined;
    expirationDays?: number | undefined;
    trainingServiceCode?: number | undefined;
    trainingHours?: number | undefined;
    continuingTrainingServiceCode?: number | undefined;
    continuingTrainingDays?: number | undefined;
    continuingTrainingServCodeName?: string | undefined;
    isRecurring?: boolean;
    isDefault?: boolean;
    isActive?: boolean;
    trainingServCodeName?: string | undefined;
    isParticipantRequired?: boolean;
    ignoreInternalAuth?: boolean;
    hasCourses?: boolean;
    gracePeriodQualification?: string | undefined;
    qualificationTypes?: QualificationClassDto[] | undefined;
}

export class QuestionnaireComponentDetails implements IQuestionnaireComponentDetails {
    componentId?: number;
    componentType?: string | undefined;
    componentCode?: string | undefined;
    componentDetailId?: number;
    componentText?: string | undefined;
    order?: number;
    questionnaireOptionDetails?: QuestionnaireOptionDetails[] | undefined;
    optionType?: string | undefined;
    optionGroupId?: number;
    selectedOptionDetailId?: number[] | undefined;
    parentComponentId?: number | undefined;

    constructor(data?: IQuestionnaireComponentDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.componentType = _data["componentType"];
            this.componentCode = _data["componentCode"];
            this.componentDetailId = _data["componentDetailId"];
            this.componentText = _data["componentText"];
            this.order = _data["order"];
            if (Array.isArray(_data["questionnaireOptionDetails"])) {
                this.questionnaireOptionDetails = [] as any;
                for (let item of _data["questionnaireOptionDetails"])
                    this.questionnaireOptionDetails!.push(QuestionnaireOptionDetails.fromJS(item));
            }
            this.optionType = _data["optionType"];
            this.optionGroupId = _data["optionGroupId"];
            if (Array.isArray(_data["selectedOptionDetailId"])) {
                this.selectedOptionDetailId = [] as any;
                for (let item of _data["selectedOptionDetailId"])
                    this.selectedOptionDetailId!.push(item);
            }
            this.parentComponentId = _data["parentComponentId"];
        }
    }

    static fromJS(data: any): QuestionnaireComponentDetails {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireComponentDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["componentType"] = this.componentType;
        data["componentCode"] = this.componentCode;
        data["componentDetailId"] = this.componentDetailId;
        data["componentText"] = this.componentText;
        data["order"] = this.order;
        if (Array.isArray(this.questionnaireOptionDetails)) {
            data["questionnaireOptionDetails"] = [];
            for (let item of this.questionnaireOptionDetails)
                data["questionnaireOptionDetails"].push(item.toJSON());
        }
        data["optionType"] = this.optionType;
        data["optionGroupId"] = this.optionGroupId;
        if (Array.isArray(this.selectedOptionDetailId)) {
            data["selectedOptionDetailId"] = [];
            for (let item of this.selectedOptionDetailId)
                data["selectedOptionDetailId"].push(item);
        }
        data["parentComponentId"] = this.parentComponentId;
        return data;
    }
}

export interface IQuestionnaireComponentDetails {
    componentId?: number;
    componentType?: string | undefined;
    componentCode?: string | undefined;
    componentDetailId?: number;
    componentText?: string | undefined;
    order?: number;
    questionnaireOptionDetails?: QuestionnaireOptionDetails[] | undefined;
    optionType?: string | undefined;
    optionGroupId?: number;
    selectedOptionDetailId?: number[] | undefined;
    parentComponentId?: number | undefined;
}

export class QuestionnaireComponentDetailsResponse implements IQuestionnaireComponentDetailsResponse {
    caregiverPersonId?: number;
    participantPersonId?: number;
    componentId?: number;
    componentType?: string | undefined;
    componentCode?: string | undefined;
    componentDetailId?: number;
    componentText?: string | undefined;
    order?: number;
    questionnaireOptionDetails?: QuestionnaireOptionDetails[] | undefined;
    optionType?: string | undefined;
    optionGroupId?: number;
    selectedOptionDetailId?: number[] | undefined;
    parentComponentId?: number | undefined;

    constructor(data?: IQuestionnaireComponentDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverPersonId = _data["caregiverPersonId"];
            this.participantPersonId = _data["participantPersonId"];
            this.componentId = _data["componentId"];
            this.componentType = _data["componentType"];
            this.componentCode = _data["componentCode"];
            this.componentDetailId = _data["componentDetailId"];
            this.componentText = _data["componentText"];
            this.order = _data["order"];
            if (Array.isArray(_data["questionnaireOptionDetails"])) {
                this.questionnaireOptionDetails = [] as any;
                for (let item of _data["questionnaireOptionDetails"])
                    this.questionnaireOptionDetails!.push(QuestionnaireOptionDetails.fromJS(item));
            }
            this.optionType = _data["optionType"];
            this.optionGroupId = _data["optionGroupId"];
            if (Array.isArray(_data["selectedOptionDetailId"])) {
                this.selectedOptionDetailId = [] as any;
                for (let item of _data["selectedOptionDetailId"])
                    this.selectedOptionDetailId!.push(item);
            }
            this.parentComponentId = _data["parentComponentId"];
        }
    }

    static fromJS(data: any): QuestionnaireComponentDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireComponentDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverPersonId"] = this.caregiverPersonId;
        data["participantPersonId"] = this.participantPersonId;
        data["componentId"] = this.componentId;
        data["componentType"] = this.componentType;
        data["componentCode"] = this.componentCode;
        data["componentDetailId"] = this.componentDetailId;
        data["componentText"] = this.componentText;
        data["order"] = this.order;
        if (Array.isArray(this.questionnaireOptionDetails)) {
            data["questionnaireOptionDetails"] = [];
            for (let item of this.questionnaireOptionDetails)
                data["questionnaireOptionDetails"].push(item.toJSON());
        }
        data["optionType"] = this.optionType;
        data["optionGroupId"] = this.optionGroupId;
        if (Array.isArray(this.selectedOptionDetailId)) {
            data["selectedOptionDetailId"] = [];
            for (let item of this.selectedOptionDetailId)
                data["selectedOptionDetailId"].push(item);
        }
        data["parentComponentId"] = this.parentComponentId;
        return data;
    }
}

export interface IQuestionnaireComponentDetailsResponse {
    caregiverPersonId?: number;
    participantPersonId?: number;
    componentId?: number;
    componentType?: string | undefined;
    componentCode?: string | undefined;
    componentDetailId?: number;
    componentText?: string | undefined;
    order?: number;
    questionnaireOptionDetails?: QuestionnaireOptionDetails[] | undefined;
    optionType?: string | undefined;
    optionGroupId?: number;
    selectedOptionDetailId?: number[] | undefined;
    parentComponentId?: number | undefined;
}

export class QuestionnaireOptionDetails implements IQuestionnaireOptionDetails {
    optionText?: string | undefined;
    optionCode?: string | undefined;
    optionDetailId?: number;
    optionId?: number;
    componentId?: number;

    constructor(data?: IQuestionnaireOptionDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.optionText = _data["optionText"];
            this.optionCode = _data["optionCode"];
            this.optionDetailId = _data["optionDetailId"];
            this.optionId = _data["optionId"];
            this.componentId = _data["componentId"];
        }
    }

    static fromJS(data: any): QuestionnaireOptionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireOptionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["optionText"] = this.optionText;
        data["optionCode"] = this.optionCode;
        data["optionDetailId"] = this.optionDetailId;
        data["optionId"] = this.optionId;
        data["componentId"] = this.componentId;
        return data;
    }
}

export interface IQuestionnaireOptionDetails {
    optionText?: string | undefined;
    optionCode?: string | undefined;
    optionDetailId?: number;
    optionId?: number;
    componentId?: number;
}

export class QuestionnnaireRequest implements IQuestionnnaireRequest {
    caregiverId?: number;
    participantId?: number | undefined;
    attestationVersion?: number;
    attestationCode?: string | undefined;
    attestationResponseId?: number | undefined;

    constructor(data?: IQuestionnnaireRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            this.attestationVersion = _data["attestationVersion"];
            this.attestationCode = _data["attestationCode"];
            this.attestationResponseId = _data["attestationResponseId"];
        }
    }

    static fromJS(data: any): QuestionnnaireRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnnaireRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        data["attestationVersion"] = this.attestationVersion;
        data["attestationCode"] = this.attestationCode;
        data["attestationResponseId"] = this.attestationResponseId;
        return data;
    }
}

export interface IQuestionnnaireRequest {
    caregiverId?: number;
    participantId?: number | undefined;
    attestationVersion?: number;
    attestationCode?: string | undefined;
    attestationResponseId?: number | undefined;
}

export class QuestionnnaireResponse implements IQuestionnnaireResponse {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    partcipantName?: string | undefined;
    questionnaireComponentDetails?: QuestionnaireComponentDetailsResponse[] | undefined;

    constructor(data?: IQuestionnnaireResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.partcipantName = _data["partcipantName"];
            if (Array.isArray(_data["questionnaireComponentDetails"])) {
                this.questionnaireComponentDetails = [] as any;
                for (let item of _data["questionnaireComponentDetails"])
                    this.questionnaireComponentDetails!.push(QuestionnaireComponentDetailsResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionnnaireResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnnaireResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["partcipantName"] = this.partcipantName;
        if (Array.isArray(this.questionnaireComponentDetails)) {
            data["questionnaireComponentDetails"] = [];
            for (let item of this.questionnaireComponentDetails)
                data["questionnaireComponentDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuestionnnaireResponse {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    partcipantName?: string | undefined;
    questionnaireComponentDetails?: QuestionnaireComponentDetailsResponse[] | undefined;
}

export class QuestionnnaireResponseApiResponse implements IQuestionnnaireResponseApiResponse {
    message?: string | undefined;
    data?: QuestionnnaireResponse;
    success?: boolean;

    constructor(data?: IQuestionnnaireResponseApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.data = _data["data"] ? QuestionnnaireResponse.fromJS(_data["data"]) : <any>undefined;
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): QuestionnnaireResponseApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnnaireResponseApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["success"] = this.success;
        return data;
    }
}

export interface IQuestionnnaireResponseApiResponse {
    message?: string | undefined;
    data?: QuestionnnaireResponse;
    success?: boolean;
}

export class RateModifierQualification implements IRateModifierQualification {
    modifierCreatedOn?: Date | undefined;
    modifierUpdatedOn?: Date | undefined;
    qualificationTypeId?: number | undefined;
    qualificationCreatedOn?: Date | undefined;
    qualificationUpdatedOn?: Date | undefined;
    careerHourRateModifierQualificationId?: number | undefined;
    isStackable?: boolean;
    rateModifier?: number;

    constructor(data?: IRateModifierQualification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modifierCreatedOn = _data["modifierCreatedOn"] ? new Date(_data["modifierCreatedOn"].toString()) : <any>undefined;
            this.modifierUpdatedOn = _data["modifierUpdatedOn"] ? new Date(_data["modifierUpdatedOn"].toString()) : <any>undefined;
            this.qualificationTypeId = _data["qualificationTypeId"];
            this.qualificationCreatedOn = _data["qualificationCreatedOn"] ? new Date(_data["qualificationCreatedOn"].toString()) : <any>undefined;
            this.qualificationUpdatedOn = _data["qualificationUpdatedOn"] ? new Date(_data["qualificationUpdatedOn"].toString()) : <any>undefined;
            this.careerHourRateModifierQualificationId = _data["careerHourRateModifierQualificationId"];
            this.isStackable = _data["isStackable"];
            this.rateModifier = _data["rateModifier"];
        }
    }

    static fromJS(data: any): RateModifierQualification {
        data = typeof data === 'object' ? data : {};
        let result = new RateModifierQualification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modifierCreatedOn"] = this.modifierCreatedOn ? this.modifierCreatedOn.toISOString() : <any>undefined;
        data["modifierUpdatedOn"] = this.modifierUpdatedOn ? this.modifierUpdatedOn.toISOString() : <any>undefined;
        data["qualificationTypeId"] = this.qualificationTypeId;
        data["qualificationCreatedOn"] = this.qualificationCreatedOn ? this.qualificationCreatedOn.toISOString() : <any>undefined;
        data["qualificationUpdatedOn"] = this.qualificationUpdatedOn ? this.qualificationUpdatedOn.toISOString() : <any>undefined;
        data["careerHourRateModifierQualificationId"] = this.careerHourRateModifierQualificationId;
        data["isStackable"] = this.isStackable;
        data["rateModifier"] = this.rateModifier;
        return data;
    }
}

export interface IRateModifierQualification {
    modifierCreatedOn?: Date | undefined;
    modifierUpdatedOn?: Date | undefined;
    qualificationTypeId?: number | undefined;
    qualificationCreatedOn?: Date | undefined;
    qualificationUpdatedOn?: Date | undefined;
    careerHourRateModifierQualificationId?: number | undefined;
    isStackable?: boolean;
    rateModifier?: number;
}

export class ReAssignCoordinator implements IReAssignCoordinator {
    oldPersonId?: string | undefined;
    newPersonId?: string | undefined;
    newPersonName?: string | undefined;
    idsToBeReAssigned?: string[] | undefined;

    constructor(data?: IReAssignCoordinator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPersonId = _data["oldPersonId"];
            this.newPersonId = _data["newPersonId"];
            this.newPersonName = _data["newPersonName"];
            if (Array.isArray(_data["idsToBeReAssigned"])) {
                this.idsToBeReAssigned = [] as any;
                for (let item of _data["idsToBeReAssigned"])
                    this.idsToBeReAssigned!.push(item);
            }
        }
    }

    static fromJS(data: any): ReAssignCoordinator {
        data = typeof data === 'object' ? data : {};
        let result = new ReAssignCoordinator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPersonId"] = this.oldPersonId;
        data["newPersonId"] = this.newPersonId;
        data["newPersonName"] = this.newPersonName;
        if (Array.isArray(this.idsToBeReAssigned)) {
            data["idsToBeReAssigned"] = [];
            for (let item of this.idsToBeReAssigned)
                data["idsToBeReAssigned"].push(item);
        }
        return data;
    }
}

export interface IReAssignCoordinator {
    oldPersonId?: string | undefined;
    newPersonId?: string | undefined;
    newPersonName?: string | undefined;
    idsToBeReAssigned?: string[] | undefined;
}

export class RelatedPersonRequest implements IRelatedPersonRequest {
    personId?: string | undefined;
    relatedPeopleTypes?: string[] | undefined;

    constructor(data?: IRelatedPersonRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            if (Array.isArray(_data["relatedPeopleTypes"])) {
                this.relatedPeopleTypes = [] as any;
                for (let item of _data["relatedPeopleTypes"])
                    this.relatedPeopleTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): RelatedPersonRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RelatedPersonRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        if (Array.isArray(this.relatedPeopleTypes)) {
            data["relatedPeopleTypes"] = [];
            for (let item of this.relatedPeopleTypes)
                data["relatedPeopleTypes"].push(item);
        }
        return data;
    }
}

export interface IRelatedPersonRequest {
    personId?: string | undefined;
    relatedPeopleTypes?: string[] | undefined;
}

export class RelationshipDateRangeRequest implements IRelationshipDateRangeRequest {
    id?: number;
    startDate?: Date;
    endDate?: Date | undefined;
    relationship?: CaregiverParticipantRelationship;

    constructor(data?: IRelationshipDateRangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.relationship = _data["relationship"];
        }
    }

    static fromJS(data: any): RelationshipDateRangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RelationshipDateRangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["relationship"] = this.relationship;
        return data;
    }
}

export interface IRelationshipDateRangeRequest {
    id?: number;
    startDate?: Date;
    endDate?: Date | undefined;
    relationship?: CaregiverParticipantRelationship;
}

export class Relationships implements IRelationships {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number;
    name?: string | undefined;
    dateBegin?: Date | undefined;
    dateEnd?: Date | undefined;
    status?: string | undefined;
    personId?: string | undefined;
    relation?: string | undefined;

    constructor(data?: IRelationships) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.dateBegin = _data["dateBegin"] ? new Date(_data["dateBegin"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.personId = _data["personId"];
            this.relation = _data["relation"];
        }
    }

    static fromJS(data: any): Relationships {
        data = typeof data === 'object' ? data : {};
        let result = new Relationships();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["id"] = this.id;
        data["name"] = this.name;
        data["dateBegin"] = this.dateBegin ? this.dateBegin.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["personId"] = this.personId;
        data["relation"] = this.relation;
        return data;
    }
}

export interface IRelationships {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    id?: number;
    name?: string | undefined;
    dateBegin?: Date | undefined;
    dateEnd?: Date | undefined;
    status?: string | undefined;
    personId?: string | undefined;
    relation?: string | undefined;
}

export class RepresentativeResponse implements IRepresentativeResponse {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    repId?: number;
    personId?: string | undefined;
    name?: string | undefined;
    status?: string | undefined;

    constructor(data?: IRepresentativeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.repId = _data["repId"];
            this.personId = _data["personId"];
            this.name = _data["name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): RepresentativeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RepresentativeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["repId"] = this.repId;
        data["personId"] = this.personId;
        data["name"] = this.name;
        data["status"] = this.status;
        return data;
    }
}

export interface IRepresentativeResponse {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    repId?: number;
    personId?: string | undefined;
    name?: string | undefined;
    status?: string | undefined;
}

export class RepresentativeResponseGridResponseBase implements IRepresentativeResponseGridResponseBase {
    items?: RepresentativeResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: RepresentativeResponse;

    constructor(data?: IRepresentativeResponseGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RepresentativeResponse.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? RepresentativeResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RepresentativeResponseGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new RepresentativeResponseGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRepresentativeResponseGridResponseBase {
    items?: RepresentativeResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: RepresentativeResponse;
}

export class ResponseModel implements IResponseModel {
    isSuccess?: boolean;
    message?: string | undefined;

    constructor(data?: IResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data;
    }
}

export interface IResponseModel {
    isSuccess?: boolean;
    message?: string | undefined;
}

export class ResponseModelResultSet implements IResponseModelResultSet {
    totalRecords?: number;
    data?: ResponseModel[] | undefined;

    constructor(data?: IResponseModelResultSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseModelResultSet {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModelResultSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseModelResultSet {
    totalRecords?: number;
    data?: ResponseModel[] | undefined;
}

export class RptFreqDto implements IRptFreqDto {
    id?: number;
    value?: string | undefined;
    code?: string | undefined;

    constructor(data?: IRptFreqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): RptFreqDto {
        data = typeof data === 'object' ? data : {};
        let result = new RptFreqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["code"] = this.code;
        return data;
    }
}

export interface IRptFreqDto {
    id?: number;
    value?: string | undefined;
    code?: string | undefined;
}

export class SaveCareerHourLogRequest implements ISaveCareerHourLogRequest {
    caregiverId?: string | undefined;
    pcn?: string | undefined;
    tcn?: string | undefined;
    externalReferenceId?: string | undefined;
    logTypeId?: number;
    logDate?: Date;
    isCchEligible?: boolean;
    hour?: number;

    constructor(data?: ISaveCareerHourLogRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.pcn = _data["pcn"];
            this.tcn = _data["tcn"];
            this.externalReferenceId = _data["externalReferenceId"];
            this.logTypeId = _data["logTypeId"];
            this.logDate = _data["logDate"] ? new Date(_data["logDate"].toString()) : <any>undefined;
            this.isCchEligible = _data["isCchEligible"];
            this.hour = _data["hour"];
        }
    }

    static fromJS(data: any): SaveCareerHourLogRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCareerHourLogRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["pcn"] = this.pcn;
        data["tcn"] = this.tcn;
        data["externalReferenceId"] = this.externalReferenceId;
        data["logTypeId"] = this.logTypeId;
        data["logDate"] = this.logDate ? this.logDate.toISOString() : <any>undefined;
        data["isCchEligible"] = this.isCchEligible;
        data["hour"] = this.hour;
        return data;
    }
}

export interface ISaveCareerHourLogRequest {
    caregiverId?: string | undefined;
    pcn?: string | undefined;
    tcn?: string | undefined;
    externalReferenceId?: string | undefined;
    logTypeId?: number;
    logDate?: Date;
    isCchEligible?: boolean;
    hour?: number;
}

export class SaveCaregiverCourseRequest implements ISaveCaregiverCourseRequest {
    trainingProgram?: string | undefined;
    courseName?: string | undefined;
    courseCode?: string | undefined;
    creditHours?: number;
    completedDate?: Date;
    trainingEntity?: string | undefined;
    transferReason?: string | undefined;
    caregiverId?: string | undefined;

    constructor(data?: ISaveCaregiverCourseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainingProgram = _data["trainingProgram"];
            this.courseName = _data["courseName"];
            this.courseCode = _data["courseCode"];
            this.creditHours = _data["creditHours"];
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.trainingEntity = _data["trainingEntity"];
            this.transferReason = _data["transferReason"];
            this.caregiverId = _data["caregiverId"];
        }
    }

    static fromJS(data: any): SaveCaregiverCourseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCaregiverCourseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainingProgram"] = this.trainingProgram;
        data["courseName"] = this.courseName;
        data["courseCode"] = this.courseCode;
        data["creditHours"] = this.creditHours;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["trainingEntity"] = this.trainingEntity;
        data["transferReason"] = this.transferReason;
        data["caregiverId"] = this.caregiverId;
        return data;
    }
}

export interface ISaveCaregiverCourseRequest {
    trainingProgram?: string | undefined;
    courseName?: string | undefined;
    courseCode?: string | undefined;
    creditHours?: number;
    completedDate?: Date;
    trainingEntity?: string | undefined;
    transferReason?: string | undefined;
    caregiverId?: string | undefined;
}

export class SearchCaregiverParticipantProspectCommand implements ISearchCaregiverParticipantProspectCommand {
    accessRights?: string[] | undefined;
    personId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    providerOneId?: string | undefined;
    relationshipConfirmationStatus?: AttestationStatus[] | undefined;
    filter?: FilterRequest;

    constructor(data?: ISearchCaregiverParticipantProspectCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(item);
            }
            this.personId = _data["personId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.providerOneId = _data["providerOneId"];
            if (Array.isArray(_data["relationshipConfirmationStatus"])) {
                this.relationshipConfirmationStatus = [] as any;
                for (let item of _data["relationshipConfirmationStatus"])
                    this.relationshipConfirmationStatus!.push(item);
            }
            this.filter = _data["filter"] ? FilterRequest.fromJS(_data["filter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchCaregiverParticipantProspectCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCaregiverParticipantProspectCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item);
        }
        data["personId"] = this.personId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["providerOneId"] = this.providerOneId;
        if (Array.isArray(this.relationshipConfirmationStatus)) {
            data["relationshipConfirmationStatus"] = [];
            for (let item of this.relationshipConfirmationStatus)
                data["relationshipConfirmationStatus"].push(item);
        }
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISearchCaregiverParticipantProspectCommand {
    accessRights?: string[] | undefined;
    personId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    providerOneId?: string | undefined;
    relationshipConfirmationStatus?: AttestationStatus[] | undefined;
    filter?: FilterRequest;
}

export class ServiceCodeGracePeriod implements IServiceCodeGracePeriod {
    serviceCode?: string | undefined;
    isTestServiceCode?: boolean;
    dateSpans?: GracePeriodDateSpan[] | undefined;

    constructor(data?: IServiceCodeGracePeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceCode = _data["serviceCode"];
            this.isTestServiceCode = _data["isTestServiceCode"];
            if (Array.isArray(_data["dateSpans"])) {
                this.dateSpans = [] as any;
                for (let item of _data["dateSpans"])
                    this.dateSpans!.push(GracePeriodDateSpan.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceCodeGracePeriod {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCodeGracePeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCode"] = this.serviceCode;
        data["isTestServiceCode"] = this.isTestServiceCode;
        if (Array.isArray(this.dateSpans)) {
            data["dateSpans"] = [];
            for (let item of this.dateSpans)
                data["dateSpans"].push(item.toJSON());
        }
        return data;
    }
}

export interface IServiceCodeGracePeriod {
    serviceCode?: string | undefined;
    isTestServiceCode?: boolean;
    dateSpans?: GracePeriodDateSpan[] | undefined;
}

export class ServiceCodes implements IServiceCodes {
    serviceCodeId?: number;
    serviceCode?: string | undefined;
    description?: string | undefined;

    constructor(data?: IServiceCodes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceCodeId = _data["serviceCodeId"];
            this.serviceCode = _data["serviceCode"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ServiceCodes {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCodes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCodeId"] = this.serviceCodeId;
        data["serviceCode"] = this.serviceCode;
        data["description"] = this.description;
        return data;
    }
}

export interface IServiceCodes {
    serviceCodeId?: number;
    serviceCode?: string | undefined;
    description?: string | undefined;
}

export class ServiceFacilitatorCaseLoad implements IServiceFacilitatorCaseLoad {
    caseLoadId?: number;
    caseLoadName?: string | undefined;
    agencyName?: string | undefined;
    participantCount?: number;

    constructor(data?: IServiceFacilitatorCaseLoad) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseLoadId = _data["caseLoadId"];
            this.caseLoadName = _data["caseLoadName"];
            this.agencyName = _data["agencyName"];
            this.participantCount = _data["participantCount"];
        }
    }

    static fromJS(data: any): ServiceFacilitatorCaseLoad {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceFacilitatorCaseLoad();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseLoadId"] = this.caseLoadId;
        data["caseLoadName"] = this.caseLoadName;
        data["agencyName"] = this.agencyName;
        data["participantCount"] = this.participantCount;
        return data;
    }
}

export interface IServiceFacilitatorCaseLoad {
    caseLoadId?: number;
    caseLoadName?: string | undefined;
    agencyName?: string | undefined;
    participantCount?: number;
}

export class ServiceFacilitatorDetails implements IServiceFacilitatorDetails {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    cellphone?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;

    constructor(data?: IServiceFacilitatorDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.cellphone = _data["cellphone"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): ServiceFacilitatorDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceFacilitatorDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["cellphone"] = this.cellphone;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["state"] = this.state;
        return data;
    }
}

export interface IServiceFacilitatorDetails {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    cellphone?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
}

export class ServiceFacilitatorProfile implements IServiceFacilitatorProfile {
    phoneDetails?: PhoneDetail[] | undefined;
    physicalAddresses?: AddressDTO[] | undefined;
    mailingAddresses?: AddressDTO[] | undefined;
    ivrAddresses?: AddressDTO[] | undefined;
    externalKeys?: ExternalKeyDTO[] | undefined;
    id?: number;
    personId?: string | undefined;
    status?: string | undefined;
    readonly personName?: string | undefined;
    ssn?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    physicalAddress?: string | undefined;
    mailingAddress?: string | undefined;
    ivrAddress?: string | undefined;
    companyCode?: string | undefined;
    unmaskedSsn?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    ivrPin?: string | undefined;
    paymentMethod?: string | undefined;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    coordinatorPersonFirstName?: string | undefined;
    coordinatorPersonLastName?: string | undefined;
    coordinatorPersonName?: string | undefined;
    lastV4LoginOn?: Date | undefined;
    isSsnValidated?: boolean | undefined;
    ssnValidationOverrideOn?: Date | undefined;
    ssnValidationOverrideBy?: string | undefined;
    agencieStatus?: string | undefined;
    agencyStatus?: PersonStatus;
    caseloadStatus?: string | undefined;

    constructor(data?: IServiceFacilitatorProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["phoneDetails"])) {
                this.phoneDetails = [] as any;
                for (let item of _data["phoneDetails"])
                    this.phoneDetails!.push(PhoneDetail.fromJS(item));
            }
            if (Array.isArray(_data["physicalAddresses"])) {
                this.physicalAddresses = [] as any;
                for (let item of _data["physicalAddresses"])
                    this.physicalAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["mailingAddresses"])) {
                this.mailingAddresses = [] as any;
                for (let item of _data["mailingAddresses"])
                    this.mailingAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["ivrAddresses"])) {
                this.ivrAddresses = [] as any;
                for (let item of _data["ivrAddresses"])
                    this.ivrAddresses!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["externalKeys"])) {
                this.externalKeys = [] as any;
                for (let item of _data["externalKeys"])
                    this.externalKeys!.push(ExternalKeyDTO.fromJS(item));
            }
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.status = _data["status"];
            (<any>this).personName = _data["personName"];
            this.ssn = _data["ssn"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.gender = _data["gender"];
            this.ethnicity = _data["ethnicity"];
            this.race = _data["race"];
            this.maritalStatus = _data["maritalStatus"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.physicalAddress = _data["physicalAddress"];
            this.mailingAddress = _data["mailingAddress"];
            this.ivrAddress = _data["ivrAddress"];
            this.companyCode = _data["companyCode"];
            this.unmaskedSsn = _data["unmaskedSsn"];
            this.onboarded = _data["onboarded"];
            this.isFirstLoginComplete = _data["isFirstLoginComplete"];
            this.ivrPin = _data["ivrPin"];
            this.paymentMethod = _data["paymentMethod"];
            this.coordinatorPersonId = _data["coordinatorPersonId"];
            this.internalUserObjectId = _data["internalUserObjectId"];
            this.coordinatorPersonFirstName = _data["coordinatorPersonFirstName"];
            this.coordinatorPersonLastName = _data["coordinatorPersonLastName"];
            this.coordinatorPersonName = _data["coordinatorPersonName"];
            this.lastV4LoginOn = _data["lastV4LoginOn"] ? new Date(_data["lastV4LoginOn"].toString()) : <any>undefined;
            this.isSsnValidated = _data["isSsnValidated"];
            this.ssnValidationOverrideOn = _data["ssnValidationOverrideOn"] ? new Date(_data["ssnValidationOverrideOn"].toString()) : <any>undefined;
            this.ssnValidationOverrideBy = _data["ssnValidationOverrideBy"];
            this.agencieStatus = _data["agencieStatus"];
            this.agencyStatus = _data["agencyStatus"];
            this.caseloadStatus = _data["caseloadStatus"];
        }
    }

    static fromJS(data: any): ServiceFacilitatorProfile {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceFacilitatorProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phoneDetails)) {
            data["phoneDetails"] = [];
            for (let item of this.phoneDetails)
                data["phoneDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.physicalAddresses)) {
            data["physicalAddresses"] = [];
            for (let item of this.physicalAddresses)
                data["physicalAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.mailingAddresses)) {
            data["mailingAddresses"] = [];
            for (let item of this.mailingAddresses)
                data["mailingAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.ivrAddresses)) {
            data["ivrAddresses"] = [];
            for (let item of this.ivrAddresses)
                data["ivrAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.externalKeys)) {
            data["externalKeys"] = [];
            for (let item of this.externalKeys)
                data["externalKeys"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["status"] = this.status;
        data["personName"] = this.personName;
        data["ssn"] = this.ssn;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["gender"] = this.gender;
        data["ethnicity"] = this.ethnicity;
        data["race"] = this.race;
        data["maritalStatus"] = this.maritalStatus;
        data["preferredLanguage"] = this.preferredLanguage;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["physicalAddress"] = this.physicalAddress;
        data["mailingAddress"] = this.mailingAddress;
        data["ivrAddress"] = this.ivrAddress;
        data["companyCode"] = this.companyCode;
        data["unmaskedSsn"] = this.unmaskedSsn;
        data["onboarded"] = this.onboarded;
        data["isFirstLoginComplete"] = this.isFirstLoginComplete;
        data["ivrPin"] = this.ivrPin;
        data["paymentMethod"] = this.paymentMethod;
        data["coordinatorPersonId"] = this.coordinatorPersonId;
        data["internalUserObjectId"] = this.internalUserObjectId;
        data["coordinatorPersonFirstName"] = this.coordinatorPersonFirstName;
        data["coordinatorPersonLastName"] = this.coordinatorPersonLastName;
        data["coordinatorPersonName"] = this.coordinatorPersonName;
        data["lastV4LoginOn"] = this.lastV4LoginOn ? this.lastV4LoginOn.toISOString() : <any>undefined;
        data["isSsnValidated"] = this.isSsnValidated;
        data["ssnValidationOverrideOn"] = this.ssnValidationOverrideOn ? this.ssnValidationOverrideOn.toISOString() : <any>undefined;
        data["ssnValidationOverrideBy"] = this.ssnValidationOverrideBy;
        data["agencieStatus"] = this.agencieStatus;
        data["agencyStatus"] = this.agencyStatus;
        data["caseloadStatus"] = this.caseloadStatus;
        return data;
    }
}

export interface IServiceFacilitatorProfile {
    phoneDetails?: PhoneDetail[] | undefined;
    physicalAddresses?: AddressDTO[] | undefined;
    mailingAddresses?: AddressDTO[] | undefined;
    ivrAddresses?: AddressDTO[] | undefined;
    externalKeys?: ExternalKeyDTO[] | undefined;
    id?: number;
    personId?: string | undefined;
    status?: string | undefined;
    personName?: string | undefined;
    ssn?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date | undefined;
    statusEndDate?: Date | undefined;
    physicalAddress?: string | undefined;
    mailingAddress?: string | undefined;
    ivrAddress?: string | undefined;
    companyCode?: string | undefined;
    unmaskedSsn?: string | undefined;
    onboarded?: boolean;
    isFirstLoginComplete?: boolean;
    ivrPin?: string | undefined;
    paymentMethod?: string | undefined;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    coordinatorPersonFirstName?: string | undefined;
    coordinatorPersonLastName?: string | undefined;
    coordinatorPersonName?: string | undefined;
    lastV4LoginOn?: Date | undefined;
    isSsnValidated?: boolean | undefined;
    ssnValidationOverrideOn?: Date | undefined;
    ssnValidationOverrideBy?: string | undefined;
    agencieStatus?: string | undefined;
    agencyStatus?: PersonStatus;
    caseloadStatus?: string | undefined;
}

export class ShiftSummary implements IShiftSummary {
    shiftSummaryResponses?: ShiftSummaryResponse[] | undefined;

    constructor(data?: IShiftSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shiftSummaryResponses"])) {
                this.shiftSummaryResponses = [] as any;
                for (let item of _data["shiftSummaryResponses"])
                    this.shiftSummaryResponses!.push(ShiftSummaryResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShiftSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shiftSummaryResponses)) {
            data["shiftSummaryResponses"] = [];
            for (let item of this.shiftSummaryResponses)
                data["shiftSummaryResponses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IShiftSummary {
    shiftSummaryResponses?: ShiftSummaryResponse[] | undefined;
}

export class ShiftSummaryResponse implements IShiftSummaryResponse {
    participantName?: string | undefined;
    participantId?: string | undefined;
    caregiverName?: string | undefined;
    caregiverId?: string | undefined;
    serviceCode?: string | undefined;
    serviceCodeDescription?: string | undefined;
    serviceDate?: Date;
    timeIn?: Date;
    timeOut?: Date;
    hours?: string | undefined;
    checkNumber?: string | undefined;
    checkAmount?: string | undefined;
    paidDate?: string | undefined;
    source?: string | undefined;
    sourceType?: string | undefined;
    destType?: string | undefined;
    ruleStatus?: string | undefined;
    transactionStatus?: string | undefined;
    transactionId?: string | undefined;
    notes?: string | undefined;
    exceptionQueue?: string | undefined;
    exception?: string | undefined;
    resolution?: string | undefined;
    reasonDescription?: string | undefined;
    documentType?: string | undefined;
    tasks?: TaskCode[] | undefined;
    caregiverComments?: string | undefined;

    constructor(data?: IShiftSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantName = _data["participantName"];
            this.participantId = _data["participantId"];
            this.caregiverName = _data["caregiverName"];
            this.caregiverId = _data["caregiverId"];
            this.serviceCode = _data["serviceCode"];
            this.serviceCodeDescription = _data["serviceCodeDescription"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.timeIn = _data["timeIn"] ? new Date(_data["timeIn"].toString()) : <any>undefined;
            this.timeOut = _data["timeOut"] ? new Date(_data["timeOut"].toString()) : <any>undefined;
            this.hours = _data["hours"];
            this.checkNumber = _data["checkNumber"];
            this.checkAmount = _data["checkAmount"];
            this.paidDate = _data["paidDate"];
            this.source = _data["source"];
            this.sourceType = _data["sourceType"];
            this.destType = _data["destType"];
            this.ruleStatus = _data["ruleStatus"];
            this.transactionStatus = _data["transactionStatus"];
            this.transactionId = _data["transactionId"];
            this.notes = _data["notes"];
            this.exceptionQueue = _data["exceptionQueue"];
            this.exception = _data["exception"];
            this.resolution = _data["resolution"];
            this.reasonDescription = _data["reasonDescription"];
            this.documentType = _data["documentType"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(TaskCode.fromJS(item));
            }
            this.caregiverComments = _data["caregiverComments"];
        }
    }

    static fromJS(data: any): ShiftSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantName"] = this.participantName;
        data["participantId"] = this.participantId;
        data["caregiverName"] = this.caregiverName;
        data["caregiverId"] = this.caregiverId;
        data["serviceCode"] = this.serviceCode;
        data["serviceCodeDescription"] = this.serviceCodeDescription;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        data["timeIn"] = this.timeIn ? this.timeIn.toISOString() : <any>undefined;
        data["timeOut"] = this.timeOut ? this.timeOut.toISOString() : <any>undefined;
        data["hours"] = this.hours;
        data["checkNumber"] = this.checkNumber;
        data["checkAmount"] = this.checkAmount;
        data["paidDate"] = this.paidDate;
        data["source"] = this.source;
        data["sourceType"] = this.sourceType;
        data["destType"] = this.destType;
        data["ruleStatus"] = this.ruleStatus;
        data["transactionStatus"] = this.transactionStatus;
        data["transactionId"] = this.transactionId;
        data["notes"] = this.notes;
        data["exceptionQueue"] = this.exceptionQueue;
        data["exception"] = this.exception;
        data["resolution"] = this.resolution;
        data["reasonDescription"] = this.reasonDescription;
        data["documentType"] = this.documentType;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        data["caregiverComments"] = this.caregiverComments;
        return data;
    }
}

export interface IShiftSummaryResponse {
    participantName?: string | undefined;
    participantId?: string | undefined;
    caregiverName?: string | undefined;
    caregiverId?: string | undefined;
    serviceCode?: string | undefined;
    serviceCodeDescription?: string | undefined;
    serviceDate?: Date;
    timeIn?: Date;
    timeOut?: Date;
    hours?: string | undefined;
    checkNumber?: string | undefined;
    checkAmount?: string | undefined;
    paidDate?: string | undefined;
    source?: string | undefined;
    sourceType?: string | undefined;
    destType?: string | undefined;
    ruleStatus?: string | undefined;
    transactionStatus?: string | undefined;
    transactionId?: string | undefined;
    notes?: string | undefined;
    exceptionQueue?: string | undefined;
    exception?: string | undefined;
    resolution?: string | undefined;
    reasonDescription?: string | undefined;
    documentType?: string | undefined;
    tasks?: TaskCode[] | undefined;
    caregiverComments?: string | undefined;
}

export class ShiftSummarySearchRequest implements IShiftSummarySearchRequest {
    startDate?: Date;
    endDate?: Date;
    participantId?: string | undefined;
    caregiverId?: string | undefined;
    companyCode?: string | undefined;
    companyId?: number;
    userMail?: string | undefined;
    pageSize?: number | undefined;

    constructor(data?: IShiftSummarySearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.participantId = _data["participantId"];
            this.caregiverId = _data["caregiverId"];
            this.companyCode = _data["companyCode"];
            this.companyId = _data["companyId"];
            this.userMail = _data["userMail"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): ShiftSummarySearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftSummarySearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["participantId"] = this.participantId;
        data["caregiverId"] = this.caregiverId;
        data["companyCode"] = this.companyCode;
        data["companyId"] = this.companyId;
        data["userMail"] = this.userMail;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IShiftSummarySearchRequest {
    startDate?: Date;
    endDate?: Date;
    participantId?: string | undefined;
    caregiverId?: string | undefined;
    companyCode?: string | undefined;
    companyId?: number;
    userMail?: string | undefined;
    pageSize?: number | undefined;
}

export class StatusHistory implements IStatusHistory {
    personStatus?: string | undefined;
    statusStartDate?: Date;
    statusEndDate?: Date | undefined;
    statusChangeReason?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IStatusHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personStatus = _data["personStatus"];
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.statusChangeReason = _data["statusChangeReason"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): StatusHistory {
        data = typeof data === 'object' ? data : {};
        let result = new StatusHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personStatus"] = this.personStatus;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["statusChangeReason"] = this.statusChangeReason;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IStatusHistory {
    personStatus?: string | undefined;
    statusStartDate?: Date;
    statusEndDate?: Date | undefined;
    statusChangeReason?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
}

export class StatusInfo implements IStatusInfo {
    statusId?: number;
    startDate?: Date;
    endDate?: Date | undefined;
    status?: PeopleStatus;
    termReason?: string | undefined;
    isActive?: boolean;
    isDeleted?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    statusV2Id?: number;

    constructor(data?: IStatusInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusId = _data["statusId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.termReason = _data["termReason"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.statusV2Id = _data["statusV2Id"];
        }
    }

    static fromJS(data: any): StatusInfo {
        data = typeof data === 'object' ? data : {};
        let result = new StatusInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusId"] = this.statusId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["termReason"] = this.termReason;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["statusV2Id"] = this.statusV2Id;
        return data;
    }
}

export interface IStatusInfo {
    statusId?: number;
    startDate?: Date;
    endDate?: Date | undefined;
    status?: PeopleStatus;
    termReason?: string | undefined;
    isActive?: boolean;
    isDeleted?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    statusV2Id?: number;
}

export class StatusRequest implements IStatusRequest {
    statusId?: number;
    status?: PeopleStatus;
    startDate?: Date;
    endDate?: Date | undefined;
    isActive?: boolean;

    constructor(data?: IStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusId = _data["statusId"];
            this.status = _data["status"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): StatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusId"] = this.statusId;
        data["status"] = this.status;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IStatusRequest {
    statusId?: number;
    status?: PeopleStatus;
    startDate?: Date;
    endDate?: Date | undefined;
    isActive?: boolean;
}

export class StatusResponse implements IStatusResponse {
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: IStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IStatusResponse {
    key?: string | undefined;
    value?: string | undefined;
}

export class StringComboboxModel implements IStringComboboxModel {
    id?: string | undefined;
    text?: string | undefined;

    constructor(data?: IStringComboboxModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): StringComboboxModel {
        data = typeof data === 'object' ? data : {};
        let result = new StringComboboxModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface IStringComboboxModel {
    id?: string | undefined;
    text?: string | undefined;
}

export class StringGridResponseBase implements IStringGridResponseBase {
    items?: string[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: string | undefined;

    constructor(data?: IStringGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(item);
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): StringGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new StringGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data;
        return data;
    }
}

export interface IStringGridResponseBase {
    items?: string[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: string | undefined;
}

export class StringInt32KeyValuePair implements IStringInt32KeyValuePair {
    key?: string | undefined;
    value?: number;

    constructor(data?: IStringInt32KeyValuePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StringInt32KeyValuePair {
        data = typeof data === 'object' ? data : {};
        let result = new StringInt32KeyValuePair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IStringInt32KeyValuePair {
    key?: string | undefined;
    value?: number;
}

export class StringStringKeyValuePair implements IStringStringKeyValuePair {
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: IStringStringKeyValuePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StringStringKeyValuePair {
        data = typeof data === 'object' ? data : {};
        let result = new StringStringKeyValuePair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IStringStringKeyValuePair {
    key?: string | undefined;
    value?: string | undefined;
}

export class SubmitAttestationCommand implements ISubmitAttestationCommand {
    accessRights?: string[] | undefined;
    typeCode?: string | undefined;
    version?: number;
    statusCode?: string | undefined;
    participantId?: number | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    caregiverId?: number;
    confirmationDate?: Date | undefined;
    endDate?: Date | undefined;
    languageId?: number;
    companyId?: number;
    isDeleted?: boolean;

    constructor(data?: ISubmitAttestationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(item);
            }
            this.typeCode = _data["typeCode"];
            this.version = _data["version"];
            this.statusCode = _data["statusCode"];
            this.participantId = _data["participantId"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.caregiverId = _data["caregiverId"];
            this.confirmationDate = _data["confirmationDate"] ? new Date(_data["confirmationDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.languageId = _data["languageId"];
            this.companyId = _data["companyId"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): SubmitAttestationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitAttestationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item);
        }
        data["typeCode"] = this.typeCode;
        data["version"] = this.version;
        data["statusCode"] = this.statusCode;
        data["participantId"] = this.participantId;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["caregiverId"] = this.caregiverId;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["languageId"] = this.languageId;
        data["companyId"] = this.companyId;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ISubmitAttestationCommand {
    accessRights?: string[] | undefined;
    typeCode?: string | undefined;
    version?: number;
    statusCode?: string | undefined;
    participantId?: number | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    caregiverId?: number;
    confirmationDate?: Date | undefined;
    endDate?: Date | undefined;
    languageId?: number;
    companyId?: number;
    isDeleted?: boolean;
}

export class SystemAction implements ISystemAction {
    systemActionMappingId?: number;
    name?: string | undefined;
    systemCode?: string | undefined;
    systemDisplayText?: string | undefined;
    actionCode?: string | undefined;
    actionDisplayText?: string | undefined;
    isDeleted?: boolean;
    isSelectable?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: string | undefined;

    constructor(data?: ISystemAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemActionMappingId = _data["systemActionMappingId"];
            this.name = _data["name"];
            this.systemCode = _data["systemCode"];
            this.systemDisplayText = _data["systemDisplayText"];
            this.actionCode = _data["actionCode"];
            this.actionDisplayText = _data["actionDisplayText"];
            this.isDeleted = _data["isDeleted"];
            this.isSelectable = _data["isSelectable"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"];
        }
    }

    static fromJS(data: any): SystemAction {
        data = typeof data === 'object' ? data : {};
        let result = new SystemAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemActionMappingId"] = this.systemActionMappingId;
        data["name"] = this.name;
        data["systemCode"] = this.systemCode;
        data["systemDisplayText"] = this.systemDisplayText;
        data["actionCode"] = this.actionCode;
        data["actionDisplayText"] = this.actionDisplayText;
        data["isDeleted"] = this.isDeleted;
        data["isSelectable"] = this.isSelectable;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn;
        return data;
    }
}

export interface ISystemAction {
    systemActionMappingId?: number;
    name?: string | undefined;
    systemCode?: string | undefined;
    systemDisplayText?: string | undefined;
    actionCode?: string | undefined;
    actionDisplayText?: string | undefined;
    isDeleted?: boolean;
    isSelectable?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: string | undefined;
}

export class SystemActionMapping implements ISystemActionMapping {
    id?: number;
    statusId?: number;
    systemActionId?: number;
    entityTypeId?: number;
    actionName?: string | undefined;
    systemName?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: ISystemActionMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusId = _data["statusId"];
            this.systemActionId = _data["systemActionId"];
            this.entityTypeId = _data["entityTypeId"];
            this.actionName = _data["actionName"];
            this.systemName = _data["systemName"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): SystemActionMapping {
        data = typeof data === 'object' ? data : {};
        let result = new SystemActionMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusId"] = this.statusId;
        data["systemActionId"] = this.systemActionId;
        data["entityTypeId"] = this.entityTypeId;
        data["actionName"] = this.actionName;
        data["systemName"] = this.systemName;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ISystemActionMapping {
    id?: number;
    statusId?: number;
    systemActionId?: number;
    entityTypeId?: number;
    actionName?: string | undefined;
    systemName?: string | undefined;
    isDeleted?: boolean;
}

export class TaskCode implements ITaskCode {
    id?: number | undefined;
    taskCodeId?: string | undefined;
    taskCodeDescription?: string | undefined;

    constructor(data?: ITaskCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskCodeId = _data["taskCodeId"];
            this.taskCodeDescription = _data["taskCodeDescription"];
        }
    }

    static fromJS(data: any): TaskCode {
        data = typeof data === 'object' ? data : {};
        let result = new TaskCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskCodeId"] = this.taskCodeId;
        data["taskCodeDescription"] = this.taskCodeDescription;
        return data;
    }
}

export interface ITaskCode {
    id?: number | undefined;
    taskCodeId?: string | undefined;
    taskCodeDescription?: string | undefined;
}

export class TaskCodeGridResponseBase implements ITaskCodeGridResponseBase {
    items?: TaskCode[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: TaskCode;

    constructor(data?: ITaskCodeGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TaskCode.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? TaskCode.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskCodeGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new TaskCodeGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITaskCodeGridResponseBase {
    items?: TaskCode[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: TaskCode;
}

export class TaskConfigurationDto implements ITaskConfigurationDto {
    taskConfigurationId?: number;
    taskConfigurationTypeId?: number;
    participantId?: number;
    serviceCodeId?: number;
    payorId?: number;
    taskCodeId?: number;
    taskCode?: string | undefined;
    description?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    isActive?: boolean;
    isDeleted?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;

    constructor(data?: ITaskConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskConfigurationId = _data["taskConfigurationId"];
            this.taskConfigurationTypeId = _data["taskConfigurationTypeId"];
            this.participantId = _data["participantId"];
            this.serviceCodeId = _data["serviceCodeId"];
            this.payorId = _data["payorId"];
            this.taskCodeId = _data["taskCodeId"];
            this.taskCode = _data["taskCode"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskConfigurationId"] = this.taskConfigurationId;
        data["taskConfigurationTypeId"] = this.taskConfigurationTypeId;
        data["participantId"] = this.participantId;
        data["serviceCodeId"] = this.serviceCodeId;
        data["payorId"] = this.payorId;
        data["taskCodeId"] = this.taskCodeId;
        data["taskCode"] = this.taskCode;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITaskConfigurationDto {
    taskConfigurationId?: number;
    taskConfigurationTypeId?: number;
    participantId?: number;
    serviceCodeId?: number;
    payorId?: number;
    taskCodeId?: number;
    taskCode?: string | undefined;
    description?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    isActive?: boolean;
    isDeleted?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
}

export class TaskConfigurationFetchRequest implements ITaskConfigurationFetchRequest {
    participantId?: number;
    serviceCodeId?: number;
    payorId?: number;
    taskConfigurationType?: TaskConfigurationType;

    constructor(data?: ITaskConfigurationFetchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.serviceCodeId = _data["serviceCodeId"];
            this.payorId = _data["payorId"];
            this.taskConfigurationType = _data["taskConfigurationType"];
        }
    }

    static fromJS(data: any): TaskConfigurationFetchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskConfigurationFetchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["serviceCodeId"] = this.serviceCodeId;
        data["payorId"] = this.payorId;
        data["taskConfigurationType"] = this.taskConfigurationType;
        return data;
    }
}

export interface ITaskConfigurationFetchRequest {
    participantId?: number;
    serviceCodeId?: number;
    payorId?: number;
    taskConfigurationType?: TaskConfigurationType;
}

export class TaskConfigurationResponse implements ITaskConfigurationResponse {
    taskConfigurationResponseList?: TaskConfigurationDto[] | undefined;

    constructor(data?: ITaskConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["taskConfigurationResponseList"])) {
                this.taskConfigurationResponseList = [] as any;
                for (let item of _data["taskConfigurationResponseList"])
                    this.taskConfigurationResponseList!.push(TaskConfigurationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskConfigurationResponseList)) {
            data["taskConfigurationResponseList"] = [];
            for (let item of this.taskConfigurationResponseList)
                data["taskConfigurationResponseList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaskConfigurationResponse {
    taskConfigurationResponseList?: TaskConfigurationDto[] | undefined;
}

export class TaskConfigurationSaveRequest implements ITaskConfigurationSaveRequest {
    taskConfigurationRequestList?: TaskConfigurationDto[] | undefined;
    taskConfigurationType?: TaskConfigurationType;

    constructor(data?: ITaskConfigurationSaveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["taskConfigurationRequestList"])) {
                this.taskConfigurationRequestList = [] as any;
                for (let item of _data["taskConfigurationRequestList"])
                    this.taskConfigurationRequestList!.push(TaskConfigurationDto.fromJS(item));
            }
            this.taskConfigurationType = _data["taskConfigurationType"];
        }
    }

    static fromJS(data: any): TaskConfigurationSaveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskConfigurationSaveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskConfigurationRequestList)) {
            data["taskConfigurationRequestList"] = [];
            for (let item of this.taskConfigurationRequestList)
                data["taskConfigurationRequestList"].push(item.toJSON());
        }
        data["taskConfigurationType"] = this.taskConfigurationType;
        return data;
    }
}

export interface ITaskConfigurationSaveRequest {
    taskConfigurationRequestList?: TaskConfigurationDto[] | undefined;
    taskConfigurationType?: TaskConfigurationType;
}

export enum TaskConfigurationType {
    Participant = "Participant",
    ServiceCode = "ServiceCode",
    ParticipantServiceCode = "ParticipantServiceCode",
}

export class TaskResponse implements ITaskResponse {
    taskCode?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;

    constructor(data?: ITaskResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskCode = _data["taskCode"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskCode"] = this.taskCode;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITaskResponse {
    taskCode?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
}

export class TasksRequest implements ITasksRequest {
    date?: Date | undefined;
    servCodeId?: string | undefined;
    participantId?: string | undefined;
    companyId?: number;

    constructor(data?: ITasksRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.servCodeId = _data["servCodeId"];
            this.participantId = _data["participantId"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): TasksRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TasksRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["servCodeId"] = this.servCodeId;
        data["participantId"] = this.participantId;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface ITasksRequest {
    date?: Date | undefined;
    servCodeId?: string | undefined;
    participantId?: string | undefined;
    companyId?: number;
}

export class TasksResponse implements ITasksResponse {
    id?: number;
    taskConfigurationId?: number;
    code?: string | undefined;
    description?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;

    constructor(data?: ITasksResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskConfigurationId = _data["taskConfigurationId"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TasksResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TasksResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskConfigurationId"] = this.taskConfigurationId;
        data["code"] = this.code;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITasksResponse {
    id?: number;
    taskConfigurationId?: number;
    code?: string | undefined;
    description?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
}

export class TerminationStatusHistory implements ITerminationStatusHistory {
    terminationStatus?: string | undefined;
    eventDate?: Date;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    terminationMemo?: string | undefined;
    createdOn?: Date;

    constructor(data?: ITerminationStatusHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.terminationStatus = _data["terminationStatus"];
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.terminationMemo = _data["terminationMemo"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TerminationStatusHistory {
        data = typeof data === 'object' ? data : {};
        let result = new TerminationStatusHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["terminationStatus"] = this.terminationStatus;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["terminationMemo"] = this.terminationMemo;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITerminationStatusHistory {
    terminationStatus?: string | undefined;
    eventDate?: Date;
    updatedOn?: Date | undefined;
    updatedBy?: string | undefined;
    terminationMemo?: string | undefined;
    createdOn?: Date;
}

export class TerritoryDto implements ITerritoryDto {
    id?: number;
    territoryName?: string | undefined;

    constructor(data?: ITerritoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.territoryName = _data["territoryName"];
        }
    }

    static fromJS(data: any): TerritoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TerritoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["territoryName"] = this.territoryName;
        return data;
    }
}

export interface ITerritoryDto {
    id?: number;
    territoryName?: string | undefined;
}

export class Twenty147StatusRequest implements ITwenty147StatusRequest {
    caregiverId?: string | undefined;
    companyCode?: string | undefined;
    participantId?: string | undefined;
    servDate?: Date;

    constructor(data?: ITwenty147StatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.companyCode = _data["companyCode"];
            this.participantId = _data["participantId"];
            this.servDate = _data["servDate"] ? new Date(_data["servDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Twenty147StatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new Twenty147StatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["companyCode"] = this.companyCode;
        data["participantId"] = this.participantId;
        data["servDate"] = this.servDate ? this.servDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITwenty147StatusRequest {
    caregiverId?: string | undefined;
    companyCode?: string | undefined;
    participantId?: string | undefined;
    servDate?: Date;
}

export class Twenty147StatusResponse implements ITwenty147StatusResponse {
    isTwenty147Status?: boolean;

    constructor(data?: ITwenty147StatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isTwenty147Status = _data["isTwenty147Status"];
        }
    }

    static fromJS(data: any): Twenty147StatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new Twenty147StatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isTwenty147Status"] = this.isTwenty147Status;
        return data;
    }
}

export interface ITwenty147StatusResponse {
    isTwenty147Status?: boolean;
}

export enum UctBatchType {
    PT = "PT",
    CG = "CG",
    PTCG = "PTCG",
    EOR = "EOR",
    PTEOR = "PTEOR",
    CGEOR = "CGEOR",
    DR = "DR",
    PTDR = "PTDR",
    PTEORDR = "PTEORDR",
}

export class UctConfiguration implements IUctConfiguration {
    firstName?: string | undefined;
    lastName?: string | undefined;
    noOfPeople?: number;
    b2CDeletionSchedule?: string | undefined;
    servCodes?: ServiceCodes[] | undefined;
    uctBatchType?: UctBatchType;
    payorId?: number;
    payor?: string | undefined;
    programId?: number;
    programTypeId?: number;
    programNumber?: string | undefined;

    constructor(data?: IUctConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.noOfPeople = _data["noOfPeople"];
            this.b2CDeletionSchedule = _data["b2CDeletionSchedule"];
            if (Array.isArray(_data["servCodes"])) {
                this.servCodes = [] as any;
                for (let item of _data["servCodes"])
                    this.servCodes!.push(ServiceCodes.fromJS(item));
            }
            this.uctBatchType = _data["uctBatchType"];
            this.payorId = _data["payorId"];
            this.payor = _data["payor"];
            this.programId = _data["programId"];
            this.programTypeId = _data["programTypeId"];
            this.programNumber = _data["programNumber"];
        }
    }

    static fromJS(data: any): UctConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new UctConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["noOfPeople"] = this.noOfPeople;
        data["b2CDeletionSchedule"] = this.b2CDeletionSchedule;
        if (Array.isArray(this.servCodes)) {
            data["servCodes"] = [];
            for (let item of this.servCodes)
                data["servCodes"].push(item.toJSON());
        }
        data["uctBatchType"] = this.uctBatchType;
        data["payorId"] = this.payorId;
        data["payor"] = this.payor;
        data["programId"] = this.programId;
        data["programTypeId"] = this.programTypeId;
        data["programNumber"] = this.programNumber;
        return data;
    }
}

export interface IUctConfiguration {
    firstName?: string | undefined;
    lastName?: string | undefined;
    noOfPeople?: number;
    b2CDeletionSchedule?: string | undefined;
    servCodes?: ServiceCodes[] | undefined;
    uctBatchType?: UctBatchType;
    payorId?: number;
    payor?: string | undefined;
    programId?: number;
    programTypeId?: number;
    programNumber?: string | undefined;
}

export class UctResponse implements IUctResponse {
    name?: string | undefined;
    personId?: number;
    email?: string | undefined;
    servCodes?: ServiceCodes[] | undefined;

    constructor(data?: IUctResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.personId = _data["personId"];
            this.email = _data["email"];
            if (Array.isArray(_data["servCodes"])) {
                this.servCodes = [] as any;
                for (let item of _data["servCodes"])
                    this.servCodes!.push(ServiceCodes.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UctResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UctResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["personId"] = this.personId;
        data["email"] = this.email;
        if (Array.isArray(this.servCodes)) {
            data["servCodes"] = [];
            for (let item of this.servCodes)
                data["servCodes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUctResponse {
    name?: string | undefined;
    personId?: number;
    email?: string | undefined;
    servCodes?: ServiceCodes[] | undefined;
}

export class UnmaskedSSN implements IUnmaskedSSN {
    ssn?: string | undefined;

    constructor(data?: IUnmaskedSSN) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ssn = _data["ssn"];
        }
    }

    static fromJS(data: any): UnmaskedSSN {
        data = typeof data === 'object' ? data : {};
        let result = new UnmaskedSSN();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ssn"] = this.ssn;
        return data;
    }
}

export interface IUnmaskedSSN {
    ssn?: string | undefined;
}

export class UpdateAttestationCommand implements IUpdateAttestationCommand {
    accessRights?: string[] | undefined;
    participantId?: number;

    constructor(data?: IUpdateAttestationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(item);
            }
            this.participantId = _data["participantId"];
        }
    }

    static fromJS(data: any): UpdateAttestationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAttestationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item);
        }
        data["participantId"] = this.participantId;
        return data;
    }
}

export interface IUpdateAttestationCommand {
    accessRights?: string[] | undefined;
    participantId?: number;
}

export class UpdateIvrPinRequest implements IUpdateIvrPinRequest {
    personId?: string | undefined;
    ivrPin?: string | undefined;
    email?: string | undefined;

    constructor(data?: IUpdateIvrPinRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.ivrPin = _data["ivrPin"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UpdateIvrPinRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIvrPinRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["ivrPin"] = this.ivrPin;
        data["email"] = this.email;
        return data;
    }
}

export interface IUpdateIvrPinRequest {
    personId?: string | undefined;
    ivrPin?: string | undefined;
    email?: string | undefined;
}

export class UpsertCaregiverCommand implements IUpsertCaregiverCommand {
    accessRights?: string[] | undefined;
    cdcnState?: string | undefined;
    area?: string | undefined;
    territory?: string | undefined;
    geoLocale?: string | undefined;
    npi?: string | undefined;
    renderingProviderFirstName?: string | undefined;
    renderingProviderLastName?: string | undefined;
    stateUniqueId?: string | undefined;
    canPaperTimesheet?: boolean | undefined;
    lepIndicator?: boolean | undefined;
    demographicsConfirmation?: AttestationStatus;
    trainingConfirmation?: AttestationStatus;
    backgroundCheckConfirmation?: AttestationStatus;
    personId?: number;

    constructor(data?: IUpsertCaregiverCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(item);
            }
            this.cdcnState = _data["cdcnState"];
            this.area = _data["area"];
            this.territory = _data["territory"];
            this.geoLocale = _data["geoLocale"];
            this.npi = _data["npi"];
            this.renderingProviderFirstName = _data["renderingProviderFirstName"];
            this.renderingProviderLastName = _data["renderingProviderLastName"];
            this.stateUniqueId = _data["stateUniqueId"];
            this.canPaperTimesheet = _data["canPaperTimesheet"];
            this.lepIndicator = _data["lepIndicator"];
            this.demographicsConfirmation = _data["demographicsConfirmation"];
            this.trainingConfirmation = _data["trainingConfirmation"];
            this.backgroundCheckConfirmation = _data["backgroundCheckConfirmation"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): UpsertCaregiverCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertCaregiverCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item);
        }
        data["cdcnState"] = this.cdcnState;
        data["area"] = this.area;
        data["territory"] = this.territory;
        data["geoLocale"] = this.geoLocale;
        data["npi"] = this.npi;
        data["renderingProviderFirstName"] = this.renderingProviderFirstName;
        data["renderingProviderLastName"] = this.renderingProviderLastName;
        data["stateUniqueId"] = this.stateUniqueId;
        data["canPaperTimesheet"] = this.canPaperTimesheet;
        data["lepIndicator"] = this.lepIndicator;
        data["demographicsConfirmation"] = this.demographicsConfirmation;
        data["trainingConfirmation"] = this.trainingConfirmation;
        data["backgroundCheckConfirmation"] = this.backgroundCheckConfirmation;
        data["personId"] = this.personId;
        return data;
    }
}

export interface IUpsertCaregiverCommand {
    accessRights?: string[] | undefined;
    cdcnState?: string | undefined;
    area?: string | undefined;
    territory?: string | undefined;
    geoLocale?: string | undefined;
    npi?: string | undefined;
    renderingProviderFirstName?: string | undefined;
    renderingProviderLastName?: string | undefined;
    stateUniqueId?: string | undefined;
    canPaperTimesheet?: boolean | undefined;
    lepIndicator?: boolean | undefined;
    demographicsConfirmation?: AttestationStatus;
    trainingConfirmation?: AttestationStatus;
    backgroundCheckConfirmation?: AttestationStatus;
    personId?: number;
}

export class UpsertCaregiverEmployerRelCommand implements IUpsertCaregiverEmployerRelCommand {
    accessRights?: string[] | undefined;
    caregiverId?: number;
    caregiverEmployerRelId?: number;
    employerId?: number;
    payorId?: number;
    allowedHours?: number | undefined;
    nbrPersonalExemptions?: number | undefined;
    workLocation?: string | undefined;
    eligibleForHoliday?: boolean;
    payService?: boolean;
    onHold?: boolean;
    maritalStatus?: string | undefined;
    permanentWWL?: number | undefined;
    caregiverEmployerRelDateId?: number;
    startDate?: Date;
    endDate?: Date | undefined;
    employerEmployerOfRecordRelationId?: number;
    employerEmployerOfRecordRelationCode?: string | undefined;
    employerEmployerOfRecordRelationName?: string | undefined;
    termReason?: string | undefined;

    constructor(data?: IUpsertCaregiverEmployerRelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(item);
            }
            this.caregiverId = _data["caregiverId"];
            this.caregiverEmployerRelId = _data["caregiverEmployerRelId"];
            this.employerId = _data["employerId"];
            this.payorId = _data["payorId"];
            this.allowedHours = _data["allowedHours"];
            this.nbrPersonalExemptions = _data["nbrPersonalExemptions"];
            this.workLocation = _data["workLocation"];
            this.eligibleForHoliday = _data["eligibleForHoliday"];
            this.payService = _data["payService"];
            this.onHold = _data["onHold"];
            this.maritalStatus = _data["maritalStatus"];
            this.permanentWWL = _data["permanentWWL"];
            this.caregiverEmployerRelDateId = _data["caregiverEmployerRelDateId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.employerEmployerOfRecordRelationId = _data["employerEmployerOfRecordRelationId"];
            this.employerEmployerOfRecordRelationCode = _data["employerEmployerOfRecordRelationCode"];
            this.employerEmployerOfRecordRelationName = _data["employerEmployerOfRecordRelationName"];
            this.termReason = _data["termReason"];
        }
    }

    static fromJS(data: any): UpsertCaregiverEmployerRelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertCaregiverEmployerRelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item);
        }
        data["caregiverId"] = this.caregiverId;
        data["caregiverEmployerRelId"] = this.caregiverEmployerRelId;
        data["employerId"] = this.employerId;
        data["payorId"] = this.payorId;
        data["allowedHours"] = this.allowedHours;
        data["nbrPersonalExemptions"] = this.nbrPersonalExemptions;
        data["workLocation"] = this.workLocation;
        data["eligibleForHoliday"] = this.eligibleForHoliday;
        data["payService"] = this.payService;
        data["onHold"] = this.onHold;
        data["maritalStatus"] = this.maritalStatus;
        data["permanentWWL"] = this.permanentWWL;
        data["caregiverEmployerRelDateId"] = this.caregiverEmployerRelDateId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["employerEmployerOfRecordRelationId"] = this.employerEmployerOfRecordRelationId;
        data["employerEmployerOfRecordRelationCode"] = this.employerEmployerOfRecordRelationCode;
        data["employerEmployerOfRecordRelationName"] = this.employerEmployerOfRecordRelationName;
        data["termReason"] = this.termReason;
        return data;
    }
}

export interface IUpsertCaregiverEmployerRelCommand {
    accessRights?: string[] | undefined;
    caregiverId?: number;
    caregiverEmployerRelId?: number;
    employerId?: number;
    payorId?: number;
    allowedHours?: number | undefined;
    nbrPersonalExemptions?: number | undefined;
    workLocation?: string | undefined;
    eligibleForHoliday?: boolean;
    payService?: boolean;
    onHold?: boolean;
    maritalStatus?: string | undefined;
    permanentWWL?: number | undefined;
    caregiverEmployerRelDateId?: number;
    startDate?: Date;
    endDate?: Date | undefined;
    employerEmployerOfRecordRelationId?: number;
    employerEmployerOfRecordRelationCode?: string | undefined;
    employerEmployerOfRecordRelationName?: string | undefined;
    termReason?: string | undefined;
}

export class UpsertCaregiverParticipantProspectCommand implements IUpsertCaregiverParticipantProspectCommand {
    accessRights?: string[] | undefined;
    caregiverParticipantProspectId?: number;
    personId?: number;
    participantId?: number | undefined;
    providerOneId?: string | undefined;
    clientAge?: string | undefined;
    relationshipToClientId?: number | undefined;
    isAuthRepresentative?: boolean | undefined;
    clientFirstName?: string | undefined;
    clientLastName?: string | undefined;
    ficaAttestationId?: number | undefined;
    ficaConfirmationStatus?: AttestationStatus;
    isFica?: boolean | undefined;
    ficaStartDate?: Date | undefined;
    ficaEndDate?: Date | undefined;
    is20147?: boolean | undefined;
    startDate20147?: Date | undefined;
    endDate20147?: Date | undefined;
    isLiveIn?: boolean | undefined;
    liveInStartDate?: Date | undefined;
    liveInEndDate?: Date | undefined;
    isFicaChild?: boolean | undefined;
    ficaChildStartDate?: Date | undefined;
    ficaChildEndDate?: Date | undefined;
    relationshipStatus?: string | undefined;
    relationshipStartDate?: Date | undefined;
    relationshipEndDate?: Date | undefined;
    difficultyOfCareAttestationId?: number | undefined;
    difficultyOfCareConfirmationStatus?: AttestationStatus;
    liveInExemptionConfirmationStatus?: AttestationStatus;
    liveInExemptionAttestationId?: number | undefined;
    requestRelationshipConfirmationStatus?: AttestationStatus;
    isProcessed?: boolean;

    constructor(data?: IUpsertCaregiverParticipantProspectCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(item);
            }
            this.caregiverParticipantProspectId = _data["caregiverParticipantProspectId"];
            this.personId = _data["personId"];
            this.participantId = _data["participantId"];
            this.providerOneId = _data["providerOneId"];
            this.clientAge = _data["clientAge"];
            this.relationshipToClientId = _data["relationshipToClientId"];
            this.isAuthRepresentative = _data["isAuthRepresentative"];
            this.clientFirstName = _data["clientFirstName"];
            this.clientLastName = _data["clientLastName"];
            this.ficaAttestationId = _data["ficaAttestationId"];
            this.ficaConfirmationStatus = _data["ficaConfirmationStatus"];
            this.isFica = _data["isFica"];
            this.ficaStartDate = _data["ficaStartDate"] ? new Date(_data["ficaStartDate"].toString()) : <any>undefined;
            this.ficaEndDate = _data["ficaEndDate"] ? new Date(_data["ficaEndDate"].toString()) : <any>undefined;
            this.is20147 = _data["is20147"];
            this.startDate20147 = _data["startDate20147"] ? new Date(_data["startDate20147"].toString()) : <any>undefined;
            this.endDate20147 = _data["endDate20147"] ? new Date(_data["endDate20147"].toString()) : <any>undefined;
            this.isLiveIn = _data["isLiveIn"];
            this.liveInStartDate = _data["liveInStartDate"] ? new Date(_data["liveInStartDate"].toString()) : <any>undefined;
            this.liveInEndDate = _data["liveInEndDate"] ? new Date(_data["liveInEndDate"].toString()) : <any>undefined;
            this.isFicaChild = _data["isFicaChild"];
            this.ficaChildStartDate = _data["ficaChildStartDate"] ? new Date(_data["ficaChildStartDate"].toString()) : <any>undefined;
            this.ficaChildEndDate = _data["ficaChildEndDate"] ? new Date(_data["ficaChildEndDate"].toString()) : <any>undefined;
            this.relationshipStatus = _data["relationshipStatus"];
            this.relationshipStartDate = _data["relationshipStartDate"] ? new Date(_data["relationshipStartDate"].toString()) : <any>undefined;
            this.relationshipEndDate = _data["relationshipEndDate"] ? new Date(_data["relationshipEndDate"].toString()) : <any>undefined;
            this.difficultyOfCareAttestationId = _data["difficultyOfCareAttestationId"];
            this.difficultyOfCareConfirmationStatus = _data["difficultyOfCareConfirmationStatus"];
            this.liveInExemptionConfirmationStatus = _data["liveInExemptionConfirmationStatus"];
            this.liveInExemptionAttestationId = _data["liveInExemptionAttestationId"];
            this.requestRelationshipConfirmationStatus = _data["requestRelationshipConfirmationStatus"];
            this.isProcessed = _data["isProcessed"];
        }
    }

    static fromJS(data: any): UpsertCaregiverParticipantProspectCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertCaregiverParticipantProspectCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item);
        }
        data["caregiverParticipantProspectId"] = this.caregiverParticipantProspectId;
        data["personId"] = this.personId;
        data["participantId"] = this.participantId;
        data["providerOneId"] = this.providerOneId;
        data["clientAge"] = this.clientAge;
        data["relationshipToClientId"] = this.relationshipToClientId;
        data["isAuthRepresentative"] = this.isAuthRepresentative;
        data["clientFirstName"] = this.clientFirstName;
        data["clientLastName"] = this.clientLastName;
        data["ficaAttestationId"] = this.ficaAttestationId;
        data["ficaConfirmationStatus"] = this.ficaConfirmationStatus;
        data["isFica"] = this.isFica;
        data["ficaStartDate"] = this.ficaStartDate ? this.ficaStartDate.toISOString() : <any>undefined;
        data["ficaEndDate"] = this.ficaEndDate ? this.ficaEndDate.toISOString() : <any>undefined;
        data["is20147"] = this.is20147;
        data["startDate20147"] = this.startDate20147 ? this.startDate20147.toISOString() : <any>undefined;
        data["endDate20147"] = this.endDate20147 ? this.endDate20147.toISOString() : <any>undefined;
        data["isLiveIn"] = this.isLiveIn;
        data["liveInStartDate"] = this.liveInStartDate ? this.liveInStartDate.toISOString() : <any>undefined;
        data["liveInEndDate"] = this.liveInEndDate ? this.liveInEndDate.toISOString() : <any>undefined;
        data["isFicaChild"] = this.isFicaChild;
        data["ficaChildStartDate"] = this.ficaChildStartDate ? this.ficaChildStartDate.toISOString() : <any>undefined;
        data["ficaChildEndDate"] = this.ficaChildEndDate ? this.ficaChildEndDate.toISOString() : <any>undefined;
        data["relationshipStatus"] = this.relationshipStatus;
        data["relationshipStartDate"] = this.relationshipStartDate ? this.relationshipStartDate.toISOString() : <any>undefined;
        data["relationshipEndDate"] = this.relationshipEndDate ? this.relationshipEndDate.toISOString() : <any>undefined;
        data["difficultyOfCareAttestationId"] = this.difficultyOfCareAttestationId;
        data["difficultyOfCareConfirmationStatus"] = this.difficultyOfCareConfirmationStatus;
        data["liveInExemptionConfirmationStatus"] = this.liveInExemptionConfirmationStatus;
        data["liveInExemptionAttestationId"] = this.liveInExemptionAttestationId;
        data["requestRelationshipConfirmationStatus"] = this.requestRelationshipConfirmationStatus;
        data["isProcessed"] = this.isProcessed;
        return data;
    }
}

export interface IUpsertCaregiverParticipantProspectCommand {
    accessRights?: string[] | undefined;
    caregiverParticipantProspectId?: number;
    personId?: number;
    participantId?: number | undefined;
    providerOneId?: string | undefined;
    clientAge?: string | undefined;
    relationshipToClientId?: number | undefined;
    isAuthRepresentative?: boolean | undefined;
    clientFirstName?: string | undefined;
    clientLastName?: string | undefined;
    ficaAttestationId?: number | undefined;
    ficaConfirmationStatus?: AttestationStatus;
    isFica?: boolean | undefined;
    ficaStartDate?: Date | undefined;
    ficaEndDate?: Date | undefined;
    is20147?: boolean | undefined;
    startDate20147?: Date | undefined;
    endDate20147?: Date | undefined;
    isLiveIn?: boolean | undefined;
    liveInStartDate?: Date | undefined;
    liveInEndDate?: Date | undefined;
    isFicaChild?: boolean | undefined;
    ficaChildStartDate?: Date | undefined;
    ficaChildEndDate?: Date | undefined;
    relationshipStatus?: string | undefined;
    relationshipStartDate?: Date | undefined;
    relationshipEndDate?: Date | undefined;
    difficultyOfCareAttestationId?: number | undefined;
    difficultyOfCareConfirmationStatus?: AttestationStatus;
    liveInExemptionConfirmationStatus?: AttestationStatus;
    liveInExemptionAttestationId?: number | undefined;
    requestRelationshipConfirmationStatus?: AttestationStatus;
    isProcessed?: boolean;
}

export class UpsertParticipantCaregiverRelationCommand implements IUpsertParticipantCaregiverRelationCommand {
    accessRights?: string[] | undefined;
    participantId?: number;
    caregiverId?: number;
    caregiverParticipantRelId?: number;
    qualificationRoleTypeId?: number | undefined;
    testAuthEndDate?: Date | undefined;
    relationshipId?: number | undefined;
    serviceTypes?: number[] | undefined;
    liveinDateRanges?: DateRangeRequest[] | undefined;
    statusDateRanges?: StatusRequest[] | undefined;
    relationshipDateRanges?: RelationshipDateRangeRequest[] | undefined;
    exemptions?: ExemptionRequest[] | undefined;

    constructor(data?: IUpsertParticipantCaregiverRelationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(item);
            }
            this.participantId = _data["participantId"];
            this.caregiverId = _data["caregiverId"];
            this.caregiverParticipantRelId = _data["caregiverParticipantRelId"];
            this.qualificationRoleTypeId = _data["qualificationRoleTypeId"];
            this.testAuthEndDate = _data["testAuthEndDate"] ? new Date(_data["testAuthEndDate"].toString()) : <any>undefined;
            this.relationshipId = _data["relationshipId"];
            if (Array.isArray(_data["serviceTypes"])) {
                this.serviceTypes = [] as any;
                for (let item of _data["serviceTypes"])
                    this.serviceTypes!.push(item);
            }
            if (Array.isArray(_data["liveinDateRanges"])) {
                this.liveinDateRanges = [] as any;
                for (let item of _data["liveinDateRanges"])
                    this.liveinDateRanges!.push(DateRangeRequest.fromJS(item));
            }
            if (Array.isArray(_data["statusDateRanges"])) {
                this.statusDateRanges = [] as any;
                for (let item of _data["statusDateRanges"])
                    this.statusDateRanges!.push(StatusRequest.fromJS(item));
            }
            if (Array.isArray(_data["relationshipDateRanges"])) {
                this.relationshipDateRanges = [] as any;
                for (let item of _data["relationshipDateRanges"])
                    this.relationshipDateRanges!.push(RelationshipDateRangeRequest.fromJS(item));
            }
            if (Array.isArray(_data["exemptions"])) {
                this.exemptions = [] as any;
                for (let item of _data["exemptions"])
                    this.exemptions!.push(ExemptionRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpsertParticipantCaregiverRelationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertParticipantCaregiverRelationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item);
        }
        data["participantId"] = this.participantId;
        data["caregiverId"] = this.caregiverId;
        data["caregiverParticipantRelId"] = this.caregiverParticipantRelId;
        data["qualificationRoleTypeId"] = this.qualificationRoleTypeId;
        data["testAuthEndDate"] = this.testAuthEndDate ? this.testAuthEndDate.toISOString() : <any>undefined;
        data["relationshipId"] = this.relationshipId;
        if (Array.isArray(this.serviceTypes)) {
            data["serviceTypes"] = [];
            for (let item of this.serviceTypes)
                data["serviceTypes"].push(item);
        }
        if (Array.isArray(this.liveinDateRanges)) {
            data["liveinDateRanges"] = [];
            for (let item of this.liveinDateRanges)
                data["liveinDateRanges"].push(item.toJSON());
        }
        if (Array.isArray(this.statusDateRanges)) {
            data["statusDateRanges"] = [];
            for (let item of this.statusDateRanges)
                data["statusDateRanges"].push(item.toJSON());
        }
        if (Array.isArray(this.relationshipDateRanges)) {
            data["relationshipDateRanges"] = [];
            for (let item of this.relationshipDateRanges)
                data["relationshipDateRanges"].push(item.toJSON());
        }
        if (Array.isArray(this.exemptions)) {
            data["exemptions"] = [];
            for (let item of this.exemptions)
                data["exemptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpsertParticipantCaregiverRelationCommand {
    accessRights?: string[] | undefined;
    participantId?: number;
    caregiverId?: number;
    caregiverParticipantRelId?: number;
    qualificationRoleTypeId?: number | undefined;
    testAuthEndDate?: Date | undefined;
    relationshipId?: number | undefined;
    serviceTypes?: number[] | undefined;
    liveinDateRanges?: DateRangeRequest[] | undefined;
    statusDateRanges?: StatusRequest[] | undefined;
    relationshipDateRanges?: RelationshipDateRangeRequest[] | undefined;
    exemptions?: ExemptionRequest[] | undefined;
}

export class UpsertParticipantCommand implements IUpsertParticipantCommand {
    accessRights?: string[] | undefined;
    participantId?: number;
    cdcnState?: string | undefined;
    area?: string | undefined;
    agency?: string | undefined;
    fipsCode?: string | undefined;
    geoLocale?: string | undefined;
    referralDate?: Date | undefined;
    dischargeDate?: Date | undefined;
    dischargeReason?: string | undefined;
    administration?: number | undefined;
    attendingProviderNumber?: string | undefined;
    referringProviderNumber?: string | undefined;
    passportId?: number | undefined;
    advancedDirective?: AdvancedDirective[] | undefined;
    participantTerritories?: ParticipantTerritoryRelation[] | undefined;

    constructor(data?: IUpsertParticipantCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(item);
            }
            this.participantId = _data["participantId"];
            this.cdcnState = _data["cdcnState"];
            this.area = _data["area"];
            this.agency = _data["agency"];
            this.fipsCode = _data["fipsCode"];
            this.geoLocale = _data["geoLocale"];
            this.referralDate = _data["referralDate"] ? new Date(_data["referralDate"].toString()) : <any>undefined;
            this.dischargeDate = _data["dischargeDate"] ? new Date(_data["dischargeDate"].toString()) : <any>undefined;
            this.dischargeReason = _data["dischargeReason"];
            this.administration = _data["administration"];
            this.attendingProviderNumber = _data["attendingProviderNumber"];
            this.referringProviderNumber = _data["referringProviderNumber"];
            this.passportId = _data["passportId"];
            if (Array.isArray(_data["advancedDirective"])) {
                this.advancedDirective = [] as any;
                for (let item of _data["advancedDirective"])
                    this.advancedDirective!.push(AdvancedDirective.fromJS(item));
            }
            if (Array.isArray(_data["participantTerritories"])) {
                this.participantTerritories = [] as any;
                for (let item of _data["participantTerritories"])
                    this.participantTerritories!.push(ParticipantTerritoryRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpsertParticipantCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertParticipantCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item);
        }
        data["participantId"] = this.participantId;
        data["cdcnState"] = this.cdcnState;
        data["area"] = this.area;
        data["agency"] = this.agency;
        data["fipsCode"] = this.fipsCode;
        data["geoLocale"] = this.geoLocale;
        data["referralDate"] = this.referralDate ? this.referralDate.toISOString() : <any>undefined;
        data["dischargeDate"] = this.dischargeDate ? this.dischargeDate.toISOString() : <any>undefined;
        data["dischargeReason"] = this.dischargeReason;
        data["administration"] = this.administration;
        data["attendingProviderNumber"] = this.attendingProviderNumber;
        data["referringProviderNumber"] = this.referringProviderNumber;
        data["passportId"] = this.passportId;
        if (Array.isArray(this.advancedDirective)) {
            data["advancedDirective"] = [];
            for (let item of this.advancedDirective)
                data["advancedDirective"].push(item.toJSON());
        }
        if (Array.isArray(this.participantTerritories)) {
            data["participantTerritories"] = [];
            for (let item of this.participantTerritories)
                data["participantTerritories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpsertParticipantCommand {
    accessRights?: string[] | undefined;
    participantId?: number;
    cdcnState?: string | undefined;
    area?: string | undefined;
    agency?: string | undefined;
    fipsCode?: string | undefined;
    geoLocale?: string | undefined;
    referralDate?: Date | undefined;
    dischargeDate?: Date | undefined;
    dischargeReason?: string | undefined;
    administration?: number | undefined;
    attendingProviderNumber?: string | undefined;
    referringProviderNumber?: string | undefined;
    passportId?: number | undefined;
    advancedDirective?: AdvancedDirective[] | undefined;
    participantTerritories?: ParticipantTerritoryRelation[] | undefined;
}

export class UpsertPersonCommand implements IUpsertPersonCommand {
    accessRights?: string[] | undefined;
    personId?: number;
    status?: string | undefined;
    email?: string | undefined;
    gender?: Gender;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    suffix?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date;
    statusEndDate?: Date | undefined;
    unmaskedSsn?: string | undefined;
    ivrPin?: string | undefined;
    coordinatorPersonId?: string | undefined;
    isCoordinatorPersonIdChanged?: boolean | false;
    coordinatorName?: string | undefined;
    personType?: string | undefined;
    internalUserObjectId?: string | undefined;
    address?: AddressDTO[] | undefined;
    phone?: PhoneDetail[] | undefined;
    externalKeys?: PersonExternalKeyDto[] | undefined;

    constructor(data?: IUpsertPersonCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(item);
            }
            this.personId = _data["personId"];
            this.status = _data["status"];
            this.email = _data["email"];
            this.gender = _data["gender"];
            this.ethnicity = _data["ethnicity"];
            this.race = _data["race"];
            this.maritalStatus = _data["maritalStatus"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.suffix = _data["suffix"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.statusStartDate = _data["statusStartDate"] ? new Date(_data["statusStartDate"].toString()) : <any>undefined;
            this.statusEndDate = _data["statusEndDate"] ? new Date(_data["statusEndDate"].toString()) : <any>undefined;
            this.unmaskedSsn = _data["unmaskedSsn"];
            this.ivrPin = _data["ivrPin"];
            this.coordinatorPersonId = _data["coordinatorPersonId"];
            this.internalUserObjectId = _data["internalUserObjectId"];
            if (Array.isArray(_data["address"])) {
                this.address = [] as any;
                for (let item of _data["address"])
                    this.address!.push(AddressDTO.fromJS(item));
            }
            if (Array.isArray(_data["phone"])) {
                this.phone = [] as any;
                for (let item of _data["phone"])
                    this.phone!.push(PhoneDetail.fromJS(item));
            }
            if (Array.isArray(_data["externalKeys"])) {
                this.externalKeys = [] as any;
                for (let item of _data["externalKeys"])
                    this.externalKeys!.push(PersonExternalKeyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpsertPersonCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertPersonCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item);
        }
        data["personId"] = this.personId;
        data["status"] = this.status;
        data["email"] = this.email;
        data["gender"] = this.gender;
        data["ethnicity"] = this.ethnicity;
        data["race"] = this.race;
        data["maritalStatus"] = this.maritalStatus;
        data["preferredLanguage"] = this.preferredLanguage;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["suffix"] = this.suffix;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["statusStartDate"] = this.statusStartDate ? this.statusStartDate.toISOString() : <any>undefined;
        data["statusEndDate"] = this.statusEndDate ? this.statusEndDate.toISOString() : <any>undefined;
        data["unmaskedSsn"] = this.unmaskedSsn;
        data["ivrPin"] = this.ivrPin;
        data["coordinatorPersonId"] = this.coordinatorPersonId;
        data["internalUserObjectId"] = this.internalUserObjectId;
        if (Array.isArray(this.address)) {
            data["address"] = [];
            for (let item of this.address)
                data["address"].push(item.toJSON());
        }
        if (Array.isArray(this.phone)) {
            data["phone"] = [];
            for (let item of this.phone)
                data["phone"].push(item.toJSON());
        }
        if (Array.isArray(this.externalKeys)) {
            data["externalKeys"] = [];
            for (let item of this.externalKeys)
                data["externalKeys"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpsertPersonCommand {
    accessRights?: string[] | undefined;
    personId?: number;
    status?: string | undefined;
    email?: string | undefined;
    gender?: Gender;
    ethnicity?: string | undefined;
    race?: string | undefined;
    maritalStatus?: string | undefined;
    preferredLanguage?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    suffix?: string | undefined;
    birthDate?: Date | undefined;
    statusStartDate?: Date;
    statusEndDate?: Date | undefined;
    unmaskedSsn?: string | undefined;
    ivrPin?: string | undefined;
    coordinatorPersonId?: string | undefined;
    internalUserObjectId?: string | undefined;
    address?: AddressDTO[] | undefined;
    phone?: PhoneDetail[] | undefined;
    externalKeys?: PersonExternalKeyDto[] | undefined;
}

export class UpsertPersonExternalKeysCommand implements IUpsertPersonExternalKeysCommand {
    accessRights?: string[] | undefined;
    personId?: number;
    externalKeys?: PersonExternalKeyDto[] | undefined;

    constructor(data?: IUpsertPersonExternalKeysCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(item);
            }
            this.personId = _data["personId"];
            if (Array.isArray(_data["externalKeys"])) {
                this.externalKeys = [] as any;
                for (let item of _data["externalKeys"])
                    this.externalKeys!.push(PersonExternalKeyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpsertPersonExternalKeysCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertPersonExternalKeysCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item);
        }
        data["personId"] = this.personId;
        if (Array.isArray(this.externalKeys)) {
            data["externalKeys"] = [];
            for (let item of this.externalKeys)
                data["externalKeys"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpsertPersonExternalKeysCommand {
    accessRights?: string[] | undefined;
    personId?: number;
    externalKeys?: PersonExternalKeyDto[] | undefined;
}

export class UpsertProspectCommand implements IUpsertProspectCommand {
    accessRights?: string[] | undefined;
    cdcnState?: string | undefined;
    interestedEligibleDate?: Date | undefined;
    isInterestedEligible?: boolean;
    prospectStatus?: StatusInfo[] | undefined;
    personId?: number;

    constructor(data?: IUpsertProspectCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(item);
            }
            this.cdcnState = _data["cdcnState"];
            this.interestedEligibleDate = _data["interestedEligibleDate"] ? new Date(_data["interestedEligibleDate"].toString()) : <any>undefined;
            this.isInterestedEligible = _data["isInterestedEligible"];
            if (Array.isArray(_data["prospectStatus"])) {
                this.prospectStatus = [] as any;
                for (let item of _data["prospectStatus"])
                    this.prospectStatus!.push(StatusInfo.fromJS(item));
            }
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): UpsertProspectCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertProspectCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item);
        }
        data["cdcnState"] = this.cdcnState;
        data["interestedEligibleDate"] = this.interestedEligibleDate ? this.interestedEligibleDate.toISOString() : <any>undefined;
        data["isInterestedEligible"] = this.isInterestedEligible;
        if (Array.isArray(this.prospectStatus)) {
            data["prospectStatus"] = [];
            for (let item of this.prospectStatus)
                data["prospectStatus"].push(item.toJSON());
        }
        data["personId"] = this.personId;
        return data;
    }
}

export interface IUpsertProspectCommand {
    accessRights?: string[] | undefined;
    cdcnState?: string | undefined;
    interestedEligibleDate?: Date | undefined;
    isInterestedEligible?: boolean;
    prospectStatus?: StatusInfo[] | undefined;
    personId?: number;
}

export class WithinGracePeriodRequest implements IWithinGracePeriodRequest {
    currentDate?: Date;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    employerId?: string | undefined;

    constructor(data?: IWithinGracePeriodRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentDate = _data["currentDate"] ? new Date(_data["currentDate"].toString()) : <any>undefined;
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            this.employerId = _data["employerId"];
        }
    }

    static fromJS(data: any): WithinGracePeriodRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WithinGracePeriodRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentDate"] = this.currentDate ? this.currentDate.toISOString() : <any>undefined;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        data["employerId"] = this.employerId;
        return data;
    }
}

export interface IWithinGracePeriodRequest {
    currentDate?: Date;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    employerId?: string | undefined;
}

export class WithinGracePeriodResponse implements IWithinGracePeriodResponse {
    serviceCodeGracePeriods?: ServiceCodeGracePeriod[] | undefined;
    defaultGracePeriods?: GracePeriodDateSpan[] | undefined;
    maxGracePeriodDays?: number;

    constructor(data?: IWithinGracePeriodResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["serviceCodeGracePeriods"])) {
                this.serviceCodeGracePeriods = [] as any;
                for (let item of _data["serviceCodeGracePeriods"])
                    this.serviceCodeGracePeriods!.push(ServiceCodeGracePeriod.fromJS(item));
            }
            if (Array.isArray(_data["defaultGracePeriods"])) {
                this.defaultGracePeriods = [] as any;
                for (let item of _data["defaultGracePeriods"])
                    this.defaultGracePeriods!.push(GracePeriodDateSpan.fromJS(item));
            }
            this.maxGracePeriodDays = _data["maxGracePeriodDays"];
        }
    }

    static fromJS(data: any): WithinGracePeriodResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WithinGracePeriodResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceCodeGracePeriods)) {
            data["serviceCodeGracePeriods"] = [];
            for (let item of this.serviceCodeGracePeriods)
                data["serviceCodeGracePeriods"].push(item.toJSON());
        }
        if (Array.isArray(this.defaultGracePeriods)) {
            data["defaultGracePeriods"] = [];
            for (let item of this.defaultGracePeriods)
                data["defaultGracePeriods"].push(item.toJSON());
        }
        data["maxGracePeriodDays"] = this.maxGracePeriodDays;
        return data;
    }
}

export interface IWithinGracePeriodResponse {
    serviceCodeGracePeriods?: ServiceCodeGracePeriod[] | undefined;
    defaultGracePeriods?: GracePeriodDateSpan[] | undefined;
    maxGracePeriodDays?: number;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
